// Translations for TerraMind - English and Greek
// Easy to maintain and extend

const translations = {
  en: {
    pageNotFound: 'Page not found',
    backToFields: 'Back to my fields',
    // Navigation
    map: 'Map',
    home: 'Home',
    goodMorning: 'Good morning',
    // The per-field sensor page (/fields/:id/dashboard). Named for what the
    // farmer goes there to see, not for the widget layout, "Dashboard" told
    // him nothing, and its Greek was the transliteration "Ταμπλό".
    fieldData: 'Field data',
    fields: 'Fields',
    myFields: 'My Fields',
    usersNavLabel: 'Users',
    recViewNavLabel: 'Calls and runs',
    recViewNavSub: 'What the engine recommended each day against the runs made',
    fieldChartsTitle: 'Charts',
    fieldChartsSub: "Build your own charts from this field's readings and download them as CSV",
    scopeMine: 'Mine',
    scopeAll: 'All',
    scopeAllTip: 'See every account\'s fields',
    scopeMineTip: 'See only your own fields',
    demoBadge: 'DEMO',
    notifications: 'Notifications',
    now: 'Now',
    sensors: 'Sensors',
    edgeDevices: 'Edge Devices',
    devicesNavLabel: 'Devices',
    hardwareNavLabel: 'Hardware',
    hardwarePageTitle: 'Hardware',
    hardwarePageSubtitle: 'Monitor and configure all field hardware, sensors, gateways and controllers',
    hardwareTabIot: 'IoT',
    hardwareTabSensors: 'Sensors',
    hardwareTabControllers: 'Controllers',
    hardwareTabRegistry: 'Registry',
    hardwareTabEdge: 'Valves',
    customizeDashboard: 'Customize',
    customizeDashboardTitle: 'Customize dashboard',
    customizeDashboardHint: 'Choose which sections to show. Your choice is saved to your account.',
    sectionKpis: 'Key metrics',
    sectionWaterComparison: 'Water: advisor vs manual',
    resetToDefaults: 'Reset',
    doneLabel: 'Done',
    allSectionsHidden: 'All sections are hidden. Use Customize to show them.',
    irrigation: 'Irrigation',
    weather: 'Weather',
    alerts: 'Alerts',
    analytics: 'Field Data',
    weeklySchedules: 'Schedules',
    dataCharts: 'Data & Analytics',

    // Data page
    ndviHistory: 'NDVI History',
    volumetricWaterContent: 'Soil Moisture (%)',
    weeklyIrrigationTotals: 'Weekly Irrigation Totals',
    weatherTrends: 'Weather Trends',
    ndviDataNotAvailable: 'NDVI snapshot timeline coming soon',
    errorLoadingFields: 'Error loading fields',
    liters: 'Liters',
    searchFields: 'Search fields...',
    needsAttention: 'Needs Attention',
    healthy: 'Healthy',
    filterByField: 'Filter by field',
    adminTools: 'Admin Tools',
    interactiveDemo: 'Interactive Demo',
    smartIrrigation: 'Smart Irrigation',
    systemOnline: 'System Online',
    lastSync: 'Last sync',
    
    // Dashboard
    terraMindDashboard: 'Dashboard',
    smartIrrigationManagement: 'Smart Irrigation Management System',
    lastUpdated: 'Last updated',
    liveMode: 'Live Mode',
    refreshData: 'Refresh Data',
    chartSettings: 'Chart settings',
    showMethodology: 'Show methodology',
    waiTooltip: 'How wet the soil is. 0% is bone dry, 100% is fully soaked.',
    activeAlerts: 'Active Alerts',
    activeFields: 'Active Fields',
    agriculturalZones: 'Agricultural zones',
    sensorNetwork: 'Sensor Network',
    iotDevicesOnline: 'IoT devices online',
    devices: 'devices',
    activeIrrigation: 'Active Irrigation',
    zonesWateringNow: 'Zones watering now',
    waterSaved: 'Water Saved',
    vsTraditionalMethods: 'vs traditional methods',
    environmentalMonitoring: 'Environmental Monitoring',
    realTimeData: 'Real-time Data',
    waterUsageToday: 'Water Usage Today',
    systemStatus: 'System Status',
    allSystemsOperational: 'All Systems Operational',
    sensorsOnline: 'sensors online',
    fieldsActive: 'fields active',
    weatherAPIConnected: 'Weather API Connected',
    realTimeDataFrom: 'Real-time data from',
    sources: 'sources',
    irrigationAlerts: 'Irrigation Alerts',
    zonesNeedAttention: 'zones need attention',
    nextIrrigationCycle: 'Next Irrigation Cycle',
    fieldAlphaIn: 'Field Alpha in',
    hours: 'hours',
    performanceMetrics: 'Performance Metrics',
    waterEfficiency: 'Water Efficiency',
    cropHealthIndex: 'Crop Health Index',
    predictionAccuracy: 'Prediction Accuracy',

    // Field Journal (Production + Farm Diary)
    fieldJournal: 'Diary',
    production: 'Production',
    productionOverview: 'Production Overview',
    productionSubtitle: 'Yearly yield, quality, and water usage per field',
    yieldPerStremma: 'Yield per Stremma',
    totalYield: 'Total Yield',
    totalYieldKg: 'Total Yield (kg)',
    fruitWeight: 'Avg Fruit Weight',
    avgFruitWeightG: 'Avg Fruit Weight (g)',
    totalWaterM3: 'Total Water (m³)',
    waterUsed: 'Water Used',
    quality: 'Quality',
    addYear: 'Add Year',
    addProduction: 'Add Production',
    editProduction: 'Edit Production',
    noProductionData: 'No production data recorded yet',
    stremma: 'str.',
    unitArea: 'str.',

    // Welcome
    welcomeToTerraMind: 'Welcome to TerraMind',
    theSmartIrrigationPlatform: 'The Smart Irrigation Platform',
    optimizeYourIrrigation: 'Optimize Your Irrigation with AI',
    terraMindUsesAdvanced: 'TerraMind uses advanced algorithms, real-time sensor data, and weather forecasts to deliver precise irrigation recommendations. Save water, reduce costs, and improve crop yield.',
    keyFeatures: 'Key Features',
    everythingYouNeed: 'Everything you need for smart farming',
    realtimeMonitoring: 'Real-time Monitoring',
    trackSoilMoisture: 'Track soil moisture, temperature, and humidity 24/7',
    weatherIntegration: 'Weather Integration',
    forecastRainfall: 'Forecast rainfall & adjust irrigation automatically',
    smartDecisions: 'Smart Decisions',
    getPreciseRecommendations: 'Get precise recommendations on when & how much to water',
    performanceTracking: 'Performance Tracking',
    monitorEfficiencyMetrics: 'Monitor efficiency metrics and historical trends',
    gettingStarted: 'Getting Started',
    navigateYourDashboard: 'Navigate your dashboard',
    dashboard_desc: 'View real-time metrics, active alerts, and system status at a glance.',
    fieldsZones: 'Fields & Zones',
    manageYourAgricultural: 'Manage your agricultural fields and set up irrigation zones with custom parameters.',
    analyticsReports: 'Analytics & Reports',
    trackWaterUsage: 'Track water usage, efficiency metrics, and historical performance data.',
    getStarted: 'Get Started',
    back: 'Back',
    next: 'Next',
    
    // Fields
    fieldsManagement: 'Fields Management',
    monitorAndManage: 'Monitor and manage your agricultural fields',
    addField: 'Add Field',
    addItem: 'Add',
    createField: 'Create Field',
    review: 'Review',
    drawn: 'Drawn',
    notSet: 'Not set',
    noFieldsFound: 'No fields found',
    createFirstField: 'Create your first field to start collecting sensor data and receive irrigation suggestions.',
    fieldName: 'Field Name',
    location: 'Location',
    locationHint: 'e.g. Veroia, Imathia',
    soilCompositionHint: 'Enter sand/silt/clay % and soil type will be auto-classified via USDA triangle. Must sum to ~100%.',
    area: 'Area (str.)',
    hectares: 'str.',
    soilType: 'Soil Type',
    soilTex_clay: 'Clay',
    soilTex_silty_clay: 'Silty Clay',
    soilTex_silt: 'Silt',
    soilTex_loam: 'Loam',
    soilTex_loamy_sand: 'Loamy Sand',
    soilTex_clay_loam: 'Clay Loam',
    soilTex_silty_clay_loam: 'Silty Clay Loam',
    cropType: 'Crop Type',
    dssModeAutoShort: 'Auto',
    expandSoilTriangle: 'View full triangle',
    clickTriangleToSet: 'Click the triangle to set soil composition',
    soilTypeStaleWarning: 'Stored soil type ({stored}) does not match sand/silt/clay ({classified}).',
    recomputeSoilTypeButton: 'Fix now',
    recomputeSoilTypeDone: 'Soil type updated: {before} → {after}. WP/FC were not changed automatically, compare and update those separately if needed.',
    recomputeSoilTypeFailed: 'Could not recompute soil type',
    cropKiwi: 'Kiwi',
    cropOlive: 'Olive',
    cropPeach: 'Peach',
    cropCherry: 'Cherry',
    cropGrape: 'Grape',
    cropApple: 'Apple',
    cropPear: 'Pear',
    cropApricot: 'Apricot',
    cropOther: 'Other',
    unknownCrop: 'Unknown Crop',
    clay: 'Clay',
    sandy: 'Sandy',
    loam: 'Loam',
    clayLoam: 'Clay Loam',
    sandyLoam: 'Sandy Loam',
    siltLoam: 'Silt Loam',
    siltyClay: 'Silty Clay',
    sandyClay: 'Sandy Clay',
    sandyClayLoam: 'Sandy Clay Loam',
    siltyClayLoam: 'Silty Clay Loam',
    soilSilt: 'Silt',
    loamySand: 'Loamy Sand',
    autoClassified: 'Auto-classified',
    soilTriangle: 'Soil Texture Triangle',
    irrigationZones: 'Irrigation Zones',
    zones: 'zones',
    zonesOne: 'zone',
    editField: 'Edit Field',
    addNewField: 'Add New Field',
    cancel: 'Cancel',
    create: 'Create',
    update: 'Update',
    soil: 'Soil',
    loadingFields: 'Loading Fields...',
    failedToLoadFields: 'Failed to load fields',
    fieldCreated: 'Field created successfully',
    fieldUpdated: 'Field updated successfully',
    deleteField: 'Delete Field',
    confirmDelete: 'Delete Field?',
    delete: 'Delete',
    save: 'Save',
    edit: 'Edit',
    // Field Detail
    drawPolygon: 'Draw field boundary on the map (optional)',
    fieldBoundary: 'Field Boundary',
    drawFieldPolygonHint: 'Draw or edit the field boundary on the map.',
    editingFieldBoundary: 'Editing field boundary',
    drawFieldHint: 'Draw or edit the field polygon on the map, then click Save.',
    fieldBoundarySaved: 'Field boundary saved',
    noBoundaryHint: 'No boundary drawn · field won\'t appear on map. Click to draw.',

    // Irrigation History tab
    noHistoryYet: 'No irrigation history yet',
    noHistoryHint: 'Completed irrigations will appear here once they finish.',
    loadMore: 'Load more',
    overview: 'Overview',

    // DSS / Attention banner
    zoneStressedSingular: 'zone stressed',
    zonesStressedPlural: 'zones stressed',
    dssCheckRecs: 'Review advisor recommendations',
    irrigationNeeded: 'Irrigation needed',
    clickToSelect: 'Click to select',
    sand: 'Sand',
    silt: 'Silt',
    wiltingPoint: 'Wilting Point',
    fieldCapacity: 'Field Capacity',
    wpHelp: 'Overrides field default',
    fcHelp: 'Overrides field default',
    optional: 'optional',
    weights: 'Weights (10/20/30cm)',
    bbch: 'BBCH Stage',
    treeDensity: 'Tree Density (trees/str.)',
    productionGoal: 'Production Goal (kg/tree)',
    maxConcurrentZones: 'Max Concurrent Zones',
    maxConcurrentHelp: 'Pump capacity limit',
    soilParams: 'Soil Parameters',
    hydrologyParams: 'Hydrology Parameters',
    cropParams: 'Crop Parameters',
    // Field Detail panel keys (used by FieldInfoPanel)
    fieldInfo: 'Field Information',
    basicInfo: 'Basic Info',
    soilComposition: 'Soil Composition',
    soilTotalNot100: 'Sand, silt and clay add up to {total}%. They must add up to 100%.',
    haveSoilAnalysis: 'I have a soil analysis',
    importFieldsButton: 'Import KML',
    importFieldsTitle: 'Import fields from a file',
    importFieldsHelp: 'KML or KMZ (OSDE, Google Earth) or GeoJSON. Every outline becomes a field you can name before it is created.',
    importFieldsFound: '{n} outlines found',
    importFieldsCreate: 'Create {n} fields',
    importFieldsFailed: 'Not created: {names}',
    importFailed: 'The file could not be read.',
    chooseFile: 'Choose file',
    irrigationParameters: 'Irrigation Parameters',
    depthWeights: 'Weights (10/20/30cm)',
    bbchStage: 'BBCH Stage',
    // Zone Management
    zoneManagement: 'Zone Management',
    addZone: 'Add Zone',
    orDrawZones: 'or draw zones on the map',
    editZone: 'Edit Zone',
    deleteZone: 'Delete Zone?',
    deleteZoneAction: 'Delete zone',
    deleteZoneConfirmBody: 'This will permanently delete this zone and its history.',
    moreActions: 'More actions',
    zoneInfo: 'Zone Info',
    noActionNeeded: 'No action needed',
    zoneNumber: 'Zone Number',
    zoneName: 'Zone Name',
    sprinklers: 'Drippers/Sprinklers (count)',
    litersPerSprinkler: 'Flow per dripper (L/h)',
    areaZone: 'Zone Area (str.)',
    provider: 'Irrigation control',
    zoneDetails: 'Zone details',
    fieldFactsTitle: 'About this field',
    zoneLimitsHelp: 'Left empty, the values of the field apply.',
    step1FieldDetails: 'Step 1: Field Details',
    step2ZoneCreation: 'Step 2: Draw Zones',
    useWholeField: 'Use Whole Field as Zone',
    atLeastOneZone: 'At least one zone is required',
    saveZone: 'Save Zone',
    drawZoneOnMap: 'Draw a zone on the map, then save it.',
    zonesAdded: 'zones added',
    providerZoneId: 'Provider Zone ID',
    relayIndex: 'Relay / Gate',
    relayN: 'Relay {n}',
    notAssigned: 'Not assigned',
    flowRate: 'Total zone flow',
    zoneCreated: 'Zone created successfully',
    zoneUpdated: 'Zone updated successfully',
    zoneDeleted: 'Zone deleted successfully',
    noZones: 'No zones configured',
    noZonesYet: 'No zones added yet.',
    chartsComingSoon: 'Charts coming soon',
    addZoneHint: 'Use the + button above to add your first irrigation zone.',
    addFirstZone: 'Add zones to manage irrigation for this field',
    irrigationZonesTitle: 'Irrigation Zones',
    zoneArea: 'Zone Area',
    confirmDeleteZone: 'Delete this zone?',
    editBoundary: 'Edit Boundary',
    drawBoundary: 'Draw Boundary',
    editingBoundary: 'Editing...',
    editingZoneBoundary: 'Editing zone boundary',
    drawZoneHint: 'Draw or edit the zone polygon on the map, then click Save.',
    zoneBoundary: 'Zone Boundary',
    drawZonePolygonHint: 'Draw the zone boundary inside the field. Area auto-calculates from polygon.',
    zoneBoundarySaved: 'Zone boundary saved',
    useMainMapHint: 'Use the "Edit Boundary" / "Draw Boundary" button on the zone card to set the polygon on the main map.',

    // Zone States · farmer vocabulary, never the OK/MARGINAL/STRESSED enum
    zoneState: 'Zone State',
    zoneStateOK: 'Healthy',
    zoneStateMarginal: 'Getting dry',
    zoneStateStressed: 'Critically dry',
    zoneStateSaturated: 'Over-watered',
    zoneStateUnknown: 'No sensor data',
    zoneStateStale: 'No new readings',

    // ServiceDegraded · shown when upstream services 5xx
    serviceDegradedLastSuccess: 'Last successful update:',
    sessionExpiredMessage: 'Your session expired. Please log in again.',
    authRequiredMessage: 'Please log in to continue.',
    deleteFieldTypeName: 'Type the field name to confirm:',
    fieldDeletedUndo: 'Field {name} deleted.',
    undoDelete: 'Undo',
    fieldAddedBy: 'Added by {name} on {date}.',
    readinessSummary: '{fields} fields · {monitored} with readings · {controlled} with a valve',
    readinessNoFields: 'No fields yet',
    readinessNextFields: 'Next: draw the fields',
    readinessNextSensor: 'Next: connect a sensor',
    notifyEmailReports: 'Report by email',
    notifyEmailReportsDesc: 'The report of all your fields as a PDF. It is always in Reports.',
    reportEmailOff: 'No',
    reportEmailDaily: 'Once a day (09:15)',
    reportEmail6h: 'Every 6 hours',
    fieldAddedUnknown: 'Who added it is not recorded: the record starts on 13/07/2026. It existed by {date}.',
    useWholeFieldZone: 'Use whole field as one zone',
    thresholdMaxUseful: 'Max useful water',
    thresholdWhenToWater: 'When to water',
    thresholdMinForPlant: 'Min for plant',
    soilWaterLevel: 'Soil water',
    soilMoistureShort: 'Moisture',
    soilWaterLevelAvg: 'Avg. soil water level',
    dailyWaterNeed: 'Daily water need',
    weatherCachedHeader: 'Forecast updated every 6 hours',
    weatherCachedExplain: 'Irrigation decisions always use the freshest sensor reading available.',
    minAgo: 'min ago',
    hourAgo: 'h ago',
    hoursAgo: 'h ago',
    dayAgo: 'day ago',
    daysAgo: 'days ago',
    weekAgo: 'week ago',
    weeksAgo: 'weeks ago',
    monthAgo: 'month ago',
    monthsAgo: 'months ago',
    stale: 'Stale',
    manageRules: 'Manage rules',
    searchUsersPlaceholder: 'Search by username, email or name…',
    allRoles: 'All roles',
    rainNext7Days: '7-day rain',
    peakWind: 'Peak wind',
    next7Days: 'Next 7 days',
    expectedTotal: 'Expected total',
    lowOf: 'Low of',
    over35Threshold: '> 35°C threshold',
    fromDate: 'From',
    toDate: 'To',
    viewAsFarmer: 'View as farmer',
    currentView: 'Current view',
    adminView: 'Admin',
    farmerView: 'Farmer',
    searchSensorsPlaceholder: 'Search by name, identifier, location…',
    noMatchingSensors: 'No sensors match the current filter',
    allSensorsUnconnected: '{count} sensor(s) are not connected to a field',
    allSensorsUnconnectedHint: 'They are reporting, but their readings are not reaching any field yet. Open one to choose the field it measures.',
    showUnconnectedSensors: 'Show them',
    clearFiltersHint: 'Try clearing the search or field filter.',
    soilMoistureTrend30d: 'Soil moisture trend (30d)',
    dssAcceptance: 'Recommendation accepted',
    weatherEvent: 'Weather event',
    zoneHistory: 'History',
    mapNote: 'Map note',
    dssMode: 'Irrigation mode',
    autoLogIrrigationToDiary: 'Auto-log irrigations to Farm Diary',
    autoLogIrrigationToDiaryDesc: 'Automatically add an entry when an irrigation completes.',
    ndviLatest: 'Latest',
    ndviToday: 'Today',
    ndviLatestAvailable: 'Latest available satellite image',
    goalAggressive: 'aggressive',
    goalConservative: 'conservative',
    goalNormal: 'normal',
    goalHintAggressive: 'High target · more water needed',
    goalHintAboveAverage: 'Above average target',
    goalHintNormal: 'Normal target',
    goalHintConservative: 'Conservative · less water',
    goalHintLow: 'Low target · water saving',
    goalHintEmpty: 'Sets irrigation intensity',
    evaporationLoss: 'Evaporation loss',
    advisorSuggests: 'Advisor suggests:',
    growthStageChip: 'Stage',
    fallsBelow: 'falls below',
    risesAbove: 'rises above',
    atOrBelow: 'at or below',
    atOrAbove: 'at or above',
    equals: 'equals',
    dssModeManual: 'No Advisor',
    dssModeAssisted: 'With Advisor',
    dssModeAutomated: 'Auto With Advisor',
    // What pressing Start does on this zone. {id} is the controller's name.
    valveNoneConnected: 'No valve controller here. Starting only records the irrigation in your history.',
    valveControllerSilent: 'Controller {id} is not answering, so the valve cannot be opened right now.',
    valveReady: 'Controller {id} is connected. Starting opens the valve for this zone.',
    appRateLabel: 'Water delivery rate (% moisture per hour)',
    appRateHelp: 'How much the moisture at 10 cm rises after an hour of watering. Empty = standard rate. Affects the suggested duration only.',
    appRateInvalid: 'Water delivery rate must be a valid number',
    appRateRange: 'Water delivery rate must be between 0.1 and 100 % per hour',
    dssModeManualHint: 'You decide when to irrigate. The Advisor only watches and logs, no automatic recommendations.',
    dssModeAssistedHint: 'The Advisor suggests when and how long to irrigate. You approve each suggestion before it runs.',
    dssModeAutomatedHint: 'The Advisor writes the schedule automatically. You can still override individual sessions.',
    addYourFirstField: 'Add your first field',
    addYourFirstFieldHint: 'Draw your field boundary on the map, add irrigation zones, and TerraMind will start tracking soil moisture and generating daily recommendations.',
    service_weather_unavailable_title: 'Weather service is unavailable',
    service_weather_unavailable_body: 'Live weather data could not be fetched. Recommendations and alerts that depend on the forecast are paused until the service is back.',
    service_ndvi_unavailable_title: 'Satellite imagery is unavailable',
    service_ndvi_unavailable_body: 'NDVI data could not be fetched from the satellite provider. The map will show your latest cached imagery if available.',
    service_dss_unavailable_title: 'Recommendations are temporarily paused',
    service_dss_unavailable_body: 'No new recommendation was produced today. Your schedules keep running. New recommendations return by themselves once the service catches up.',

    // Field Detail - Farmer View KPIs
    totalZones: 'Total Zones',
    needsWater: 'Needs Water',
    waterThisWeek: 'Water This Week',
    zoneHealth: 'Zone Health',
    needAction: 'need action',
    todaysRecommendations: "Today's Recommendations",

    // Zone Polygon
    zonePolygon: 'Zone Boundary',
    polygon: 'Polygon',
    drawZoneBoundary: 'Draw the zone boundary on the map',

    // Weekly Schedule
    addSchedule: 'Add Schedule',
    editSchedule: 'Edit Schedule',
    noWeeklySchedules: 'No weekly schedules configured. Add one to automate irrigation.',
    confirmDeleteSchedule: 'Delete this schedule?',
    confirmStopTitle: 'Stop Irrigation?',
    confirmStopMessage: 'This will stop the active irrigation for this zone immediately.',
    confirmCancelQueueTitle: 'Remove from Queue?',
    confirmCancelQueueMessage: 'This will remove the zone from the irrigation queue.',
    removeFromQueue: 'Remove',
    applyRecommendation: 'Apply',
    day: 'Day',
    time: 'Time',
    duration: 'Duration',
    dose: 'Dose',
    mode: 'Mode',
    active: 'Active',
    inactive: 'Inactive',
    dssOverride: 'Advisor Override',
    calendarView: 'Calendar',
    tableView: 'Table',
    scheduleCreated: 'Schedule created successfully',
    saveAndNext: 'Save & Next',
    saveThis: 'Save This',
    saveAll: 'Save All',
    normal: 'Normal',
    fertigation: 'Fertigation',
    antiFrost: 'Anti-Frost',
    noSchedulesConfigured: 'No schedules configured',
    addScheduleHint: 'Add a schedule to automate irrigation.',
    paintHint: 'Tip: Click and drag on the calendar to paint time slots',
    paintMode: 'Paint',
    paintModeHint: 'Click and drag on the calendar to select time slots',
    schedule: 'Schedule',
    dssRecs: 'Advisor',
    saveChanges: 'Save Changes',
    drawZoneHintInline: 'Draw or edit the zone polygon on the map. Area auto-calculates.',
    upcomingIrrigations: 'Upcoming Irrigations',
    task: 'task',
    tasks: 'tasks',
    overdue: 'Overdue',

    // Dashboard Views
    mapView: 'Map View',
    zoneControl: 'Zone Control',
    irrigationControl: 'Irrigation Control',
    sensorMonitoring: 'Sensor Monitoring',
    auditTrail: 'Audit Trail / History',
    history: 'History',
    emergencyStop: 'Emergency Stop',
    emergencyStopConfirm: 'EMERGENCY STOP: This will cancel ALL active irrigations. Continue?',
    emergencyStopFailed: 'Emergency stop failed: ',
    fieldMap: 'Field Map',
    toggleFieldInfo: 'Field Info',
    aiMode: 'With Advisor',
    manualMode: 'No Advisor',

    // History / Audit trail filters
    advancedFilters: 'Filters',
    dateFrom: 'From',
    dateTo: 'To',
    decisionType: 'Decision Type',
    allZones: 'All Zones',
    activeFilters: 'Active:',
    clearAll: 'Clear all',
    clearFilters: 'Clear advanced filters',
    filteringByZone: 'Showing entries for',
    from: 'From',
    to: 'To',

    // Dashboard view content
    allFields: 'All Fields',
    allShort: 'All',
    allCrops: 'All Crops',
    name: 'Name',
    areaStremma: 'Area (str.)',
    wai: 'WAI',
    plainLabelWai: 'Soil water level',
    plainLabelEt0: 'Daily water need',
    status: 'Status',
    zone: 'Zone',
    tabNow: 'Now',
    tabSensors: 'Sensors',
    tabHistory: 'History',
    tabForecast: 'Forecast',
    forecastComingSoonTitle: '5-Day Soil Forecast',
    forecastComingSoonDesc: 'This feature will show a 5-day WAI trajectory combining your sensor readings, weather forecast, and NDVI satellite data. Plan irrigation up to a week ahead.',
    forecastComingSoonNote: 'Available once live sensor data and weather API are connected for this zone.',
    thisWeekWater: 'This week',
    noIrrigationsThisWeek: 'no irrigations',
    psaRiskTitle: 'Disease risk',
    psaRiskLevel_medium: 'medium',
    psaRiskLevel_high: 'high',
    automaticMode: 'Advisor On',
    advisorModeOnTip: 'Irrigation Advisor is active. Recommendations are generated automatically. Click to switch to manual mode.',
    advisorModeOffTip: 'Manual mode: you control all irrigation. Click to activate the Irrigation Advisor.',
    count: 'Count',
    confirmDiscardTitle: 'Discard changes?',
    confirmDiscardBody: 'You have unsaved changes. If you close now they will be lost.',
    confirmDiscardAction: 'Discard',
    pendingApprovals: 'Pending approvals',
    id: 'ID',
    actions: 'Actions',
    activeCount: 'Active',
    noZonesConfigured: 'No zones configured. Add zones via Field Management.',
    activeScheduledIrrigations: 'Active & Scheduled Irrigations',
    field: 'Field',
    targetField: 'Target',
    slots: 'slots',
    viewField: 'View Field',
    viewOnMap: 'Map',
    before: 'Before',
    viewFullJournal: 'View full journal →',
    durationMin: 'Duration (min)',
    waterL: 'Water (L)',
    scheduledTime: 'Scheduled Time',
    vwc10: 'Soil moisture at 10 cm',
    vwc20: 'Soil moisture at 20 cm',
    vwc30: 'Soil moisture at 30 cm',
    waterAvailabilityIndex: 'Water Availability Index',
    systemAlertsTitle: 'System Alerts',
    auditTrailSubtitle: 'Decision, plan, run and outcome',
    refresh: 'Refresh',
    noPlansRecorded: 'No irrigation plans recorded yet.',
    decision: 'DECISION',
    plan: 'PLAN',
    execution: 'EXECUTION',
    outcome: 'OUTCOME',

    // Auth
    login: 'Login',
    logout: 'Logout',
    install: 'Install',
    installApp: 'Add TerraMind to your home screen',
    username: 'Username',
    usernameOrEmail: 'Username or email',
    mapSearchPlaceholder: 'Field, place or coordinates',
    mapSearchShort: 'Search',
    drawFieldMapHint: 'Find the place, tap the outline tool (top left), then tap each corner of the field.',
    drawZoneMapHint: 'Tap the outline tool (top left), then tap each corner of the zone inside the field.',
    drawFirstVertex: 'Tap the first corner',
    drawContinue: 'Tap the next corner',
    drawFinishPoly: 'Tap the first corner again to finish',
    drawFinish: 'Finish',
    drawUndoPoint: 'Undo last point',
    drawPolyButton: 'Draw the outline',
    drawEditButton: 'Move the corners',
    drawDeleteButton: 'Delete the outline',
    fieldNeedsOutlineOrArea: 'Draw the field on the map, or type its area.',
    errorNoPermission: 'Your account is not allowed to do this. Contact the administrator.',
    errorNoConnection: 'No connection to the server. Try again.',
    welcomeSetPasswordTitle: 'Welcome to TerraMind',
    welcomeSetPasswordHint: 'Choose your password. After that you sign in with your email.',
    welcomePasswordSet: 'Your password is set. Sign in with your email and this password.',
    welcomeLinkExpired: 'This invitation link has expired. Ask the administrator for a new one.',
    zoneOutsideField: 'The zone goes outside the field. Move its corners inside the white dashed line.',
    zoneOverlapsDraft: 'The zone overlaps a zone you already drew. Move its corners apart.',
    zoneOverlapsZones: 'The zone overlaps zone {zones}. Move its corners apart.',
    fieldStopPartial: 'Stopped {stopped} of {total}. {failed} did not stop.',
    oneZoneReady: '1 zone ready',
    zonesReadyCount: '{n} zones ready',
    mapSearchGoToCoords: 'Go to these coordinates',
    mapSearchNothing: 'Nothing found',
    places: 'Places',
    clear: 'Clear',
    inviteEmailRequired: 'Enter the email of the person',
    inviteUser: 'Invite',
    inviteSentTo: 'Invitation sent to {name}. They set their password from the link.',
    inviteNotSent: 'No email was sent to {name}. Send them this link to set their password.',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    sendPasswordLink: 'Send password link',
    invitePending: 'Invite pending',
    showInactiveUsers: 'Inactive',
    hideInactiveUsers: 'Hide inactive',
    addFieldsForUser: 'Add their fields',
    usernameDefaultsToEmail: 'Optional. Empty = the email. They can sign in with either.',
    passwordOptionalInvite: 'Optional. Empty = they get a link to set their own.',
    password: 'Password',
    loginSubtitle: 'Sign in to your irrigation management system',
    welcomeTitle: 'Welcome to TerraMind',
    welcomeSubtitle: 'How would you like to start?',
    welcomeCreateFieldBtn: 'Create my first field',
    createFirstFieldDesc: 'Skip the tour. Start with a blank workspace.',
    tourBannerLabel: 'A sample field sits alongside your own. Nothing you do to it touches your real ones.',
    resetTourData: 'Reset the sample',
    startFresh: 'Remove the sample',
    exitTourTitle: 'Remove the sample field?',
    exitTourBody: 'The sample field and its zones and alerts are removed. Your own fields, schedules, readings and alerts stay exactly as they are.',
    deleteAndContinue: 'Remove it',
    launchTour: 'Launch tour',
    removeDemoData: 'Remove demo data',
    tourDataActiveDesc: 'Demo data is active. You can reset or delete it.',
    tourDataInactiveDesc: 'Load a sample kiwi farm to explore all features without affecting real data.',
    loginFailed: 'Invalid username or password',
    credentialsRequired: 'Username and password are required',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    sessionExpired: 'Session expired. Please log in again.',
    register: 'Create Account',
    createAccount: 'Create your account',
    freeTrial: '30-day free trial',
    allFieldsRequired: 'All fields are required',
    registrationFailed: 'Registration failed. Please try again.',
    alreadyHaveAccount: 'Already have an account?',
    noAccount: "Don't have an account?",
    forgotPassword: 'Forgot password?',
    forgotPasswordSubtitle: 'Enter your email and we will send you a reset link.',
    sendResetLink: 'Send Reset Link',
    passwordResetSent: 'If that email is registered you will receive a reset link.',
    emailServiceUnavailable: 'Email service unavailable. Please try again later.',
    resetPassword: 'Set New Password',
    passwordResetSuccess: 'Password reset successful. You can now log in.',
    passwordResetFailed: 'Invalid or expired reset link. Please request a new one.',
    passwordsDoNotMatch: 'Passwords do not match.',
    backToLogin: 'Back to Login',
    or: 'or',
    subscriptionExpired: 'Your subscription has expired',
    maxFieldsReached: 'Maximum fields reached for your plan',
    maxZonesReached: 'Maximum zones reached for your plan',
    trialDaysRemaining: 'Trial days remaining',

    // KPI Strip
    watering: 'watering',
    stressed: 'stressed',
    needWater: 'Need water',
    weekTotal: 'Week total',
    aiZones: 'Automated zones',
    waterPerWeek: 'Water / Week',

    // Map
    clickToShowZones: 'Click to show zones',
    doubleClickToOpen: 'Double-click to open',
    zoneStatus: 'Field Status',
    locateOnMap: 'Locate on map',
    closePanel: 'Close panel',
    openPanel: 'Open field panel',

    // Test Run
    testRun: 'Test Run',
    testRunInfo: 'Manual test run. Does not affect the advisor schedule.',
    durationMinutes: 'Duration (minutes)',
    starting: 'Starting...',
    startTestRun: 'Start Test Run',

    // Dialog buttons
    creating: 'Creating...',
    saving: 'Saving...',
    stopping: 'Stopping...',
    notes: 'Notes',
    options: 'Options',
    dssOverrideHelp: 'When enabled, the advisor can skip this schedule if conditions don\'t require irrigation',
    permanentlyRemoveZone: 'This will permanently remove the zone and its configuration.',
    permanentlyRemoveSchedule: 'This will permanently remove this schedule.',

    // Zone cards
    withoutBoundary: 'without boundary',
    exceedsFieldArea: 'Exceeds field area',
    noBoundary: 'No boundary',
    zoneCoverage: 'Zone Coverage',
    autoCalculatedFromPolygon: 'Auto-calculated from polygon',
    areaAutoCalc: 'Will auto-calculate from drawn polygon',

    // Zone operations (field detail page)
    soilMoisture30d: 'Soil Moisture · Last 30 Days',
    ndviVegetationHealth: 'Vegetation Health (NDVI)',
    weatherLast14d: 'Weather · Last 14 Days',
    noSensorHistory: 'No sensor history available',
    dssRecentDecisions: 'Recent Advisor Decisions',
    noDssDecisions: 'No advisor decisions yet',
    noDiaryEntries: 'No diary entries yet',
    noSensorData: 'No sensor data',
    config: 'Config',
    fieldDetail: 'Field Detail',
    soilMoisture: 'Soil Moisture',
    soilProfileProbe: 'Soil profile probe',
    profileProbe: 'Profile probe',
    probeStale: 'No recent reading',
    range7d: '7d',
    range30d: '30d',
    range90d: '90d',
    rangeAll: 'All',
    customRange: 'Custom',
    daysSinceIrrigation: 'Last irrigated',
    minShort: 'm',
    upcomingSchedule: 'Upcoming',
    viewAll: 'View all',
    zonesShort: 'z',
    switchToAI: 'Switch to AI',
    switchToManual: 'No Advisor',
    lockField: 'Lock field',
    unlockField: 'Unlock field',
    fieldLocked: 'Field locked',
    fieldUnlocked: 'Field unlocked',
    irrigationRecommended: 'Irrigation Recommended',
    noIrrigationNeeded: 'No irrigation recommendations at this time.',

    // Field Detail - Actions & States
    ok: 'OK',
    marginal: 'Marginal',
    stop: 'Stop',
    stopAll: 'STOP ALL',
    startAll: 'Start All',
    startAllIrrigation: 'Start All Irrigation',
    allIrrigationStarted: 'All irrigations started',
    failedToStartIrrigations: 'Failed to start some irrigations',
    dss: 'Irrigation Advisor',
    dssTab: 'Advisor',
    runDss: 'Refresh advice',
    analyzing: 'Analyzing...',
    runAdvisorForAllDesc: 'Generate irrigation recommendations for all zones based on soil moisture and weather forecast',
    runningDss: 'Analyzing…',
    failedDssTrigger: 'Failed to run analysis',
    dssNoActionNeeded: 'Soil moisture is satisfactory. No irrigation needed.',
    recurrenceOnce: '1×',
    dssApproved: 'AI-approved recommendation',
    recApproved: 'Approved and scheduled',
    recRejected: 'Rejected',
    dssTriggered: 'Analysis complete',
    dssError: 'Advisor failed. Try again.',
    data: 'Data',
    soilSensors: 'Soil & Sensors',
    waterAvailability: 'Water Availability Index',
    pendingRecommendations: 'pending recommendation(s)',
    basedOnSensorData: 'Based on sensor data from',
    noDssRecommendationsZone: 'No advisor recommendations yet for this zone.',
    editZoneConfiguration: 'Edit Zone Configuration',
    fieldStartAllConfirm: 'Start irrigation on all idle zones? Each zone will run for 30 minutes.',
    emergencyStartAllConfirm: 'This will start irrigation on all idle zones across all fields for 30 minutes each. Are you sure?',
    startIrrigation: 'Start Irrigation',
    viewAiRecommendation: 'View AI recommendation',
    startNow: 'Start Now',
    modeNormal: 'Normal',
    modeFertigation: 'Fert.',
    modeFrost: 'Frost',
    planTab: 'Plan',
    completionPercent: 'done',
    actionIrrigate: 'IRRIGATE',
    actionMonitor: 'MONITOR',
    actionSkip: 'SKIP',
    noPrescription: 'No prescription available',
    noPrescriptionHint: 'Sensor data needed to generate recommendations',
    soilResponseTracking: 'Soil Response Tracking',
    vwcBefore: 'Before',
    vwcAfter: 'After',
    vwcChange: 'VWC Change',
    vwcTrend7d: '7-day VWC Trend',
    trendChartUnavailable: 'Trend chart unavailable',
    mmApplied: 'mm Applied',
    responseDelay: 'Response Delay',
    noSoilResponse: 'No soil response data yet',
    noSoilResponseHint: 'Appears after first completed irrigation cycle',
    queued: 'Queued',
    queuePosition: 'Queue',
    zoneQueued: 'Zone queued',
    once: 'Once',
    scheduledDate: 'Date',
    dateRequired: 'Date is required for one-time schedules',
    daily: 'Daily',
    weekly: 'Weekly',
    custom: 'Custom',
    everyNDays: 'Every N days',
    every: 'Every',
    intervalRange: 'Interval must be 1-365 days',
    ndviOverlay: 'Satellite Layer',
    satelliteImagery: 'Satellite Imagery',
    layerSettings: 'Layer Settings',
    ndviNotConfigured: 'Sentinel Hub not configured',
    ndviFetchError: 'Failed to load NDVI data',
    ndviTimeout: 'NDVI data unavailable · satellite connection timed out.',
    ndviNoData: 'No cloud-free satellite images found for this period',
    ndviLoading: 'Loading satellite data…',
    ndviUnavailable: 'Satellite data unavailable',
    noSatelliteDataYet: 'No satellite data yet',
    noImagery: 'No imagery',
    sentinelProvider: 'Sentinel-2',
    viewAllZones: 'View all zones',
    general: 'General',
    yieldMetrics: 'Yield & Water',
    photo: 'Photo',
    layerImagery: 'Imagery',
    layerHealth: 'Health',
    layerNdvi: 'NDVI',
    ndviToggleHint: 'Toggle NDVI satellite overlay',
    cropLabels: 'Crops',
    cropLabelsHint: 'Show crop type beside each field name',
    mapModeSatellite: 'Satellite',
    mapModeHealth: 'Health',
    mapModeNdvi: 'NDVI',
    mapModeCrops: 'Crops',
    cropTypeFilter: 'crop view',
    ndviLegendTitle: 'crop greenness',
    ndviLegendBare: 'bare soil',
    ndviLegendDense: 'dense canopy',
    ndviUnavailableForDate: 'NDVI unavailable for this date',
    tiles: 'tiles',
    typicalValues: 'typical for soil type',
    awaitingFirstReading: 'awaiting first reading',
    ndviZoomInHint: 'Zoom in to see NDVI',
    cropType_kiwi: 'Kiwi',
    cropType_olive: 'Olive',
    cropType_peach: 'Peach',
    cropType_cherry: 'Cherry',
    cropType_grape: 'Grape',
    cropType_apple: 'Apple',
    cropType_pear: 'Pear',
    cropType_apricot: 'Apricot',
    cropType_other: 'Other crop',
    zoneAllGood: 'zone · all good',
    zonesAllGood: 'zones · all good',
    alertSettingsSubtitle: 'Thresholds, quiet hours, and custom rules',
    currentPasswordHint: 'Leave blank to keep your current password',
    currentPasswordRequired: 'Current password is required to change password',
    start: 'Start',
    vegetationIndex: 'Vegetation Index',
    zoneNeedsWater: 'Needs water',
    zonesNeedWater: '{n} zones need water',
    ndviNoBoundary: 'Draw a zone boundary on the map to enable NDVI',
    ndviTryIncreaseCloud: 'Try increasing max cloud cover below',
    maxCloudCover: 'Max cloud cover',
    ndviHealthy: 'Healthy',
    ndviModerate: 'Moderate',
    ndviSparse: 'Sparse',
    ndviStressed: 'Stressed',
    ndviLow: 'Low',
    paintSlots: 'Draw schedule',
    painting: 'Painting',
    stopPainting: 'Stop painting',
    showFullDay: 'Full day',
    farmingHours: 'Farming hours',
    collapseSidebar: 'Collapse',
    expandSidebar: 'Expand',
    layerNdviLabel: 'Vegetation Index',
    layerNdviDesc: 'Color zones by their NDVI value · shows crop greenness',
    labelsName: 'Name',
    labelsArea: 'Area',
    labelsOff: 'Off',
    ruler: 'Measure distance',
    rulerStop: 'Stop measuring',
    segment: 'segment',
    segments: 'segments',
    filter: 'Filter',
    dssAdvisor: 'Irrigation Advisor',
    advancedOptions: 'Advanced options',
    noFieldsYet: 'No fields yet',
    noSchedulesToday: 'Nothing scheduled today',
    adjustBlock: 'Adjust block',
    apply: 'Apply',
    removeBlock: 'Remove block',
    autoApprove: 'Auto-approve',
    approveAll: 'Activate all',
    goToCurrentWeek: 'Go to current week',
    selectFieldToApprove: 'Select a field to approve schedules',
    allSchedulesAlreadyActive: 'All schedules are already active',
    approvedSchedules: 'Approved {count} schedule(s)',
    failedToApprove: 'Could not approve. Try again.',
    approveZoneBusy: 'This zone is already irrigating or waiting its turn. See the schedule.',
    approveControllerDown: 'The controller of this zone is not responding. Check its power and network, then try again.',
    failedToReject: 'Could not reject. Try again.',
    failedToApproveSchedules: 'Failed to approve schedules',
    approve: 'Water it',
    approved: 'Approved',
    pending: 'Needs your OK',
    accepted: 'Approved',
    rejected: 'Rejected',
    modified: 'Modified',
    expired: 'Expired',
    approveModified: 'Approve modified',
    reason: 'Reason',
    confirmReject: 'Confirm reject',
    noPendingRecs: 'No pending recommendations',
    noPendingRecsHint: 'The DSS will create recommendations the next time it runs or when you trigger it manually.',
    recentHistory: 'Recent history',
    recommendedTime: 'Time',
    dssConf: 'conf.',
    dssSourceML: 'Adaptive model',
    dssSourcePhysics: 'Physics rules',
    dssReasonWaiLow: 'Soil moisture below threshold',
    dssReasonForecastHeat: 'High temperature forecast',
    dssReasonDeficitGrowing: 'Water deficit increasing',
    dssReasonKcPeak: 'Peak crop water demand',
    dssReasonStressPrev: 'Preventive · approaching stress',
    dssReasonProdGoal: 'High yield target',
    dssReasonMlModel: 'Adaptive recommendation',
    dssReasonRainSkip: 'Rain forecast · skip irrigation',
    dssReasonHighEt0: 'High evapotranspiration',
    rejectRecentRain: 'Recent rain',
    rejectDiffSchedule: 'Different schedule planned',
    rejectMaintenance: 'System maintenance',
    rejectAlreadyIrr: 'Already irrigated today',
    rejectOther: 'Other',
    resetFilter: 'Reset',
    applyFilter: 'Apply',
    addNote: 'Add note on map',
    reviewDss: 'Review DSS',
    editNote: 'Edit note',
    comment: 'Comment',
    noteType: 'Type',
    failedToDelete: 'Failed to delete. Please try again.',
    noteCommentHint: 'Describe what you observed...',
    clickToPlaceNote: 'Click on the map to place the note',
    noteTypeDisease: 'Disease',
    noteTypePests: 'Pests',
    noteTypeWaterlogging: 'Waterlogging',
    noteTypeFrost: 'Frost damage',
    noteTypeHail: 'Hail damage',
    noteTypeTreeDeath: 'Tree death',
    noteTypeSensorIssue: 'Sensor issue',
    noteTypeOther: 'Other',
    any: 'Any',
    hasStressedZones: 'Has stressed zones',
    allZonesOk: 'All zones OK',
    currentlyIrrigating: 'Currently irrigating',
    notIrrigating: 'Not irrigating',
    layerCropLabel: 'Crop Type',
    layerCropDesc: 'Color fields by crop type',
    layerZoneStateLabel: 'Zone State',
    layerZoneStateDesc: 'Color zones by irrigation health (OK / Marginal / Stressed)',
    opacity: 'Opacity',
    observations: 'obs.',
    range: 'Range',
    cropHealthNdvi: 'Crop Health (Satellite)',
    avgNdvi: 'Vegetation Index',
    satelliteData: 'Satellite data',
    ndviTrend: 'NDVI Trend',
    maxNdvi: 'Max',
    minNdvi: 'Min',
    ndviByZone: 'NDVI by Zone',
    zoneHealthDistribution: 'Zone Health Distribution',
    noData: 'No Data',
    ndviPerZoneTrend: 'NDVI Trend per Zone',
    ndviNoTrendData: 'Not enough data points for trend',
    ndviDataSource: 'Data source: Copernicus Sentinel-2 L2A via Sentinel Hub Statistical API',
    zonesWithData: 'zones with data',
    stopIrrigation: 'Stop Irrigation',
    todaysActivity: "Today's Activity",
    noScheduleToday: 'No irrigation scheduled today',
    sensorsNotConnected: 'Sensors not connected · check device status',
    recommendation: 'Recommendation',
    weeklyWater: 'This week',
    controlMode: 'Control',
    editConfig: 'Config',
    boundary: 'Boundary',
    week: 'week',
    irrigationStarted: 'Irrigation started',
    irrigationStopped: 'Irrigation stopped',
    allIrrigationStopped: 'All irrigations stopped',
    testRunStarted: 'Test run started',
    fieldEmergencyStopConfirm: 'Stop all active irrigations for this field?',
    deleteFieldConfirm: 'The field and its zones are removed from the app and its scheduled irrigations are cancelled. Its history is kept.',
    zoneNeedsIrrigation: 'zone needs irrigation',
    zonesNeedIrrigation: 'zones need attention',
    allZonesHealthy: 'All zones healthy',
    zoneSwitchedToAI: 'Zone switched to automated control',
    zoneSwitchedToManual: 'Zone switched to Manual control',
    failedToStopIrrigations: 'Failed to stop some irrigations',
    showParameters: 'Show parameters',
    hideParameters: 'Hide parameters',
    noSensorDataAvailable: 'No sensor data available',
    showingHistoricalData: 'Showing most recent available data · no readings in selected period.',
    areaStremmaLabel: 'Area (str.)',

    // Weather Widget
    currentConditions: 'Current Conditions',
    todayForecast: 'Today\'s Forecast',
    viewForecast: 'View forecast',

    // Irrigation Page
    activeNow: 'Active Now',
    comingUpToday: 'Coming Up Today',
    completedToday: 'Completed Today',
    planned: 'Planned',
    noIrrigationData: 'No irrigation data yet',
    noPendingIrrigations: 'No pending irrigations for today',
    noIrrigationsToday: 'No irrigations scheduled for today',
    irrigationCreated: 'Irrigation task created successfully',
    started: 'Started',
    failed: 'failed',

    // Weather Page
    rainDetected: 'Rain detected · irrigation schedules may be adjusted by the advisor.',

    // Sensors
    sensorsNetworkManagement: 'Sensors Network Management',
    monitorYourSensors: 'Monitor and manage IoT sensor devices',
    addDevice: 'Add Device',
    realtimeSensorReadings: 'Real-time Sensor Readings',
    activeSensors: 'Active Sensors',
    averageTemperature: 'Average Temperature',
    averageHumidity: 'Average Humidity',
    averageSoilMoisture: 'Average Soil Moisture',
    fieldInsights: 'Field Insights',
    soilMoistureRange: 'Soil Moisture Range',
    totalWaterToday: 'Total Water Today',
    lastIrrigation: 'Last Irrigation',
    sensorDashboard: 'Sensor Dashboard',
    vwcDepth10: 'VWC 10cm',
    vwcDepth20: 'VWC 20cm',
    vwcDepth30: 'VWC 30cm',
    avgVwc: 'Avg VWC',
    airTemperature: 'Air Temperature',
    airHumidity: 'Air humidity',
    zoneReport: 'Report for this zone',
    chillTitle: 'Winter chill',
    chillHours: 'Chill hours (0 to 7.2 °C)',
    chillHoursTip: 'Hours between 0 and 7.2 °C (Weinberger)',
    chillUtah: 'Utah units',
    chillUtahTip: 'Weighted chill units. Warm hours count against them (Richardson)',
    chillPortions: 'Chill portions',
    chillPortionsTip: 'Dynamic model (Fishman & Erez)',
    chillSourceOther: 'Air temperature from the station of {name}',
    report: 'Report',
    soilTemperature: 'Soil Temperature',
    rainfallAndWind: 'Rainfall & Wind',
    rainfall: 'Rainfall',
    precipitation: 'Rainfall',
    windSpeed: 'Wind Speed',
    et0Label: 'ET₀ Today',
    et0Unit: 'mm/day',
    et0Tooltip: 'Reference evapotranspiration · atmospheric demand (Penman-Monteith, FAO-56)',
    last7Days: '7d',
    last30Days: '30d',
    readingsCount: 'Readings',
    importSensorData: 'Import sensor data or wait for live readings',

    // Request Help
    requestHelp: 'Contact Support',
    contactSupport: 'Contact Support',
    contactSupportDesc: 'Choose a category and describe your issue. We\'ll respond promptly.',
    requestHelpDescription: 'Send a message to the TerraMind team for assistance with your fields or irrigation setup.',
    requestHelpPlaceholder: 'Describe what you need help with...',
    bugReportPlaceholder: 'What happened? What did you expect? Browser/device details...',
    helpTypeQuestion: 'Question',
    helpTypeBug: 'Bug Report',
    helpTypeFeature: 'Feature Request',
    helpTypeData: 'Data Issue',
    helpRequestSent: 'Message sent! We\'ll get back to you shortly.',
    helpRequestFailed: 'Failed to send help request',
    sending: 'Sending...',
    send: 'Send',
    message: 'Message',

    // Alerts Page
    alertsAndNotifications: 'Alerts',
    alertsSubtitle: 'System and weather warnings',
    acknowledgeAll: 'Acknowledge All',
    acknowledged: 'Acknowledged',
    acknowledge: 'Acknowledge',
    dismiss: 'Dismiss',
    criticalAlerts: 'Critical, still open',
    highPriority: 'High, still open',
    mediumPriority: 'Medium, still open',
    totalActive: 'Open in total',
    searchAlerts: 'Search alerts...',
    severity: 'Severity',
    allSeverities: 'All Severities',
    critical: 'Critical',
    highSeverity: 'High',
    mediumSeverity: 'Medium',
    lowSeverity: 'Low',
    infoSeverity: 'Info',
    all: 'All',
    noAlertsFound: 'No Alerts Found',
    adjustFilters: 'Try adjusting your filters to see more alerts.',
    allSystemsSmooth: 'All systems are running smoothly. Great job!',
    allClear: 'All Clear',
    allClearHint: 'No active alerts. TerraMind monitors your fields 24/7 and will notify you when action is needed.',
    configureAlertRules: 'Configure Alert Rules',
    alertSettings: 'Alert Settings',
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Receive email alerts for critical and high priority notifications.',
    alertThresholds: 'Alert Thresholds',
    lowMoistureThreshold: 'Low Moisture (%)',
    highTempThreshold: 'High Temp (°C)',
    waiThreshold: 'Soil water level threshold',
    sensorTimeout: 'Sensor Timeout (min)',
    noReadings: 'No readings',
    justNow: 'Just now',
    ago: 'ago',
    updated: 'Updated',
    quietHours: 'Quiet Hours',
    quietHoursDesc: 'Suppress non-critical notifications during specified hours.',
    startTime: 'Start Time',
    endTime: 'End Time',
    alertRules: 'Alert Rules',
    addRule: 'Add Rule',
    noRulesDefined: 'No rules defined yet.',
    ruleName: 'Rule Name',
    sensorType: 'Sensor Type',
    operator: 'Operator',
    saveSettings: 'Save Settings',

    // Alert severity labels
    severity_critical: 'Critical',
    severity_high: 'High',
    severity_medium: 'Medium',
    severity_low: 'Low',

    // Alert rule name labels · backend stores English; frontend localizes by name
    alertRule_lowMoisture: 'Low soil moisture',
    alertRule_highTemp: 'High temperature',
    alertRule_waiThreshold: 'Soil water level below threshold',
    alertRule_sensorTimeout: 'Sensor offline',
    // Alert type values (SENSOR / WEATHER / IRRIGATION / SYSTEM)
    alertTypeValue_sensor: 'Sensor',
    alertTypeValue_weather: 'Weather',
    alertTypeValue_irrigation: 'Irrigation',
    alertTypeValue_system: 'System',
    // Operator labels for alert rules
    operator_lt: 'Less than',
    operator_gt: 'Greater than',
    operator_lte: 'At most',
    operator_gte: 'At least',
    operator_eq: 'Equals',

    // Status labels (irrigation plans / history)
    status_pending: 'Needs your OK',
    status_executing: 'Watering now',
    status_completed: 'Completed',
    status_failed: 'Failed',
    status_cancelled: 'Cancelled',
    status_in_progress: 'In Progress',
    status_assigned: 'Assigned',

    // Weather provider labels
    cachedData: 'Cached data',
    weatherUnavailable: 'Weather unavailable',
    sampleData: 'Sample data',

    // Zone card
    sensorData: 'Sensor data',

    // Analytics / Data Explorer
    dataExplorer: 'Field Data',
    dataExplorerSubtitle: 'Build your own charts from sensor, weather, and irrigation data',
    // Production-use dashboard (DSS adoption + outcome)
    productionTab: 'Production',
    productionUseSubtitle: 'How the irrigation advisor is being used and how it performs',
    followThrough: 'Follow-through',
    recommendationsFollowed: 'recommendations done',
    noRecommendationsYet: 'No recommendations yet',
    waterApplied: 'Water applied',
    rowsExcludedNoData: 'runs excluded (no data)',
    viaCompletedPlans: 'via completed plans',
    faults: 'Faults',
    noFaults: 'No faults',
    executionFaults: 'execution faults',
    noManualComparison: 'No manual data to compare',
    waterDssVsManual: 'Water: advisor vs manual',
    advisorScheduled: 'Advisor-scheduled',
    manualScheduled: 'Manually-scheduled',
    decisionMix: 'Decision mix over time',
    decisionMixSub: 'What the system recommended each day',
    noDecisionsYet: 'No decisions in this period yet',
    waiTrajectory: 'Soil water vs threshold',
    waiTrajectorySub: 'Did soil water stay in the healthy band?',
    waiLabel: 'Soil water (WAI)',
    reasonBreakdown: 'Why the system decided',
    reasonBreakdownSub: 'Top reasons across all decisions',
    recommendedVsActual: 'Recommended vs actual duration',
    recommendedVsActualSub: 'Did irrigation run as long as advised?',
    actual: 'Actual',
    minutesShort: 'min',
    noCompletedPlans: 'No completed irrigations to compare',
    engineMix: 'Decision engine mix',
    engineMixSub: 'Rules vs ML, is the model live?',
    decIrrigate: 'Irrigate',
    decNoIrrigation: 'No irrigation',
    decSuspend: 'Suspend',
    decResume: 'Resume',
    analyticsAndReports: 'Analytics & Reports',
    analyticsSubtitle: 'Water efficiency metrics, trends, and performance insights',
    analyticsSubtitleAdmin: 'System-wide efficiency, sensor diagnostics, and performance trends',
    analyticsSubtitleFarmer: 'Soil health, water usage, crop status, and weather for your fields',
    myFarmInsights: 'My Farm Insights',
    timeRange: 'Time Range',
    thisWeek: 'Last 7 days',
    thisMonth: 'Last 30 days',
    thisQuarter: 'Last 90 days',
    thisYear: 'Last 12 months',
    allData: 'All Data',
    recommended: 'Recommended',
    recommendedCharts: 'Recommended Charts',
    customChart: 'Custom Chart',
    chart: 'chart',
    charts: 'charts',
    export: 'Export',
    totalWaterUsed: 'Total Water Used',
    avgEfficiency: 'Avg Efficiency',
    runsCompletedShare: 'Irrigations completed',
    runsCompletedShareSub: 'of those scheduled',
    waterEstimateFromFlow: 'Estimate from the sprinkler flow',
    costSavings: 'Money Saved',
    et0Average: 'ET₀ Average',
    waterUsage: 'Water Used This Period',
    fieldPerformance: 'How Each Field Is Doing',
    efficiencyTrends: 'Savings Over Time',
    irrigationBreakdown: 'Irrigation Summary',
    waterUsageVsOptimal: 'Water Usage vs Optimal Requirements',
    fieldByFieldPerformance: 'How Each Field Is Doing',
    expectedYield: 'Expected Yield',
    monthlyEfficiencyTrends: 'Monthly Efficiency & Savings Trends',
    irrigationTypeDistribution: 'Irrigation Type Distribution',
    fieldEfficiencyComparison: 'Field Efficiency Comparison',
    waterConservationImpact: 'Water Conservation Impact',
    waterConservationDesc: 'TerraMind helps save water each month through intelligent irrigation decisions based on soil and weather data.',
    waterConservationEquiv: 'Savings depend on field size, crop type, and season.',
    predictionAccuracyDesc: 'WAI predictions are continuously improving, optimizing irrigation timing for your fields.',
    predictionAccuracyDetail: 'Accuracy is based on your sensor readings and irrigation history.',
    cropHealthImprovement: 'Crop Health Improvement',
    cropHealthImprovementDesc: 'Average crop health index improved by 8% compared to last season with optimized watering.',
    cropHealthImprovementDetail: 'Projected yield increase: 10-12% for kiwi harvest.',

    // Sensors Page (additional)
    confirmDeleteDevice: 'Delete Device',
    confirmDeleteDeviceMessage: 'Are you sure you want to delete this device? This action cannot be undone.',
    deviceCreatedSuccessfully: 'Device created successfully',
    deviceUpdatedSuccessfully: 'Device updated successfully',
    deviceDeletedSuccessfully: 'Device deleted successfully',
    failedToCreateDevice: 'Failed to save device',
    failedToDeleteDevice: 'Failed to delete device',
    editDevice: 'Edit Device',
    addNewDevice: 'Add New Device',
    deviceName: 'Device Name',
    deviceLocation: 'Location',
    deviceIdentifier: 'Identifier',
    sensorOnline: 'Online',
    sensorUnconnected: 'Not assigned',
    sensorOffline: 'Offline',
    sensorOfflineSince: 'Sensor offline since',
    sensorDevices: 'Sensors',
    noSensor: 'No sensor',
    clickToFilterByZone: 'Click zone to filter',
    sensorStaleWarning: 'Sensor data is outdated',
    sensorError: 'Error',
    sensorUnknown: 'Unknown',
    noSensorsFound: 'No sensor devices found',
    createFirstSensor: 'Add a sensor device to start collecting data',

    // History Page
    failedToLoadHistory: 'Failed to load history',
    retry: 'Retry',

    // Weather Page
    weatherForecast: 'Weather Forecast',
    weatherHistory: 'Weather History',
    weatherSubtitle: 'Current weather and forecast for irrigation planning',
    weatherFallbackWarning: 'Weather data unavailable · showing sample data',
    weatherConnectionError: 'Weather service unavailable',
    collectingWeatherHistory: 'Gathering weather history…',
    weatherSampleWarning: 'Showing sample data · weather APIs not configured',
    weatherCachedWarning: 'Showing cached data',
    temperature: 'Temperature',
    humidity: 'Humidity',
    forecast: 'Forecast',
    dayForecast: '5-Day Forecast',
    physicsModel: 'Physics',
    mlModel: 'ML Forecast',
    mlFellBackToPhysics: '= Physics',
    mlNotTrained: 'ML model not yet trained. Run: python manage.py train_dss',
    stressIn: 'Stress in',

    // Weekly Schedule (additional)
    failedToLoadSchedules: 'Failed to load schedules',
    failedToUpdateSchedule: 'Failed to update schedule',
    failedToDeleteSchedule: 'Failed to delete schedule',
    editAllFields: 'Edit All...',

    // Language
    language: 'Language',

    // Validation
    fieldRequired: 'Field is required',
    zoneRequired: 'Zone is required',
    selectFieldFirst: 'Select a field first',
    selectFieldFirstPaint: 'Choose a field and zone in the sidebar to enable Add all',
    selectZoneFirstPaint: 'Choose a zone in the sidebar to enable Add all',
    discardNewField: 'Discard new field?',
    discardNewFieldBody: 'The field was created in Step 1 but has no zones yet. Leaving now will delete it. Are you sure?',
    discardAndDelete: 'Discard and delete',
    deleting: 'Deleting…',
    durationRange: 'Duration must be 1-480 minutes',
    doseRange: 'Dose must be 0.1-100 mm',
    deviceNameRequired: 'Device name is required',
    deviceIdentifierRequired: 'Device identifier is required',

    // DSS Intelligence (Admin)
    dssDemo: 'Irrigation Intelligence',
    dssDebugger: 'DSS Algorithm Trace',
    dssDebuggerSubtitle: 'Understand exactly why the algorithm makes each irrigation decision',

    // Admin Analytics KPIs
    adminUsers: 'Users',
    adminCoverage: 'Coverage',
    adminIrrigationActivity: 'Irrigation Activity',
    adminDssPerformance: 'Advisor Performance',
    adminTotalUsers: 'Total Users',
    adminActiveWeek: 'Active This Week',
    adminTrialAccounts: 'Trial Accounts',
    adminPaidAccounts: 'Paid Accounts',
    adminFieldsProduction: 'Production Fields',
    adminZones: 'Irrigation Zones',
    adminSensorsDeployed: 'Sensors Deployed',
    adminSensorHealth: 'Sensor Health',
    adminEventsToday: 'Events Today',
    adminEventsWeek: 'Events This Week',
    adminExecuting: 'Currently Irrigating',
    adminDssAcceptRate: 'Advisor Acceptance Rate',
    adminRecsGenerated: 'Recommendations Generated',
    adminRecsAccepted: 'Accepted',
    adminRecsRejected: 'Rejected',
    adminRecsPending: 'Pending',
    adminSensorReporting: 'Sensor Reporting Health',
    adminCompletedIrrigations: 'Completed Irrigations: Last 8 Weeks',
    adminPlatformDesc: 'Platform health, user activity, and operational KPIs',
    adminLast30Days: 'Last 30 days',
    adminPlanDistribution: 'Plan Distribution',
    failedToLoadAnalytics: 'Failed to load analytics. Try refreshing.',
    adminDataFreshness: 'Data Freshness',
    adminWeatherData: 'Weather Data',
    adminNdviScene: 'NDVI Satellite Scene',
    adminSensorReadings: 'Sensor Readings',
    adminLive: 'Live',
    adminNoData: 'No data',
    adminNoRecentData: 'No recent data',
    adminDaysAgo: 'd ago',

    // Operations per field (admin analytics, staff only)
    opsTitle: 'Operations per field',
    opsDays: 'days',
    opsGrowersActive: 'Growers who used the app',
    opsFieldsStale: 'Probes without new readings',
    opsFieldsWithCall: 'Fields with a recommendation',
    opsRuns: 'Irrigation runs',
    opsFollowed: 'After a recommendation',
    opsFollowedShort: 'after a recommendation',
    opsBoard: 'Confirmed by the controller',
    opsFelt: 'Felt by the probe',
    opsOutside: 'Waterings outside the app',
    opsAlerts: 'Open equipment alerts',
    opsCall: 'Recommendation',
    opsNoProbe: 'No probe',
    opsNever: 'Never',
    opsHoursAgo: 'h ago',
    opsNoCall: 'No recommendation',
    opsCallNone: 'Not now',
    opsMinutes: 'min',
    opsSearch: 'Search grower or field',
    opsOnlyIssues: 'Only fields that need a look',
    opsUse: 'Use of the app',
    opsActiveDays: 'Days used',
    opsUseMinutes: 'Minutes',
    opsLastSeen: 'Last used',
    opsDevices: 'Signed-in devices',
    opsUseNote: 'Use counts every visit with the grower\'s login, our own checks included.',

    // User Management (Admin)
    userManagement: 'User Management',
    systemAnalytics: 'Analytics',
    addUser: 'Add User',
    user: 'User',
    allUsers: 'All users',
    viewFields: 'View Fields',
    allPlans: 'All plans',
    noUsersFound: 'No users match the current filter.',
    discardZoneChanges: 'You have unsaved zone changes. Discard them?',
    subscriptionExpiry: 'Subscription expiry date',
    subscriptionExpiryHelp: 'Leave blank to keep current expiry',
    myRequests: 'My Requests',
    myRequestsDesc: 'Your submitted requests and replies from the TerraMind team.',
    replyFromTeam: 'Reply from TerraMind',
    awaiting: 'Awaiting reply',
    read: 'Read',
    recurrenceWeekly: 'Every week (recurring)',
    subscriptionPlan: 'Subscription Plan',
    planTrial: 'Free Trial (30 days)',
    planBasic: 'Basic',
    planPro: 'Pro',
    planEnterprise: 'Enterprise',
    editUser: 'Edit User',
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    failedToLoadUsers: 'Failed to load users',
    usernamePasswordRequired: 'Username and password are required',
    firstName: 'First Name',
    lastName: 'Last Name',
    newPassword: 'New Password',
    owner: 'Owner',
    role: 'Role',
    email: 'Email',
    fieldCount: 'Fields',
    farmer: 'Farmer',
    admin: 'Admin',
    lastLogin: 'Last Login',
    dateJoined: 'Joined',
    neverLoggedIn: 'Never logged in',

    // Schedule multi-day
    selectDays: 'Select days',
    selectAtLeastOneDay: 'Select at least one day',

    // Weather warnings
    weatherCacheWarning: 'Weather APIs unavailable · showing cached data from database',

    // History
    yesterday: 'Yesterday',

    // Schedule drag-and-drop
    dragToCreate: 'Drag to select · Click blocks to edit · Drag blocks to move',
    paintToSelect: 'Paint slots to select · Click blocks to edit · Drag blocks to move',
    quickIrrigation: 'Quick Irrigation',
    dragToMove: 'Drag blocks to reschedule',
    movedSchedule: 'Schedule moved',
    timezone: 'Timezone',

    // Alerts page
    alertType: 'Type',
    allTypes: 'All Types',
    allStatuses: 'All Statuses',
    resolved: 'Resolved',
    failedToLoadAlerts: 'Failed to load alerts',
    sensorValue: 'Value',
    threshold: 'threshold',

    // Misc
    allIrrigationsStopped: 'All irrigations stopped',
    seasonAlreadyExists: 'Season already exists for this year',
    seasonAlreadyExistsAll: 'Season already exists for all fields',
    seasonCreated: 'Season created successfully',
    seasonCreateFailed: 'Failed to create season',
    alreadyExisted: 'already existed',
    created: 'created',
    sensor: 'Sensor',
    weatherApi: 'Weather API',
    otherZones: 'Other zones',
    groupBy: 'Group',
    crop: 'Crop',
    forecastAware: 'Forecast-aware',
    compareModels: 'Compare models',
    nextEvent: 'Next',
    unavailable: 'Unavailable',
    allYears: 'All years',
    local: 'Local',
    et0MeteoblueHint: 'Reference evapotranspiration from Meteoblue agromodeling (Penman-Monteith with full hourly atmosphere)',
    et0LocalHint: 'Local FAO-56 approximation from temp / humidity / wind',
    forecastMissingInputs: 'Forecast unavailable · missing sensor / weather inputs',
    missingFields: 'Missing',
    somethingWentWrong: 'Something went wrong',
    tryAgain: 'Try again',
    today: 'Today',
    todaysSchedule: "Today's Schedule",
    noSchedulesFound: 'No upcoming',
    more: 'more',
    min: 'min',
    merged: 'merged',
    on: 'ON',
    off: 'OFF',
    unknown: 'Unknown',
    sprinklersShort: 'spr.',
    cancelQueue: 'Cancel',
    allZonesBusy: 'All zones are active',
    noActiveIrrigations: 'No active irrigations',
    failedToLoadData: 'Failed to load data. Check that the backend is running.',

    // Decision types (History page)
    allDecisions: 'All Decisions',
    irrigate: 'Irrigate',
    noIrrigation: 'No Irrigation',
    suspend: 'Suspend',
    resume: 'Resume',
    plansEmptySubtitle: 'Plans will appear here as the advisor generates irrigation decisions.',

    // Dashboard attention
    zoneNeedsAttention: 'zone needs attention',
    needsIrrigationDose: 'Needs',

    // Sensors
    failedToLoadSensors: 'Failed to load sensor data',
    statusOnline: 'online',
    statusOk: 'ok',
    unknownDevice: 'Unknown Device',

    // Weather
    cached: 'Cached',
    kmh: 'km/h',

    // History
    minActual: 'min actual',

    // Analytics chart labels
    irrigationType_dss: 'Advisor',
    irrigationType_manual: 'Manual',
    irrigationType_weeklySchedule: 'Schedule',

    // Validation messages
    durationRequired: 'Duration is required',
    waterAmountRequired: 'Water amount is required',
    durationInvalid: 'Duration must be a valid number',
    durationTooShort: 'Duration must be at least 1 minute',
    durationTooLong: 'Duration cannot exceed 240 minutes (4 hours)',
    waterAmountInvalid: 'Water amount must be a valid number',
    waterAmountNegative: 'Water amount cannot be negative',
    waterAmountMax: 'Water amount cannot exceed 100,000 liters',
    fieldNameRequired: 'Field name is required',
    fieldNameTooLong: 'Field name cannot exceed 100 characters',
    areaInvalid: 'Area must be a valid number',
    areaMin: 'Area must be greater than 0',
    areaMax: 'One field can be at most 500 str. Split a larger area into several fields.',

    // Day names
    monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday',
    thursday: 'Thursday', friday: 'Friday', saturday: 'Saturday', sunday: 'Sunday',
    mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun',

    // Schedule form labels
    fieldAndZone: 'Field & Zone',
    irrigationMode: 'Irrigation Mode',
    recurrence: 'Recurrence',
    timing: 'Timing',
    moreOptions: 'More Options',
    editDetails: 'Edit Details',
    smartSkip: 'Smart Skip',
    smartSkipHelp: 'Advisor can skip this schedule if soil moisture is sufficient',
    unsavedChanges: 'Unsaved changes',
    discardChanges: 'You have unsaved changes. Discard them?',
    keepEditing: 'Keep editing',
    discard: 'Discard',
    restoreDraft: 'Restore',
    draftFoundHint: 'You have an unsaved draft for this field.',
    supportInbox: 'Inbox',
    supportInboxSubtitle: 'Messages from farmers',
    noMessages: 'No messages yet',
    markUnread: 'Mark unread',
    connectedOnly: 'Connected only',
    noSearchResults: 'No results',
    searchMessages: 'Search messages...',
    subject: 'Subject',
    unread: 'Unread',
    replied: 'Replied',
    selectMessageToRead: 'Select a message to read it',
    allMessages: 'All',
    typeReplyHere: 'Type your reply…',
    sendReply: 'Send Reply',
    replySent: 'Reply sent',
    yourReply: 'Your reply',
    failedToLoadMessages: 'Failed to load messages',
    failedToSendReply: 'Failed to send reply',
    scheduleUpdated: 'Schedule updated',
    scheduleDeleted: 'Schedule deleted',
    schedulesCreated: 'schedules created',
    calendarHint: 'Click blocks to edit · Drag to move',
    paintCalendarHint: 'Paint to select slots · Then create schedule',
    analyzingFields: 'Analyzing all fields...',
    dssRecommendations: 'What to do today',
    dssRecommendationsInfo: 'These zones need irrigation. Select which to schedule for today.',
    dssRecentRecommendations: 'Advisor Recommendations',
    viewInSchedule: 'View in Schedule',
    viewAnalytics: 'View Analytics',
    accept: 'Accept',
    reject: 'Skip today',
    reasonWaiLow: 'Low Moisture',
    reasonSoilAdequate: 'Moisture OK',
    reasonForecastHeat: 'Heat Forecast',
    reasonDeficitGrowing: 'Deficit Growing',
    reasonKcPeak: 'Peak Demand',
    reasonStressPrevention: 'Stress Prevention',
    reasonProductionGoal: 'Yield Target',
    reasonMlModel: 'ML Model',
    viewFieldOnMapFromAlert: 'View Field',
    scheduleSelected: 'Schedule',
    scheduling: 'Scheduling...',
    selected: 'selected',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',

    // Alert type labels
    alertTypeIrrigation: 'Irrigation',
    alertTypeSensor: 'Sensor',
    alertTypeWeather: 'Weather',
    alertTypeSystem: 'System',

    // Alert status labels
    alertStatus_active: 'Active',
    alertStatus_acknowledged: 'Acknowledged',
    alertStatus_resolved: 'Resolved',

    // Provider labels
    providerManual: 'Manual',
    providerEdge: 'Edge Controller',
    providerHunter: 'Hunter X2',
    providerHydrawise: 'Hydrawise',

    // User management errors
    failedToSaveUser: 'Failed to save user',
    failedToUpdateUserStatus: 'Failed to update user status',
    cannotDeactivateSelf: 'Cannot deactivate your own account',

    // Analytics chart labels
    leafHumidity: 'Leaf Humidity',
    leafTemperature: 'Leaf Temperature',
    leafWetness: 'Leaf Wetness',
    soilSalinity: 'Soil Salinity',
    solarRadiation: 'Solar Radiation',
    et0Chart: 'Reference Evapotranspiration ET₀',
    atmosphericConditions: 'Atmospheric Conditions',
    atmosphericPressure: 'Atmospheric Pressure',
    uvIndex: 'UV Index',
    solarPanelVoltage: 'Sensor Hub Battery',
    noAtmosphericData: 'No atmospheric data available for this period',
    category: 'Category',
    allCategories: 'All',
    lineChart: 'Line',
    areaChart: 'Area',
    barChart: 'Bar',
    selectMetrics: 'Select one or more metrics above to visualize',
    metricsSelected: 'metrics selected',
    clearSelection: 'Clear all',
    energy: 'Energy & Radiation',
    temperatureHistory: 'Temperature History',
    maxTemp: 'Max',
    minTemp: 'Min',
    avgTemp: 'Average',
    totalUsage: 'Total',
    manual: 'Manual',
    noWaterData: 'No water usage data for this period',
    noFieldData: 'No field data available',
    noTrendData: 'No trend data available',
    noBreakdownData: 'No irrigation data',
    noLeafData: 'No leaf sensor data available for this period',
    noWeatherData: 'No weather history data available',
    dssVsManual: 'Advisor vs manual irrigation',
    avgWaiAllZones: 'Avg WAI across zones',
    fromWeatherData: 'From weather data',
    vsPreviousPeriod: 'vs previous period',
    periodAverage: 'Period average',
    periodTotal: 'Period total',
    soilTemp10: 'Soil 10cm',
    soilTemp20: 'Soil 20cm',
    soilTemp30: 'Soil 30cm',
    salinity10: 'Salinity 10cm',
    salinity20: 'Salinity 20cm',
    salinity30: 'Salinity 30cm',
    weeklyWaterUsage: 'Water Used · Smart vs Manual',
    fieldStatus: 'Field Status',
    customizeWidgets: 'Customize',
    chooseWidgets: 'Choose what to show',
    resetDefaults: 'Reset to defaults',
    insightsWidgets: 'Insights',
    leafAndEnvironment: 'Leaf & Environment',
    noWidgetsSelected: 'No widgets selected. Click "Customize" to choose what to display.',
    viewFieldOnMap: 'View on Map',
    backToField: 'Back to Field',

    // ── Competitive Features (20 features) ──────────────────────
    // Morning Prescription
    morningPrescription: 'Morning Prescription',
    prescriptionSummary: 'zones need water today',
    skipZone: 'Skip',
    irrigateZone: 'Irrigate',
    monitorZone: 'Monitor',
    startRecommended: 'Start Recommended',
    rainExpected: 'Rain expected',
    frostRisk: 'Frost risk',

    // Operational KPIs
    operationalKpis: 'Operational KPIs',
    litersToday: 'Liters Today',
    percentComplete: 'Complete',
    nextScheduled: 'Next',
    running: 'Running',

    // 72h Timeline
    timeline72h: '72h Timeline',
    past24h: 'Past 24h',
    next48h: 'Next 48h',
    nowMarker: 'Now',

    // Soil Cross-Section
    soilCrossSection: 'Soil Cross-Section',
    deepSoil: 'Deep soil',
    surfaceSoil: 'Surface',
    rootZone: 'Root zone',
    confidence: 'Confidence',
    depthProfile: 'Depth Profile',
    trendUp: 'Rising',
    trendDown: 'Falling',
    trendStable: 'Stable',

    // Spray Window
    sprayWindow: 'Spray Windows',
    sprayWindowAdvisory: 'Spray Window Advisory',
    excellent: 'Excellent',
    fair: 'Fair',
    poor: 'Poor',
    noWindowAvailable: 'No suitable spray window available',

    // Disease Risk
    diseaseRisk: 'Disease Risk',
    psaRisk: 'PSA Risk',
    lowRisk: 'Low',
    mediumRisk: 'Medium',
    highRisk: 'High',
    criticalRisk: 'Critical',
    copperSpray: 'Apply copper spray within 48h',
    leafWetnessHours: 'Leaf wetness',

    // DSS Insights Widget
    dssInsights: 'Advisor Insights',
    dssInsightsDesc: 'Detailed analysis of advisor behavior and irrigation decisions',
    dssReasonDistribution: 'Advisor Decision Distribution',
    dssReasonDistributionDesc: 'How the advisor classified each irrigation decision',
    rainSkipAnalysis: 'Rain-Skip Analysis',
    rainSkipAnalysisDesc: 'Days where the advisor detected rainfall and recommended skipping irrigation',
    noRainSkipsFound: 'No rain-skip events found in the analysis period',
    totalSaved: 'total saved',
    monthlyComparisonMatrix: 'Monthly Comparison',
    monthlyComparisonDesc: 'Farmer vs Advisor irrigation days per month with agreement rate',
    agreementDays: 'Agreement',
    savedDays: 'Saved Days',
    topReason: 'Top reason',
    potentialSavings: 'Potential savings',
    depthTimeline: 'Soil Moisture Depth Profile',
    depthTimelineDesc: 'Volumetric water content at 3 depths with irrigation and rainfall overlay',
    irrigationEvent: 'Irrigation (min)',
    decisions: 'Decisions',
    days: 'days',
    reason_WAI_LOW: 'Low WAI',
    reason_FORECAST_HEAT: 'Heat Forecast',
    reason_DEFICIT_GROWING: 'Growing Deficit',
    reason_KC_PEAK: 'Kc Peak',
    reason_STRESS_PREVENTION: 'Stress Prevention',
    reason_PRODUCTION_GOAL: 'Production Goal',
    reason_ML_MODEL: 'ML Model',
    reason_RAIN_SKIP: 'Rain Skip',
    reason_HIGH_ET0: 'High ET0',
    reason_SOIL_ADEQUATE: 'Soil Adequate',
    reason_NO_STRESS: 'No Stress',

    // Water Budget
    waterBudget: 'Water Budget',
    historicalComparison: 'Farmer vs Advisor',
    requestDss: 'Get Recommendations',
    refreshRecommendations: 'Refresh recommendations',
    scheduleHintPaint: 'Paint time slots on the calendar to schedule irrigation, or approve a recommendation below.',
    dssAccepted: 'Advisor recommendation accepted',
    dssRejected: 'Advisor recommendation rejected',
    dssModified: 'Advisor recommendation modified & accepted',
    noDssRecommendations: 'Advisor: No irrigation needed this week',
    dssRecsCreated: '{count} recommendations ready for {field}',
    failedDssRecommend: 'Failed to get advisor recommendations',
    clickPocketToEdit: 'Click the painted block to configure',
    smartSkipEnabled: 'Smart Skip enabled',
    allZonesFilter: 'All Zones',
    allocated: 'Allocated',
    used: 'Used',
    remaining: 'Remaining',
    budgetUtilization: 'Budget Utilization',

    // Farm Diary
    farmDiary: 'Farm Diary',
    mapObservations: 'Map observations',
    farmDiarySubtitle: 'Track field activities, scouting observations, and farm operations',
    entriesThisMonth: 'entries this month',
    entry: 'entry',
    entries: 'entries',
    byDate: 'By Date',
    byYear: 'By Year',
    byCrop: 'By Crop',
    byField: 'By Field',
    highImpact: 'high impact',
    addEntry: 'Add Entry',
    pruning: 'Pruning',
    harvest: 'Harvest',
    spray: 'Spray',
    scouting: 'Scouting',
    frostProtection: 'Frost Protection',
    fertilization: 'Fertilization',
    other: 'Other',
    eventType: 'Event Type',
    addObservation: 'Add Observation',
    noFarmEvents: 'No farm diary entries yet',
    eventCreated: 'Entry added',
    eventDeleted: 'Entry deleted',
    photos: 'Photos',
    addPhoto: 'Add',
    maxPhotos: 'Maximum 6 photos per entry',
    uploading: 'Uploading...',
    failedToRemovePhoto: 'Failed to remove photo',
    photosFailedUpload: '{count} photo(s) failed to upload: {files}',

    // Phenology
    phenology: 'Phenology',
    growthStage: 'Growth Stage',
    gdd: 'GDD (Growing Degree Days)',
    phenologicalStage: 'Growth Stage',
    dormancy: 'Dormancy',
    budBreak: 'Bud Break',
    shootGrowth: 'Shoot Growth',
    flowering: 'Flowering',
    fruitSet: 'Fruit Set',
    fruitDevelopment: 'Fruit Development',
    fruitRipening: 'Fruit Ripening',
    fruitGrowth: 'Fruit Growth',
    harvestStage: 'Harvest',
    postHarvest: 'Post-Harvest',
    senescence: 'Senescence',
    daysToNextStage: 'Days to next stage',

    // Hydraulic Schematic
    hydraulicSchematic: 'Hydraulic Schematic',
    pumpLimit: 'Pump Limit',
    mainPipe: 'Main Pipe',
    valveStatus: 'Valve Status',
    borehole: 'Borehole / Pump',
    idle: 'Idle',
    executing: 'Executing',

    // Fertigation
    ecTarget: 'EC Target (mS/cm)',
    phTarget: 'pH Target',
    nutrientRecipe: 'Nutrient Recipe',
    npkPreset: 'N-P-K Preset',
    customRecipe: 'Custom',

    // Fruit Sizing
    fruitSizing: 'Fruit Sizing',
    currentWeight: 'Current Weight',
    harvestEstimate: 'Harvest Estimate',
    growthRate: 'Growth Rate',
    gradeA: 'Grade A',
    gradeB: 'Grade B',
    gradeC: 'Grade C',
    gPerDay: 'g/day',

    // OPEKEPE
    opekepeExport: 'OPEKEPE Report',
    generateReport: 'Generate Report',
    exportCsv: 'Export CSV',
    downloadCsv: 'Download CSV',

    // Summary section
    cooperativeView: 'Overview',
    allFarms: 'All Farms',
    farmOwner: 'Owner',
    zonesNeedingWater: 'Zones Needing Water',

    // Sparklines
    sparkline: 'Sparkline',
    vwcTrend: 'VWC Trend',

    // Recommendation Rationale
    rationale: 'Rationale',
    refillThreshold: 'Refill Threshold',
    etForecast: 'ET Forecast',



    // Schedule summary
    activeSchedules: 'Active',
    nextRun: 'Next Run',
    weeklyTotal: 'Weekly Total',

    // History page KPIs
    totalPlans: 'Total Plans',
    completedPlans: 'Completed',
    totalWater: 'Water Used',
    avgDuration: 'Avg Duration',

    // Weather page
    forecastUnavailable: 'Forecast unavailable · showing latest readings',
    weatherNoDataTitle: 'No weather data available',
    weatherEmptyHint: 'Configure a weather API key (Meteoblue or OpenWeatherMap) or run the seed command to populate sample data.',
    weatherApisTempUnavailable: 'Weather APIs temporarily unavailable',

    // Missing keys used in components
    failedToDeleteField: 'Failed to delete field',
    failedToDeleteZone: 'Failed to delete zone',
    failedToLoadField: 'Failed to load field details',
    search: 'Search',
    settingsSaved: 'Settings saved successfully',
    savedAt: 'Saved at',
    date: 'Date',
    wind: 'Wind',
    environment: 'Environment',
    selectField: 'Field',
    noFields: 'No fields yet',
    users: 'Users',
    total: 'Total',
    loadingMap: 'Loading map...',
    noDataAvailable: 'No data available',
    loading: 'Loading',
    failedToLoadDiary: 'Failed to load diary entries',
    failedToSaveEntry: 'Failed to save entry',
    failedToDeleteEntry: 'Failed to delete entry',
    farmDiaryDescription: 'Record farm activities like fertilization, pruning, scouting, and harvest to keep a detailed log of your field operations.',
    addFirstEntry: 'Record First Activity',
    confirmDeleteEntry: 'Are you sure you want to delete this diary entry?',
    editEntry: 'Edit Diary Entry',
    addEntryDescription: 'Record a farm activity for your fields',
    notesPlaceholder: 'What did you observe or do?',
    none: 'None',
    addYourFields: 'Add your fields',
    addFieldsHint: 'Draw your field boundaries on the map to get started.',
    addFields: 'Add fields',
    fieldsAnalyzed: 'Analyzed',
    fieldsNotAnalyzed: 'Fields not analyzed',
    sortByName: 'Name (A→Z)',
    sortByNameDesc: 'Name (Z→A)',
    sortByArea: 'Area (largest first)',
    sortByAreaAsc: 'Area (smallest first)',
    sortByStatus: 'Status (stressed first)',
    sortByAttention: 'Needs attention first',
    sortByMoisture: 'Driest first',
    noFieldsMatchFilter: 'No fields match the current filter.',
    recommendationActionFailed: 'That did not go through. Nothing was scheduled. Try again.',
    hardwareTabCoverage: 'Coverage',
    // Valve controllers (Hardware > Controllers). A board can drive valves on
    // several farms, so every row names the farm, not just a relay number.
    edgePageTitle: 'Valve controllers',
    edgePageSubtitle: 'The boards that open and close the valves, their live status, and manual control',
    edgeStateOnline: 'Online',
    edgeStateOffline: 'Offline',
    edgeStateNeverSeen: 'Never connected',
    edgeHeartbeat: 'Last signal',
    edgeNoHeartbeat: 'No signal yet',
    edgeFirmware: 'Firmware',
    edgeFirmwareUnknown: 'Firmware unknown',
    edgeUptime: 'running {m} min',
    edgeAgeSeconds: '{s} sec ago',
    edgeAgeMinutes: '{m} min ago',
    edgeAgeHours: '{h} h ago',
    edgeMinutesLeft: '{m} min left',
    edgeMinutes: '{m} min',
    edgeNoFieldsServed: 'No valve wired to a field yet',
    edgeNoValvesWired: 'No valve on this controller is wired to a zone yet.',
    edgeStatusUnreachable: 'Could not read the controller status.',
    edgeListFailed: 'Could not load the controllers.',
    edgeColValve: 'Valve',
    edgeColLocation: 'Field and zone',
    edgeColIrrigate: 'Irrigation (the farmer sees this)',
    edgeColTest: 'Test',
    edgeValveNumber: 'Valve {n}',
    edgeValveUnwired: 'Not wired',
    edgeRelayTooltip: 'Relay {n} on the board',
    edgeZoneLabel: 'Zone {n}',
    edgeIrrigatingNow: 'Watering',
    edgeQueued: 'Waiting its turn',
    edgeStart: 'Start',
    edgeStop: 'Stop',
    edgeTest5s: 'Test 5s',
    edgeDeviceOffline: 'The controller is offline',
    edgeStartTooltip: 'Water for {m} minutes. The farmer sees it.',
    edgeTestTooltip: 'Open the valve for 5 seconds to check the wiring. The farmer is not notified.',
    edgeStartNote: 'waters the zone and appears in the farmer’s schedule and history.',
    edgeTestNote: 'opens the valve for 5 seconds to check the wiring. Admin only.',
    edgeAddButton: 'Add controller',
    edgeAddTitle: 'Register a valve controller',
    edgeAddDeviceId: 'Controller ID',
    edgeAddField: 'Field',
    edgeAddToken: 'Token (leave blank to generate one)',
    edgeAddTokenPlaceholder: 'Paste an existing token or leave blank',
    edgeAddTokenOnce: 'Controller registered. Copy this token into the firmware now, it is shown only once.',
    edgeAddMissingFields: 'The controller ID and the field are both needed.',
    edgeAddFailed: 'The controller was not registered.',
    edgeAddSubmit: 'Register',
    edgeAddCancel: 'Cancel',
    edgeAddDone: 'Done',
    edgeNoDevices: 'No valve controller registered yet.',
    coverageIntro: 'What the platform can do with each field today. Monitoring needs a sensor that is reporting. Control needs a valve controller that is answering. A field can have one without the other.',
    coverageMonitoring: 'Monitoring',
    coverageControl: 'Control',
    coverageTotalFields: 'Fields',
    coverageMonitored: 'Reporting',
    coverageControllable: 'Can irrigate',
    coverageBoth: 'Both',
    coverageMon_live: 'Reporting',
    coverageMon_stale: 'Last reading is old',
    coverageMon_silent: 'No reading yet',
    coverageMon_none: 'No sensor',
    coverageCtl_ready: 'Valve ready',
    coverageCtl_offline: 'Controller not answering',
    coverageCtl_none: 'No valve',
    coverageLoadFailed: 'Could not load the hardware picture. Try again.',
    coverageStaleNote: 'A reading older than {hours} hours counts as old.',
    gapNoSensor: 'No sensor on this field, so the advisor cannot tell you when to water it.',
    coverageAddSensor: 'Add a sensor',
    probeFromField: 'From the sensor of {field}',
    sensorIssueStuck: 'The {cm} cm sensor has shown the same value for a day: it is left out of the recommendation.',
    sensorIssueRange: 'The {cm} cm sensor shows an impossible value: it is left out of the recommendation.',
    sensorIssueStuckEstimated: 'The {cm} cm sensor has shown the same value for a day: the recommendation estimates it from the {ref} cm sensor.',
    sensorIssueRangeEstimated: 'The {cm} cm sensor shows an impossible value: the recommendation estimates it from the {ref} cm sensor.',
    sensorEstimatedValue: 'estimate',
    coverageUseProbeOf: 'Use the sensor of another field',
    coverageProbeSourceHelp: 'Only for a field of the same grower, same soil and crop, watered together with it. It shows the recommendation of that field, without minutes or alerts of its own.',
    coverageProbeSourceNone: 'Its own sensors',
    coverageProbeFrom: 'Reads the sensor of {field}',
    coverageAddController: 'Add a controller',
    coverageSetupFor: 'Equipment of {name}',
    userEquipment: 'Equipment',
    gapSensorStale: 'The sensor has stopped sending. Check the station or the gateway.',
    gapSensorSilent: 'A sensor is assigned but has never sent a reading. Check the gateway.',
    gapNoController: 'No valve controller here, so Start records the irrigation without opening anything.',
    gapControllerOffline: 'The controller has not been heard from recently. A valve may not open.',
    gapZonesWithoutValve: 'Zones with no valve wired',
    metric_moisture: 'soil moisture',
    metric_tension: 'soil tension',
    metric_weather: 'weather',
    controllerOnline: 'answering',
    controllerOffline: 'not answering',
    relay: 'relay',
    irrigateDurationNotDerived: 'Irrigate now',
    irrigateDurationNotDerivedWhy: 'This field measures soil tension, not moisture, so there is no water deficit to size a duration from. The advisor says water is needed and leaves the length to you.',
    sensorNoneOnZone: 'No sensor is assigned to this zone, so there are no soil readings to show.',
    sensorSilent: 'A sensor is assigned to this zone but has not sent any reading yet.',
    sensorStale: 'The last reading is older than a day.',
    assignSensor: 'Assign a sensor',
    hoursShort: 'h',
    collapse: 'Collapse',
    expand: 'Expand',
    advisor: 'Irrigation Advisor',
    profile: 'Profile',
    agreementRate: 'Agreement Rate',
    waterSavings: 'Potential Water Savings',
    farmerDays: 'Farmer Irrigated Days',
    dssDays: 'Advisor Recommended Days',
    irrigationTimeline: 'Irrigation Timeline',
    monthlyBreakdown: 'Monthly Breakdown',
    confusionMatrix: 'Decision Agreement Matrix',
    matrixDssIrrigate: 'Advisor: Irrigate',
    matrixDssSkip: 'Advisor: Skip',
    matrixFarmerIrrigated: 'Farmer: Irrigated',
    matrixFarmerSkipped: 'Farmer: Skipped',
    matrixBothAgree: 'Both Agree',
    matrixFarmerOnly: 'Farmer Only',
    matrixDssOnly: 'Advisor Only',
    matrixBothSkip: 'Both Skip',
    waterSavedM3: 'Water Saved',
    waterSavedSubtext: 'if advisor was used instead of manual irrigation',
    efficiencyPerStremma: 'Efficiency per Stremma',
    farmerM3Str: 'Farmer',
    dssM3Str: 'Advisor',
    reductionLabel: 'reduction',
    weatherOverlay: 'Weather Overlay',
    whatWouldHaveChanged: 'What Would Have Changed?',
    savedWater: 'Saved Water',
    earlyDetection: 'Early Detection',
    showMore: 'Show More',
    showLess: 'Show Less',
    noWhatIfData: 'No divergence scenarios found.',
    scheduled: 'Scheduled',
    completed: 'Completed',
    cancelled: 'Cancelled',

    // Keys that existed in EL only · adding EN counterparts
    sensorsStatus: 'Sensor Status',
    deviceType: 'Device Type',
    failedToUpdateDevice: 'Failed to update device',
    lastReading: 'Last Reading',
    soilTension: 'Soil tension',
    soilTensionHint: 'low = wet',
    batteryLevel: 'Battery Level',
    online: 'Online',
    offline: 'Offline',
    loadingSensors: 'Loading Sensors...',
    irrigationManagement: 'Irrigation Management',
    monitorAndControl: 'Monitor and control your irrigation system',
    scheduleIrrigation: 'Schedule Irrigation',
    activeSystems: 'Active Systems',
    waterDelivered: 'Water Delivered',
    nextSchedule: 'Next Schedule',
    activeZones: 'Active Zones',
    waterUsageMetrics: 'Water Usage Metrics',
    totalWaterDelivered: 'Total Water Delivered',
    averageWaterPerCycle: 'Average Water Per Cycle',
    systemUptime: 'System Uptime',
    createFirstSchedule: 'Create your first irrigation schedule to automate watering',
    scheduleName: 'Schedule Name',
    waterQuantity: 'Water Quantity (liters)',
    loadingIrrigation: 'Loading Irrigation Data...',
    failedToLoadIrrigation: 'Failed to load irrigation schedules',
    currentWeather: 'Current Weather',
    conditions: 'Conditions',
    tomorrow: 'Tomorrow',
    nextFiveDays: 'Next 5 Days',
    mph: 'km/h',
    mm: 'mm',
    loadingWeather: 'Loading Weather Data...',
    failedToLoadWeather: 'Failed to load weather data',
    weatherData: 'Weather Data',
    weatherUpdated: 'Weather data updated',

    // Additional missing keys (second pass)
    failedToLoadRecommendations: 'Failed to load advisor recommendations',
    failedToCreateSchedules: 'Failed to create schedules from recommendations',
    newSchedule: 'New schedule',
    d: 'd',
    addAllDays: 'Add all days',
    addAllBlocks: 'Add all',
    clickBlockForDay: 'Click a block to configure, or use "Add" for batch',
    clickEachBlockToConfigure: 'Click each block to configure it individually',
    unassigned: 'Unassigned',
    sensorDeviceManagement: 'Sensor Devices',
    manageSensorDevices: 'Manage your IoT sensor devices and hubs',
    sensorHub: 'Sensor Hub',
    noHub: 'No Hub',
    sensorFieldSection: 'Field this sensor measures',
    sensorFieldSectionHelp: 'Its readings appear on this field and are used for the irrigation recommendation.',
    sensorFieldGatewayManaged: 'This is an IoT gateway. Set the field it serves on the gateway itself, under Hardware.',
    sensorFieldLabel: 'Field',
    sensorFieldNone: 'Not connected to a field',
    sensorZoneLabel: 'Zone',
    sensorZoneWholeField: 'Whole field (all zones)',
    sensorDepthLabel: 'Installation depth',
    sensorDepthReported: 'Measures at',
    tensionGaugeTooltip: 'Soil water tension: lower means wetter soil, higher means the plant works harder for water',
    vwTensionHistoryTitle: 'Soil tension, last 14 days',
    vwTensionHistoryAxis: 'Centibar (cb). The line rises as the soil dries.',
    vwTensionHistoryTrigger: 'Needs water above',
    vwTensionHistoryTooFew: 'Not enough readings yet to draw a trend. It will appear once the station has reported for two days.',
    vwTensionHistoryError: 'The readings for this chart could not be loaded.',
    vwTensionHistoryIrrigation: 'Irrigated',
    vwTensionHistorySuspect: 'Sensor reading not trusted',
    vwMoistureHistoryTitle: 'Soil moisture, last 14 days',
    vwMoistureHistoryAxis: 'Volumetric water content (%). The line falls as the soil dries.',
    vwMoistureHistoryTrigger: 'Needs water below',
    vwProbeVwc: 'Soil moisture',
    vwProbeTension: 'Soil tension',
    vwProbeWeighted: 'Weighted mean',
    vwProbeState_IRRIGATE: 'Irrigate',
    vwProbeState_PREPARE: 'Get ready',
    vwProbeState_WAIT: 'Wait',
    vwProbeState_NO_IRRIGATION: 'No irrigation',
    vwProbeNotChecked: 'shown, not compared with the limits',
    vwProbeProvisional: 'Provisional sensor limits, set by the agronomist for testing on this field.',
    vwProbeNoReading: 'No reading from this sensor.',
    stationTitle: 'Weather station',
    stationOnThisField: 'on this field',
    stationOnField: 'on {field}, {km} km away',
    stationTemp: 'Temperature',
    stationHumidity: 'Humidity',
    stationRainToday: 'Rain today',
    stationRainRate: 'Rain now',
    stationMinutesAgo: '{n} min ago',
    stationHoursAgo: '{n} h ago',
    stationDaysAgo: '{n} days ago',
    stationNoReading: 'no reading yet',
    stationStale: 'The station has not sent a new reading for over an hour. The values are its last.',
    station24h: 'Last 24 h (low / high)',
    stationRain24h: 'rain {mm}',
    stationFrost: 'The station measured 0 °C or lower in the last 24 hours.',
    frostTitleFrost: 'Frost forecast',
    frostTitleRisk: 'Frost risk on the next nights',
    frostMeasured: 'Measured {t} °C at the station on {field} in the last 24 hours.',
    frostNightOf: 'Night of {day}',
    frostSource: 'Lowest air temperature of each night (18:00 to 09:00), from the forecast for the area. Low-lying parts of the field can be colder.',
    hardwareTabStations: 'Weather stations',
    hardwareTabSentek: 'Sentek',
    sentekIntro: 'Sentek probes read from IrriMAX Live. Set where each one stands and its status. A new one is added with the add device button.',
    sentekEmpty: 'No Sentek probe yet.',
    sentekName: 'Name in IrriMAX Live',
    sentekNameLocked: 'The name cannot change once readings have arrived, because they are stored under it.',
    sentekZone: 'Zone',
    sentekWholeField: 'The whole field',
    kaekCodesLabel: 'KAEK, one or more',
    kaekCodesHelp: 'Separate them with a comma if the field has several parcels.',
    kaekFind: 'Find in the Land Registry',
    kaekFound: '{n} parcels, {area} stremmata',
    kaekOutline: 'The outline found',
    kaekUse: 'Use as the field boundary',
    kaekUsed: 'The boundary is set. It is stored when you save the field.',
    kaekMissing: 'Not found: {codes}. The area may not be loaded yet, so import the boundary from a KML file.',
    kaekApart: 'These parcels do not touch, so they cannot be one field. Enter them as separate fields.',
    kaekFailed: 'The search did not complete.',
    kaekCredit: 'Boundaries: Hellenic Cadastre, data.gov.gr, CC-BY',
    stationsIntro: "Growers' own weather stations. Each is read every 10 minutes and shown on the field it stands on and on fields nearby.",
    stationsAdd: 'Add station',
    stationsEmpty: 'No weather station yet.',
    stationsName: 'Name',
    stationsProvider: 'Service',
    stationsExternalId: 'Station link or number',
    stationsExternalIdHelp: 'e.g. app.weathercloud.net/d6334617235 (the station must be public)',
    stationsField: 'Field it stands on',
    stationsRadius: 'Show on fields within (km)',
    stationsLatest: 'Last reading',
    stationsError: 'Could not be read',
    stationsReadNow: 'Read now',
    stationsActive: 'Active',
    stationsSave: 'Save',
    stationsCancel: 'Cancel',
    stationsDelete: 'Remove',
    vwRangeTo: 'to',
    vwNoValue: 'no value',
    waterUnknownSub: 'Shown once the zone drippers are entered',
    sensorAssignmentFailed: 'The sensor was saved but could not be connected to the field.',
    deviceIdentifierLocked: 'The identifier cannot be changed, readings already arrive under it.',
    manageUsersSubtitle: 'Manage user accounts, roles, and field assignments',
    noActiveAlerts: 'No active alerts',
    alert: 'Alert',
    viewAllAlerts: 'View all alerts',

    // Analytics widget keys
    leafWetnessDuration: 'Leaf Wetness Duration',
    leafWetnessSubtitle: 'Hours wet · PSA disease risk indicator',
    calibrated: 'Calibrated',
    watchZone: 'Watch',
    watch: 'Watch',
    low: 'Low',
    noLeafWetnessData: 'No leaf wetness data',
    psaWarning: 'Extended leaf wetness detected. Monitor for PSA symptoms · canker, leaf spots, dieback.',
    soilMoistureProfile: 'Soil Moisture Profile',
    vwcThreeDepths: 'Volumetric Water Content at 10, 20, 30 cm',
    refillPoint: 'Refill Point',
    optimal: 'Optimal',
    dry: 'Dry',
    noZoneData: 'No zone data',
    noZoneDataHint: 'Select a field with zones to see health status',
    fieldMicroclimate: 'Field Microclimate',
    microclimateSubtitle: 'On-site air temperature & relative humidity',
    relativeHumidity: 'RH',
    heatStress: 'Heat stress',
    frost: 'Frost',
    heat: 'Heat',
    noMicroclimateData: 'No microclimate data',
    leafCanopyClimate: 'Leaf & Canopy Climate',
    leafCanopySubtitle: 'Leaf temperature and humidity · transpiration & disease',

    // Irrigation timeline widget keys
    irrigateToday: 'Irrigation recommended today',
    checkSoilMoisture: 'Check soil moisture sensors',
    irrigated: 'Irrigated',
    forecastRain: 'Forecast Rain',
    noIrrigationTimeline: 'No irrigation timeline data',
    noIrrigationTimelineHint: 'Schedule irrigations to see timeline',

    // Demo Tour
    tourPresentation: 'Presentation',
    startTour: 'Start Tour',
    nextStep: 'Next',
    prevStep: 'Back',
    skipTour: 'Exit Tour',
    finishTour: 'Finish',
    replayTour: 'Replay Tour',
    hideTourFab: 'Hide Guide',
    tourActFeatures: 'Feature Tour',

    // === Feature Showcase Tour (7 steps) ===
    tourWelcomeTitle: 'Welcome to TerraMind',
    tourWelcomeDesc: 'A quick look at everything TerraMind offers. We\'ll walk through the map, zones, satellite imagery, weather, scheduling, alerts, diary, history, analytics and settings. The full picture in under 3 minutes.',
    tourFieldsTitle: 'Your Fields at a Glance',
    tourFieldsDesc: 'All your fields appear on the map with color-coded zones. Green means soil moisture is good, amber means it\'s dropping, red means it needs water now. Click any field to see details.',
    tourZonesTitle: 'Zones & Soil Moisture',
    tourZonesDesc: 'Each field is divided into irrigation zones. Every zone has sensors measuring moisture at 3 depths (10cm, 20cm, 30cm), so you always know exactly where water is needed.',
    tourWeatherTitle: 'Live Weather & Forecasts',
    tourWeatherDesc: 'Weather data updates automatically from local stations. The system checks the forecast before it suggests irrigation. If rain is expected, it recommends skipping to save water.',
    tourNdviTitle: 'Satellite Imagery (NDVI)',
    tourNdviDesc: 'View vegetation health from Copernicus Sentinel-2 satellites. NDVI maps show crop vigor per zone. Greener areas are healthier, yellow or red ones may need attention.',
    tourScheduleTitle: 'Irrigation Scheduling',
    tourScheduleDesc: 'Plan irrigation visually with the weekly calendar. You can create schedules by hand or ask the Advisor, which recommends the best time and duration for each zone.',
    tourAlertsTitle: 'Alerts & Notifications',
    tourAlertsDesc: 'Get notified when soil moisture drops too low, a sensor goes offline, or the system detects an issue. You can customize which alerts you receive and how.',
    tourDiaryTitle: 'Farm Diary',
    tourDiaryDesc: 'Keep a log of everything that happens on your farm, such as fertilization, spraying, pruning and harvest notes. Every entry is linked to a field and a date.',
    tourHistoryTitle: 'Irrigation History',
    tourHistoryDesc: 'Review past irrigation plans, see which zones were watered and for how long, and track how your water usage changes over time.',
    tourAnalyticsTitle: 'Performance Analytics',
    tourAnalyticsDesc: 'Track water usage, compare your decisions with the system\'s suggestions, and see how each zone responds over time. All data comes from your actual sensors and weather.',
    tourSettingsTitle: 'Settings & Preferences',
    tourSettingsDesc: 'Configure DSS behavior, enable automatic acceptance of suggestions, set calendar preferences, choose your language, and manage notification settings.',
    tourSummaryTitle: 'You\'re All Set',
    tourSummaryDesc: 'That\'s the full tour! Explore the demo data freely, or check out the Irrigation Intelligence for a detailed walkthrough of how the decision support system works with real field data.',
    tourSeeDetails: 'See full details',
    tourOpenDssDemoLink: 'Open Irrigation Intelligence',

    // === Section-based Tour (GuidedTourFab + TourOverlay) ===
    tourSelectorTitle: 'TerraMind Tour',
    tourSelectorSubtitle: 'Pick a section or start the full walkthrough',
    tourPlayAll: 'Full Tour',
    tourClose: 'Close',
    tourStep: 'step',
    tourSteps: 'steps',
    tourExitSection: 'Sections',
    tourBackToSections: 'Back to Sections',
    tourNextSection: 'Next Section',
    // Section titles
    tourSectionMap: 'Map',
    tourSectionWeather: 'Weather',
    tourSectionSchedule: 'Schedule',
    tourSectionAnalytics: 'Analytics',
    tourSectionAlerts: 'Alerts',
    tourSectionDiary: 'Diary',
    tourSectionSettings: 'Settings',
    tourSectionFieldDetail: 'Field Detail',
    tourSectionDss: 'DSS Intelligence',
    tourSectionFieldManagement: 'Field Management',
    tourAddFieldBtnTitle: 'Create a New Field',
    tourAddFieldBtnDesc: 'Click "Add Field" to open the creation wizard. You will draw the field boundary on the map, then add irrigation zones in step 2.',
    tourAddZoneBtnTitle: 'Add a Zone',
    tourAddZoneBtnDesc: 'Each field is divided into irrigation zones. Click + to draw a new zone polygon on the map. The area is auto-calculated from the polygon.',
    tourZoneEditBtnTitle: 'Edit Zone Configuration',
    tourZoneEditBtnDesc: 'Click Edit to update sprinkler count, flow rate, soil composition, and the zone boundary polygon.',
    // Step titles & descriptions (map)
    tourMapFieldsTitle: 'Your Fields',
    tourMapFieldsDesc: 'Click a field to see its zones, soil moisture readings, and sensor status.',
    tourKpiChipsTitle: 'Live Farm KPIs',
    tourKpiChipsDesc: 'Water used today, active zones, and next scheduled irrigation · updated every 30 seconds.',
    tourDssBannerTitle: 'Stressed Zones Alert',
    tourDssBannerDesc: 'When zones need water, this banner appears. It shows how many zones are stressed so you can act immediately. Tip: press Esc at any time to exit the tour and explore on your own.',
    tourFieldKebabTitle: 'Field shortcuts',
    tourFieldKebabDesc: 'This kebab menu (⋮) on each field row opens the shortcut menu · right now it exposes Delete. Edit and rename will land here so you can manage many fields without drilling into each one.',
    tourMapLayerPillTitle: 'Map Layer Switcher',
    tourMapLayerPillDesc: 'Switch between zone-state view (stress colours), NDVI satellite imagery, and crop type overlay.',
    tourMapContainerTitle: 'Interactive Map',
    tourMapContainerDesc: 'Click any zone polygon to see its moisture and state. Click a field boundary to open the detail panel.',
    tourSeasonSelectorTitle: 'Season Selector',
    tourSeasonSelectorDesc: 'Switch between growing seasons to compare soil moisture, schedules, and decisions from past years.',
    tourRunDssBtnTitle: 'Run DSS for This Field',
    tourRunDssBtnDesc: 'Trigger the decision engine now. TerraMind reads live WAI values and automatically queues irrigation for stressed zones.',
    // Step titles & descriptions (field detail)
    tourMapZonesTitle: 'Zone States & Moisture',
    tourMapZonesDesc: 'Each zone shows soil moisture at 3 depths and a status badge: OK (adequate), Marginal (monitor closely), Stressed (irrigate now), or Saturated (pause · too much water). The bar fills from wilting point to field capacity.',
    tourDssRecsTitle: 'DSS Recommendations',
    tourDssRecsDesc: 'The Advisor shows per-zone irrigation decisions. Press "Apply" to schedule immediately, or reject to skip.',
    tourMapNdviTitle: 'Satellite NDVI Overlay',
    tourMapNdviDesc: 'Turn on the satellite view to see how green each zone is. Dark green means healthy leaves. Yellow means keep an eye on it. Red means stress or bare soil. A new image arrives about every 5 days.',
    tourHistoryFiltersTitle: 'History Filters',
    tourHistoryFiltersDesc: 'Filter irrigation history by date range (7d, 30d, 90d) or by zone. Each row shows duration, water used, and who triggered it.',
    tourSoilResponseTitle: 'Soil Response Tracking',
    tourSoilResponseDesc: 'After each irrigation, TerraMind compares the soil moisture at 10 cm before and after. A green mark means the water reached the roots. No rise usually means a problem with the sensor or the equipment, and we look into it.',
    tourIrrigationModeTitle: 'Irrigation Mode',
    tourIrrigationModeDesc: 'Choose Normal (standard irrigation), Fertigation (bypasses concurrent limits to push nutrients through all zones), or Frost (emergency mode · runs all zones simultaneously regardless of queue).',
    tourCompareModelsTitle: 'Compare DSS models',
    tourCompareModelsDesc: 'Each card shows what a different decision model recommends for this zone right now: Physics (WAI vs threshold), ML (hybrid classifier with confidence), and Forecast-aware (uses the 5-day forecast and plans the NEXT event too). Divergence between cards is the interesting signal.',
    tourPlanTabTitle: "Today's Plan",
    tourPlanTabDesc: 'The Plan tab shows KPIs (liters applied, completion %) and a per-zone prescription · IRRIGATE, MONITOR, or SKIP · based on live WAI and DSS analysis. Frost risk and rain alerts appear as banners at the top.',
    // Step titles & descriptions (weather)
    tourWeatherHeroTitle: 'Current Weather',
    tourWeatherHeroDesc: 'Temperature, humidity, wind and 5-day forecast. If rain is expected, TerraMind suggests skipping irrigation.',
    tourSprayWindowTitle: 'Spray Window',
    tourSprayWindowDesc: 'See if conditions allow spraying: wind below 3 m/s, no rain in the next hours, suitable temperature.',
    tourWeatherHistoryChartsTitle: '30-Day History',
    tourWeatherHistoryChartsDesc: 'Temperature and rain charts for the past 30 days. Correlate wet spells with irrigation skips to review past decisions.',
    // Step titles & descriptions (schedule)
    tourDssButtonTitle: 'Recommendation',
    tourDssButtonDesc: 'Press "Recommendation" to get an automatic suggestion based on soil moisture, weather forecast, and crop needs.',
    tourScheduleFieldFilterTitle: 'Field Filter',
    tourScheduleFieldFilterDesc: 'Select a field to filter the calendar view. Only schedules for the chosen field and its zones will appear.',
    tourWeeklyCalendarTitle: 'Weekly schedule',
    tourWeeklyCalendarDesc: 'Click and drag to paint time slots. Release to open the schedule form · set zone, duration, and recurrence (once / daily / weekly).',
    tourSchedulePaintTitle: 'Paint Mode',
    tourSchedulePaintDesc: 'Activate paint mode to draw irrigation slots directly on the calendar. Paint multiple days at once or create per-day overrides.',
    tourScheduleFormPanelTitle: 'Schedule Form',
    tourScheduleFormPanelDesc: 'After painting a slot, this panel opens. Choose the zone, set duration, and pick recurrence. Save to create the irrigation entry.',
    tourScheduleTableTitle: 'Table View',
    tourScheduleTableDesc: 'Switch to table view to see all schedules in a compact list. Edit, toggle active/inactive, or delete entries from here.',
    // Step titles & descriptions (analytics)
    tourKpiStripTitle: 'Key Indicators (KPIs)',
    tourKpiStripDesc: 'Total water, irrigation count, average duration, and zone status · all from your real sensors.',
    tourWidgetAreaTitle: 'Charts & Widgets',
    tourWidgetAreaDesc: 'Drag, resize, or remove widgets. Weekly water use, farmer vs Advisor comparison, zone moisture trends.',
    tourFarmerVsDssTitle: 'Farmer vs Advisor Comparison',
    tourFarmerVsDssDesc: 'See where your decisions agreed or differed from the Advisor. Understand when irrigation was recommended and you didn\'t proceed · and why.',
    // Step titles & descriptions (DSS intelligence)
    tourDssZonesTitle: 'Zone Stress Analysis',
    tourDssZonesDesc: 'The DSS evaluates each zone\'s WAI, crop coefficient, and soil type to classify it as OK, Marginal, Stressed, or Saturated.',
    tourDssPlaygroundTitle: 'DSS Scenario Playground',
    tourDssPlaygroundDesc: 'Enter different moisture and weather values to see how the algorithm responds. Useful for understanding the decision logic.',
    // Step titles & descriptions (alerts)
    tourNotificationBellTitle: 'Notifications',
    tourNotificationBellDesc: 'Real-time alerts for stressed zones, completed irrigations, and sensor warnings. The bell shows the unread count.',
    tourAlertsPageTitle: 'Alerts',
    tourAlertsPageDesc: 'Low moisture, offline sensor, cancelled irrigation. Tap each alert for details and next action.',
    // Step titles & descriptions (diary)
    tourDiaryPageTitle: 'Farm Diary',
    tourDiaryPageDesc: 'Log fertilization, spraying, pruning, and observations. Each entry is linked to a field and date.',
    tourHistoryPageTitle: 'Irrigation History',
    tourHistoryPageDesc: 'See which zones were watered, when, and for how long. Compare actual water use by week or month.',
    tourDiaryAddBtnTitle: 'Add Diary Entry',
    tourDiaryAddBtnDesc: 'Record any farm activity: fertilization, pesticide, pruning, scouting. Attach photos and link to a field for a complete log.',
    // Step titles & descriptions (settings)
    tourLanguageToggleTitle: 'Language Switch',
    tourLanguageToggleDesc: 'Switch between English and Greek. All labels, prompts, and DSS reason codes are fully translated.',
    tourAutoAcceptTitle: 'Auto-Accept DSS',
    tourAutoAcceptDesc: 'Enable this to automatically apply irrigation suggestions without manual approval.',
    tourPrioritySliderTitle: 'Savings Priority',
    tourPrioritySliderDesc: 'Adjust whether you prefer water savings or maximum yield. The DSS adapts its suggestions accordingly.',
    tourSeasonChipTitle: 'Season filter',
    tourSeasonChipDesc: 'This chip syncs with the sidebar season pill on the map. Click it to toggle between the current season and all years.',

    // === DSS Demo Page ===
    dssDemoNoData: 'No backtest data available',
    dssDemoNoDataDesc: 'Enable demo mode and make sure demo data is seeded, then try again.',
    dssDemoDecisions: 'Decisions analyzed',
    dssDemoAgreement: 'Farmer-DSS agreement',
    dssDemoSavingsPct: 'Potential water savings',
    dssDemoSavingsM3: 'Water saved',
    dssDemoFarmerDays: 'Days you irrigated',
    dssDemoDssDays: 'Days DSS would irrigate',
    dssDemoSection1Title: 'What is the DSS?',
    dssDemoSection1Desc: 'The Decision Support System (DSS) analyzes soil moisture, weather forecasts, and crop growth stage to recommend when and how long to irrigate each zone. It learns from your field\'s history to make better suggestions over time.',
    dssDemoIntroDetail: 'The system uses the FAO-56 Penman-Monteith equation combined with real-time soil moisture from 3 depths (10cm, 20cm, 30cm) to calculate a Weighted Availability Index (WAI) for each zone. When WAI drops below the threshold for the crop\'s growth stage, irrigation is recommended.',
    dssDemoSection2Title: 'Your Decisions vs. the System',
    dssDemoSection2Desc: 'We compared every day you irrigated with what the system would have recommended. On some days you agreed. On others, the system would have saved water or caught a dry spell you missed.',
    dssDemoSection3Title: 'The Numbers',
    dssDemoSection3Desc: 'The full picture from 13 months of data: how many decisions were analyzed, how often you agreed and how much water could have been saved.',
    dssDemoSection4Title: 'Real Scenarios',
    dssDemoSection4Desc: 'The DSS adapts to weather conditions. Here are three real scenarios from your field data:',
    dssDemoRainTitle: 'Rain Detected: Skip Irrigation',
    dssDemoRainDesc: 'When forecast shows rain, the DSS recommends skipping irrigation. In May 2024, this saved 3 irrigation cycles worth of water.',
    dssDemoHeatTitle: 'Heatwave: Extend Duration',
    dssDemoHeatDesc: 'During the August 2024 heatwave (40\u00b0C+), the DSS increased irrigation duration by 20% to protect root-zone moisture.',
    dssDemoOptimalTitle: 'Normal Conditions: Optimize Timing',
    dssDemoOptimalDesc: 'On typical days, the DSS fine-tunes start time and duration per zone based on soil type, current moisture, and evapotranspiration forecast.',
    dssDemoSection5Title: 'Ready to Try It?',
    dssDemoSection5Desc: 'The DSS is designed to work alongside your experience, not replace it. You always have the final say.',
    dssDemoConclusionDetail: 'Start by running the DSS alongside your manual schedule. Review its suggestions and compare results. When you\'re confident, enable automatic mode in Settings.',
    dssDemoBackToMap: 'Back to Map',
    dssDemoGoAnalytics: 'View Analytics',
    // Section headers used directly in DSSDemo.js
    dssDemoAnalysisDays: 'Analysis days',
    dssDemoEstimatedSavings: 'Estimated water savings:',
    dssDemoScenariosTitle: 'How It Reacts to Real Conditions',
    dssDemoScenariosSub: 'Four scenarios from real field data · rain, stress, heatwave, and good management.',
    dssDemoSection1: 'What We Found',
    dssDemoSection1Sub: 'Key indicators from 13 months of farmer vs. system comparison',
    dssDemoSection2: 'Training & Evaluation',
    dssDemoSection2Sub: 'Left: training data (2024 + May 2025). Right: evaluation on unseen data (Jun·Aug 2025). The dashed line separates the two sets.',
    dssDemoSection3: 'Where We Disagreed',
    dssDemoSection3Sub: 'Days when farmer and system had different decisions',
    dssDemoSection4: 'Per Zone Breakdown',
    dssDemoSection4Sub: 'Each zone has different soil and different behavior',
    dssDemoSection5: 'Why It Decides This Way',
    dssDemoSection5Sub: 'The most frequent reasons behind each recommendation',
    dssDemoScenarioRain: 'Rain · Skip Irrigation',
    dssDemoScenarioStress: 'Moisture Drop · Alert',
    dssDemoScenarioHeat: 'Heatwave · Maximum Need',
    dssDemoScenarioOk: 'Good Management · Confirmed',
    dssDemoSection6: 'Each Soil Type Behaves Differently',
    dssDemoSection6Sub: 'Same system, different soils. Sandy drains fast (more frequent irrigation), clay retains water (less irrigation needed).',

    snapshotViewing: 'Viewing',

    // Demo Date Picker (time-travel)
    demoDateLiveMode: 'Live Mode',
    demoDateHistoricalMode: 'Historical Mode',
    demoDateLive: 'Live',
    demoDateGoLive: 'Return to live data',
    demoDateSelectDate: 'Select date...',
    demoDateScenarios: 'Explore real data scenarios:',
    demoDateViewingAsOf: 'Viewing data as of',
    demoDatePreset_drought_jul24: 'Drought · July 2024',
    demoDatePresetDesc_drought_jul24: 'VWC drops to 18%, DSS triggers urgent irrigation',
    demoDatePreset_rain_may24: 'Rainfall · May 2024',
    demoDatePresetDesc_rain_may24: 'DSS skips irrigation, saves water from rain',
    demoDatePreset_heat_aug24: 'Heat Wave · August 2024',
    demoDatePresetDesc_heat_aug24: 'Peak ET₀, DSS increases irrigation duration',
    demoDatePreset_winter25: 'Winter Dormancy · Jan 2025',
    demoDatePresetDesc_winter25: 'Low Kc, minimal water needs, DSS reduces irrigation',
    demoDateNoData: 'No data available for this date',
    demoDateZoneState: 'Zone state as of',

    // Weather improvements
    showingLatestWeatherData: 'Showing latest weather data',
    showCharts: 'Show Charts',
    hideCharts: 'Hide Charts',
    noWeatherHistory: 'No historical data yet',
    noWeatherHistoryHint: 'Weather records are collected automatically every 6 hours. Check back after the first scheduled fetch.',
    weatherHistoryFewPoints: 'Few days of data recorded · charts need at least 3 days to render.',
    hourly: 'Hourly',

    // Settings page
    settings: 'Settings',
    settingsSubtitle: 'Configure your preferences for the irrigation system',
    profileSettings: 'Profile',
    profileSettingsDesc: 'Your account information',
    saveProfile: 'Save Profile',
    profileSaved: 'Profile saved',
    changePassword: 'Change Password',
    signedInDevices: 'Signed-in devices',
    signedInDevicesDesc: 'Each phone, computer or screen signed in to your account. Signing in on a new one keeps the others signed in.',
    thisDevice: 'This device',
    signedInUnknownDevice: 'Unknown device',
    deviceSignedInAt: 'Signed in',
    deviceLastActive: 'Last active',
    signOutDevice: 'Sign out',
    showAllDevices: 'All devices ({n})',
    signOutOtherDevices: 'Sign out all other devices',
    signedInDevicesError: 'The list of devices could not be loaded.',
    confirmPassword: 'Confirm Password',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordChanged: 'Password changed successfully',
    emailAddress: 'Email Address',
    dssPreferences: 'DSS Preferences',
    dssPreferencesDesc: 'Control how the Irrigation Advisor generates and applies recommendations.',
    autoAcceptDss: 'Auto With Advisor',
    autoAcceptDssDesc: 'The Advisor creates irrigation schedules automatically, no approval needed from you',
    defaultIrrigationMode: 'Default irrigation mode',
    productionGoalPriority: 'Production goal priority',
    productionGoalPriorityDesc: 'Balance between water conservation and maximum yield',
    conservative: 'Conservative',
    balanced: 'Balanced',
    aggressive: 'Aggressive',
    calendarPreferences: 'Calendar Preferences',
    calendarStartHour: 'Start hour',
    calendarEndHour: 'End hour',
    display: 'Display',
    defaultField: 'Default field',
    defaultFieldDesc: 'The field shown by default when you open the dashboard',
    notificationPreferences: 'Notifications',
    notifyInApp: 'In the app',
    notifyInAppDesc: 'Irrigation calls and important messages appear on the bell. Always on.',
    notifyEmailIrrigation: 'Email when a field needs irrigation',
    notifyEmailIrrigationDesc: 'One email when a field of yours turns to irrigate, with the minutes.',
    guidedTour: 'Guided Tour',
    tutorialWalkthrough: 'Interactive Tutorial',
    demoFarmData: 'Sample Farm Data',
    tourRestartDesc: 'Restart the guided tour to revisit all app features and capabilities.',
    restartTour: 'Start Tour',

    // Season management
    season: 'Season',
    noSeason: 'No season',
    noSeasonsYet: 'No seasons yet',
    newSeason: 'New season',

    // Map / NDVI vegetation labels
    bare: 'Bare',
    sparse: 'Sparse',
    dense: 'Dense',

    // DSS decision matrix labels
    bothAgree: 'Both Agree',
    bothAgreedIrrigated: 'Both irrigated',
    bothAgreedSkipped: 'Both skipped',
    farmerOnly: 'Farmer Only',
    farmerOnlyDesc: 'Advisor would skip',
    dssOnly: 'Advisor Only',
    dssOnlyDesc: 'Farmer skipped',
    bothSkip: 'Both Skip',

    // DSS timeline labels
    zoneStateOKDesc: 'Soil looks good, no watering needed today',
    zoneStateMarginalDesc: 'Soil is getting dry, think about watering today',
    zoneStateStressedDesc: 'Too dry, water as soon as you can',
    zoneStateUnknownDesc: 'No sensor reading yet for this zone',
    agreementBothIrrigated: 'Agreement · Both irrigated',
    agreementBothSkipped: 'Agreement · Both skipped',
    farmerIrrigatedDssSkip: 'Farmer irrigated · Advisor would skip',
    dssWouldIrrigateFarmerSkipped: 'Advisor would irrigate · Farmer skipped',
    farmerLabel: 'Farmer',
    irrigatedLabel: 'Irrigated',
    waiThresholdHint: 'Soil water level · below 55% = needs irrigation',
    farmerVsSystemHint: 'Farmer vs system agreement per day (click any day)',

    // ProductionOverview
    gradeM: 'Mixed',

    // ScheduleFormPanel fertigation
    fertNPKBalanced: 'N-P-K Balanced',
    fertHighNitrogen: 'High Nitrogen',
    fertBloomBoost: 'Bloom Boost',
    fertCustom: 'Custom',
    fertNone: 'None',
    fertilizerRecipe: 'Fertilizer Recipe',
    fertilizerRecipePlaceholder: 'e.g. NPK 20-20-20',
    fertilizerRecipeHelp: 'Recipe name or formula for this fertigation run',

    // Misc UI
    currentWeatherTooltip: 'Current weather · updates every 5 min',
    updatedAgo: 'Updated',
    selectDate: 'Select date',
    previousWeek: 'Previous week',
    nextWeek: 'Next week',

    // Missing keys · FieldPanel / Schedule tab
    noScheduleTodayHint: 'Add a weekly schedule or start irrigation manually.',
    goToSchedule: 'Go to Schedule',
    minutes: 'min',
    customDuration: 'Custom',
    kiwi: 'Kiwi',
    inQueue: 'In Queue',

    // Missing keys · FieldListSidebar / layout
    sort: 'Sort',
    year: 'Year',
    close: 'Close',
    ariaExpandSidebar: 'Expand sidebar',
    ariaCollapseSidebar: 'Collapse sidebar',
    ariaCloseSidebar: 'Close sidebar',
    ariaSortFields: 'Sort fields',
    ariaFilterFields: 'Filter fields',
    ariaEditZone: 'Edit zone configuration',
    ariaDeleteZone: 'Delete zone',
    ariaCloseZonePanel: 'Close zone detail panel',
    ariaToggleNav: 'Toggle navigation',
    ariaDismissInstall: 'Dismiss install banner',
    diary: 'Diary',

    // Missing keys · Analytics widgets
    addChart: 'Add Chart',
    browseRecommended: 'Browse Recommended',
    chartTitle: 'Chart Title',
    chartType: 'Chart Type',
    createCustom: 'Create Custom',
    cumulativeBalance: 'Cumulative Balance',
    deficit: 'Deficit',
    demoData: 'Historical',
    demoDataDate: 'Showing historical data',
    dssRecommends: 'Advisor Recommends',
    dss_recommendation: 'Advisor Recommendation',
    duration_min: 'Duration (min)',
    editChart: 'Edit Chart',
    elevated: 'Elevated',
    heavyRain: 'Heavy Rain',
    high: 'High',
    highDemand: 'High Demand',
    loss: 'Loss',
    modify: 'Modify',
    month: 'Month',
    ndviZoneColoring: 'NDVI Zone Coloring',
    netBalance: 'Net Balance',
    newChart: 'New Chart',
    newScheduleEntry: 'New Schedule Entry',
    noBacktestData: 'No backtest data available',
    noChartsDescription: 'Add charts to monitor your field data',
    noChartsYet: 'No charts yet',
    noRainfallData: 'No rainfall data available',
    noSalinityData: 'No salinity data available',
    noSoilTempData: 'No soil temperature data available',
    noSolarData: 'No solar radiation data available',
    noTimelineData: 'No timeline data available',
    noWaterBalanceData: 'No water balance data available',
    noWaterBalanceHint: 'Water balance requires sensor readings and weather data.',
    noWeatherDataHint: 'Weather data will appear once the station starts reporting.',
    panelVoltage: 'Panel Voltage',
    rain: 'Rain',
    rainfallWindSubtitle: 'Rainfall & wind speed over time',
    realData: 'Real Data',
    removeChart: 'Remove Chart',
    save_changes: 'Save Changes',
    saveFailed: 'Save failed',
    saved: 'Saved',
    deleted: 'Deleted',
    deleteFailed: 'Delete failed',
    severeStress: 'Severe Stress',
    slowUptake: 'Slow Uptake',
    soilSalinitySubtitle: 'Electrical conductivity by depth',
    soilTempSubtitle: 'Soil temperature by depth over time',
    solarAndEnergy: 'Solar Radiation & Energy',
    solarSubtitle: 'Photosynthetically active radiation',
    surplus: 'Surplus',
    timingPerDay: 'Timing per Day',
    totalRain: 'Total Rain',
    warm: 'Warm',
    cold: 'Cold',
    waterBalance: 'Water Balance',
    windDamage: 'Wind Damage',
    yieldLoss: 'Yield Loss',

    // Common UI words (i18n audit fixes)
    done: 'Done',
    max: 'Max',
    configuration: 'Configuration',

    // Irrigation history
    irrigationHistory: 'Irrigation History',
    noIrrigationHistory: 'No irrigation history',
    noIrrigationYet: 'No irrigation recorded',

    // Sensor data
    noSensorReadings: 'No sensor readings available',
    sensorDataUnavailable: 'Sensor data temporarily unavailable.',
    soilDataPending: 'Sensor data pending · outcome will populate when readings arrive',
    sensorsOffline: 'Soil sensors offline',
    sensorsOfflineHint: 'Using past weather and soil estimates. Recommendations stay available. They become more accurate once the sensors are back.',
    sensorsNotReporting: 'No soil sensor data yet',
    sensorsNotReportingHint: 'Once sensors are connected and reporting, this field will show live moisture and recommendations will be refined.',
    daysShort: 'd',
    daysRemaining: 'days left',
    irrigating: 'Irrigating',
    minRemaining: 'min left',
    vwcTrend30d: 'VWC Trend (30d)',

    // Confirmation dialogs
    confirmStop: 'Stop irrigation?',
    confirmStopZoneDesc: 'This will stop the current irrigation for this zone.',

    // Error messages
    errorCreatingField: 'Error creating field',
    errorCreatingZone: 'Error creating zone',
    errorLoadingData: 'Could not load data',
    errorSavingField: 'Error saving field',
    failedToSave: 'Failed to save',

    // Field wizard & polygon
    noFieldPolygon: 'No field polygon available',

    // Schedule
    paintScheduleHint: 'Click and drag on the calendar to paint irrigation time slots. Use the + button in the toolbar to add manually.',

    // New season
    newSeasonDesc: 'Create a new growing season for all your fields. A journal entry will also be added to your Farm Diary.',

    // Tour / onboarding
    resetTourProgress: 'Reset progress',
    tourResetAllDesc: 'Mark all sections as unread. The tour button will appear again.',

    // Settings / password
    currentPassword: 'Current Password',
    passwordHint: 'Min 12 chars, uppercase, number & symbol',
    passwordTooWeak: 'Password is too weak. Use uppercase, numbers, and symbols.',

    // ── DSS Demo (DSSDemo.js + page tabs) ────────────────────────────
    dssDemoTitle: 'Irrigation Intelligence · Decision Engine',
    dssDemoSubtitle: 'Kiwi · Veroia, Greece',
    dssDemoPageDesc: 'Admin view: how the irrigation algorithm makes decisions, validated against 2 seasons of real field data. Use the Simulation tab to test any input scenario live.',
    dssDemoLoading: 'Loading DSS data...',
    dssDemoLoadError: 'Load error',
    dssDemoRetry: 'Retry',
    dssDemoBack: 'Back',
    dssPage_architecture: '1. Architecture',
    dssPage_datasources: '2. Data Sources',
    dssPage_backtest: '3. Evaluation & KPIs',
    dssPage_timeline: '4. Time Series',
    dssPage_water: '5. Irrigation Compare',
    dssPage_playground: '6. Simulation',

    // ── DSS Backtest section (BacktestPage in DSSDemo.js) ────────────
    dssBacktest_strategy_calendar_name: 'Calendar Rule',
    dssBacktest_strategy_calendar_desc: 'Fixed 3-day schedule · ignores soil moisture entirely',
    dssBacktest_strategy_physics_name: 'Physics Only',
    dssBacktest_strategy_physics_desc: 'Waters when moisture drops below threshold · no weather forecast or ML',
    dssBacktest_strategy_dssml_name: 'DSS (ML + Physics)',
    dssBacktest_strategy_dssml_desc: 'Soil moisture + weather forecast + crop stage + machine learning',
    dssBacktest_metric_daysRecommended: 'Days recommended',
    dssBacktest_metric_recall: 'Recall',
    dssBacktest_metric_precision: 'Precision',
    dssBacktest_evaluatedCaption: 'Evaluated on 2025 season data (withheld from 2024 training).',
    dssBacktest_dayBreakdown: 'Day Breakdown',
    dssBacktest_seg_tp: 'Both agreed · soil stressed',
    dssBacktest_seg_tn: 'Both skipped · soil adequate',
    dssBacktest_seg_fp: 'DSS only · farmer missed stress event',
    dssBacktest_seg_fn: 'Farmer only · soil was adequate',
    dssBacktest_seg_waiAvg: 'WAI avg',
    dssBacktest_avgWaiByGroup: 'Avg. Soil Moisture by Group',
    dssBacktest_avgWaiByGroupDesc: 'Average WAI (%) on days each group recommended irrigation',
    dssBacktest_avgWaiTooltip: 'Avg WAI',
    dssBacktest_waiGroup_tp: 'TP days · both irrigated',
    dssBacktest_waiGroup_fp: 'DSS-only · farmer missed',
    dssBacktest_waiGroup_tn: 'TN days · both skipped',
    dssBacktest_distinguishCaption: 'The three groups occupy entirely different moisture ranges, confirming the DSS distinguishes between stress conditions rather than recommending randomly.',
    dssBacktest_perMonthTitle: 'Per-Month Performance · Leave-One-Month-Out',
    dssBacktest_meanF1: 'Mean F1',
    dssBacktest_stdDev: 'std dev',
    dssBacktest_perMonthDesc: 'Each month evaluated independently · shows when the model performs well and where it struggles.',
    dssBacktest_best: 'Best',
    dssBacktest_hardest: 'Hardest',
    // FP callout · uses {fp} {missed} {wai} placeholders
    dssBacktest_fpCalloutFull: 'The {fp} days where DSS recommended but the farmer did not irrigate: average WAI {wai}%, below stress threshold on {missed} of {fp} days. The soil was genuinely stressed · the system was not wrong.',
    dssBacktest_fpCalloutNoWai: 'The {fp} days where DSS recommended but the farmer did not irrigate: below stress threshold on {missed} of {fp} days. The soil was genuinely stressed · the system was not wrong.',
    dssBacktest_fpCalloutSimple: 'The {fp} days where DSS recommended but the farmer did not irrigate. The soil was genuinely stressed · the system was not wrong.',
    dssBacktest_farmerImperfectFootnote: '* On the {fp} days the DSS recommended irrigation but the farmer did not irrigate, in {missed} of them ({pct}%) the soil was actually under stress. The farmer is not a perfect reference · the {precision} precision is measured against farmer behaviour, not soil physics.',

    // ── DSS Timeline (DSSPageTimeline.js) ────────────────────────────
    dssTime_noData: 'No timeseries data',
    dssTime_legend_moistureChart: 'Moisture chart',
    dssTime_legend_chartMarkers: 'Chart markers',
    dssTime_legend_show: 'Show legend',
    dssTime_legend_hide: 'Hide legend',
    dssTime_legend_vwc10_actual: 'Moisture at 10cm (sensor)',
    dssTime_legend_dssScenario: 'DSS scenario · if farmer had followed recommendations (estimate)',
    dssTime_legend_vwc20: 'Moisture 20cm',
    dssTime_legend_vwc30: 'Moisture 30cm',
    dssTime_legend_wp: 'Wilting point 15% (below: irreversible damage)',
    dssTime_legend_fc: 'Field capacity 36% (above: soil saturation)',
    dssTime_legend_farmerDot: 'Dot = farmer irrigated that day',
    dssTime_legend_dssTriangle: 'Triangle = algorithm would recommend irrigation',
    dssTime_inlineLegend_moisture10: 'Moisture 10cm',
    dssTime_inlineLegend_farmerIrr: 'Farmer irrigated',
    dssTime_inlineLegend_dssRec: 'DSS recommended',
    dssTime_daysCount: '{n} days',
    dssTime_panel1_title: 'Soil moisture (%) · Actual vs DSS scenario',
    dssTime_panel1_actual10cm: 'Actual sensor (10cm)',
    dssTime_panel1_ifFollowed: 'If DSS recommendations followed',
    dssTime_chart_wp: 'WP 15%',
    dssTime_chart_fc: 'FC 36%',
    dssTime_chart_vwc10: 'VWC 10cm',
    dssTime_chart_vwc20: 'VWC 20cm',
    dssTime_chart_vwc30: 'VWC 30cm',
    dssTime_chart_dssScenario: 'DSS scenario',
    dssTime_chart_farmerIrrigated: 'Farmer irrigated',
    dssTime_chart_dssRecommended: 'DSS recommended',
    dssTime_panel2_title: 'WAI · Below {pct}% = needs irrigation',
    dssTime_panel2_limit: 'Limit {pct}%',
    dssTime_panel2_dssDuration: 'DSS Duration',
    dssTime_panel3_title: 'Temporal Context · ET Deficit & Stress Hours',
    dssTime_panel3_etDeficit7d: '7-day ET deficit',
    dssTime_panel3_stressHours: 'Stress hours',
    dssTime_panel3_etDeficit: 'ET Deficit',
    dssTime_panel4_title: 'NDVI · Vegetation index (satellite)',
    dssTime_panel4_supplementary: 'Supplementary indicator ~2% weight',
    dssTime_panel4_caption: 'NDVI checks vegetation health via Sentinel-2 satellite. Values >0.6 = healthy vegetation, <0.3 = bare/dry soil. Updated every 5-10 days (depends on cloud cover).',
    dssTime_panel5_title: 'Farmer vs system agreement per day (click any day)',
    dssTime_strip_agreement: 'Agreement',
    dssTime_strip_disagreement: 'Disagreement',
    dssTime_strip_legend_bothIrr: 'Both irrigated',
    dssTime_strip_legend_bothSkip: 'Both skipped',
    dssTime_strip_legend_dssOnly: 'DSS only (farmer skipped)',
    dssTime_strip_legend_farmerOnly: 'Farmer only (DSS skipped)',
    // Detail card
    dssTime_detail_data: 'Data',
    dssTime_detail_decisions: 'Decisions',
    dssTime_detail_soilWaterLevel: 'Soil water level',
    dssTime_detail_belowThreshold: 'Below threshold 55%',
    dssTime_detail_waiTomorrow: 'WAI tomorrow',
    dssTime_detail_daysToStress: 'Days to stress',
    dssTime_detail_temperature: 'Temperature',
    dssTime_detail_humidity: 'Humidity',
    dssTime_detail_rainfall: 'Rainfall',
    dssTime_detail_dailyWaterNeed: 'Daily water need',
    dssTime_detail_farmer: 'Farmer',
    dssTime_detail_irrigated: 'Irrigated',
    dssTime_detail_skipped: 'Skipped',
    dssTime_detail_recommended: 'Recommended',
    dssTime_detail_skip: 'Skip',
    dssTime_detail_detected: 'Detected',
    dssTime_detail_confidence_high: 'High confidence',
    dssTime_detail_confidence_medium: 'Medium confidence',
    dssTime_detail_confidence_low: 'Low confidence',
    dssTime_detail_rain: 'Rain',
    dssTime_detail_verdict_bothIrr: 'Agreement · Both irrigated',
    dssTime_detail_verdict_bothSkip: 'Agreement · Both skipped',
    dssTime_detail_verdict_farmerOnly: 'Farmer irrigated · DSS would skip',
    dssTime_detail_verdict_dssOnly: 'DSS would irrigate · Farmer skipped',
    dssTime_detail_hours: 'h',
    dssTime_detail_minutes: 'min',
    // Zone state labels (used by DSSPageTimeline.zoneStateLabel)
    dssZone_state_OK: 'Soil looks good, no watering needed today',
    dssZone_state_MARGINAL: 'Soil is getting dry, think about watering today',
    dssZone_state_STRESSED: 'Too dry, water as soon as you can',
    dssZone_state_UNKNOWN: 'No sensor data',

    // ── DSS Zones (DSSPageZones.js) ──────────────────────────────────
    dssZones_noData: 'No per-zone data available',
    dssZones_intro: 'The test farm has {n} zones with different soil types (clay loam, sandy loam, etc). The algorithm decides separately for each zone because each has its own sensors and behaves differently. Average farmer-system agreement: {pct}%.',
    dssZones_agreementPerZone: 'Agreement per Zone',
    dssZones_zone: 'Zone',
    dssZones_th_zone: 'Zone',
    dssZones_th_soil: 'Soil',
    dssZones_th_farmer: 'Farmer',
    dssZones_th_dss: 'DSS',
    dssZones_th_agreement: 'Agreement',
    dssZones_th_topReason: 'Top reason',
    dssZones_reasonDistribution: 'Decision Reason Distribution',
    dssZones_bySoilType: 'By Soil Type',
    dssZones_soil_farmer: 'Farmer',
    dssZones_soil_agreement: 'Agreement',

    // ── DSS Playground (DSSPagePlayground.js) ────────────────────────
    dssPlay_loading: 'Loading live field data…',
    dssPlay_noSensorData: 'No sensor data available',
    dssPlay_liveBanner: 'Live data · {field} · {zone}',
    dssPlay_lastReading: 'Last reading:',
    dssPlay_irrChip: 'Irr.',
    dssPlay_month: 'Month',
    dssPlay_soilType: 'Soil Type',
    dssPlay_bbchStage: 'BBCH Stage',
    dssPlay_waiThreshold: 'WAI threshold',
    dssPlay_slidersHint: 'Starting values are latest sensor readings · adjust to explore scenarios',
    dssPlay_run: '▶ Run',
    dssPlay_realContextTitle: 'Real Context (from DB)',
    dssPlay_ctx_hoursSinceIrr: 'Hours since last irr.',
    dssPlay_ctx_irr7d: 'Irrigations last 7d',
    dssPlay_ctx_water7d: 'Water applied 7d',
    dssPlay_ctx_solarRadiation: 'Solar radiation',
    dssPlay_decisionIrrigate: 'IRRIGATE',
    dssPlay_decisionSkip: 'SKIP',
    dssPlay_unitHours: 'h',
    dssPlay_unitMinutes: 'min',
    dssPlay_traceTitle: 'Decision Trace · 3 Tiers',
    dssPlay_tier1Label: 'Physics (WAI)',
    dssPlay_tier2Label: 'ML XGBoost',
    dssPlay_tier2NotLoaded: 'Not loaded',
    dssPlay_tier3Label: 'Safety Guards',
    dssPlay_tier3_frost: 'Frost risk · override',
    dssPlay_tier3_recentRain: 'Recent rain {n}mm',
    dssPlay_tier3_rainForecast: 'Rain forecast {n}mm',
    dssPlay_tier3_clear: 'No active guards',
    dssPlay_forecastTitle: '5-Day Forward Simulation',
    dssPlay_forecastSrc_meteoblue: 'Meteoblue weather',
    dssPlay_forecastSrc_assumed: '0mm assumed',
    dssPlay_forecastDesc: 'WAI evolution applying DSS recommendations · each irrigation is applied and carried forward',
    dssPlay_dayIrrigate: 'Irrigate',
    dssPlay_dayRainSkip: 'Rain · skip',
    dssPlay_dayNoNeed: 'No need',
    // Slider labels
    dssPlay_slider_vwc_10: 'Moisture 10cm',
    dssPlay_slider_vwc_20: 'Moisture 20cm',
    dssPlay_slider_vwc_30: 'Moisture 30cm',
    dssPlay_slider_temperature: 'Temperature',
    dssPlay_slider_humidity: 'Humidity',
    dssPlay_slider_wind_speed: 'Wind',
    dssPlay_slider_rainfall_24h: 'Rain 24h',
    dssPlay_slider_rain_forecast_48h: 'Rain forecast 48h',
    // Months
    dssMonth_3: 'Mar',
    dssMonth_4: 'Apr',
    dssMonth_5: 'May',
    dssMonth_6: 'Jun',
    dssMonth_7: 'Jul',
    dssMonth_8: 'Aug',
    dssMonth_9: 'Sep',
    dssMonth_10: 'Oct',
    // BBCH stage labels · agronomic phenology
    dssBbch_10: 'Vegetation',
    dssBbch_30: 'Growth',
    dssBbch_50: 'Flowering',
    dssBbch_60: 'Fruit set',
    dssBbch_71: 'Fruit development',
    dssBbch_75: 'Fruit development',
    dssBbch_80: 'Ripening',
    dssBbch_85: 'Ripening',
    dssBbch_89: 'Harvest',

    // ── DSS Shared (DSSShared.js · moisture tooltip + categories) ────
    dssShared_tooltip_moisture10: 'Moisture 10cm',
    dssShared_tooltip_moisture20: 'Moisture 20cm',
    dssShared_tooltip_moisture30: 'Moisture 30cm',
    dssShared_tooltip_dssProjected: 'DSS projected',
    dssShared_tooltip_soilWaterLevel: 'Soil water level',
    dssShared_tooltip_rainfall: 'Rainfall',
    dssShared_tooltip_temperature: 'Temperature',
    dssShared_tooltip_dailyWaterNeed: 'Daily water need',
    dssShared_tooltip_farmer: 'Farmer',
    dssShared_tooltip_farmerIrrigated: 'Irrigated',
    dssShared_tooltip_dssRecommended: 'Recommended',
    dssShared_cat_soil_moisture: 'Soil Moisture',
    dssShared_cat_wai: 'Water Index (WAI)',
    dssShared_cat_weather: 'Weather',
    dssShared_cat_forecast: 'Weather Forecast',
    dssShared_cat_et: 'Water Evaporation',
    dssShared_cat_satellite: 'Satellite (NDVI)',
    dssShared_cat_crop: 'Crop Growth Stage',
    dssShared_cat_history: 'Irrigation History',
    dssShared_cat_soil_properties: 'Soil Type',
    dssShared_cat_trends: 'Moisture Trends',
    dssShared_cat_risk_flags: 'Alerts',
    dssShared_cat_interactions: 'Combined Indicators',
    dssShared_cat_projection: 'Next-Day Estimate',
    dssShared_cat_saturation: 'Saturation Risk',
    dssShared_cat_temporal: 'Season / Date',
    dssShared_cat_zone_hydraulics: 'Irrigation Network',
    dssShared_cat_other: 'Other',
    // Reason codes
    dssReason_RAIN_SKIP: 'Rain expected · skip irrigation',
    dssReason_WAI_LOW: 'Soil drying out · needs water',
    dssReason_SOIL_ADEQUATE: 'Soil has enough moisture',
    dssReason_ET_HIGH: 'High evaporation · drying fast',
    dssReason_STRESS_RISK: 'Plant stress risk detected',
    dssReason_FC_REACHED: 'Soil at full capacity',
    dssReason_GROWTH_STAGE: 'Adjusted for crop growth stage',
    dssReason_TEMP_LOW: 'Low temperature',
    dssReason_TEMP_HIGH: 'High heat · increased water demand',
    dssReason_RECENT_IRRIGATION: 'Recently irrigated',
    dssReason_DEFAULT: 'Standard assessment',
    dssReason_ROOTZONE_STRESSED: 'Root zone needs water',
    dssReason_ML_DECISION: 'Algorithm assessment',
    dssReason_WAI_THRESHOLD: 'Moisture below safe level',
    dssReason_HIGH_ET: 'High evaporation · drying fast',
    dssReason_FORECAST_RAIN: 'Rain in forecast',
    dssReason_SOIL_SATURATION: 'Soil saturated · do not irrigate',
    dssReason_STALE_SENSOR: 'Sensor data outdated',
    dssReason_FROST_RISK: 'Frost risk detected',
    dssReason_SUFFICIENT_MOISTURE: 'Enough moisture · no need',
    // Backend DSSRecommendation + Decision reason_code exact-match keys
    // Used via t(`dssReasonCode_${reason_code}`) in ZoneDetailPopup
    dssReasonCode_ROOTZONE_BELOW_MIN: 'Soil moisture is below the minimum threshold · irrigation needed.',
    dssReasonCode_ROOTZONE_STRESSED: 'Root zone under stress. Urgent irrigation required.',
    dssReasonCode_SOIL_ADEQUATE: 'Soil moisture is adequate. No irrigation needed.',
    dssReasonCode_TENSION_ADEQUATE: 'Soil moisture is adequate. No irrigation needed.',
    dssReasonCode_TENSION_IRRIGATE: 'Soil-water tension is high. Irrigation recommended.',
    dssReasonCode_PROBE_IRRIGATE: 'Both probes show the soil drying. Irrigation recommended.',
    dssReasonCode_PROBE_PREPARE: 'The soil is drying. Get ready to irrigate.',
    dssReasonCode_PROBE_ADEQUATE: 'Soil moisture is adequate. No irrigation needed.',
    dssReasonCode_RAIN_EXPECTED: 'Rain is expected. Irrigation held back.',
    dssReasonCode_ZONE_CAPACITY_UNCONFIGURED: 'The sprinkler setup for this zone is not configured yet, so no duration can be given.',
    dssReasonCode_DRYING_TREND: 'The soil is drying steadily. Irrigation is approaching.',
    dssReasonCode_FROST_PROTECT: 'Frost is forecast. Irrigation may be used for protection.',
    dssReasonCode_OFF_SEASON: 'Outside the irrigation season.',
    dssReasonCode_OFF_SEASON_DRY: 'Outside the irrigation season, but the soil has dried. Please check the field.',
    dssReasonCode_IRRIGATING: 'This zone is being irrigated.',
    dssReasonCode_JUST_IRRIGATED: 'This zone was just irrigated. The reading will show it shortly.',
    dssReasonCode_MARGINAL_HIGH_ET: 'Moisture is borderline and water demand is high. Watch this zone.',
    dssReasonCode_NO_SENSOR_DATA: 'No recent sensor reading for this zone.',
    dssReasonCode_OK: 'Soil moisture is in the healthy range.',
    dssReasonCode_RECENTLY_IRRIGATED: 'Recently irrigated. No action needed.',
    dssReasonCode_RECENT_RAIN: 'Recent rain has recharged the soil.',
    dssReasonCode_SATURATED: 'The soil is saturated. Irrigation suspended.',
    dssReasonCode_FORECAST_HEAT: 'High temperatures forecast · increased water demand expected.',
    dssReasonCode_DEFICIT_GROWING: 'Soil water deficit is growing · irrigation recommended.',
    dssReasonCode_KC_PEAK: 'Crop is at peak water demand stage (flowering/fruit fill).',
    dssReasonCode_PRODUCTION_GOAL: 'High yield target requires additional irrigation.',
    dssReasonCode_ML_MODEL: 'Adaptive recommendation based on historical soil and weather data.',
    dssReasonCode_RAIN_FORECAST: 'Rain expected · irrigation skipped.',

    // ── DSS How-It-Works (DSSPageHowItWorks.js) ─────────────────────
    dssHow_archTitle: '3-Tier Decision Architecture',
    dssHow_archSubtitle: 'Every irrigation decision passes through physics validation, machine learning, and safety checks · three independent tiers that compensate for each other.',
    dssHow_finalOutput: 'Final Output',
    dssHow_executionExample: 'Execution Example',
    dssHow_realExampleCaption: 'Real example · {date}, Safarikas field',
    dssHow_step1_title: 'Data',
    dssHow_step2_title: 'Physics',
    dssHow_step3_title: 'ML + Rules',
    dssHow_status: 'Status',
    dssHow_pIrrigate: 'P(irrigate)',
    dssHow_reason: 'Reason',
    dssHow_finalDecision: 'Final Decision',
    dssHow_irrigateWithDur: '✓ Irrigate {dur} min',
    dssHow_irrigate: '✓ Irrigate',
    // Tier definitions
    dssHow_tier1_title: 'Data Collection',
    dssHow_tier1_subtitle: '6 data sources',
    dssHow_tier1_item1: 'What is the soil moisture right now? (10/20/30 cm)',
    dssHow_tier1_item2: 'What does the weather forecast say for the next 48 h?',
    dssHow_tier1_item3: 'What stage is the crop at? (BBCH → Kc → water demand)',
    dssHow_tier1_item4: 'What was irrigated in the last 7 days?',
    dssHow_tier1_output: 'Zone snapshot · 85 features per reading',
    dssHow_tier2_title: 'Physics Assessment',
    dssHow_tier2_subtitle: 'FAO-56 interpretable baseline',
    dssHow_tier2_item1: 'Is WAI below the stress threshold for this growth stage?',
    dssHow_tier2_item2: 'How much water does the crop need today? (ET₀ × Kc)',
    dssHow_tier2_item3: 'How many days until the soil reaches stress?',
    dssHow_tier2_item4: 'Is saturation or frost risk present?',
    dssHow_tier2_output: 'WAI index + 74 features for ML training',
    dssHow_tier3_title: 'ML + Safety Guardrails',
    dssHow_tier3_subtitle: 'XGBoost classifier + hard overrides',
    dssHow_tier3_item1: 'Does the XGBoost model agree with the physics signal?',
    dssHow_tier3_item2: 'How many minutes of irrigation will restore field capacity?',
    dssHow_tier3_item3: 'Does any safety rule override the ML output?',
    dssHow_tier3_item4: 'What is the confidence level and reason code?',
    dssHow_tier3_output: 'Decision + Duration + Confidence + Explanation',
    // Outputs
    dssHow_out_decision_label: 'Decision',
    dssHow_out_decision_desc: 'Irrigate or skip',
    dssHow_out_duration_label: 'Duration',
    dssHow_out_duration_desc: 'Minutes (from soil deficit)',
    dssHow_out_priority_label: 'Priority',
    dssHow_out_priority_desc: 'Zone urgency rank',
    dssHow_out_explanation_label: 'Explanation',
    dssHow_out_explanation_desc: 'Top factors',
    dssHow_out_bestHour_label: 'Best hour',
    dssHow_out_bestHour_desc: 'Optimal time',

    // ── DSS Decision Trace / Crop Science (DSSPageDecisionTrace.js) ──
    dssTrace_title: 'Crop Science & Calibration',
    dssTrace_subtitle: 'WAI thresholds and Kc crop coefficients shift at each growth stage. The system was calibrated using laboratory soil analysis and 13 months of sensors from the Safarikas field.',
    dssTrace_waiThreshold: 'WAI threshold',
    dssTrace_soilLab_title: 'Soil Lab Analysis',
    dssTrace_soilLab_caption: 'Safarikas Field · Veroia (March 2026)',
    dssTrace_soilLab_sand: 'Sand',
    dssTrace_soilLab_silt: 'Silt',
    dssTrace_soilLab_clay: 'Clay',
    dssTrace_soilLab_usda: 'USDA Type',
    dssTrace_soilLab_clayValue: 'Clay',
    dssTrace_soilLab_wp: 'Wilting point (WP)',
    dssTrace_soilLab_fc: 'Field capacity (FC)',
    dssTrace_soilLab_method: 'Method',
    dssTrace_soilLab_methodValue: 'Saxton & Rawls (soil model)',
    dssTrace_soilLab_physicsNote: 'Below WP=26.6%: root hairs cannot extract water · irreversible damage. Above FC=39.6%: saturation · oxygen depletion.',
    dssTrace_history_title: 'Historical Data',
    dssTrace_history_period: 'Period',
    dssTrace_history_periodValue: 'Apr 2024 · Aug 2025',
    dssTrace_history_duration: 'Duration',
    dssTrace_history_durationValue: '13 months',
    dssTrace_history_hourly: 'Hourly readings',
    dssTrace_history_depths: 'Sensor depths',
    dssTrace_history_detected: 'Detected irrigations',
    dssTrace_history_detectedValue: '76 days',
    dssTrace_ml_title: 'ML Training',
    dssTrace_ml_cvHeading: 'Leave-one-month-out CV',
    dssTrace_ml_meanF1: 'Mean F1',
    dssTrace_ml_stdDev: 'Std dev',
    dssTrace_ml_bestMonth: 'Best month',
    dssTrace_ml_hardestMonth: 'Hardest month',
    dssTrace_ml_cvFooter: '{n} months · each held out once',
    dssTrace_ml_timeSplit: 'Time split',
    dssTrace_ml_train: 'Training: Apr·Oct 2024 (7m)',
    dssTrace_ml_eval: 'Eval: May·Aug 2025',
    dssTrace_ml_features: 'Features',
    dssTrace_ml_algorithm: 'Algorithm',
    dssTrace_ml_threshold: 'Threshold P(irrigate)',
    dssTrace_temporal_title: 'Temporal Context (Rolling Features)',
    dssTrace_temporal_caption: 'Cumulative features derived from historical sensor readings · give the ML model temporal memory beyond the instantaneous snapshot.',
    dssTrace_temporal_avg: 'Avg',
    dssTrace_temporal_peak: 'Peak',
    dssTrace_temporal_etTitle: '7-day ET Deficit',
    dssTrace_temporal_etDesc: 'Sum of (ETc − rainfall) last 7 days',
    dssTrace_temporal_stressTitle: 'Consecutive Stress Hours',
    dssTrace_temporal_stressDesc: 'Hours with WAI below threshold',
    dssTrace_temporal_droughtTitle: 'Drought Days',
    dssTrace_temporal_droughtDesc: 'Days since last rainfall >2mm',
    dssTrace_chart_title: 'Kiwi Crop Dynamics · Kc & WAI Threshold by BBCH Stage',
    dssTrace_chart_caption: 'Crop coefficient Kc (water demand) and WAI threshold (when to irrigate) shift across the season · during flowering (BBCH 60) the system becomes most protective (WAI 70%) because fruit set is at risk.',
    dssTrace_chart_xAxis: 'BBCH Stage',
    dssTrace_chart_yAxis: 'WAI Threshold',
    dssTrace_chart_legend_kc: 'Kc (water demand)',
    dssTrace_chart_legend_wai: 'WAI threshold (when to irrigate)',
    dssTrace_chart_legend_flowering: 'Flowering (BBCH 60·75)',
    dssTrace_chart_callout: 'BBCH 60·75: Flowering & Fruit Set · system raises WAI threshold to 70%. Damage at this stage is irreversible.',
    // BBCH stage labels (used in chart tooltip)
    dssTrace_stage_0: 'Dormancy',
    dssTrace_stage_10: 'Bud break',
    dssTrace_stage_30: 'Shoot growth',
    dssTrace_stage_50: 'Inflorescence',
    dssTrace_stage_60: 'Flowering',
    dssTrace_stage_70: 'Fruit dev',
    dssTrace_stage_80: 'Ripening',
    dssTrace_stage_90: 'Post-harvest',

    // ── DSS Water Balance (DSSPageWaterBalance.js) ──────────────────
    dssWater_noData: 'No data available',
    dssWater_kpi_farmer: 'Farmer',
    dssWater_kpi_dssDiff: 'DSS difference',
    dssWater_kpi_irrigations: 'irrigations',
    dssWater_kpi_extraDays: 'additional days',
    dssWater_kpi_unitMin: 'm',
    dssWater_kpi_unitDay: 'd',
    dssWater_kpi_water: 'water',
    dssWater_interpretation: 'DSS recommends more frequent but shorter irrigations. Rather than a few large sessions, it maintains stable soil moisture near field capacity · preventing stress during flowering.',
    dssWater_interpretationAvg: ' Average duration per session: {min} minutes.',
    dssWater_chart_title: 'Pump Hours per Month',
    dssWater_chart_caption: 'Estimated pump operating hours: farmer vs DSS recommendations per month',
    dssWater_chart_yAxis: 'Hours',
    dssWater_chart_farmerHours: 'Farmer (hours)',
    dssWater_chart_dssHours: 'DSS (hours)',
    dssWater_chart_agreementPct: 'Agreement %',

    // Devices page, unified hardware list (GET /api/devices/)
    devicesPageTitle: 'Devices',
    devicesPageSubtitle: 'Every controller and sensor gateway, and what needs attention.',
    devicesEmpty: 'No devices registered yet.',
    devicesNeedAttention: 'need attention',
    devicesJobsStale: 'The system\'s automatic jobs have stopped. New readings are not being processed, so a device shown as online may not be.',
    deviceStateOnline: 'Online',
    deviceStateOffline: 'Offline',
    deviceStateNeverSeen: 'Never seen',
    deviceStateSpare: 'No field yet',
    deviceStateLab: 'Bench trial',
    deviceLabChoice: 'Bench trial (no field, readings not stored)',
    deviceStateDegraded: 'Needs attention',
    deviceStateUnregistered: 'Not registered',
    deviceKindController: 'Valve controller',
    deviceKindGateway: 'Sensor gateway',
    deviceKindProbe: 'Sensor on an IoT gateway',
    deviceVia: 'Reports through',
    deviceKindStation: 'Sensor station',
    deviceLastSeen: 'Last seen',
    deviceLastSeenNever: 'Never',
    deviceHealthBattery: 'Battery',
    deviceHealthSignal: 'Signal',
    deviceHealthFirmware: 'Firmware',
    deviceHealthNextExpected: 'Next reading expected',
    deviceHealthNextExpectedOverdue: 'Next reading overdue, expected',
    deviceRegisterThis: 'Register',
    deviceTelemetryShow: 'Show telemetry',
    deviceTelemetryLast: 'Latest',
    deviceTelemetryNote: 'Tension (cb) is the inverse of moisture: low = wet, high = dry.',
    deviceTelemetryEmpty: 'No decoded channel data yet.',
    deviceTelemetryError: 'Could not load telemetry.',
    deviceField: 'Field',
    deviceZone: 'Zone',
    deviceUnassigned: 'Not connected to a field',
    deviceMapping: 'Wiring',
    deviceMappingEmpty: 'No channels bound yet.',
    deviceMappingRelay: 'Relay',
    deviceMappingChannel: 'Channel',
    deviceMappingDepth: 'cm depth',
    deviceTestButton: 'Test',
    deviceTestSent: 'Test pulse sent',
    deviceTestFailed: 'Could not send test pulse',
    deviceEditMapping: 'Edit wiring',
    deviceAssignButton: 'Assign to field',
    devicePlainLanguageNote: 'What this means',
    deviceBindingDialogTitle: 'Bind a channel to a zone',
    deviceBindingChannelLabel: 'Channel',
    deviceBindingChannelHelp: "e.g. 'relay:0' for a valve, 's0.0' for sensor address 0 channel 0",
    deviceBindingZoneLabel: 'Zone',
    deviceBindingRoleLabel: 'Measures',
    deviceBindingDepthLabel: 'Depth (cm)',
    deviceBindingSave: 'Save wiring',
    deviceBindingCancel: 'Cancel',
    deviceBindingDelete: 'Remove',
    deviceBindingAdd: 'Add channel',
    deviceBindingSaved: 'Wiring saved',
    deviceBindingSaveFailed: 'Could not save, check the fields below',
    deviceBindingDeleteConfirm: 'Remove this channel binding?',
    deviceBindingEdit: 'Edit',
    deviceBindingEditDialogTitle: 'Edit channel binding',
    deviceRoleValve: 'Valve (opens irrigation)',
    deviceRoleVwc: 'Soil moisture',
    deviceRoleSoilTemp: 'Soil temperature',
    deviceRoleSalinity: 'Salinity',
    unboundZonesWarning: 'zone(s) are set to a controller but have no channel bound, irrigating them will do nothing.',

    // Edit / delete an existing device
    deviceEditButton: 'Edit device',
    deviceDeleteButton: 'Remove device',
    deviceDeleteConfirm: 'Remove this device? This cannot be undone.',
    deviceEditDialogTitle: 'Edit device',
    deviceDisplayNameLabel: 'Display name',
    deviceDisplayNameHelp: 'The name shown on this page. Leave blank to use the technical id.',
    deviceEditNotesLabel: 'Notes',
    deviceStatusLabel: 'What is happening to it',
    deviceStatusAssigned: 'Installed and working',
    deviceStatusSpare: 'In storage',
    deviceStatusMoving: 'Being moved',
    deviceStatusStopped: 'Out of service',
    deviceStatusRetired: 'Retired',
    deviceStatusHelp: 'Unless it is installed, it feeds nothing and raises no alarm. Its field stays on record.',
    deviceChangesTitle: 'Latest changes',
    deviceChangesAll: 'All history and undo',
    deviceChangesCreated: 'Added',
    deviceChangesEdited: 'Details changed',
    deviceEditActiveLabel: 'Status',
    deviceEditActiveYes: 'Active',
    deviceEditActiveNo: 'Inactive',
    deviceEditRegenerateToken: 'Regenerate token',
    deviceEditSave: 'Save',
    deviceEditSaveFailed: 'Could not save, check the fields below',
    historyTabChanges: 'Changes',
    historyTabActivity: 'Actions',
    activityLogin: 'Logged in',
    activityLoginFailed: 'Failed login',
    activityLogout: 'Logged out',
    activityRequest: 'Action',
    activityValveTest: 'Valve test',
    activityEmergencyStop: 'Emergency stop',
    activityStop: 'Stopped an irrigation',
    activityStart: 'Started an irrigation',
    activityBroadcast: 'Message to everyone',
    activityUndo: 'Undid a change',
    activityDownload: 'Download',
    activityNobody: 'Not logged in',
    activityFilter: 'Kind',
    activityNone: 'No actions yet.',
    activityPerson: 'Person',
    deviceMoveNote: 'Change the field once the unit stands in its new place. The new field shows it from its next message, and the change is recorded in the history.',

    // VWCw dashboard (in-app, mirrors the emailed client PDF)
    vwPanelRecommendation: 'Recommended irrigation',
    vwPanelMoisture: 'Weighted root-zone moisture',
    vwPanelSensors: 'Soil sensors',
    vwPanelForecast: 'TerraMind forecast',
    vwPanelForecastNoIrr: 'Forecast without irrigation',
    vwPanelForecastBoth: 'Forecast with and without irrigation',
    vwForecastWithRun: 'With the recommended irrigation',
    vwForecastNoRun: 'Without irrigation',
    vwPanelForecastAfterIrr: 'Forecast after today\'s irrigation',
    vwPanelTrend: 'Last 48h trend',
    vwDecisionIrrigateNow: 'Irrigate now',
    vwDecisionIrrigate: 'Irrigate today',
    vwDecisionMonitor: 'Monitor',
    vwDecisionSkip: 'No action',
    vwDecisionSuspend: 'Suspend (too wet)',
    vwDecisionNa: 'Unavailable',
    vwTensionBasis: 'Based on soil tension',
    vwTensionByDepth: 'Soil tension by depth',
    vwTensionTrigger: 'Irrigate above',
    vwTensionHint: 'higher cb = drier soil',
    vwTimingNow: 'Now',
    vwTimingToday: 'Today',
    vwTimingSuspend: 'No irrigation',
    vwTimingNot24h: 'Not within 24 hours',
    vwTimingLt6h: 'In under 6 hours',
    vwTiming612: 'In 6 to 12 hours',
    vwTiming1224: 'In 12 to 24 hours',
    vwZoneCritical: 'Critical',
    vwZoneWarning: 'Warning',
    vwZoneTarget: 'Target',
    vwZoneHigh: 'High',
    vwZoneFilling: 'Filling',
    vwZoneExcess: 'Excess',
    vwDuration: 'Duration',
    vwMinutes: 'min',
    vwNetDose: 'Net dose',
    vwTargetZone: 'Target zone',
    vwNow: 'Now',
    vwHourShort: 'h',
    vwNextEntry: 'Estimated entry into irrigation zone',
    vwNoIrrigation24h: 'No irrigation expected in the next 24h',
    vwNoForecast: 'Forecast unavailable',
    vwLegendVwcw: 'Weighted moisture',
    vwGaugeMoisture: 'Moisture',
    zoneOpenDetails: 'Open zone',
    vwLegendIrrigation: 'Irrigation',
    vwRain24h: 'Rain 24h',
    vwHeroNoIrrigation: 'No irrigation needed today',
    vwHeroIrrigate: 'Irrigation',
    vwHeroSuspend: 'No irrigation: the soil is too wet',
    vwHeroNextDuration: 'Next irrigation, when needed',
    vwHeroUpdates: 'Updates with every new reading',
    vwHeroUpdatesEstimate: 'Updates every hour from the weather',
    vwCtxLastReading: 'last reading',
    vwCtxEstimatedAt: 'estimated',
    vwCtxMaxTemp: 'Max temperature',
    vwCtxWaterDemand: 'Water evaporation',
    vwCtxStage: 'Growth stage',
    stageEdit: 'Correct the growth stage',
    stageDialogTitle: "The field's growth stage",
    stageDialogHelp: 'Pick the stage you see in the field today. The calendar continues from there, and the recommendation follows it.',
    stageCorrectedNote: 'You have corrected the stage this season.',
    stageReset: 'Back to the calendar',
    stageOutOfReach: 'This stage is more than 60 days from the calendar. Pick a nearer one.',
    stageLocked: 'The field is locked.',
    stageSaveError: 'Not saved. Please try again.',
    vwCtxSoil: 'Soil',
    vwCtxSoilLimits: 'field capacity / wilting point',
    vwRainDay: 'Rain',
    vwStale: 'Data delayed',
    liveRecReading: 'Reading',
    liveRecEstimate: 'Estimate',
    mobileNoReadings: 'No readings yet',
    vwRetry: 'Retry',
    vwLoadError: 'Could not load the dashboard.',
    vwNoProfile: 'This field\'s soil type has no VWCw threshold table yet. Set a supported soil texture (clay, silty clay, silt, loam, or loamy sand) to enable the dashboard.',
    vwNoData: 'No sensor readings reach this field yet. Once its sensors report, the dashboard will populate.',
    vwProvisionalSoil: 'Provisional soil thresholds, these bands are FAO-56 estimates, not yet confirmed by the agronomist. The recommendation is indicative until the field\'s soil profile is signed off.',
    provisionalShort: 'est.',
    vwcwTooltip: 'Weighted root-zone soil moisture (VWCw), the client\'s irrigation metric, combining 10/20/30 cm by depth weight.',
    historyNav: 'Change history',
    historySubtitle: 'Every edit and creation, who made it and when. Any of them can be taken back.',
    historyFilterModel: 'Show',
    historyAll: 'Everything',
    historyNone: 'No changes yet.',
    historyMore: 'Show older',
    historySystem: 'System',
    historyEmpty: 'empty',
    historyYes: 'yes',
    historyNo: 'no',
    historyUndo: 'Undo',
    historyRestore: 'Restore to this',
    historyCancel: 'Cancel',
    historyConfirmUndo: 'Take back this change? It stays in the history as a new entry.',
    historyConfirmRestore: 'Put it back as it was at this moment? Later changes to it are replaced, and stay in the history.',
    historyDone: 'Done. The history has a new entry.',
    historyUndoFailed: 'That did not go through. Nothing changed.',
    historyLoadFailed: 'The history could not be loaded.',
    historyTypeCreated: 'Created',
    historyTypeChanged: 'Changed',
    historyTypeDeleted: 'Deleted',
    historyReasonBaseline: 'State when the history began',
    historyReasonPassword: 'Password changed',
    historyReasonUndo: 'Undo',
    historyReasonRestore: 'Restore',
    historyReasonNames: 'Names put in one form',
    historyRefusedBaseline: 'This is where the history starts, there is nothing to undo.',
    historyRefusedValves: 'A schedule can open a valve, so change it from the irrigation schedule.',
    historyRefusedPerson: 'Accounts are changed only by the main administrator.',
    historyRefusedSecret: 'This device has to be set up again, its key is not kept in the history.',
    historyRefusedChanged: 'This value changed again since. Use restore to go back to this moment.',
    historyRefusedNothingBefore: 'There is no earlier state to go back to.',
    historyRefusedInUse: 'Other data depends on it, so it stays.',
    historyRefusedGone: 'It no longer exists.',
    historyRefusedNothingToUndo: 'It is already back.',
    historyModelUser: 'Account',
    historyModelPreference: 'Account settings',
    historyModelSubscription: 'Subscription',
    historyModelField: 'Field',
    historyModelZone: 'Zone',
    historyModelSoilProfile: 'Soil profile',
    historyModelSensorDevice: 'Field sensor',
    historyModelBinding: 'Device connection',
    historyModelTreeClass: 'Tree class',
    historyModelTree: 'Tree',
    historyModelProduction: 'Production',
    historyModelSeason: 'Season',
    historyModelEdgeDevice: 'Controller',
    historyModelNote: 'Field note',
    historyModelApiKey: 'Sensor key',
    historyModelIoTDevice: 'Device',
    historyModelHub: 'Sensor hub',
    historyModelDevice: 'Sensor',
    historyModelSentek: 'Sentek logger',
    historyModelSchedule: 'Irrigation',
    historyModelWeekly: 'Recurring irrigation',
    historyModelEvent: 'Field event',
    historyModelStation: 'Weather station',
    historyModelAlertRule: 'Alert rule',
    historyModelMessage: 'Support message',
    historyFieldName: 'Name',
    historyFieldOwner: 'Owner',
    historyFieldField: 'Field',
    historyFieldZone: 'Zone',
    historyFieldLabel: 'Label',
    historyFieldStatus: 'Status',
    historyFieldNotes: 'Notes',
    historyFieldActive: 'Active',
    historyFieldCrop: 'Crop',
    historyFieldArea: 'Area',
    historyFieldSoil: 'Soil',
    historyFieldDeletedAt: 'Deleted at',
    historyFieldDeletedBy: 'Deleted by',
    historyFieldUsername: 'Username',
    historyFieldEmail: 'Email',
    historyFieldFirstName: 'First name',
    historyFieldLastName: 'Last name',
    historyFieldGroups: 'Role',
    historyFieldStaff: 'Staff',
    historyFieldSuperuser: 'Main administrator',
    historyFieldDuration: 'Duration',
    historyFieldScheduled: 'Time',
    historyFieldDescription: 'Description',
    onbTitle: 'New customer',
    onbStepPerson: 'The person',
    onbStepFields: 'The fields',
    onbStepNext: 'What is left',
    onbExisting: 'For whom',
    onbNewPerson: 'A new person',
    onbNoMail: 'No email goes out. You get a link to pass on when the time comes.',
    onbFieldsHelp: 'Choose a KML, KMZ or GeoJSON file. Each outline becomes a field. Fill in what you know, the rest can wait.',
    onbCrop: 'Crop',
    onbVariety: 'Variety',
    onbKaek: 'Land registry code (KAEK)',
    onbPlanted: 'Planted',
    onbTrees: 'Trees',
    onbCaco3: 'Calcium carbonate %',
    onbOrganic: 'Organic matter %',
    onbEc: 'Conductivity mS/cm',
    onbNext: 'Next',
    onbSkipFields: 'Later',
    onbDone: '{name} has {n} new fields.',
    onbGoZones: 'Add zones to the fields',
    onbGoDevices: 'Connect sensors and valves',
    onbLinkHelp: 'The link for setting a password. Nothing was sent, pass it on when the time comes.',
    soilProfiles: 'Soil profiles',
    spTitle: 'Soil profiles',
    spSubtitle: 'Review and correct the moisture thresholds for each soil texture. Editing a texture affects every field of that texture.',
    spProvisional: 'These bands are FAO-56 estimates awaiting your sign-off. Turn off "Provisional" once you have confirmed them.',
    spProvisionalFlag: 'Provisional',
    spFC: 'Field capacity (%)',
    spWP: 'Wilting point (%)',
    spRootZone: 'Root zone (m)',
    spTensionTrigger: 'Tension trigger (cb)',
    spTensionTriggerHelp: 'Used where the probe reads tension, not moisture',
    spMonth: 'Month',
    spDerived: 'VWCw (auto)',
    spDerivedHint: 'Derived automatically from the weights and per-depth bands.',
    spWeightsSum: 'Depth weights in each month must sum to 1.0 (highlighted rows do not).',
    spSave: 'Save',
    spResetBtn: 'Reset to default',
    spSaved: 'Soil profile saved. It is now live.',
    spReset: 'Restored to the built-in defaults.',
    spSaveError: 'Save failed.',
    spResetError: 'Reset failed.',
    spLoadError: 'Could not load soil profiles.',
    vwRefresh: 'Refresh',
    vwAsOf: 'As of',
    vwForecastDays: 'Next days',
    vwProvenance: 'The recommendations come from your own sensors and the weather forecast.',
    vwProvenanceEstimate: 'No sensor in this field: the moisture is estimated from the weather, the crop, the soil and the recorded irrigations.',
    vwRecentReports: 'Recent reports',
    vwReportsNone: 'No reports generated yet for this field.',
    vwReportsLoadError: 'Could not load reports.',
    vwReportsOpenError: 'Could not open that report.',
    vwReportView: 'View',
    vwReportDownload: 'Download',
    // The trade-fair player (/showcase). A stand exhibit, not a product page:
    // it replays a measured fortnight and lets a visitor ask the real engine
    // what it would say under different weather.
    // Guided walkthrough captions. Written to be read aloud: one idea each,
    // no jargon, and every number in them is measured at station 810.
    tourIntro: 'A kiwi orchard in Veria. One station, three depths, every hour.',
    tourDry: 'First of October. The root zone is at 25 per cent and falling.',
    tourDepths: 'The depths disagree, and that is the point. Ten centimetres is at 21 per cent, thirty is still at 31. The surface dries first.',
    tourVerdict: 'The platform asks for 50 minutes. Not a guess at a schedule, a number that comes from how dry the roots actually are.',
    tourRainFell: 'Overnight, 67 millimetres arrive.',
    tourSkip: 'So the answer changes on its own. Do not water. Nobody had to cancel anything.',
    tourDryDown: 'Then a fortnight of drying, hour by hour, with nothing to do about it.',
    tourAgain: 'The thirteenth. Water again, 35 minutes.',
    tourLonger: 'Three days later the same field needs 50. The drier it gets, the longer it asks for.',
    tourWhatIf: 'What if rain were forecast? Twenty millimetres, and the recommendation stands down.',
    tourUndo: 'Back to what actually happened.',
    tourSoil: 'Now the same reading on sandy ground. The verdict flips, because the whole scale moves. Critical falls from 29 per cent to 12.',
    tourSoilBack: 'Back to the real soil of this field, which is clay.',
    tourShallowRain: 'The seventeenth. Fourteen millimetres fell. Ten centimetres jumped from 21 to 34, and twenty centimetres did not move at all. The rain wet the surface and never reached the roots. A rain gauge would have called that a wet day.',
    tourEnd: 'Fourteen days, measured. Every recommendation came from the same engine that runs the platform every morning.',
    tourPrev: 'Previous step',
    tourNext: 'Next step',
    tourTakeControl: 'Take control',
    tourRestart: 'Play the walkthrough',
    // The farm overview and the report, in the walkthrough.
    farmTitle: 'My fields',
    farmIntro: 'Six fields, and the platform is honest about what it can do on each one.',
    farmTotalFields: 'fields',
    farmTotalMonitored: 'reporting',
    farmTotalControllable: 'switchable',
    farmZones: '{n} zones',
    farmMonLive: 'Sensor reporting',
    farmMonStale: 'Sensor quiet',
    farmMonSilent: 'Sensor down',
    farmMonNone: 'No sensor',
    farmCtlReady: 'Valve ready',
    farmCtlOffline: 'Valve offline',
    farmCtlNone: 'No valve',
    reportTitle: 'The morning report',
    reportIntro: 'It arrives by email and it stays in the platform, so it is there on any device.',
    reportStamp: 'measured at station 810',
    reportVerdictLabel: 'Today',
    reportWater: 'Water for {n} minutes',
    reportNoWater: 'No watering needed',
    reportRowMoisture: 'Root zone moisture',
    reportRowZone: 'Band',
    reportRowDepths: 'At 10 / 20 / 30 cm',
    reportRowRain: 'Rain that day',
    reportRowTemp: 'Highest temperature',
    reportRowHours: 'Hours asking for water',
    reportHoursValue: '{n} of 24',
    tourFarm: 'This is the farm as the platform sees it. Six fields, one screen, every morning.',
    tourFarmMix: 'And it says plainly what it can do on each. Two fields it can measure and switch. Two it can only switch. One has a probe and no valve. Nobody has to guess which is which.',
    tourSubject: 'This one has the probe we are about to follow, for a fortnight.',
    tourReport: 'And this arrives every morning. The same numbers, on one page, in the platform rather than only in an inbox.',
    controlTitle: 'Watering it, from here',
    controlIntro: 'Three zones on one controller, {device}, all answering.',
    controlZone: 'Zone {n}',
    controlRelay: 'Valve {n}',
    controlOnline: 'Answering',
    controlOffline: 'Offline',
    controlStart: 'Start',
    controlRunning: 'Watering',
    controlSafety: 'These valves are live on a working farm, so nothing on this screen opens one.',
    tourControl: 'Knowing is half of it. This field has three valves on one controller, and all three are answering.',
    tourPress: 'The recommendation was 50 minutes on zone two. One press.',
    tourRunning: 'It is watering. Not a message to somebody, not a note to do it later. The valve is open.',
    tourLogged: 'And it is written down: which zone, how long, who asked for it. That record is what next year is planned from.',
    seasonTitle: 'The {y} season, as the station recorded it',
    seasonIntro: 'Not a projection. This is what the probe and the rain gauge actually logged, from March to October.',
    seasonHours: 'hours of measurement',
    seasonRain: 'of rain, counted',
    seasonWaterings: 'waterings, logged',
    seasonHonest: 'There is no water-saved figure on this screen. That would need to know what this farmer would have done without the platform, and nobody measured it.',
    tourFarmGaps: 'And where there is a gap it says so. One field has a probe that has stopped talking. Better to see that here than to find it in August.',
    tourShallowWhy: 'A rain gauge would have called that a wet day and told him to skip the watering. The probe knew better.',
    tourSeason: 'Over a season it adds up. Five thousand eight hundred hours of measurement, four hundred and twenty millimetres of rain counted, a hundred and thirty-eight waterings logged.',
    tourHonest: 'And no invented savings figure, because nobody measured what he would have done without it. The record is the argument.',
    showcaseSwitchLanguage: 'Switch to Greek',
    showcaseLangShort: 'EL',
    manualDurationNoRec: 'No recommendation for this zone right now. Any duration you set here is your own.',
    tourShowFieldsTitle: 'Your whole farm at a glance',
    tourShowFieldsDesc: 'Open the app and every field tells you where it stands. The one that needs you is already flagged.',
    tourShowZonesTitle: 'See the water where the roots are',
    tourShowZonesDesc: 'Moisture at three depths, live. The surface lies. The root zone is where the crop is won or lost.',
    tourTrendTitle: 'Moisture over time',
    tourTrendDesc: 'Soil water at 10, 20 and 30 cm across the period, with the refill and full lines marked.',
    tourShowTrendTitle: 'The data behind the call',
    tourShowTrendDesc: 'This field\'s probes read soil moisture at 10, 20 and 30 cm. The line dropping to the refill mark drove the decision.',
    tourShowWeatherTitle: 'It already checked the forecast for you',
    tourShowWeatherDesc: 'Heat and rain for the days ahead, folded into every decision. No watering the ground before a storm.',
    tourShowDssTitle: 'The decision, and the reason behind it',
    tourShowDssDesc: 'Water this zone, this long, because the root zone dried below the safe line. The readings behind the call are all here.',
    tourShowApproveTitle: 'You approve, in one tap',
    tourShowApproveDesc: 'Happy with the call? Approve it. Change the minutes or the start first if you want. You stay in charge.',
    tourShowNdviTitle: 'Proof from space',
    tourShowNdviDesc: 'Satellite imagery over your zones. A weak corner shows here weeks before you would spot it on foot.',
    tourShowMapTitle: 'Every block, one glance',
    tourShowMapDesc: 'Your orchard as it sits on the ground, each zone coloured by what it needs today.',
    tourShowScheduleTitle: 'Approved, and now it is scheduled',
    tourShowScheduleDesc: 'The run you agreed sits on the calendar. Move the start or change the duration to fit your own setup.',
    tourShowProgrammeTitle: 'The next recommendations, your call',
    tourShowProgrammeDesc: 'The algorithm keeps proposing the runs ahead. Approve the ones you want, or set your own by hand.',
    tourShowReportsTitle: 'Your paperwork, already written',
    tourShowReportsDesc: 'Every decision kept with the numbers behind it. When the export auditor asks, you open a page.',
    tourShowReportTitle: 'The whole day on one page',
    tourShowReportDesc: 'Built from this field. Soil moisture at three depths, soil temperature, weather and growth stage, with what ran and why. Fully sourced.',
    tourShowReportGenerateTitle: 'A full report, on demand',
    tourShowReportGenerateDesc: 'The platform builds the day report on the spot, ready to read the moment you ask, any time of day.',
    tourShowFleetTitle: 'Every device, named and healthy',
    tourShowFleetDesc: 'IoT gateways, sensors and controllers, each on its own tab, named the way you call the field, with its status.',
    tourShowHardwareTitle: 'Keep the gear you already bought',
    tourShowHardwareDesc: 'Works on top of any sensors and controllers in the field. No rip-out, no new supplier.',
    tourShowAlertsTitle: 'It flags what needs you first',
    tourShowAlertsDesc: 'Every warning in one place, sorted by what matters. The dry block reached you before the leaves showed it.',
        showcaseChapterProblemKicker: 'The problem',
showcaseChapterProblemTitle: 'Watering by feel is a gamble',
    showcaseChapterProblemDesc: 'In a high-value orchard the wrong call costs fruit, quality and water. Every year, on every block.',
        showcaseChapterDiagnosisKicker: '01 Diagnose',
showcaseChapterDiagnosisTitle: 'It reads the whole field',
    showcaseChapterDiagnosisDesc: 'Root-zone moisture, soil tension, weather, crop stage and history, together.',
        showcaseChapterDecisionKicker: '02 Decide',
showcaseChapterDecisionTitle: 'It makes the call',
    showcaseChapterDecisionDesc: 'Every soil depth, the crop\'s own limits, and reasoning you can follow. One answer per zone.',
        showcaseChapterActionKicker: '03 Act',
showcaseChapterActionTitle: 'It carries the call out',
    showcaseChapterActionDesc: 'Time, duration, reason. You stay in charge. The orchard runs itself.',
    showcaseIntroKicker: 'AI Irrigation Decision Engine',
    showcaseIntroLine: 'When to irrigate, how much, and why.',
    showcaseOutroTitle: 'Stop guessing. Start deciding.',
    showcaseOutroLine: 'Proven on a commercial kiwifruit orchard in Northern Greece. Patent filed.',
    showcaseOutroContact: 'www.terramind.gr',
    showcasePreparing: 'Preparing the demo…',
    showcasePlay: 'Play',
    showcasePause: 'Pause',
    durationNotAvailable: 'see settings',
    tourPauseDemo: 'Pause',
    tourResumeDemo: 'Play',
    tourExitDemo: 'Exit',
    // Demo voice: what the screen means. The tutorial keeps its own
    // instructional copy for a farmer learning the app with a mouse in hand.
    showcaseNext: 'Next',
    showcasePrev: 'Previous',
    showcaseSpeed: 'Playback speed',
    showcaseExit: 'Close',
    showcaseYouAreDriving: 'You have control',
    showcaseHistoricalNote: 'Real data from this field, on a day it needed water.',
    showcaseWrongAccountTitle: 'Start the trailer on the showcase account',
    showcaseWrongAccountBody: 'The stand trailer runs on the prepared showcase orchard, where one block is set up to need water so the decision is clear. You are signed in as another account, so the demo would play on whatever data that account holds. Sign out and sign in as the showcase account, then open this page again.',
    showcaseWrongAccountCurrent: 'Signed in as',
    showcaseWrongAccountProceed: 'Play here anyway',
    tourSectionHardware: 'Hardware',
    tourSectionReports: 'Reports',
    tourCoverageTitle: 'What each field can actually do',
    tourCoverageDesc: 'Every field, and whether the platform can measure it, water it, or both. A field with a probe and no valve says so, instead of leaving you to find out when a button does nothing.',
    tourHardwareTabsTitle: 'The equipment behind it',
    tourHardwareTabsDesc: 'Stations, gateways and valve controllers, each one showing whether it is answering right now. Adding a new controller is done here, not by anyone visiting the field.',
    tourReportsGenerateTitle: 'Generate a report now',
    tourReportsGenerateDesc: 'Make a fresh report whenever you want one, without waiting for the daily email. It opens here in a few seconds.',
    tourReportsListTitle: 'Every report it has produced',
    tourReportsListDesc: 'The irrigation report runs four times a day and the sensor report three. They arrive by email and they stay here, so nothing is lost with a deleted message.',
    tourReportsViewerTitle: 'The report itself',
    tourReportsViewerDesc: 'The same figures the screens showed you, on one page, ready to keep or to hand to an agronomist.',
    reportsNavLabel: 'Reports',
    reportsPageTitle: 'Reports',
    reportsPageSubtitle: 'Every irrigation and sensor report the platform has produced, newest first',
    reportsFilterAll: 'All',
    reportsDownload: 'Download',
    reportsNoneOfThisType: 'No report of this kind yet.',
    reportsEmptyTitle: 'No report yet',
    reportsEmptyBody: 'Your reports appear here. Press «Generate report now» for the first one.',
    reportsLoadFailed: 'The list of reports could not be loaded.',
    reportsOpenFailed: 'This report could not be opened. Try downloading it.',
    reportsGenerateNow: 'Generate report now',
    reportsGenerating: 'Generating...',
    reportsGenerateChoose: 'Choose report type',
    reportsGenerateVwcw: 'Irrigation report',
    reportsGenerateIot: 'Sensor report',
    reportsGenerateField: 'Field report',
    reportsWindow: 'Time window',
    reportsWindow2d: '48 hours',
    reportsWindow7d: '7 days',
    reportsWindow14d: '14 days',
    reportsSections: 'Contents',
    reportSection_sensors: 'Soil sensors per depth',
    reportSection_soil: 'Soil temperature and salinity',
    reportSection_forecast: 'Forecast',
    reportSection_weather: 'Weather',
    reportsGenerateFailed: 'The report could not be generated. Please try again.',
    reportsGenerateBusy: 'A report is already being generated. Please try again in a moment.',
    reportTypeVwcwDaily: 'Irrigation, daily',
    reportTypeVwcwSimple: 'Irrigation, short',
    reportTypeFieldDaily: 'Field report, daily',
    reportTypeFieldSimple: 'Field report, short',
    reportTypeFarm: 'All fields',
    reasonShort_ROOTZONE_BELOW_MIN: 'Root zone below minimum',
    reasonShort_ROOTZONE_STRESSED: 'Root zone stressed',
    reasonShort_SUBSOIL_DRY: 'Deep layer dry',
    reasonShort_HEAT_STRESS: 'Heat',
    reasonShort_MARGINAL_HIGH_ET: 'Marginal, high demand',
    reasonShort_DRYING_TREND: 'Drying',
    reasonShort_FROST_PROTECT: 'Frost protection',
    reasonShort_RAIN_SKIP: 'Rain forecast',
    reasonShort_RAIN_FORECAST: 'Rain forecast',
    reasonShort_RECENT_RAIN: 'Recent rain',
    reasonShort_RECENTLY_IRRIGATED: 'Recently irrigated',
    reasonShort_SOIL_ADEQUATE: 'Moisture adequate',
    reasonShort_OFF_SEASON: 'Off season',
    reasonShort_OFF_SEASON_DRY: 'Off season, dry',
    reasonShort_IRRIGATING: 'Irrigating',
    reasonShort_JUST_IRRIGATED: 'Just irrigated',
    reasonShort_NO_DATA: 'No data',
    reasonShort_NO_SENSOR_DATA: 'No sensor data',
    reasonShort_STALE_DATA: 'Readings too old',
    reasonShort_SATURATED: 'Soil saturated',
    reasonShort_MANUAL_OVERRIDE: 'Changed by the farmer',
    reasonShort_WEEKLY_BASELINE: 'Weekly schedule',
    reportsGenerateFarm: 'All fields, each on its own page',
    reportsScope: 'What the report covers',
    reportsWholeField: 'The whole field',
    reportTypeIot4h2o: 'Sensors',
    reportTypeIot4h2oSnapshot: 'Sensor snapshot',

    // Register-a-device dialog
    deviceRegisterButton: 'Add device',
    deviceRegisterDialogTitle: 'Register a device',
    deviceRegisterKindLabel: 'Device type',
    deviceRegisterKindController: 'Valve controller (ESP8266 / ESP32)',
    deviceRegisterKindGateway: 'Sensor gateway (telemetry unit)',
    deviceRegisterKindSentek: 'Sentek probe (IrriMAX Live)',
    deviceRegisterSentekNameLabel: 'Logger name in IrriMAX Live',
    deviceRegisterSentekNameHelp: 'Exactly as IrriMAX Live shows it, e.g. terramind001',
    deviceRegisterSentekTest: 'Test',
    deviceRegisterFieldHelpSentek: 'The field the probe stands in.',
    deviceRegisterSentekTestOk: 'Connected. Latest reading {time}: {values}',
    deviceRegisterIdLabel: 'Device ID',
    deviceRegisterIdHelp: 'Must match exactly what the physical unit sends.',
    deviceRegisterVendorLabel: 'Vendor',
    deviceRegisterModelLabel: 'Model',
    deviceRegisterFieldLabel: 'Field',
    deviceRegisterFieldHelpSpare: 'Leave blank to register it as a spare, not installed anywhere yet.',
    deviceRegisterFieldHelpRequired: 'A controller must be assigned to a field.',
    deviceRegisterZoneLabel: 'Zone (optional)',
    deviceRegisterSubmit: 'Register',
    deviceRegisterCancel: 'Cancel',
    recViewSubtitle: 'What the system recommended and the irrigations made, per field and day.',
    recViewAppRunsOnly: 'Irrigations started from the app are counted. Irrigation done outside the app does not appear yet.',
    recViewIrrigateDays: 'Days with an irrigation call',
    recViewRuns: 'Irrigations',
    recViewMinutesRun: 'Minutes of irrigation',
    recViewWithoutCall: 'Irrigations without a call',
    recViewNoResponseDays: 'Days with no soil response',
    recViewLegendRun: 'Minutes run',
    recViewLegendCall: 'Minutes recommended',
    recViewLegendForecast: 'Irrigation hour forecast',
    recViewLegendNoResponse: 'No soil response',
    recViewNoCall: 'No call recorded',
    recViewCallIrrigate: 'Call: irrigate',
    recViewCallForecast: 'Call: irrigation forecast for a later hour',
    recViewCallNone: 'Call: no irrigation',
    recViewNoResponse: 'no soil response',
    recViewNotRecorded: 'No recommendations recorded for this field yet.',
    recViewEmpty: 'No fields to show.',
    recViewError: 'The data could not be loaded.',
    recViewStripAria: 'Recommendations and irrigations per day',
    readingsDays: '{n} days',
    readingsMeasure_moisture: 'soil moisture',
    readingsMeasure_tension: 'soil tension',
    readingsMeasure_soil_temp: 'soil temperature',
    readingsSensor: 'Sensor',
    readingsShort_moisture: 'moisture',
    readingsShort_tension: 'tension',
    readingsShort_soil_temp: 'temperature',
    readingsLimit: 'Irrigation limit',
    readingsIrrigation: 'Irrigation run',
    readingsSuspect: 'Sensor reading not trusted',
    readingsEmpty: 'No readings in this period.',
    readingsError: 'The readings could not be loaded.',
    readingsTitle: 'Readings',
    deviceConnectButton: 'Connect to a field',
    deviceConnectTitle: 'Connect the unit to a field',
    deviceConnectIntro: 'Choose the field and zone where its sensors are installed. From the moment you connect it, its readings are saved and used in the recommendations for that field.',
    deviceConnectNow: 'Current values',
    deviceConnectNotInSoil: 'Moisture reads almost zero, so the sensors are probably not in the soil yet. Moisture of 1 % or less is never saved.',
    deviceConnectField: 'Field',
    deviceConnectZone: 'Zone (optional)',
    deviceConnectWholeField: 'Whole field',
    deviceConnectSave: 'Connect',
    deviceConnectNoProbe: 'No sensor was recognised on this unit. Check that the sensors are plugged into the gateway.',
    deviceConnectFailed: 'The unit could not be connected. Please try again.',
    deviceRegisterSaved: 'Device registered',
    deviceRegisterSaveFailed: 'Could not register the device, check the fields below',
    deviceRegisterTokenLabel: 'Token (leave blank to generate one)',
    deviceRegisterTokenHelp: 'If the board is already flashed, paste the token it carries. Otherwise leave this empty and one will be issued.',
    deviceRegisterTokenTitle: 'Save this token now',
    deviceRegisterTokenBody: 'This is shown once. Copy it into the device firmware.',
    deviceRegisterTokenDone: 'Done',
    deviceRegisterSpareBadge: 'Spare (not installed)',
  },

  el: {
    pageNotFound: 'Η σελίδα δεν βρέθηκε',
    backToFields: 'Επιστροφή στα χωράφια μου',
    // Navigation
    fieldInsights: 'Στοιχεία Χωραφιών',
    soilMoistureRange: 'Εύρος Υγρασίας Εδάφους',
    totalWaterToday: 'Συνολικό Νερό Σήμερα',
    lastIrrigation: 'Τελευταία άρδευση',
    // Navigation
    map: 'Χάρτης',
    home: 'Αρχική',
    goodMorning: 'Καλημέρα',
    fieldData: 'Δεδομένα χωραφιού',
    fields: 'Χωράφια',
    myFields: 'Χωράφια μου',
    usersNavLabel: 'Χρήστες',
    recViewNavLabel: 'Συστάσεις και αρδεύσεις',
    recViewNavSub: 'Τι πρότεινε η σύσταση κάθε μέρα και ποιες αρδεύσεις έγιναν',
    fieldChartsTitle: 'Γραφήματα',
    fieldChartsSub: 'Φτιάξτε τα δικά σας γραφήματα από τις μετρήσεις του χωραφιού και κατεβάστε τα σε CSV',
    scopeMine: 'Δικά μου',
    scopeAll: 'Όλα',
    scopeAllTip: 'Δείτε τα χωράφια όλων των λογαριασμών',
    scopeMineTip: 'Δείτε μόνο τα δικά σας χωράφια',
    demoBadge: 'DEMO',
    notifications: 'Ειδοποιήσεις',
    now: 'Τώρα',
    sensors: 'Αισθητήρες',
    edgeDevices: 'Συσκευές Edge',
    devicesNavLabel: 'Συσκευές',
    hardwareNavLabel: 'Εξοπλισμός',
    hardwarePageTitle: 'Εξοπλισμός',
    hardwarePageSubtitle: 'Παρακολούθηση και ρύθμιση όλου του εξοπλισμού, αισθητήρες, πύλες και ελεγκτές',
    hardwareTabIot: 'IoT',
    hardwareTabSensors: 'Αισθητήρες',
    hardwareTabControllers: 'Ελεγκτές',
    hardwareTabRegistry: 'Μητρώο',
    hardwareTabEdge: 'Ηλεκτροβάνες',
    customizeDashboard: 'Προσαρμογή',
    customizeDashboardTitle: 'Προσαρμογή πίνακα',
    customizeDashboardHint: 'Επιλέξτε ποιες ενότητες θα εμφανίζονται. Η επιλογή σας αποθηκεύεται στον λογαριασμό σας.',
    sectionKpis: 'Βασικοί δείκτες',
    sectionWaterComparison: 'Νερό: σύμβουλος έναντι χειροκίνητου',
    resetToDefaults: 'Επαναφορά',
    doneLabel: 'Τέλος',
    allSectionsHidden: 'Όλες οι ενότητες είναι κρυμμένες. Χρησιμοποιήστε την Προσαρμογή για να τις εμφανίσετε.',
    irrigation: 'Άρδευση',
    weather: 'Καιρός',
    alerts: 'Ειδοποιήσεις',
    analytics: 'Δεδομένα Αγρού',
    weeklySchedules: 'Προγράμματα',
    dataCharts: 'Δεδομένα & Ανάλυση',

    // Data page
    ndviHistory: 'Ιστορικό NDVI',
    volumetricWaterContent: 'Υγρασία εδάφους (%)',
    weeklyIrrigationTotals: 'Εβδομαδιαία Σύνολα Άρδευσης',
    weatherTrends: 'Τάσεις Καιρού',
    ndviDataNotAvailable: 'Η χρονολογία στιγμιοτύπων NDVI σύντομα',
    errorLoadingFields: 'Σφάλμα φόρτωσης χωραφιών',
    liters: 'Λίτρα',
    searchFields: 'Αναζήτηση χωραφιών...',
    needsAttention: 'Χρειάζεται Προσοχή',
    healthy: 'Υγιή',
    filterByField: 'Φίλτρο ανά χωράφι',
    adminTools: 'Εργαλεία Διαχείρισης',
    interactiveDemo: 'Διαδραστική Επίδειξη',
    smartIrrigation: 'Έξυπνη Άρδευση',
    systemOnline: 'Σύστημα Σε Σύνδεση',
    lastSync: 'Τελευταίος συγχρονισμός',
    
    // Dashboard
    terraMindDashboard: 'Ταμπλό',
    smartIrrigationManagement: 'Σύστημα Διαχείρισης Έξυπνης Άρδευσης',
    lastUpdated: 'Τελευταία ενημέρωση',
    liveMode: 'Ζωντανή Λειτουργία',
    refreshData: 'Ανανέωση Δεδομένων',
    chartSettings: 'Ρυθμίσεις γραφήματος',
    showMethodology: 'Εμφάνιση μεθοδολογίας',
    waiTooltip: 'Πόσο υγρό είναι το χώμα. 0% είναι τελείως ξηρό, 100% είναι πλήρως κορεσμένο.',
    activeAlerts: 'Ενεργές Ειδοποιήσεις',
    activeFields: 'Ενεργά Χωράφια',
    agriculturalZones: 'Γεωργικές ζώνες',
    sensorNetwork: 'Δίκτυο Αισθητήρων',
    iotDevicesOnline: 'Συσκευές IoT σε σύνδεση',
    devices: 'Συσκευές',
    activeIrrigation: 'Ενεργή Άρδευση',
    zonesWateringNow: 'Ζώνες που ποτίζονται τώρα',
    waterSaved: 'Νερό που Εξοικονομήθηκε',
    vsTraditionalMethods: 'έναντι παραδοσιακών μεθόδων',
    environmentalMonitoring: 'Παρακολούθηση Περιβάλλοντος',
    realTimeData: 'Δεδομένα Σε Πραγματικό Χρόνο',
    waterUsageToday: 'Κατανάλωση Νερού Σήμερα',
    systemStatus: 'Κατάσταση Συστήματος',
    allSystemsOperational: 'Όλα τα Συστήματα Λειτουργούν',
    sensorsOnline: 'αισθητήρες σε σύνδεση',
    fieldsActive: 'χωράφια ενεργά',
    weatherAPIConnected: 'API Καιρού Συνδεδεμένο',
    realTimeDataFrom: 'Δεδομένα σε πραγματικό χρόνο από',
    sources: 'πηγές',
    irrigationAlerts: 'Ειδοποιήσεις Άρδευσης',
    zonesNeedAttention: 'ζώνες χρειάζονται προσοχή',
    nextIrrigationCycle: 'Επόμενος Κύκλος Άρδευσης',
    fieldAlphaIn: 'Χωράφι Alpha σε',
    hours: 'ώρες',
    performanceMetrics: 'Μετρήσεις Απόδοσης',
    waterEfficiency: 'Αποδοτικότητα Νερού',
    cropHealthIndex: 'Δείκτης Υγείας Καλλιέργειας',
    predictionAccuracy: 'Ακρίβεια Πρόβλεψης',

    // Field Journal
    fieldJournal: 'Ημερολόγιο',
    production: 'Παραγωγή',
    productionOverview: 'Επισκόπηση Παραγωγής',
    productionSubtitle: 'Ετήσια απόδοση, ποιότητα και χρήση νερού ανά χωράφι',
    yieldPerStremma: 'Απόδοση ανά Στρέμμα',
    totalYield: 'Συνολική Απόδοση',
    totalYieldKg: 'Συνολική Απόδοση (kg)',
    fruitWeight: 'Μέσο Βάρος Καρπού',
    avgFruitWeightG: 'Μέσο Βάρος Καρπού (g)',
    totalWaterM3: 'Συνολικό Νερό (m³)',
    waterUsed: 'Νερό που Χρησιμοποιήθηκε',
    quality: 'Ποιότητα',
    addYear: 'Προσθήκη Έτους',
    addProduction: 'Προσθήκη Παραγωγής',
    editProduction: 'Επεξεργασία Παραγωγής',
    noProductionData: 'Δεν υπάρχουν δεδομένα παραγωγής',
    stremma: 'στρ.',
    unitArea: 'στρ.',

    // Welcome
    welcomeToTerraMind: 'Καλώς ήρθατε στο TerraMind',
    theSmartIrrigationPlatform: 'Η Πλατφόρμα Έξυπνης Άρδευσης',
    optimizeYourIrrigation: 'Βελτιστοποιήστε την Άρδευσή σας με AI',
    terraMindUsesAdvanced: 'Το TerraMind χρησιμοποιεί προηγμένους αλγορίθμους, δεδομένα αισθητήρων σε πραγματικό χρόνο και προβλέψεις καιρού για να παρέχει ακριβείς συστάσεις άρδευσης. Εξοικονομήστε νερό, μειώστε το κόστος και βελτιώστε την απόδοση της καλλιέργειας.',
    keyFeatures: 'Κύρια Χαρακτηριστικά',
    everythingYouNeed: 'Όλα όσα χρειάζεστε για έξυπνη γεωργία',
    realtimeMonitoring: 'Παρακολούθηση Σε Πραγματικό Χρόνο',
    trackSoilMoisture: 'Παρακολουθήστε την υγρασία εδάφους, τη θερμοκρασία και την υγρασία 24/7',
    weatherIntegration: 'Ενσωμάτωση Καιρού',
    forecastRainfall: 'Προβλέψτε τη βροχή & προσαρμόστε αυτόματα την άρδευση',
    smartDecisions: 'Έξυπνες Αποφάσεις',
    getPreciseRecommendations: 'Λάβετε ακριβείς συστάσεις για πότε και πόσο να ποτίσετε',
    performanceTracking: 'Παρακολούθηση Απόδοσης',
    monitorEfficiencyMetrics: 'Παρακολουθήστε τις μετρήσεις αποδοτικότητας και τις τάσεις του ιστορικού',
    gettingStarted: 'Ξεκίνημα',
    navigateYourDashboard: 'Περιηγηθείτε στο ταμπλό σας',
    dashboard_desc: 'Προβάλλετε μετρήσεις σε πραγματικό χρόνο, ενεργές ειδοποιήσεις και κατάσταση συστήματος με μια ματιά.',
    fieldsZones: 'Χωράφια & Ζώνες',
    manageYourAgricultural: 'Διαχειριστείτε τα γεωργικά σας χωράφια και ρυθμίστε ζώνες άρδευσης με προσαρμοσμένες παραμέτρους.',
    analyticsReports: 'Ανάλυση & Αναφορές',
    trackWaterUsage: 'Παρακολουθήστε την κατανάλωση νερού, τις μετρήσεις αποδοτικότητας και τα ιστορικά δεδομένα απόδοσης.',
    getStarted: 'Ξεκίνημα',
    back: 'Πίσω',
    next: 'Επόμενο',
    
    // Fields
    fieldsManagement: 'Διαχείριση Χωραφιών',
    monitorAndManage: 'Παρακολουθήστε και διαχειριστείτε τα γεωργικά σας χωράφια',
    addField: 'Προσθήκη Χωραφιού',
    addItem: 'Προσθήκη',
    createField: 'Δημιουργία Χωραφιού',
    review: 'Επισκόπηση',
    drawn: 'Σχεδιασμένο',
    notSet: 'Μη ορισμένο',
    noFieldsFound: 'Δεν βρέθηκαν χωράφια',
    createFirstField: 'Δημιουργήστε το πρώτο σας χωράφι για να ξεκινήσετε να συλλέγετε δεδομένα αισθητήρων και να λάβετε συστάσεις άρδευσης.',
    fieldName: 'Όνομα Χωραφιού',
    location: 'Τοποθεσία',
    locationHint: 'π.χ. Βέροια, Ημαθία',
    soilCompositionHint: 'Εισάγετε ποσοστά άμμου/ιλύος/αργίλου και ο τύπος εδάφους θα ταξινομηθεί αυτόματα μέσω τριγώνου USDA. Πρέπει να αθροίζουν ~100%.',
    area: 'Έκταση (στρ.)',
    hectares: 'στρ.',
    soilType: 'Τύπος Εδάφους',
    soilTex_clay: 'Αργιλώδες',
    soilTex_silty_clay: 'Ιλυοαργιλώδες',
    soilTex_silt: 'Ιλυώδες',
    soilTex_loam: 'Πηλώδες',
    soilTex_loamy_sand: 'Πηλώδης άμμος',
    soilTex_clay_loam: 'Αργιλοπηλώδες',
    soilTex_silty_clay_loam: 'Ιλυοαργιλοπηλώδες',
    cropType: 'Τύπος Καλλιέργειας',
    dssModeAutoShort: 'Αυτόματο',
    expandSoilTriangle: 'Εμφάνιση τριγώνου',
    clickTriangleToSet: 'Κάντε κλικ στο τρίγωνο για να ορίσετε τη σύσταση εδάφους',
    soilTypeStaleWarning: 'Ο αποθηκευμένος τύπος εδάφους ({stored}) δεν ταιριάζει με άμμο/ιλύ/άργιλο ({classified}).',
    recomputeSoilTypeButton: 'Διόρθωση τώρα',
    recomputeSoilTypeDone: 'Ο τύπος εδάφους ενημερώθηκε: {before} → {after}. Τα WP/FC δεν άλλαξαν αυτόματα, συγκρίνετε και ενημερώστε τα ξεχωριστά αν χρειάζεται.',
    recomputeSoilTypeFailed: 'Αποτυχία επανυπολογισμού τύπου εδάφους',
    cropKiwi: 'Ακτινίδιο',
    cropOlive: 'Ελιά',
    cropPeach: 'Ροδάκινο',
    cropCherry: 'Κεράσι',
    cropGrape: 'Σταφύλι',
    cropApple: 'Μήλο',
    cropPear: 'Αχλάδι',
    cropApricot: 'Βερίκοκο',
    cropOther: 'Άλλο',
    unknownCrop: 'Άγνωστη Καλλιέργεια',
    clay: 'Άργιλος',
    sandy: 'Αμμώδης',
    loam: 'Πηλός',
    clayLoam: 'Αργιλοπηλός',
    sandyLoam: 'Αμμοπηλός',
    siltLoam: 'Ιλυοπηλός',
    siltyClay: 'Ιλυοάργιλος',
    sandyClay: 'Αμμοάργιλος',
    sandyClayLoam: 'Αμμοαργιλοπηλός',
    siltyClayLoam: 'Ιλυοαργιλοπηλός',
    soilSilt: 'Ιλύς',
    loamySand: 'Πηλώδης Άμμος',
    autoClassified: 'Αυτόματη ταξινόμηση',
    soilTriangle: 'Τρίγωνο Μηχανικής Σύστασης',
    irrigationZones: 'Ζώνες Άρδευσης',
    zones: 'ζώνες',
    zonesOne: 'ζώνη',
    editField: 'Επεξεργασία Χωραφιού',
    addNewField: 'Προσθήκη Νέου Χωραφιού',
    cancel: 'Ακύρωση',
    create: 'Δημιουργία',
    update: 'Ενημέρωση',
    soil: 'Έδαφος',
    loadingFields: 'Φόρτωση Χωραφιών...',
    failedToLoadFields: 'Αποτυχία φόρτωσης χωραφιών',
    fieldCreated: 'Το χωράφι δημιουργήθηκε με επιτυχία',
    fieldUpdated: 'Το χωράφι ενημερώθηκε με επιτυχία',
    deleteField: 'Διαγραφή Χωραφιού',
    confirmDelete: 'Διαγραφή Χωραφιού;',
    delete: 'Διαγραφή',
    save: 'Αποθήκευση',
    edit: 'Επεξεργασία',
    // Field Detail
    drawPolygon: 'Σχεδιάστε τα όρια του χωραφιού στον χάρτη (προαιρετικό)',
    fieldBoundary: 'Όρια Χωραφιού',
    drawFieldPolygonHint: 'Σχεδιάστε ή επεξεργαστείτε τα όρια του χωραφιού στον χάρτη.',
    editingFieldBoundary: 'Επεξεργασία ορίων χωραφιού',
    drawFieldHint: 'Σχεδιάστε ή επεξεργαστείτε το πολύγωνο του χωραφιού στον χάρτη, μετά πατήστε Αποθήκευση.',
    fieldBoundarySaved: 'Τα όρια του χωραφιού αποθηκεύτηκαν',
    noBoundaryHint: 'Δεν έχουν σχεδιαστεί όρια · το χωράφι δεν θα εμφανιστεί στον χάρτη. Κλικ για σχεδίαση.',

    // Irrigation History tab
    noHistoryYet: 'Δεν υπάρχει ιστορικό άρδευσης ακόμα',
    noHistoryHint: 'Οι ολοκληρωμένες αρδεύσεις θα εμφανιστούν εδώ.',
    loadMore: 'Φόρτωση περισσότερων',
    overview: 'Επισκόπηση',

    // DSS / Attention banner
    zoneStressedSingular: 'ζώνη υπό πίεση',
    zonesStressedPlural: 'ζώνες υπό πίεση',
    dssCheckRecs: 'Ελέγξτε τις συστάσεις Συμβούλου',
    irrigationNeeded: 'Απαιτείται άρδευση',
    clickToSelect: 'Κλικ για επιλογή',
    sand: 'Άμμος',
    silt: 'Ιλύς',
    wiltingPoint: 'Σημείο Μάρανσης',
    fieldCapacity: 'Υδατοϊκανότητα',
    wpHelp: 'Παρακάμπτει την προεπιλογή αγρού',
    fcHelp: 'Παρακάμπτει την προεπιλογή αγρού',
    optional: 'προαιρετικό',
    weights: 'Βάρη (10/20/30εκ.)',
    bbch: 'Στάδιο BBCH',
    treeDensity: 'Πυκνότητα Δέντρων (δέντρα/στρ.)',
    productionGoal: 'Στόχος Παραγωγής (kg/δέντρο)',
    maxConcurrentZones: 'Μέγ. Ταυτόχρονες Ζώνες',
    maxConcurrentHelp: 'Όριο αντλίας',
    soilParams: 'Παράμετροι Εδάφους',
    hydrologyParams: 'Υδρολογικές Παράμετροι',
    cropParams: 'Παράμετροι Καλλιέργειας',
    // Field Detail panel keys
    fieldInfo: 'Πληροφορίες Χωραφιού',
    basicInfo: 'Βασικά Στοιχεία',
    soilComposition: 'Σύσταση Εδάφους',
    soilTotalNot100: 'Άμμος, ιλύς και άργιλος αθροίζουν {total}%. Πρέπει να αθροίζουν 100%.',
    haveSoilAnalysis: 'Έχω εδαφολογική ανάλυση',
    importFieldsButton: 'Εισαγωγή KML',
    importFieldsTitle: 'Εισαγωγή χωραφιών από αρχείο',
    importFieldsHelp: 'KML ή KMZ (ΟΣΔΕ, Google Earth) ή GeoJSON. Κάθε περίγραμμα γίνεται χωράφι, που ονομάζετε πριν δημιουργηθεί.',
    importFieldsFound: 'Βρέθηκαν {n} περιγράμματα',
    importFieldsCreate: 'Δημιουργία {n} χωραφιών',
    importFieldsFailed: 'Δεν δημιουργήθηκαν: {names}',
    importFailed: 'Το αρχείο δεν διαβάστηκε.',
    chooseFile: 'Επιλογή αρχείου',
    irrigationParameters: 'Παράμετροι Άρδευσης',
    depthWeights: 'Βάρη (10/20/30εκ.)',
    bbchStage: 'Στάδιο BBCH',
    // Zone Management
    zoneManagement: 'Διαχείριση Ζωνών',
    addZone: 'Προσθήκη Ζώνης',
    orDrawZones: 'ή σχεδιάστε ζώνες στον χάρτη',
    editZone: 'Επεξεργασία Ζώνης',
    deleteZone: 'Διαγραφή Ζώνης;',
    deleteZoneAction: 'Διαγραφή Ζώνης',
    deleteZoneConfirmBody: 'Αυτό θα διαγράψει μόνιμα αυτή τη ζώνη και το ιστορικό της.',
    moreActions: 'Περισσότερες ενέργειες',
    zoneInfo: 'Πληροφορίες Ζώνης',
    noActionNeeded: 'Δεν απαιτείται ενέργεια',
    zoneNumber: 'Αριθμός Ζώνης',
    zoneName: 'Όνομα Ζώνης',
    sprinklers: 'Σταλάκτες/Εκτοξευτήρες (αριθμός)',
    litersPerSprinkler: 'Παροχή ανά σταλάκτη (L/ώρα)',
    areaZone: 'Περιοχή Ζώνης (στρ.)',
    provider: 'Έλεγχος άρδευσης',
    zoneDetails: 'Στοιχεία ζώνης',
    fieldFactsTitle: 'Στοιχεία κτήματος',
    zoneLimitsHelp: 'Αν μείνουν κενά, ισχύουν οι τιμές του κτήματος.',
    step1FieldDetails: 'Βήμα 1: Στοιχεία Χωραφιού',
    step2ZoneCreation: 'Βήμα 2: Σχεδιασμός Ζωνών',
    useWholeField: 'Χρήση Ολόκληρου Χωραφιού ως Ζώνη',
    atLeastOneZone: 'Απαιτείται τουλάχιστον μια ζώνη',
    saveZone: 'Αποθήκευση Ζώνης',
    drawZoneOnMap: 'Σχεδιάστε μια ζώνη στον χάρτη και αποθηκεύστε την.',
    zonesAdded: 'ζώνες προστέθηκαν',
    providerZoneId: 'ID Ζώνης Παρόχου',
    relayIndex: 'Ρελέ / Πύλη',
    relayN: 'Ρελέ {n}',
    notAssigned: 'Μη ορισμένο',
    flowRate: 'Συνολική παροχή ζώνης',
    zoneCreated: 'Η ζώνη δημιουργήθηκε με επιτυχία',
    zoneUpdated: 'Η ζώνη ενημερώθηκε με επιτυχία',
    zoneDeleted: 'Η ζώνη διαγράφηκε με επιτυχία',
    noZones: 'Δεν υπάρχουν διαμορφωμένες ζώνες',
    noZonesYet: 'Δεν έχουν προστεθεί ζώνες ακόμα.',
    chartsComingSoon: 'Γραφήματα σύντομα διαθέσιμα',
    addZoneHint: 'Χρησιμοποιήστε το κουμπί + παραπάνω για να προσθέσετε την πρώτη σας ζώνη άρδευσης.',
    addFirstZone: 'Προσθέστε ζώνες για τη διαχείριση άρδευσης αυτού του χωραφιού',
    irrigationZonesTitle: 'Ζώνες Άρδευσης',
    zoneArea: 'Περιοχή Ζώνης',
    confirmDeleteZone: 'Διαγραφή αυτής της ζώνης;',
    editBoundary: 'Επεξεργασία Ορίου',
    drawBoundary: 'Σχεδιασμός Ορίου',
    editingBoundary: 'Επεξεργασία...',
    editingZoneBoundary: 'Επεξεργασία ορίου ζώνης',
    drawZoneHint: 'Σχεδιάστε ή επεξεργαστείτε το πολύγωνο της ζώνης στον χάρτη και πατήστε Αποθήκευση.',
    zoneBoundary: 'Όρια Ζώνης',
    drawZonePolygonHint: 'Σχεδιάστε τα όρια ζώνης εντός του χωραφιού. Η έκταση υπολογίζεται αυτόματα.',
    zoneBoundarySaved: 'Το όριο ζώνης αποθηκεύτηκε',
    useMainMapHint: 'Χρησιμοποιήστε το κουμπί "Επεξεργασία Ορίου" / "Σχεδιασμός Ορίου" στην κάρτα ζώνης για να ορίσετε το πολύγωνο στον κεντρικό χάρτη.',

    // Zone States · farmer vocabulary, never the OK/MARGINAL/STRESSED enum
    zoneState: 'Κατάσταση Ζώνης',
    zoneStateOK: 'Υγιές',
    zoneStateMarginal: 'Στεγνώνει',
    zoneStateStressed: 'Πολύ ξηρό',
    zoneStateSaturated: 'Υπερβολικό νερό',
    zoneStateUnknown: 'Χωρίς δεδομένα αισθητήρα',
    zoneStateStale: 'Χωρίς νέες μετρήσεις',

    // ServiceDegraded · shown when upstream services 5xx
    serviceDegradedLastSuccess: 'Τελευταία επιτυχής ενημέρωση:',
    sessionExpiredMessage: 'Η συνεδρία σας έληξε. Συνδεθείτε ξανά.',
    authRequiredMessage: 'Συνδεθείτε για να συνεχίσετε.',
    deleteFieldTypeName: 'Πληκτρολογήστε το όνομα του χωραφιού για επιβεβαίωση:',
    fieldDeletedUndo: 'Το χωράφι {name} διαγράφηκε.',
    undoDelete: 'Αναίρεση',
    fieldAddedBy: 'Το πρόσθεσε: {name}, στις {date}.',
    readinessSummary: '{fields} χωράφια · {monitored} με μετρήσεις · {controlled} με βάνα',
    readinessNoFields: 'Χωρίς χωράφια ακόμη',
    readinessNextFields: 'Επόμενο: σχεδίαση χωραφιών',
    readinessNextSensor: 'Επόμενο: σύνδεση αισθητήρα',
    notifyEmailReports: 'Αναφορά με email',
    notifyEmailReportsDesc: 'Η αναφορά όλων των χωραφιών σας σε PDF. Υπάρχει πάντα στις Αναφορές.',
    reportEmailOff: 'Όχι',
    reportEmailDaily: 'Μία φορά την ημέρα (09:15)',
    reportEmail6h: 'Κάθε 6 ώρες',
    fieldAddedUnknown: 'Δεν είναι καταγεγραμμένο ποιος το πρόσθεσε: η καταγραφή ξεκινά στις 13/07/2026. Υπήρχε ήδη στις {date}.',
    useWholeFieldZone: 'Όλο το χωράφι ως μία ζώνη',
    thresholdMaxUseful: 'Μέγιστο χρήσιμο νερό',
    thresholdWhenToWater: 'Πότε να ποτίσετε',
    thresholdMinForPlant: 'Ελάχιστο για το φυτό',
    soilWaterLevel: 'Νερό εδάφους',
    soilMoistureShort: 'Υγρασία',
    soilWaterLevelAvg: 'Μέσο επίπεδο νερού εδάφους',
    dailyWaterNeed: 'Ημερήσια ανάγκη νερού',
    weatherCachedHeader: 'Η πρόγνωση ανανεώνεται κάθε 6 ώρες',
    weatherCachedExplain: 'Οι αποφάσεις άρδευσης χρησιμοποιούν πάντα την πιο πρόσφατη διαθέσιμη μέτρηση.',
    minAgo: 'λεπτά πριν',
    hourAgo: 'ώρα πριν',
    hoursAgo: 'ώρες πριν',
    dayAgo: 'ημέρα πριν',
    daysAgo: 'ημέρες πριν',
    weekAgo: 'εβδομάδα πριν',
    weeksAgo: 'εβδομάδες πριν',
    monthAgo: 'μήνας πριν',
    monthsAgo: 'μήνες πριν',
    stale: 'Παλιό',
    manageRules: 'Διαχείριση κανόνων',
    searchUsersPlaceholder: 'Όνομα ή email…',
    allRoles: 'Όλοι οι ρόλοι',
    rainNext7Days: 'Βροχή 7 ημερών',
    peakWind: 'Μέγιστος άνεμος',
    next7Days: 'Επόμενες 7 ημέρες',
    expectedTotal: 'Αναμενόμενο σύνολο',
    lowOf: 'Ελάχ.',
    over35Threshold: '> 35°C όριο',
    fromDate: 'Από',
    toDate: 'Έως',
    viewAsFarmer: 'Προβολή ως παραγωγός',
    currentView: 'Τρέχουσα προβολή',
    adminView: 'Διαχειριστής',
    farmerView: 'Παραγωγός',
    searchSensorsPlaceholder: 'Αναζήτηση με όνομα, αναγνωριστικό, τοποθεσία…',
    noMatchingSensors: 'Κανένας αισθητήρας δεν ταιριάζει με το φίλτρο',
    allSensorsUnconnected: '{count} αισθητήρας/ες δεν είναι συνδεδεμένοι με χωράφι',
    allSensorsUnconnectedHint: 'Στέλνουν μετρήσεις, αλλά δεν φτάνουν σε κανένα χωράφι. Ανοίξτε έναν για να επιλέξετε το χωράφι που μετράει.',
    showUnconnectedSensors: 'Εμφάνιση',
    clearFiltersHint: 'Δοκιμάστε να καθαρίσετε το πεδίο αναζήτησης ή το φίλτρο χωραφιού.',
    soilMoistureTrend30d: 'Τάση υγρασίας εδάφους (30η)',
    dssAcceptance: 'Αποδοχή σύστασης',
    weatherEvent: 'Καιρικό γεγονός',
    zoneHistory: 'Ιστορικό',
    mapNote: 'Σημείωση χάρτη',
    dssMode: 'Λειτουργία άρδευσης',
    autoLogIrrigationToDiary: 'Αυτόματη καταχώρηση ποτισμάτων στο Ημερολόγιο',
    autoLogIrrigationToDiaryDesc: 'Αυτόματη προσθήκη καταχώρησης κάθε φορά που ολοκληρώνεται άρδευση.',
    ndviLatest: 'Τελευταία',
    ndviToday: 'Σήμερα',
    ndviLatestAvailable: 'Τελευταία διαθέσιμη δορυφορική εικόνα',
    goalAggressive: 'επιθετικό',
    goalConservative: 'συντηρητικό',
    goalNormal: 'κανονικό',
    goalHintAggressive: 'Υψηλός στόχος · χρειάζεται περισσότερο νερό',
    goalHintAboveAverage: 'Υπεράνω μέσου στόχου',
    goalHintNormal: 'Κανονικός στόχος',
    goalHintConservative: 'Συντηρητικός · λιγότερο νερό',
    goalHintLow: 'Χαμηλός στόχος · εξοικονόμηση νερού',
    goalHintEmpty: 'Καθορίζει την ένταση άρδευσης',
    evaporationLoss: 'Απώλεια εξάτμισης',
    advisorSuggests: 'Σύσταση συμβούλου:',
    growthStageChip: 'Στάδιο',
    fallsBelow: 'πέφτει κάτω από',
    risesAbove: 'ανεβαίνει πάνω από',
    atOrBelow: 'στο ή κάτω από',
    atOrAbove: 'στο ή πάνω από',
    equals: 'ισούται με',
    dssModeManual: 'Χωρίς Σύμβουλο',
    dssModeAssisted: 'Με Σύμβουλο',
    dssModeAutomated: 'Αυτόματα Με Σύμβουλο',
    valveNoneConnected: 'Δεν υπάρχει χειριστήριο βάνας εδώ. Η έναρξη μόνο καταγράφει την άρδευση στο ιστορικό.',
    valveControllerSilent: 'Το χειριστήριο {id} δεν απαντά, οπότε η βάνα δεν μπορεί να ανοίξει αυτή τη στιγμή.',
    valveReady: 'Το χειριστήριο {id} είναι συνδεδεμένο. Η έναρξη ανοίγει τη βάνα αυτής της ζώνης.',
    appRateLabel: 'Ρυθμός ανόδου υγρασίας (% ανά ώρα)',
    appRateHelp: 'Πόσο ανεβαίνει η υγρασία στα 10 cm μετά από μία ώρα ποτίσματος. Κενό = προεπιλογή. Επηρεάζει μόνο την προτεινόμενη διάρκεια.',
    appRateInvalid: 'Ο ρυθμός ανόδου υγρασίας πρέπει να είναι αριθμός',
    appRateRange: 'Ο ρυθμός ανόδου υγρασίας πρέπει να είναι από 0,1 έως 100 % ανά ώρα',
    dssModeManualHint: 'Εσείς αποφασίζετε πότε να ποτίσετε. Ο Σύμβουλος παρακολουθεί μόνο, καμία αυτόματη σύσταση.',
    dssModeAssistedHint: 'Ο Σύμβουλος προτείνει πότε και για πόσο να ποτίσετε. Εσείς εγκρίνετε κάθε πρόταση πριν εκτελεστεί.',
    dssModeAutomatedHint: 'Ο Σύμβουλος γράφει αυτόματα το πρόγραμμα. Μπορείτε να αλλάξετε επιμέρους αρδεύσεις.',
    addYourFirstField: 'Προσθέστε το πρώτο σας χωράφι',
    addYourFirstFieldHint: 'Σχεδιάστε τα όρια του χωραφιού στον χάρτη, προσθέστε ζώνες άρδευσης και το TerraMind θα αρχίσει να παρακολουθεί την υγρασία εδάφους και να παράγει ημερήσιες συστάσεις.',
    service_weather_unavailable_title: 'Η υπηρεσία καιρού δεν είναι διαθέσιμη',
    service_weather_unavailable_body: 'Δεν ήταν δυνατή η λήψη ζωντανών δεδομένων καιρού. Οι συστάσεις και οι ειδοποιήσεις που βασίζονται στην πρόγνωση έχουν παύσει μέχρι να αποκατασταθεί η υπηρεσία.',
    service_ndvi_unavailable_title: 'Η δορυφορική εικόνα δεν είναι διαθέσιμη',
    service_ndvi_unavailable_body: 'Δεν ήταν δυνατή η λήψη δεδομένων NDVI από τον δορυφορικό πάροχο. Ο χάρτης θα εμφανίσει την πιο πρόσφατη αποθηκευμένη εικόνα, εφόσον υπάρχει.',
    service_dss_unavailable_title: 'Οι συστάσεις έχουν προσωρινά παύσει',
    service_dss_unavailable_body: 'Δεν βγήκε νέα σύσταση σήμερα. Τα προγράμματα άρδευσης συνεχίζονται κανονικά. Οι συστάσεις θα επανέλθουν μόλις αποκατασταθεί η υπηρεσία.',

    // Field Detail - Farmer View KPIs
    totalZones: 'Σύνολο Ζωνών',
    needsWater: 'Χρειάζεται Νερό',
    waterThisWeek: 'Νερό Αυτήν την Εβδομάδα',
    zoneHealth: 'Υγεία Ζωνών',
    needAction: 'χρειάζονται ενέργεια',
    todaysRecommendations: 'Συστάσεις Σήμερα',

    // Zone Polygon
    zonePolygon: 'Όριο Ζώνης',
    polygon: 'Πολύγωνο',
    drawZoneBoundary: 'Σχεδιάστε το όριο της ζώνης στον χάρτη',

    // Weekly Schedule
    addSchedule: 'Προσθήκη Προγράμματος',
    editSchedule: 'Επεξεργασία Προγράμματος',
    noWeeklySchedules: 'Δεν υπάρχουν εβδομαδιαία προγράμματα. Προσθέστε ένα για αυτοματοποίηση άρδευσης.',
    confirmDeleteSchedule: 'Διαγραφή αυτού του προγράμματος;',
    confirmStopTitle: 'Διακοπή Άρδευσης;',
    confirmStopMessage: 'Αυτό θα σταματήσει αμέσως την ενεργή άρδευση για αυτή τη ζώνη.',
    confirmCancelQueueTitle: 'Αφαίρεση από Ουρά;',
    confirmCancelQueueMessage: 'Αυτό θα αφαιρέσει τη ζώνη από την ουρά άρδευσης.',
    removeFromQueue: 'Αφαίρεση',
    applyRecommendation: 'Εφαρμογή',
    day: 'Ημέρα',
    time: 'Ώρα',
    duration: 'Διάρκεια',
    dose: 'Δόση',
    mode: 'Λειτουργία',
    active: 'Ενεργό',
    inactive: 'Ανενεργό',
    dssOverride: 'Παράκαμψη Συμβούλου',
    calendarView: 'Ημερολόγιο',
    tableView: 'Πίνακας',
    scheduleCreated: 'Το πρόγραμμα δημιουργήθηκε με επιτυχία',
    saveAndNext: 'Αποθήκευση & Επόμενο',
    saveThis: 'Αποθήκευση Αυτού',
    saveAll: 'Αποθήκευση Όλων',
    normal: 'Κανονική',
    fertigation: 'Υδρολίπανση',
    antiFrost: 'Αντιπαγετική',
    noSchedulesConfigured: 'Δεν υπάρχουν προγράμματα',
    addScheduleHint: 'Προσθέστε πρόγραμμα για αυτοματοποίηση άρδευσης.',
    paintHint: 'Κάντε κλικ και σύρετε στο ημερολόγιο για επιλογή χρονοθυρίδων',
    paintMode: 'Ζωγραφική',
    paintModeHint: 'Κάντε κλικ και σύρετε στο ημερολόγιο για επιλογή χρονοθυρίδων',
    schedule: 'Πρόγραμμα',
    dssRecs: 'Σύμβουλος',
    saveChanges: 'Αποθήκευση',
    drawZoneHintInline: 'Σχεδιάστε ή επεξεργαστείτε το πολύγωνο ζώνης στον χάρτη. Η έκταση υπολογίζεται αυτόματα.',
    upcomingIrrigations: 'Προσεχείς Αρδεύσεις',
    task: 'εργασία',
    tasks: 'εργασίες',
    overdue: 'Ληγμένη',

    // Dashboard Views
    mapView: 'Προβολή Χάρτη',
    zoneControl: 'Έλεγχος Ζωνών',
    irrigationControl: 'Έλεγχος Άρδευσης',
    sensorMonitoring: 'Παρακολούθηση Αισθητήρων',
    auditTrail: 'Ιστορικό Ενεργειών',
    history: 'Ιστορικό',
    emergencyStop: 'Έκτακτη Διακοπή',
    emergencyStopConfirm: 'ΕΚΤΑΚΤΗ ΔΙΑΚΟΠΗ: Θα ακυρωθούν ΟΛΕΣ οι ενεργές αρδεύσεις. Συνέχεια;',
    emergencyStopFailed: 'Η έκτακτη διακοπή απέτυχε: ',
    fieldMap: 'Χάρτης Χωραφιού',
    toggleFieldInfo: 'Πληροφορίες Χωραφιού',
    aiMode: 'Με Σύμβουλο',
    manualMode: 'Χωρίς Σύμβουλο',

    // History / Audit trail filters
    advancedFilters: 'Φίλτρα',
    dateFrom: 'Από',
    dateTo: 'Έως',
    decisionType: 'Τύπος Απόφασης',
    allZones: 'Όλες οι Ζώνες',
    activeFilters: 'Ενεργά:',
    clearAll: 'Καθαρισμός όλων',
    clearFilters: 'Καθαρισμός φίλτρων',
    filteringByZone: 'Εμφάνιση καταχωρήσεων για',
    from: 'Από',
    to: 'Έως',

    // Dashboard view content
    allFields: 'Όλα τα Χωράφια',
    allShort: 'Όλα',
    allCrops: 'Όλες οι Καλλιέργειες',
    name: 'Όνομα',
    areaStremma: 'Έκταση (στρ.)',
    wai: 'WAI',
    plainLabelWai: 'Επίπεδο νερού εδάφους',
    plainLabelEt0: 'Ημερήσια ανάγκη νερού',
    zone: 'Ζώνη',
    tabNow: 'Τώρα',
    tabSensors: 'Αισθητήρες',
    tabHistory: 'Ιστορικό',
    tabForecast: 'Πρόβλεψη',
    forecastComingSoonTitle: 'Πρόβλεψη Υγρασίας 5 Ημερών',
    forecastComingSoonDesc: 'Αυτή η λειτουργία θα δείχνει την πορεία WAI για 5 ημέρες συνδυάζοντας μετρήσεις αισθητήρων, πρόβλεψη καιρού και δορυφορικά δεδομένα NDVI. Προγραμματίστε άρδευση έως μια εβδομάδα νωρίτερα.',
    forecastComingSoonNote: 'Διαθέσιμο όταν συνδεθούν ζωντανά δεδομένα αισθητήρων και API καιρού για αυτή τη ζώνη.',
    thisWeekWater: 'Εβδομάδα',
    noIrrigationsThisWeek: 'καμία άρδευση',
    psaRiskTitle: 'Κίνδυνος ασθενείας',
    psaRiskLevel_medium: 'μεσαίος',
    psaRiskLevel_high: 'υψηλός',
    automaticMode: 'Σύμβουλος Ενεργός',
    advisorModeOnTip: 'Με Σύμβουλο, πατήστε για χειροκίνητο έλεγχο.',
    advisorModeOffTip: 'Χωρίς Σύμβουλο, πατήστε για να ενεργοποιήσετε τον Σύμβουλο.',
    count: 'Πλήθος',
    confirmDiscardTitle: 'Απόρριψη αλλαγών;',
    confirmDiscardBody: 'Έχετε μη αποθηκευμένες αλλαγές. Αν κλείσετε τώρα θα χαθούν.',
    confirmDiscardAction: 'Απόρριψη',
    pendingApprovals: 'Εκκρεμείς εγκρίσεις',
    id: 'ID',
    actions: 'Ενέργειες',
    activeCount: 'Ενεργά',
    noZonesConfigured: 'Δεν υπάρχουν ζώνες. Προσθέστε ζώνες μέσω Διαχείρισης Χωραφιών.',
    activeScheduledIrrigations: 'Ενεργές & Προγραμματισμένες Αρδεύσεις',
    field: 'Χωράφι',
    durationMin: 'Διάρκεια (λεπτά)',
    waterL: 'Νερό (L)',
    vwc10: 'Υγρασία στα 10 εκ.',
    vwc20: 'Υγρασία στα 20 εκ.',
    vwc30: 'Υγρασία στα 30 εκ.',
    waterAvailabilityIndex: 'Δείκτης Διαθεσιμότητας Νερού',
    systemAlertsTitle: 'Ειδοποιήσεις Συστήματος',
    auditTrailSubtitle: 'Απόφαση, σχέδιο, εκτέλεση και αποτέλεσμα',
    refresh: 'Ανανέωση',
    noPlansRecorded: 'Δεν υπάρχουν καταγεγραμμένα σχέδια άρδευσης.',
    decision: 'ΑΠΟΦΑΣΗ',
    plan: 'ΣΧΕΔΙΟ',
    execution: 'ΕΚΤΕΛΕΣΗ',
    outcome: 'ΑΠΟΤΕΛΕΣΜΑ',

    // KPI Strip
    watering: 'Σε άρδευση',
    stressed: 'καταπονημένες',
    needWater: 'Χρειάζονται νερό',
    weekTotal: 'Σύνολο εβδομάδας',
    aiZones: 'Αυτόματες ζώνες',
    waterPerWeek: 'Νερό / Εβδομάδα',

    // Map
    clickToShowZones: 'Κλικ για ζώνες',
    doubleClickToOpen: 'Διπλό κλικ για άνοιγμα',
    zoneStatus: 'Κατάσταση Χωραφιού',
    locateOnMap: 'Εντοπισμός στον χάρτη',
    closePanel: 'Κλείσιμο πάνελ',
    openPanel: 'Άνοιγμα πάνελ χωραφιών',

    // Test Run
    testRun: 'Δοκιμαστική Λειτουργία',
    testRunInfo: 'Χειροκίνητη δοκιμαστική λειτουργία. Δεν επηρεάζει το πρόγραμμα Συμβούλου.',
    durationMinutes: 'Διάρκεια (λεπτά)',
    starting: 'Εκκίνηση...',
    startTestRun: 'Έναρξη Δοκιμής',

    // Dialog buttons
    creating: 'Δημιουργία...',
    saving: 'Αποθήκευση...',
    stopping: 'Διακοπή...',
    notes: 'Σημειώσεις',
    options: 'Επιλογές',
    dssOverrideHelp: 'Όταν είναι ενεργοποιημένο, ο Σύμβουλος μπορεί να παρακάμψει αυτό το πρόγραμμα αν οι συνθήκες δεν απαιτούν άρδευση',
    permanentlyRemoveZone: 'Η ζώνη και η διαμόρφωσή της θα διαγραφούν μόνιμα.',
    permanentlyRemoveSchedule: 'Αυτό θα αφαιρέσει μόνιμα αυτό το πρόγραμμα.',

    // Zone cards
    withoutBoundary: 'χωρίς όριο',
    exceedsFieldArea: 'Υπερβαίνει την έκταση χωραφιού',
    noBoundary: 'Χωρίς όριο',
    zoneCoverage: 'Κάλυψη Ζωνών',
    autoCalculatedFromPolygon: 'Υπολογισμός από πολύγωνο',
    areaAutoCalc: 'Θα υπολογιστεί αυτόματα από το πολύγωνο',

    // Zone operations (field detail page)
    soilMoisture30d: 'Υγρασία Εδάφους · Τελευταίες 30 Ημέρες',
    ndviVegetationHealth: 'Υγεία Βλάστησης (NDVI)',
    weatherLast14d: 'Καιρός · Τελευταίες 14 Ημέρες',
    noSensorHistory: 'Δεν υπάρχει ιστορικό αισθητήρων',
    dssRecentDecisions: 'Πρόσφατες Αποφάσεις Συμβούλου',
    noDssDecisions: 'Δεν υπάρχουν αποφάσεις Συμβούλου ακόμα',
    noDiaryEntries: 'Δεν υπάρχουν καταχωρίσεις ημερολογίου',
    noSensorData: 'Χωρίς δεδομένα αισθητήρων',
    config: 'Ρυθμίσεις',
    fieldDetail: 'Λεπτομέρειες Χωραφιού',
    soilMoisture: 'Υγρασία εδάφους',
    soilProfileProbe: 'Αισθητήρας προφίλ εδάφους',
    profileProbe: 'Αισθητήρας προφίλ',
    probeStale: 'Καμία πρόσφατη μέτρηση',
    range7d: '7ημ',
    range30d: '30ημ',
    range90d: '90ημ',
    rangeAll: 'Όλα',
    customRange: 'Προσαρμ.',
    daysSinceIrrigation: 'Τελ. άρδευση',
    minShort: 'λ',
    upcomingSchedule: 'Προσεχείς',
    viewAll: 'Όλα →',
    zonesShort: 'ζ',
    switchToAI: 'Αλλαγή σε AI',
    switchToManual: 'Χωρίς Σύμβουλο',
    lockField: 'Κλείδωμα χωραφιού',
    unlockField: 'Ξεκλείδωμα χωραφιού',
    fieldLocked: 'Το χωράφι κλειδώθηκε',
    fieldUnlocked: 'Το χωράφι ξεκλειδώθηκε',
    irrigationRecommended: 'Συνιστάται Άρδευση',
    noIrrigationNeeded: 'Δεν υπάρχουν συστάσεις άρδευσης αυτή τη στιγμή.',

    // Field Detail - Actions & States
    ok: 'ΟΚ',
    marginal: 'Οριακή',
    stop: 'Διακοπή',
    stopAll: 'Διακοπή όλων',
    startAll: 'Εκκίνηση όλων',
    startAllIrrigation: 'Εκκίνηση Όλων των Αρδεύσεων',
    allIrrigationStarted: 'Όλες οι αρδεύσεις ξεκίνησαν',
    failedToStartIrrigations: 'Αποτυχία εκκίνησης ορισμένων αρδεύσεων',
    dss: 'Σύμβουλος Άρδευσης',
    dssTab: 'Σύμβουλος',
    runDss: 'Ανανέωση σύστασης',
    analyzing: 'Ανάλυση...',
    runAdvisorForAllDesc: 'Δημιουργία συστάσεων άρδευσης για όλες τις ζώνες με βάση τρέχουσα εδαφική υγρασία και καιρική πρόβλεψη',
    runningDss: 'Αναλύω…',
    failedDssTrigger: 'Αποτυχία εκτέλεσης ανάλυσης',
    dssNoActionNeeded: 'Η υγρασία εδάφους είναι ικανοποιητική. Δεν χρειάζεται άρδευση.',
    recurrenceOnce: '1×',
    dssApproved: 'Εγκεκριμένη σύσταση ΑΙ',
    recApproved: 'Εγκρίθηκε και προγραμματίστηκε',
    recRejected: 'Απορρίφθηκε',
    dssTriggered: 'Η ανάλυση ολοκληρώθηκε',
    dssError: 'Αποτυχία Συμβούλου. Δοκιμάστε ξανά.',
    data: 'Δεδομένα',
    soilSensors: 'Έδαφος & Αισθητήρες',
    waterAvailability: 'Δείκτης Διαθεσιμότητας Νερού',
    pendingRecommendations: 'εκκρεμής/-είς πρόταση/-εις',
    basedOnSensorData: 'Βάσει δεδομένων αισθητήρα από',
    noDssRecommendationsZone: 'Δεν υπάρχουν ακόμα προτάσεις για αυτή τη ζώνη.',
    editZoneConfiguration: 'Επεξεργασία Διαμόρφωσης Ζώνης',
    fieldStartAllConfirm: 'Εκκίνηση άρδευσης σε όλες τις ανενεργές ζώνες; Κάθε ζώνη θα λειτουργήσει για 30 λεπτά.',
    emergencyStartAllConfirm: 'Αυτό θα ξεκινήσει άρδευση σε όλες τις ανενεργές ζώνες σε όλα τα χωράφια για 30 λεπτά η καθεμία. Είστε σίγουροι;',
    todaysActivity: 'Σημερινή Δραστηριότητα',
    noScheduleToday: 'Δεν υπάρχει πρόγραμμα άρδευσης σήμερα',
    sensorsNotConnected: 'Οι αισθητήρες δεν είναι συνδεδεμένοι · ελέγξτε τη συσκευή',
    recommendation: 'Σύσταση',
    weeklyWater: 'Αυτή την εβδομάδα',
    controlMode: 'Έλεγχος',
    editConfig: 'Ρυθμίσεις',
    boundary: 'Όριο',
    week: 'εβδομάδα',
    irrigationStarted: 'Η άρδευση ξεκίνησε',
    irrigationStopped: 'Η άρδευση σταμάτησε',
    allIrrigationStopped: 'Όλες οι αρδεύσεις σταμάτησαν',
    testRunStarted: 'Η δοκιμή ξεκίνησε',
    fieldEmergencyStopConfirm: 'Διακοπή όλων των ενεργών αρδεύσεων αυτού του χωραφιού;',
    deleteFieldConfirm: 'Το χωράφι και οι ζώνες του αφαιρούνται από την εφαρμογή και οι προγραμματισμένες αρδεύσεις του ακυρώνονται. Το ιστορικό του διατηρείται.',
    zoneNeedsIrrigation: 'ζώνη χρειάζεται άρδευση',
    zonesNeedIrrigation: 'ζώνες χρειάζονται προσοχή',
    allZonesHealthy: 'Όλες οι ζώνες σε καλή κατάσταση',
    zoneSwitchedToAI: 'Η ζώνη άλλαξε σε αυτόματο έλεγχο',
    zoneSwitchedToManual: 'Η ζώνη λειτουργεί Χωρίς Σύμβουλο',
    failedToStopIrrigations: 'Αποτυχία διακοπής κάποιων αρδεύσεων',
    showParameters: 'Εμφάνιση παραμέτρων',
    hideParameters: 'Απόκρυψη παραμέτρων',
    noSensorDataAvailable: 'Δεν υπάρχουν δεδομένα αισθητήρων',
    showingHistoricalData: 'Εμφάνιση τελευταίων διαθέσιμων δεδομένων · δεν υπάρχουν μετρήσεις στην επιλεγμένη περίοδο.',
    areaStremmaLabel: 'Έκταση (στρ.)',

    // Weather Widget
    currentConditions: 'Τρέχουσες Συνθήκες',
    todayForecast: 'Πρόβλεψη Σήμερα',
    viewForecast: 'Προβολή πρόβλεψης',

    // Auth
    login: 'Σύνδεση',
    logout: 'Αποσύνδεση',
    install: 'Εγκατάσταση',
    installApp: 'Προσθέστε το TerraMind στην αρχική σελίδα',
    username: 'Όνομα Χρήστη',
    usernameOrEmail: 'Όνομα χρήστη ή email',
    mapSearchPlaceholder: 'Χωράφι, τόπος ή συντεταγμένες',
    mapSearchShort: 'Αναζήτηση',
    drawFieldMapHint: 'Βρείτε το σημείο, πατήστε το εργαλείο περιγράμματος (πάνω αριστερά) και μετά κάθε γωνία του χωραφιού.',
    drawZoneMapHint: 'Πατήστε το εργαλείο περιγράμματος (πάνω αριστερά) και μετά κάθε γωνία της ζώνης μέσα στο χωράφι.',
    drawFirstVertex: 'Πατήστε την πρώτη γωνία',
    drawContinue: 'Πατήστε την επόμενη γωνία',
    drawFinishPoly: 'Πατήστε ξανά την πρώτη γωνία για ολοκλήρωση',
    drawFinish: 'Ολοκλήρωση',
    drawUndoPoint: 'Αναίρεση σημείου',
    drawPolyButton: 'Σχεδίαση περιγράμματος',
    drawEditButton: 'Μετακίνηση γωνιών',
    drawDeleteButton: 'Διαγραφή περιγράμματος',
    fieldNeedsOutlineOrArea: 'Σχεδιάστε το χωράφι στον χάρτη ή συμπληρώστε την έκταση.',
    errorNoPermission: 'Ο λογαριασμός σας δεν έχει δικαίωμα για αυτή την ενέργεια. Επικοινωνήστε με τον διαχειριστή.',
    errorNoConnection: 'Δεν υπάρχει σύνδεση με τον διακομιστή. Δοκιμάστε ξανά.',
    welcomeSetPasswordTitle: 'Καλώς ήρθατε στο TerraMind',
    welcomeSetPasswordHint: 'Ορίστε τον κωδικό σας. Μετά συνδέεστε με το email σας.',
    welcomePasswordSet: 'Ο κωδικός ορίστηκε. Συνδεθείτε με το email σας και αυτόν τον κωδικό.',
    welcomeLinkExpired: 'Ο σύνδεσμος της πρόσκλησης έληξε. Ζητήστε νέο από τον διαχειριστή.',
    zoneOutsideField: 'Η ζώνη βγαίνει έξω από το χωράφι. Μετακινήστε τις γωνίες της μέσα στη λευκή διακεκομμένη γραμμή.',
    zoneOverlapsDraft: 'Η ζώνη πέφτει πάνω σε ζώνη που σχεδιάσατε ήδη. Απομακρύνετε τις γωνίες της.',
    zoneOverlapsZones: 'Η ζώνη πέφτει πάνω στη ζώνη {zones}. Απομακρύνετε τις γωνίες της.',
    fieldStopPartial: 'Σταμάτησαν {stopped} από {total}. {failed} δεν σταμάτησαν.',
    oneZoneReady: '1 ζώνη έτοιμη',
    zonesReadyCount: '{n} ζώνες έτοιμες',
    mapSearchGoToCoords: 'Μετάβαση σε αυτές τις συντεταγμένες',
    mapSearchNothing: 'Δεν βρέθηκε κάτι',
    places: 'Τοποθεσίες',
    clear: 'Καθαρισμός',
    inviteEmailRequired: 'Συμπληρώστε το email του ατόμου',
    inviteUser: 'Πρόσκληση',
    inviteSentTo: 'Η πρόσκληση στάλθηκε στον/στην {name}. Ορίζει τον κωδικό από τον σύνδεσμο.',
    inviteNotSent: 'Δεν στάλθηκε email στον/στην {name}. Στείλτε του αυτόν τον σύνδεσμο για να ορίσει κωδικό.',
    copyLink: 'Αντιγραφή συνδέσμου',
    linkCopied: 'Ο σύνδεσμος αντιγράφηκε',
    sendPasswordLink: 'Σύνδεσμος κωδικού',
    invitePending: 'Εκκρεμεί πρόσκληση',
    showInactiveUsers: 'Ανενεργοί',
    hideInactiveUsers: 'Απόκρυψη ανενεργών',
    addFieldsForUser: 'Προσθήκη χωραφιών',
    usernameDefaultsToEmail: 'Προαιρετικό. Κενό = το email. Συνδέεται με οποιοδήποτε από τα δύο.',
    passwordOptionalInvite: 'Προαιρετικό. Κενό = λαμβάνει σύνδεσμο για να ορίσει δικό του.',
    password: 'Κωδικός',
    loginSubtitle: 'Συνδεθείτε στο σύστημα διαχείρισης άρδευσης',
    welcomeTitle: 'Καλώς ήρθατε στο TerraMind',
    welcomeSubtitle: 'Πώς θέλετε να ξεκινήσετε;',
    welcomeCreateFieldBtn: 'Δημιουργία πρώτου χωραφιού',
    createFirstFieldDesc: 'Παράλειψη της περιήγησης. Ξεκινήστε με κενό χώρο εργασίας.',
    tourBannerLabel: 'Ένα δοκιμαστικό χωράφι δίπλα στα δικά σας. Ό,τι κάνετε σε αυτό δεν αγγίζει τα πραγματικά.',
    resetTourData: 'Επαναφορά του δοκιμαστικού',
    startFresh: 'Αφαίρεση του δοκιμαστικού',
    exitTourTitle: 'Αφαίρεση του δοκιμαστικού χωραφιού;',
    exitTourBody: 'Αφαιρείται το δοκιμαστικό χωράφι με τις ζώνες και τις ειδοποιήσεις του. Τα δικά σας χωράφια, προγράμματα, μετρήσεις και ειδοποιήσεις μένουν όπως είναι.',
    deleteAndContinue: 'Αφαίρεση',
    launchTour: 'Έναρξη ξενάγησης',
    removeDemoData: 'Αφαίρεση δεδομένων επίδειξης',
    tourDataActiveDesc: 'Τα δεδομένα επίδειξης είναι ενεργά. Μπορείτε να τα επαναφέρετε ή να τα διαγράψετε.',
    tourDataInactiveDesc: 'Φορτώστε ένα παράδειγμα αγροκτήματος ακτινίδιου για να εξερευνήσετε όλες τις λειτουργίες χωρίς να επηρεάσετε πραγματικά δεδομένα.',
    loginFailed: 'Λάθος όνομα χρήστη ή κωδικός',
    credentialsRequired: 'Απαιτούνται όνομα χρήστη και κωδικός',
    showPassword: 'Εμφάνιση κωδικού',
    hidePassword: 'Απόκρυψη κωδικού',
    sessionExpired: 'Η συνεδρία έληξε. Παρακαλώ συνδεθείτε ξανά.',
    register: 'Δημιουργία Λογαριασμού',
    createAccount: 'Δημιουργήστε τον λογαριασμό σας',
    freeTrial: 'Δωρεάν δοκιμή 30 ημερών',
    allFieldsRequired: 'Όλα τα πεδία είναι υποχρεωτικά',
    registrationFailed: 'Η εγγραφή απέτυχε. Δοκιμάστε ξανά.',
    alreadyHaveAccount: 'Έχετε ήδη λογαριασμό;',
    noAccount: 'Δεν έχετε λογαριασμό;',
    forgotPassword: 'Ξεχάσατε τον κωδικό;',
    forgotPasswordSubtitle: 'Εισάγετε το email σας και θα σας στείλουμε σύνδεσμο επαναφοράς.',
    sendResetLink: 'Αποστολή Συνδέσμου',
    passwordResetSent: 'Αν το email είναι καταχωρημένο θα λάβετε σύνδεσμο επαναφοράς.',
    emailServiceUnavailable: 'Η υπηρεσία email δεν είναι διαθέσιμη. Δοκιμάστε ξανά αργότερα.',
    resetPassword: 'Ορισμός Νέου Κωδικού',
    passwordResetSuccess: 'Ο κωδικός επαναφέρθηκε. Μπορείτε να συνδεθείτε.',
    passwordResetFailed: 'Μη έγκυρος ή ληγμένος σύνδεσμος. Ζητήστε νέο.',
    passwordsDoNotMatch: 'Οι κωδικοί δεν ταιριάζουν.',
    backToLogin: 'Επιστροφή στη Σύνδεση',
    or: 'ή',
    subscriptionExpired: 'Η συνδρομή σας έχει λήξει',
    maxFieldsReached: 'Μέγιστος αριθμός χωραφιών για το πλάνο σας',
    maxZonesReached: 'Μέγιστος αριθμός ζωνών για το πλάνο σας',
    trialDaysRemaining: 'Ημέρες δοκιμής που απομένουν',

    // Irrigation Page
    activeNow: 'Ενεργά Τώρα',
    comingUpToday: 'Επερχόμενα Σήμερα',
    completedToday: 'Ολοκληρωμένα Σήμερα',
    planned: 'Προγραμματισμένο',
    noIrrigationData: 'Δεν υπάρχουν δεδομένα άρδευσης',
    noPendingIrrigations: 'Δεν υπάρχουν εκκρεμείς αρδεύσεις για σήμερα',
    noIrrigationsToday: 'Δεν υπάρχουν προγραμματισμένες αρδεύσεις για σήμερα',
    irrigationCreated: 'Η εργασία άρδευσης δημιουργήθηκε με επιτυχία',
    started: 'Ξεκίνησε',

    // Weather Page
    rainDetected: 'Ανιχνεύτηκε βροχή · τα προγράμματα άρδευσης μπορεί να προσαρμοστούν από τον Σύμβουλο.',

    // Sensors
    sensorsNetworkManagement: 'Διαχείριση Δικτύου Αισθητήρων',
    monitorYourSensors: 'Παρακολουθήστε και διαχειριστείτε συσκευές αισθητήρων IoT',
    addDevice: 'Προσθήκη Συσκευής',
    realtimeSensorReadings: 'Ανάγνωση Αισθητήρων Σε Πραγματικό Χρόνο',
    activeSensors: 'Ενεργοί Αισθητήρες',
    averageTemperature: 'Μέση Θερμοκρασία',
    averageHumidity: 'Μέση Υγρασία',
    averageSoilMoisture: 'Μέση Υγρασία Εδάφους',
    sensorsStatus: 'Κατάσταση Αισθητήρων',
    sensorOnline: 'Συνδεδεμένος',
    sensorUnconnected: 'Μη ανατεθειμένος',
    sensorOffline: 'Αποσυνδεδεμένος',
    sensorOfflineSince: 'Αισθητήρας εκτός σύνδεσης από',
    sensorDevices: 'Αισθητήρες',
    noSensor: 'Χωρίς αισθητήρα',
    clickToFilterByZone: 'Κλικ σε ζώνη για φιλτράρισμα',
    sensorStaleWarning: 'Τα δεδομένα αισθητήρα είναι παλιά',
    sensorError: 'Σφάλμα',
    sensorUnknown: 'Άγνωστο',
    noSensorsFound: 'Δεν βρέθηκαν αισθητήρες',
    createFirstSensor: 'Προσθέστε την πρώτη συσκευή αισθητήρα για να ξεκινήσετε τη συλλογή δεδομένων περιβάλλοντος σε πραγματικό χρόνο.',
    deviceName: 'Όνομα Συσκευής',
    deviceLocation: 'Τοποθεσία Συσκευής',
    deviceIdentifier: 'Αναγνωριστικό Συσκευής',
    deviceType: 'Τύπος Συσκευής',
    editDevice: 'Επεξεργασία Συσκευής',
    addNewDevice: 'Προσθήκη Νέας Συσκευής',
    loadingSensors: 'Φόρτωση Αισθητήρων...',
    failedToLoadSensors: 'Αποτυχία φόρτωσης αισθητήρων',
    statusOnline: 'σε λειτουργία',
    statusOk: 'ok',
    unknownDevice: 'Άγνωστη Συσκευή',
    deviceCreatedSuccessfully: 'Η συσκευή δημιουργήθηκε με επιτυχία',
    deviceUpdatedSuccessfully: 'Η συσκευή ενημερώθηκε με επιτυχία',
    deviceDeletedSuccessfully: 'Η συσκευή διαγράφηκε με επιτυχία',
    failedToCreateDevice: 'Αποτυχία δημιουργίας συσκευής',
    failedToUpdateDevice: 'Αποτυχία ενημέρωσης συσκευής',
    failedToDeleteDevice: 'Αποτυχία διαγραφής συσκευής',
    lastReading: 'Τελευταία Ανάγνωση',
    soilTension: 'Εδαφική τάση',
    soilTensionHint: 'χαμηλό = υγρό',
    batteryLevel: 'Επίπεδο Μπαταρίας',
    status: 'Κατάσταση',
    online: 'Σε Σύνδεση',
    offline: 'Χωρίς Σύνδεση',
    sensorDashboard: 'Πίνακας Αισθητήρων',
    vwcDepth10: 'VWC 10cm',
    vwcDepth20: 'VWC 20cm',
    vwcDepth30: 'VWC 30cm',
    avgVwc: 'Μέση VWC',
    airTemperature: 'Θερμοκρασία Αέρα',
    airHumidity: 'Υγρασία αέρα',
    zoneReport: 'Αναφορά ζώνης',
    chillTitle: 'Ψύχος χειμώνα',
    chillHours: 'Ώρες ψύχους (0 έως 7,2 °C)',
    chillHoursTip: 'Ώρες με θερμοκρασία από 0 έως 7,2 °C (Weinberger)',
    chillUtah: 'Μονάδες Utah',
    chillUtahTip: 'Μονάδες ψύχους κατά Richardson. Οι ζεστές ώρες αφαιρούν μονάδες.',
    chillPortions: 'Μερίδες ψύχους',
    chillPortionsTip: 'Δυναμικό μοντέλο (Fishman & Erez)',
    chillSourceOther: 'Θερμοκρασία αέρα από τον σταθμό του χωραφιού {name}',
    report: 'Αναφορά',
    soilTemperature: 'Θερμοκρασία Εδάφους',
    rainfallAndWind: 'Βροχόπτωση & Άνεμος',
    last7Days: '7η',
    last30Days: '30η',
    readingsCount: 'Μετρήσεις',
    importSensorData: 'Εισαγωγή δεδομένων αισθητήρων ή αναμονή για μετρήσεις',

    // Request Help
    requestHelp: 'Επικοινωνία',
    contactSupport: 'Επικοινωνία Υποστήριξης',
    contactSupportDesc: 'Επιλέξτε κατηγορία και περιγράψτε το ζήτημά σας. Θα επικοινωνήσουμε σύντομα.',
    requestHelpDescription: 'Στείλτε μήνυμα στην ομάδα TerraMind για βοήθεια με τα χωράφια ή το σύστημα άρδευσης.',
    requestHelpPlaceholder: 'Περιγράψτε τι χρειάζεστε βοήθεια...',
    bugReportPlaceholder: 'Τι συνέβη; Τι περιμένατε; Λεπτομέρειες browser/συσκευής...',
    helpTypeQuestion: 'Ερώτηση',
    helpTypeBug: 'Αναφορά Σφάλματος',
    helpTypeFeature: 'Πρόταση Λειτουργίας',
    helpTypeData: 'Πρόβλημα Δεδομένων',
    helpRequestSent: 'Το μήνυμα στάλθηκε! Θα επικοινωνήσουμε σύντομα.',
    helpRequestFailed: 'Αποτυχία αποστολής αιτήματος βοήθειας',
    sending: 'Αποστολή...',
    send: 'Αποστολή',
    message: 'Μήνυμα',

    // Irrigation
    irrigationManagement: 'Διαχείριση Άρδευσης',
    monitorAndControl: 'Παρακολουθήστε και ελέγξτε το σύστημα άρδευσής σας',
    scheduleIrrigation: 'Χρονοδιάγραμμα Άρδευσης',
    activeSystems: 'Ενεργά Συστήματα',
    waterDelivered: 'Νερό Παραδοθέν',
    nextSchedule: 'Επόμενο Χρονοδιάγραμμα',
    activeZones: 'Ενεργές Ζώνες',
    waterUsageMetrics: 'Μετρήσεις Χρήσης Νερού',
    totalWaterDelivered: 'Συνολικό Νερό Παραδοθέν',
    averageWaterPerCycle: 'Μέσο Νερό ανά Κύκλο',
    systemUptime: 'Διαθεσιμότητα Συστήματος',
    noSchedulesFound: 'Δεν βρέθηκαν χρονοδιαγράμματα άρδευσης',
    createFirstSchedule: 'Δημιουργήστε το πρώτο σας πρόγραμμα για αυτόματη άρδευση',
    scheduleName: 'Όνομα Χρονοδιαγράμματος',
    targetField: 'Χωράφι Στόχος',
    slots: 'θυρίδες',
    viewField: 'Προβολή Χωραφιού',
    viewOnMap: 'Χάρτης',
    before: 'Πριν',
    viewFullJournal: 'Πλήρες ημερολόγιο →',
    waterQuantity: 'Ποσότητα Νερού (λίτρα)',
    scheduledTime: 'Προγραμματισμένος Χρόνος',
    startIrrigation: 'Έναρξη Άρδευσης',
    viewAiRecommendation: 'Προβολή σύστασης AI',
    startNow: 'Έναρξη Τώρα',
    modeNormal: 'Κανονική',
    modeFertigation: 'Λίπανση',
    modeFrost: 'Παγετός',
    planTab: 'Πλάνο',
    completionPercent: 'ολοκλ.',
    actionIrrigate: 'ΑΡΔΕΥΣΗ',
    actionMonitor: 'ΠΑΡΑΚΟΛΟΥΘΗΣΗ',
    actionSkip: 'ΠΑΡΑΛΕΙΨΗ',
    noPrescription: 'Δεν υπάρχει διαθέσιμη συνταγή',
    noPrescriptionHint: 'Απαιτούνται δεδομένα αισθητήρων για προτάσεις',
    soilResponseTracking: 'Ανταπόκριση Εδάφους',
    vwcBefore: 'Πριν',
    vwcAfter: 'Μετά',
    vwcChange: 'Μεταβολή VWC',
    vwcTrend7d: 'Τάση VWC 7 ημερών',
    trendChartUnavailable: 'Το γράφημα τάσης δεν είναι διαθέσιμο',
    mmApplied: 'mm Εφαρμογής',
    responseDelay: 'Καθυστέρηση',
    noSoilResponse: 'Δεν υπάρχουν δεδομένα ανταπόκρισης',
    noSoilResponseHint: 'Εμφανίζεται μετά τον πρώτο κύκλο άρδευσης',
    queued: 'Σε αναμονή',
    queuePosition: 'Σειρά',
    zoneQueued: 'Ζώνη σε αναμονή',
    once: 'Μία φορά',
    scheduledDate: 'Ημερομηνία',
    dateRequired: 'Η ημερομηνία απαιτείται για εφάπαξ προγράμματα',
    daily: 'Καθημερινά',
    weekly: 'Εβδομαδιαία',
    custom: 'Προσαρμοσμένο',
    everyNDays: 'Κάθε N ημέρες',
    every: 'Κάθε',
    intervalRange: 'Το διάστημα πρέπει να είναι 1-365 ημέρες',
    ndviOverlay: 'Επίπεδο Δορυφόρου',
    satelliteImagery: 'Δορυφορική Εικόνα',
    layerSettings: 'Ρυθμίσεις Επιπέδου',
    ndviNotConfigured: 'Το Sentinel Hub δεν έχει ρυθμιστεί',
    ndviFetchError: 'Αποτυχία φόρτωσης δεδομένων NDVI',
    ndviTimeout: 'Τα δεδομένα NDVI δεν είναι διαθέσιμα · λήξη χρόνου σύνδεσης δορυφόρου.',
    ndviNoData: 'Δεν βρέθηκαν εικόνες δορυφόρου χωρίς σύννεφα για αυτή την περίοδο',
    ndviLoading: 'Φόρτωση δεδομένων δορυφόρου…',
    ndviUnavailable: 'Μη διαθέσιμα δεδομένα δορυφόρου',
    noSatelliteDataYet: 'Δεν υπάρχουν δεδομένα δορυφόρου ακόμη',
    noImagery: 'Χωρίς εικόνα',
    sentinelProvider: 'Sentinel-2',
    viewAllZones: 'Προβολή όλων των ζωνών',
    general: 'Γενικά',
    yieldMetrics: 'Παραγωγή & Νερό',
    photo: 'Φωτογραφία',
    layerImagery: 'Δορυφόρος',
    layerHealth: 'Υγεία',
    layerNdvi: 'NDVI',
    ndviToggleHint: 'Εναλλαγή δορυφορικού δείκτη NDVI',
    cropLabels: 'Καλλιέργειες',
    cropLabelsHint: 'Εμφάνιση τύπου καλλιέργειας δίπλα στο όνομα κάθε χωραφιού',
    mapModeSatellite: 'Δορυφόρος',
    mapModeHealth: 'Υγεία',
    mapModeNdvi: 'NDVI',
    mapModeCrops: 'Καλλιέργειες',
    cropTypeFilter: 'προβολή καλλιέργειας',
    ndviLegendTitle: 'πρασινάδα καλλιέργειας',
    ndviLegendBare: 'γυμνό έδαφος',
    ndviLegendDense: 'πυκνή φυτοκάλυψη',
    ndviUnavailableForDate: 'NDVI μη διαθέσιμο για αυτή την ημέρα',
    tiles: 'πλακίδια',
    typicalValues: 'τυπικές τιμές',
    awaitingFirstReading: 'αναμονή πρώτης μέτρησης',
    ndviZoomInHint: 'Κάντε ζουμ για NDVI',
    cropType_kiwi: 'Ακτινίδιο',
    cropType_olive: 'Ελιά',
    cropType_peach: 'Ροδακινιά',
    cropType_cherry: 'Κερασιά',
    cropType_grape: 'Αμπέλι',
    cropType_apple: 'Μηλιά',
    cropType_pear: 'Αχλαδιά',
    cropType_apricot: 'Βερικοκιά',
    cropType_other: 'Άλλη καλλιέργεια',
    zoneAllGood: 'ζώνη · όλα καλά',
    zonesAllGood: 'ζώνες · όλες καλά',
    alertSettingsSubtitle: 'Όρια, ώρες ησυχίας και προσαρμοσμένοι κανόνες',
    currentPasswordHint: 'Αφήστε κενό για να διατηρήσετε τον τρέχοντα κωδικό',
    currentPasswordRequired: 'Ο τρέχων κωδικός απαιτείται για αλλαγή',
    start: 'Έναρξη',
    vegetationIndex: 'Δείκτης Βλάστησης',
    zoneNeedsWater: 'Χρειάζεται νερό',
    zonesNeedWater: '{n} ζώνες χρειάζονται νερό',
    ndviNoBoundary: 'Σχεδιάστε τα όρια της ζώνης στον χάρτη για να ενεργοποιηθεί το NDVI',
    ndviTryIncreaseCloud: 'Δοκιμάστε να αυξήσετε τη μέγιστη νεφοκάλυψη παρακάτω',
    maxCloudCover: 'Μέγιστη νεφοκάλυψη',
    ndviHealthy: 'Υγιές',
    ndviModerate: 'Μέτριο',
    ndviSparse: 'Αραιό',
    ndviStressed: 'Καταπονημένο',
    ndviLow: 'Χαμηλό',
    paintSlots: 'Σχεδιασμός προγράμματος',
    painting: 'Σχεδιάζω',
    stopPainting: 'Διακοπή σχεδιασμού',
    showFullDay: 'Πλήρης ημέρα',
    farmingHours: 'Ώρες αγροκτήματος',
    collapseSidebar: 'Σύμπτυξη',
    expandSidebar: 'Ανάπτυξη',
    layerNdviLabel: 'Δείκτης Βλάστησης',
    layerNdviDesc: 'Χρωματισμός ζωνών με βάση τον δείκτη NDVI · δείχνει την πρασινάδα της καλλιέργειας',
    labelsName: 'Όνομα',
    labelsArea: 'Εμβαδόν',
    labelsOff: 'Ανενεργό',
    ruler: 'Μέτρηση απόστασης',
    rulerStop: 'Τέλος μέτρησης',
    segment: 'τμήμα',
    segments: 'τμήματα',
    filter: 'Φίλτρο',
    dssAdvisor: 'Σύμβουλος',
    advancedOptions: 'Προηγμένες επιλογές',
    noFieldsYet: 'Δεν υπάρχουν χωράφια ακόμα',
    noSchedulesToday: 'Τίποτα σήμερα',
    adjustBlock: 'Προσαρμογή',
    apply: 'Εφαρμογή',
    removeBlock: 'Αφαίρεση',
    autoApprove: 'Αυτόματη έγκριση',
    approveAll: 'Ενεργοποίηση όλων',
    goToCurrentWeek: 'Μετάβαση στην τρέχουσα εβδομάδα',
    selectFieldToApprove: 'Επιλέξτε ένα χωράφι για έγκριση προγραμμάτων',
    allSchedulesAlreadyActive: 'Όλα τα προγράμματα είναι ήδη ενεργά',
    approvedSchedules: 'Εγκρίθησαν {count} πρόγραμμα(τα)',
    failedToApprove: 'Αδυναμία έγκρισης. Δοκιμάστε ξανά.',
    approveZoneBusy: 'Η ζώνη ποτίζεται ήδη ή περιμένει τη σειρά της. Δείτε το Πρόγραμμα.',
    approveControllerDown: 'Ο ελεγκτής της ζώνης δεν απαντά. Ελέγξτε το ρεύμα και το δίκτυο και δοκιμάστε ξανά.',
    failedToReject: 'Αδυναμία απόρριψης. Δοκιμάστε ξανά.',
    failedToApproveSchedules: 'Αποτυχία έγκρισης προγραμμάτων',
    approve: 'Πότισε το',
    approved: 'Εγκρίθηκε',
    pending: 'Περιμένει έγκρισή σου',
    accepted: 'Εγκρίθηκε',
    rejected: 'Απορρίφθηκε',
    modified: 'Τροποποιήθηκε',
    expired: 'Έληξε',
    approveModified: 'Έγκριση (τροποποιημένη)',
    reason: 'Λόγος',
    confirmReject: 'Επιβεβαίωση απόρριψης',
    noPendingRecs: 'Δεν υπάρχουν εκκρεμείς συστάσεις',
    noPendingRecsHint: 'Ο Σύμβουλος θα δημιουργήσει συστάσεις την επόμενη φορά που θα εκτελεστεί ή όταν το ενεργοποιήσετε χειροκίνητα.',
    recentHistory: 'Πρόσφατο ιστορικό',
    recommendedTime: 'Ώρα',
    dssConf: 'εμπ.',
    dssSourceML: 'Προσαρμοστικό μοντέλο',
    dssSourcePhysics: 'Φυσικοί κανόνες',
    dssReasonWaiLow: 'Υγρασία εδάφους κάτω από το όριο',
    dssReasonForecastHeat: 'Πρόβλεψη υψηλής θερμοκρασίας',
    dssReasonDeficitGrowing: 'Αυξανόμενο υδατικό έλλειμμα',
    dssReasonKcPeak: 'Κορύφωση υδατικών αναγκών καλλιέργειας',
    dssReasonStressPrev: 'Προληπτική · προσέγγιση στρες',
    dssReasonProdGoal: 'Υψηλός στόχος απόδοσης',
    dssReasonMlModel: 'Προσαρμοστική σύσταση',
    dssReasonRainSkip: 'Πρόβλεψη βροχής · παράλειψη άρδευσης',
    dssReasonHighEt0: 'Υψηλή εξατμισοδιαπνοή',
    rejectRecentRain: 'Πρόσφατη βροχόπτωση',
    rejectDiffSchedule: 'Διαφορετικό πρόγραμμα σχεδιάζεται',
    rejectMaintenance: 'Συντήρηση συστήματος',
    rejectAlreadyIrr: 'Ήδη αρδεύτηκε σήμερα',
    rejectOther: 'Άλλος λόγος',
    resetFilter: 'Επαναφορά',
    applyFilter: 'Εφαρμογή',
    addNote: 'Προσθήκη σημείωσης στον χάρτη',
    reviewDss: 'Έλεγχος DSS',
    editNote: 'Επεξεργασία σημείωσης',
    comment: 'Σχόλιο',
    noteType: 'Τύπος',
    failedToDelete: 'Αποτυχία διαγραφής. Παρακαλώ δοκιμάστε ξανά.',
    noteCommentHint: 'Περιγράψτε τι παρατηρήσατε...',
    clickToPlaceNote: 'Κάντε κλικ στον χάρτη για να τοποθετήσετε τη σημείωση',
    noteTypeDisease: 'Ασθένεια',
    noteTypePests: 'Παράσιτα',
    noteTypeWaterlogging: 'Πλημμύρισμα',
    noteTypeFrost: 'Παγετός',
    noteTypeHail: 'Χαλάζι',
    noteTypeTreeDeath: 'Νέκρωση δέντρου',
    noteTypeSensorIssue: 'Πρόβλημα αισθητήρα',
    noteTypeOther: 'Άλλο',
    any: 'Οποιοδήποτε',
    hasStressedZones: 'Έχει αγχωμένες ζώνες',
    allZonesOk: 'Όλες οι ζώνες OK',
    currentlyIrrigating: 'Αρδεύει τώρα',
    notIrrigating: 'Σε αδρανοποίηση',
    layerCropLabel: 'Τύπος Καλλιέργειας',
    layerCropDesc: 'Χρωματισμός χωραφιών βάσει τύπου καλλιέργειας',
    layerZoneStateLabel: 'Κατάσταση Ζωνών',
    layerZoneStateDesc: 'Χρωματισμός ζωνών κατά υγεία άρδευσης (ΟΚ / Οριακό / Στρες)',
    opacity: 'Αδιαφάνεια',
    observations: 'παρ.',
    range: 'Εύρος',
    cropHealthNdvi: 'Υγεία Καλλιέργειας (Δορυφόρος)',
    avgNdvi: 'Δείκτης Βλάστησης',
    satelliteData: 'Δορυφορικά δεδομένα',
    ndviTrend: 'Τάση NDVI',
    maxNdvi: 'Μέγ.',
    minNdvi: 'Ελάχ.',
    ndviByZone: 'NDVI ανά Ζώνη',
    zoneHealthDistribution: 'Κατανομή Υγείας Ζωνών',
    noData: 'Χωρίς Δεδομένα',
    ndviPerZoneTrend: 'Τάση NDVI ανά Ζώνη',
    ndviNoTrendData: 'Δεν υπάρχουν αρκετά δεδομένα για τάση',
    ndviDataSource: 'Πηγή: Copernicus Sentinel-2 L2A μέσω Sentinel Hub Statistical API',
    zonesWithData: 'ζώνες με δεδομένα',
    stopIrrigation: 'Διακοπή Άρδευσης',
    running: 'Σε Εξέλιξη',
    scheduled: 'Προγραμματισμένο',
    completed: 'Ολοκληρώθηκε',
    cancelled: 'Ακυρώθηκε',
    failed: 'Απέτυχε',
    loadingIrrigation: 'Φόρτωση Δεδομένων Άρδευσης...',
    failedToLoadIrrigation: 'Αποτυχία φόρτωσης χρονοδιαγραμμάτων άρδευσης',
    
    // Weather
    weatherForecast: 'Πρόβλεψη Καιρού',
    weatherHistory: 'Ιστορικό Καιρού',
    currentWeather: 'Τρέχων Καιρός',
    temperature: 'Θερμοκρασία',
    humidity: 'Υγρασία',
    windSpeed: 'Ταχύτητα Ανέμου',
    rainfall: 'Βροχόπτωση',
    precipitation: 'Βροχόπτωση',
    et0Label: 'ΕΤ₀ Σήμερα',
    et0Unit: 'mm/ημέρα',
    et0Tooltip: 'Εξατμισοδιαπνοή αναφοράς · ατμοσφαιρική ζήτηση νερού (Penman-Monteith, FAO-56)',
    conditions: 'Συνθήκες',
    forecast: 'Πρόβλεψη',
    dayForecast: 'Πρόβλεψη 5 Ημερών',
    physicsModel: 'Φυσικό Μοντέλο',
    mlModel: 'Πρόβλεψη ΜΛ',
    mlFellBackToPhysics: '= Φυσική',
    mlNotTrained: 'Το μοντέλο ΜΛ δεν έχει εκπαιδευτεί. Εκτελέστε: python manage.py train_dss',
    stressIn: 'Στρες σε',
    today: 'Σήμερα',
    tomorrow: 'Αύριο',
    nextFiveDays: 'Επόμενες 5 Ημέρες',
    mph: 'χμ/ώ',
    mm: 'χιλ.',
    loadingWeather: 'Φόρτωση Δεδομένων Καιρού...',
    failedToLoadWeather: 'Αποτυχία φόρτωσης δεδομένων καιρού',
    weatherData: 'Δεδομένα Καιρού',
    weatherUpdated: 'Τα δεδομένα καιρού ενημερώθηκαν',
    weatherFallbackWarning: 'Δεδομένα καιρού μη διαθέσιμα · εμφάνιση δείγματος δεδομένων',
    weatherSubtitle: 'Τρέχων καιρός και πρόβλεψη για σχεδιασμό άρδευσης',
    weatherConnectionError: 'Η υπηρεσία καιρού δεν είναι διαθέσιμη',
    collectingWeatherHistory: 'Συλλογή ιστορικού καιρού…',
    weatherSampleWarning: 'Εμφάνιση δείγματος δεδομένων · τα API καιρού δεν έχουν ρυθμιστεί',
    weatherCachedWarning: 'Εμφάνιση αποθηκευμένων δεδομένων',

    // Alerts Page
    alertsAndNotifications: 'Ειδοποιήσεις',
    alertsSubtitle: 'Προειδοποιήσεις συστήματος και καιρού',
    acknowledgeAll: 'Αποδοχή Όλων',
    acknowledged: 'Αναγνωρισμένη',
    acknowledge: 'Αποδοχή',
    dismiss: 'Απόρριψη',
    criticalAlerts: 'Κρίσιμες σε εκκρεμότητα',
    highPriority: 'Υψηλής σε εκκρεμότητα',
    mediumPriority: 'Μεσαίας σε εκκρεμότητα',
    totalActive: 'Σύνολο σε εκκρεμότητα',
    searchAlerts: 'Αναζήτηση ειδοποιήσεων...',
    severity: 'Σοβαρότητα',
    allSeverities: 'Όλες οι Σοβαρότητες',
    critical: 'Κρίσιμη',
    highSeverity: 'Υψηλή',
    mediumSeverity: 'Μεσαία',
    lowSeverity: 'Χαμηλή',
    infoSeverity: 'Πληροφοριακή',
    all: 'Όλα',
    noAlertsFound: 'Δεν Βρέθηκαν Ειδοποιήσεις',
    adjustFilters: 'Δοκιμάστε να προσαρμόσετε τα φίλτρα σας για περισσότερες ειδοποιήσεις.',
    allSystemsSmooth: 'Όλα τα συστήματα λειτουργούν ομαλά. Μπράβο!',
    allClear: 'Όλα Εντάξει',
    allClearHint: 'Δεν υπάρχουν ενεργές ειδοποιήσεις. Το TerraMind παρακολουθεί τα χωράφια σας 24/7 και θα σας ενημερώσει όταν χρειαστεί δράση.',
    configureAlertRules: 'Ρύθμιση Κανόνων Ειδοποίησης',
    alertSettings: 'Ρυθμίσεις Ειδοποιήσεων',
    emailNotifications: 'Ειδοποιήσεις Email',
    emailNotificationsDesc: 'Λάβετε ειδοποιήσεις email για κρίσιμες και υψηλής προτεραιότητας προειδοποιήσεις.',
    alertThresholds: 'Κατώφλια Ειδοποιήσεων',
    lowMoistureThreshold: 'Χαμηλή Υγρασία (%)',
    highTempThreshold: 'Υψηλή Θερμ. (°C)',
    waiThreshold: 'Κατώφλι επιπέδου νερού εδάφους',
    sensorTimeout: 'Χρονικό Όριο Αισθητήρα (λεπτά)',
    noReadings: 'Χωρίς μετρήσεις',
    justNow: 'Μόλις τώρα',
    ago: 'πριν',
    updated: 'Ενημερώθηκε',
    quietHours: 'Ώρες Ησυχίας',
    quietHoursDesc: 'Απόκρυψη μη κρίσιμων ειδοποιήσεων κατά τις καθορισμένες ώρες.',
    startTime: 'Ώρα Έναρξης',
    endTime: 'Ώρα Λήξης',
    alertRules: 'Κανόνες Ειδοποιήσεων',
    addRule: 'Προσθήκη Κανόνα',
    noRulesDefined: 'Δεν έχουν οριστεί κανόνες.',
    ruleName: 'Όνομα Κανόνα',
    sensorType: 'Τύπος Αισθητήρα',
    operator: 'Τελεστής',
    saveSettings: 'Αποθήκευση Ρυθμίσεων',

    // Alert severity labels
    severity_critical: 'Κρίσιμη',
    severity_high: 'Υψηλή',
    severity_medium: 'Μέτρια',
    severity_low: 'Χαμηλή',

    // Alert rule name labels
    alertRule_lowMoisture: 'Χαμηλή υγρασία εδάφους',
    alertRule_highTemp: 'Υψηλή θερμοκρασία',
    alertRule_waiThreshold: 'Διαθέσιμο νερό κάτω από όριο',
    alertRule_sensorTimeout: 'Αισθητήρας εκτός σύνδεσης',
    // Alert type values
    alertTypeValue_sensor: 'Αισθητήρας',
    alertTypeValue_weather: 'Καιρός',
    alertTypeValue_irrigation: 'Άρδευση',
    alertTypeValue_system: 'Σύστημα',
    // Operator labels
    operator_lt: 'Μικρότερο από',
    operator_gt: 'Μεγαλύτερο από',
    operator_lte: 'Έως',
    operator_gte: 'Από',
    operator_eq: 'Ίσο με',

    // Status labels (irrigation plans / history)
    status_pending: 'Περιμένει έγκρισή σου',
    status_executing: 'Σε άρδευση τώρα',
    status_completed: 'Ολοκληρωμένη',
    status_failed: 'Αποτυχία',
    status_cancelled: 'Ακυρωμένη',
    status_in_progress: 'Σε Εξέλιξη',
    status_assigned: 'Ανατεθείσα',

    // Weather provider labels
    cachedData: 'Αποθηκευμένα',
    weatherUnavailable: 'Ο καιρός δεν είναι διαθέσιμος',
    sampleData: 'Δείγμα δεδομένων',

    // Zone card
    sensorData: 'Δεδομένα αισθητήρα',

    // Analytics / Data Explorer
    dataExplorer: 'Δεδομένα Αγρού',
    dataExplorerSubtitle: 'Δημιουργήστε γραφήματα από δεδομένα αισθητήρων, καιρού και άρδευσης',
    // Πίνακας παραγωγικής χρήσης (υιοθέτηση + αποτελέσματα DSS)
    productionTab: 'Παραγωγή',
    productionUseSubtitle: 'Πώς χρησιμοποιείται ο σύμβουλος άρδευσης και πώς αποδίδει',
    followThrough: 'Εφαρμογή συστάσεων',
    recommendationsFollowed: 'συστάσεις εκτελέστηκαν',
    noRecommendationsYet: 'Δεν υπάρχουν συστάσεις ακόμη',
    waterApplied: 'Νερό που εφαρμόστηκε',
    rowsExcludedNoData: 'αρδεύσεις εξαιρέθηκαν (χωρίς δεδομένα)',
    viaCompletedPlans: 'από ολοκληρωμένες αρδεύσεις',
    faults: 'Σφάλματα',
    noFaults: 'Χωρίς σφάλματα',
    executionFaults: 'σφάλματα εκτέλεσης',
    noManualComparison: 'Δεν υπάρχουν χειροκίνητα δεδομένα για σύγκριση',
    waterDssVsManual: 'Νερό: σύμβουλος vs χειροκίνητα',
    advisorScheduled: 'Προγρ. από σύμβουλο',
    manualScheduled: 'Προγρ. χειροκίνητα',
    decisionMix: 'Κατανομή αποφάσεων στον χρόνο',
    decisionMixSub: 'Τι συνέστησε το σύστημα κάθε ημέρα',
    noDecisionsYet: 'Δεν υπάρχουν αποφάσεις σε αυτή την περίοδο ακόμη',
    waiTrajectory: 'Εδαφικό νερό vs όριο',
    waiTrajectorySub: 'Παρέμεινε το εδαφικό νερό στην υγιή ζώνη;',
    waiLabel: 'Εδαφικό νερό (WAI)',
    reasonBreakdown: 'Γιατί αποφάσισε το σύστημα',
    reasonBreakdownSub: 'Κύριοι λόγοι σε όλες τις αποφάσεις',
    recommendedVsActual: 'Προτεινόμενη vs πραγματική διάρκεια',
    recommendedVsActualSub: 'Πότισε όσο συνέστησε ο σύμβουλος;',
    actual: 'Πραγματική',
    minutesShort: 'λεπτά',
    noCompletedPlans: 'Δεν υπάρχουν ολοκληρωμένες αρδεύσεις για σύγκριση',
    engineMix: 'Κατανομή μηχανής αποφάσεων',
    engineMixSub: 'Κανόνες vs ML, λειτουργεί το μοντέλο;',
    decIrrigate: 'Άρδευση',
    decNoIrrigation: 'Χωρίς άρδευση',
    decSuspend: 'Αναστολή',
    decResume: 'Συνέχιση',
    analyticsAndReports: 'Αναλύσεις & Αναφορές',
    analyticsSubtitle: 'Μετρήσεις αποδοτικότητας νερού, τάσεις και πληροφορίες απόδοσης',
    analyticsSubtitleAdmin: 'Συνολική αποδοτικότητα, διαγνωστικά αισθητήρων και τάσεις απόδοσης',
    analyticsSubtitleFarmer: 'Υγεία εδάφους, κατανάλωση νερού, κατάσταση καλλιέργειας και καιρός',
    myFarmInsights: 'Η Εκμετάλλευσή μου',
    timeRange: 'Χρονικό Εύρος',
    thisWeek: 'Τελευταίες 7 ημέρες',
    thisMonth: 'Τελευταίες 30 ημέρες',
    thisQuarter: 'Τελευταίες 90 ημέρες',
    thisYear: 'Τελευταίοι 12 μήνες',
    allData: 'Όλα τα Δεδομένα',
    recommended: 'Προτεινόμενα',
    recommendedCharts: 'Προτεινόμενα Γραφήματα',
    customChart: 'Προσαρμοσμένο Γράφημα',
    chart: 'γράφημα',
    charts: 'γραφήματα',
    export: 'Εξαγωγή',
    totalWaterUsed: 'Συνολικό Νερό',
    avgEfficiency: 'Μέση Αποδοτικότητα',
    runsCompletedShare: 'Αρδεύσεις που ολοκληρώθηκαν',
    runsCompletedShareSub: 'από όσες προγραμματίστηκαν',
    waterEstimateFromFlow: 'Εκτίμηση από την παροχή',
    costSavings: 'Εξοικονόμηση',
    et0Average: 'Μέσος ET₀',
    waterUsage: 'Νερό Αυτής της Περιόδου',
    fieldPerformance: 'Πώς Πάει Κάθε Χωράφι',
    efficiencyTrends: 'Εξοικονόμηση με τον Καιρό',
    irrigationBreakdown: 'Σύνοψη Άρδευσης',
    waterUsageVsOptimal: 'Κατανάλωση Νερού vs Βέλτιστες Απαιτήσεις',
    fieldByFieldPerformance: 'Πώς Πάει Κάθε Χωράφι',
    expectedYield: 'Αναμενόμενη Απόδοση',
    monthlyEfficiencyTrends: 'Μηνιαίες Τάσεις Αποδοτικότητας & Εξοικονόμησης',
    irrigationTypeDistribution: 'Κατανομή Τύπου Άρδευσης',
    fieldEfficiencyComparison: 'Σύγκριση Αποδοτικότητας Χωραφιών',
    waterConservationImpact: 'Επίπτωση Εξοικονόμησης Νερού',
    waterConservationDesc: 'Το TerraMind βοηθά στην εξοικονόμηση νερού κάθε μήνα μέσω ευφυών αποφάσεων άρδευσης βάσει εδάφους και καιρού.',
    waterConservationEquiv: 'Η εξοικονόμηση εξαρτάται από το μέγεθος του χωραφιού, τον τύπο καλλιέργειας και την εποχή.',
    predictionAccuracyDesc: 'Οι προβλέψεις WAI βελτιώνονται συνεχώς, βελτιστοποιώντας τον χρονισμό άρδευσης για τα χωράφια σας.',
    predictionAccuracyDetail: 'Η ακρίβεια βασίζεται στις αναγνώσεις αισθητήρων και το ιστορικό άρδευσης.',
    cropHealthImprovement: 'Βελτίωση Υγείας Καλλιέργειας',
    cropHealthImprovementDesc: 'Ο μέσος δείκτης υγείας καλλιέργειας βελτιώθηκε κατά 8% σε σχέση με την προηγούμενη σεζόν.',
    cropHealthImprovementDetail: 'Προβλεπόμενη αύξηση απόδοσης: 10-12% για τη συγκομιδή ακτινιδίων.',

    // History Page
    failedToLoadHistory: 'Αποτυχία φόρτωσης ιστορικού',
    retry: 'Επανάληψη',

    // Weekly Schedule (additional)
    failedToLoadSchedules: 'Αποτυχία φόρτωσης προγραμμάτων',
    failedToUpdateSchedule: 'Αποτυχία ενημέρωσης προγράμματος',
    failedToDeleteSchedule: 'Αποτυχία διαγραφής προγράμματος',
    editAllFields: 'Επεξεργασία Όλων...',

    // Language
    language: 'Γλώσσα',

    // DSS Debugger (Admin)
    dssDemo: 'Ευφυΐα Άρδευσης',
    dssDebugger: 'Ανάλυση Αλγορίθμου DSS',
    dssDebuggerSubtitle: 'Κατανοήστε γιατί ο αλγόριθμος παίρνει κάθε απόφαση άρδευσης',

    // Admin Analytics KPIs
    adminUsers: 'Χρήστες',
    adminCoverage: 'Κάλυψη',
    adminIrrigationActivity: 'Δραστηριότητα Άρδευσης',
    adminDssPerformance: 'Απόδοση Συμβούλου',
    adminTotalUsers: 'Σύνολο Χρηστών',
    adminActiveWeek: 'Ενεργοί Αυτή την Εβδομάδα',
    adminTrialAccounts: 'Λογαριασμοί Δοκιμής',
    adminPaidAccounts: 'Επί Πληρωμή Λογαριασμοί',
    adminFieldsProduction: 'Παραγωγικά Χωράφια',
    adminZones: 'Ζώνες Άρδευσης',
    adminSensorsDeployed: 'Αισθητήρες σε Λειτουργία',
    adminSensorHealth: 'Υγεία Αισθητήρων',
    adminEventsToday: 'Αρδεύσεις Σήμερα',
    adminEventsWeek: 'Αρδεύσεις Εβδομάδας',
    adminExecuting: 'Σε Εξέλιξη Τώρα',
    adminDssAcceptRate: 'Αποδοχή Συστάσεων Συμβούλου',
    adminRecsGenerated: 'Συστάσεις που Δημιουργήθηκαν',
    adminRecsAccepted: 'Αποδεκτές',
    adminRecsRejected: 'Απορριφθείσες',
    adminRecsPending: 'Σε Αναμονή',
    adminSensorReporting: 'Υγεία Αναφοράς Αισθητήρων',
    adminCompletedIrrigations: 'Ολοκληρωμένες Αρδεύσεις: Τελευταίες 8 Εβδομάδες',
    adminPlatformDesc: 'Υγεία πλατφόρμας, δραστηριότητα χρηστών και λειτουργικοί δείκτες',
    adminLast30Days: 'Τελευταίες 30 ημέρες',
    adminPlanDistribution: 'Κατανομή Πλάνων',
    failedToLoadAnalytics: 'Αποτυχία φόρτωσης αναλυτικών. Δοκιμάστε ανανέωση.',
    adminDataFreshness: 'Επικαιρότητα Δεδομένων',
    adminWeatherData: 'Μετεωρολογικά Δεδομένα',
    adminNdviScene: 'Δορυφορική Εικόνα NDVI',
    adminSensorReadings: 'Μετρήσεις Αισθητήρων',
    adminLive: 'Ζωντανά',
    adminNoData: 'Χωρίς δεδομένα',
    adminNoRecentData: 'Χωρίς πρόσφατα δεδομένα',
    adminDaysAgo: 'ημ. πριν',

    // Operations per field (admin analytics, staff only)
    opsTitle: 'Λειτουργία ανά χωράφι',
    opsDays: 'ημέρες',
    opsGrowersActive: 'Παραγωγοί που χρησιμοποίησαν την εφαρμογή',
    opsFieldsStale: 'Αισθητήρες χωρίς νέες μετρήσεις',
    opsFieldsWithCall: 'Χωράφια με σύσταση',
    opsRuns: 'Αρδεύσεις',
    opsFollowed: 'Μετά από σύσταση',
    opsFollowedShort: 'μετά από σύσταση',
    opsBoard: 'Επιβεβαίωση από τον ελεγκτή',
    opsFelt: 'Φάνηκαν στον αισθητήρα',
    opsOutside: 'Αρδεύσεις εκτός εφαρμογής',
    opsAlerts: 'Ανοιχτές ειδοποιήσεις εξοπλισμού',
    opsCall: 'Σύσταση',
    opsNoProbe: 'Χωρίς αισθητήρα',
    opsNever: 'Ποτέ',
    opsHoursAgo: 'ώρες πριν',
    opsNoCall: 'Χωρίς σύσταση',
    opsCallNone: 'Όχι τώρα',
    opsMinutes: 'λεπτά',
    opsSearch: 'Αναζήτηση παραγωγού ή χωραφιού',
    opsOnlyIssues: 'Μόνο όσα θέλουν έλεγχο',
    opsUse: 'Χρήση της εφαρμογής',
    opsActiveDays: 'Ημέρες χρήσης',
    opsUseMinutes: 'Λεπτά',
    opsLastSeen: 'Τελευταία χρήση',
    opsDevices: 'Συνδεδεμένες συσκευές',
    opsUseNote: 'Η χρήση μετράει κάθε επίσκεψη με τα στοιχεία του παραγωγού, μαζί με τους δικούς μας ελέγχους.',

    // User Management (Admin)
    userManagement: 'Διαχείριση Χρηστών',
    systemAnalytics: 'Αναλυτικά',
    subscriptionPlan: 'Πλάνο Συνδρομής',
    planTrial: 'Δωρεάν Δοκιμή (30 ημέρες)',
    planBasic: 'Βασικό',
    planPro: 'Pro',
    planEnterprise: 'Enterprise',
    addUser: 'Προσθήκη Χρήστη',
    user: 'Χρήστης',
    allUsers: 'Όλοι οι χρήστες',
    viewFields: 'Προβολή Χωραφιών',
    allPlans: 'Όλα τα πλάνα',
    noUsersFound: 'Κανένας χρήστης δεν ταιριάζει με τα φίλτρα.',
    discardZoneChanges: 'Έχετε μη αποθηκευμένες αλλαγές ζώνης. Να απορριφθούν;',
    subscriptionExpiry: 'Ημερομηνία λήξης συνδρομής',
    subscriptionExpiryHelp: 'Αφήστε κενό για να διατηρήσετε την τρέχουσα λήξη',
    myRequests: 'Τα Αιτήματά μου',
    myRequestsDesc: 'Τα υποβληθέντα αιτήματά σας και οι απαντήσεις της ομάδας TerraMind.',
    replyFromTeam: 'Απάντηση από TerraMind',
    awaiting: 'Αναμένει απάντηση',
    read: 'Διαβάστηκε',
    recurrenceWeekly: 'Κάθε εβδομάδα (επαναλαμβανόμενο)',
    editUser: 'Επεξεργασία Χρήστη',
    userCreated: 'Ο χρήστης δημιουργήθηκε με επιτυχία',
    userUpdated: 'Ο χρήστης ενημερώθηκε με επιτυχία',
    failedToLoadUsers: 'Αποτυχία φόρτωσης χρηστών',
    usernamePasswordRequired: 'Απαιτούνται όνομα χρήστη και κωδικός',
    firstName: 'Όνομα',
    lastName: 'Επώνυμο',
    newPassword: 'Νέος Κωδικός',
    owner: 'Ιδιοκτήτης',
    role: 'Ρόλος',
    email: 'Email',
    fieldCount: 'Χωράφια',
    farmer: 'Παραγωγός',
    admin: 'Διαχειριστής',
    lastLogin: 'Τελευταία Σύνδεση',
    dateJoined: 'Εγγραφή',
    neverLoggedIn: 'Δεν έχει συνδεθεί ποτέ',

    // Schedule multi-day
    selectDays: 'Επιλέξτε ημέρες',
    selectAtLeastOneDay: 'Επιλέξτε τουλάχιστον μία ημέρα',

    // Weather warnings
    weatherCacheWarning: 'Τα API καιρού δεν είναι διαθέσιμα · εμφάνιση αποθηκευμένων δεδομένων',

    // History
    yesterday: 'Χτες',

    // Schedule drag-and-drop
    dragToCreate: 'Σύρετε για επιλογή · Κλικ σε μπλοκ για επεξεργασία · Σύρετε μπλοκ για μετακίνηση',
    paintToSelect: 'Ζωγραφίστε χρονοθυρίδες · Κλικ σε μπλοκ για επεξεργασία · Σύρετε μπλοκ για μετακίνηση',
    quickIrrigation: 'Γρήγορη Άρδευση',
    dragToMove: 'Σύρετε μπλοκ για αναπρογραμματισμό',
    movedSchedule: 'Το πρόγραμμα μετακινήθηκε',
    timezone: 'Ζώνη ώρας',

    // Alerts page
    alertType: 'Τύπος',
    allTypes: 'Όλοι οι Τύποι',
    allStatuses: 'Όλες οι Καταστάσεις',
    resolved: 'Επιλυμένο',
    failedToLoadAlerts: 'Αποτυχία φόρτωσης ειδοποιήσεων',
    sensorValue: 'Τιμή',
    threshold: 'όριο',

    // Misc
    allIrrigationsStopped: 'Όλες οι αρδεύσεις σταμάτησαν',
    seasonAlreadyExists: 'Η σεζόν υπάρχει ήδη για αυτό το έτος',
    seasonAlreadyExistsAll: 'Η σεζόν υπάρχει ήδη σε όλα τα χωράφια',
    seasonCreated: 'Η σεζόν δημιουργήθηκε επιτυχώς',
    seasonCreateFailed: 'Αποτυχία δημιουργίας σεζόν',
    alreadyExisted: 'υπήρχαν ήδη',
    created: 'δημιουργήθηκαν',
    sensor: 'Αισθητήρας',
    weatherApi: 'API Καιρού',
    otherZones: 'Υπόλοιπες ζώνες',
    groupBy: 'Ομαδοποίηση',
    crop: 'Καλλιέργεια',
    forecastAware: 'Με πρόβλεψη',
    compareModels: 'Σύγκριση μοντέλων',
    nextEvent: 'Επόμενο',
    unavailable: 'Μη διαθέσιμο',
    allYears: 'Όλα τα έτη',
    local: 'Τοπικό',
    et0MeteoblueHint: 'Εξατμισοδιαπνοή αναφοράς από το μοντέλο αγρομετεωρολογίας της Meteoblue (Penman-Monteith με πλήρη ωριαία ατμόσφαιρα)',
    et0LocalHint: 'Τοπική προσέγγιση FAO-56 από θερμοκρασία / υγρασία / άνεμο',
    forecastMissingInputs: 'Η πρόβλεψη δεν είναι διαθέσιμη · λείπουν δεδομένα αισθητήρων / καιρού',
    missingFields: 'Λείπουν',
    somethingWentWrong: 'Κάτι πήγε στραβά',
    tryAgain: 'Δοκιμάστε ξανά',
    todaysSchedule: 'Πρόγραμμα Σήμερα',
    more: 'ακόμα',
    min: 'λεπτά',
    merged: 'συγχωνευμένα',
    on: 'ΝΑΙ',
    off: 'ΟΧΙ',
    unknown: 'Άγνωστο',
    sprinklersShort: 'εκτ.',
    cancelQueue: 'Ακύρωση',
    allZonesBusy: 'Όλες οι ζώνες είναι ενεργές',
    noActiveIrrigations: 'Δεν υπάρχουν ενεργές αρδεύσεις',
    failedToLoadData: 'Αποτυχία φόρτωσης δεδομένων. Ελέγξτε ότι ο server λειτουργεί.',

    // Weather
    cached: 'Αποθηκευμένο',
    kmh: 'χλμ/ώ',

    // History
    minActual: 'λεπ πραγματικά',

    // Analytics chart labels
    irrigationType_dss: 'Advisor',
    irrigationType_manual: 'Χειροκίνητη',
    irrigationType_weeklySchedule: 'Πρόγραμμα',

    // Decision types (History page)
    allDecisions: 'Όλες οι Αποφάσεις',
    irrigate: 'Άρδευση',
    noIrrigation: 'Χωρίς Άρδευση',
    suspend: 'Αναστολή',
    resume: 'Συνέχιση',
    plansEmptySubtitle: 'Τα σχέδια θα εμφανιστούν εδώ καθώς ο Σύμβουλος παράγει αποφάσεις άρδευσης.',

    // Dashboard attention
    zoneNeedsAttention: 'ζώνη χρειάζεται προσοχή',
    needsIrrigationDose: 'Χρειάζεται',

    // Validation messages
    durationRequired: 'Η διάρκεια είναι υποχρεωτική',
    waterAmountRequired: 'Η ποσότητα νερού είναι υποχρεωτική',
    durationInvalid: 'Η διάρκεια πρέπει να είναι αριθμός',
    durationTooShort: 'Η διάρκεια πρέπει να είναι τουλάχιστον 1 λεπτό',
    durationTooLong: 'Η διάρκεια δεν μπορεί να υπερβεί τα 240 λεπτά (4 ώρες)',
    waterAmountInvalid: 'Η ποσότητα νερού πρέπει να είναι αριθμός',
    waterAmountNegative: 'Η ποσότητα νερού δεν μπορεί να είναι αρνητική',
    waterAmountMax: 'Η ποσότητα νερού δεν μπορεί να υπερβεί τα 100.000 λίτρα',
    fieldNameRequired: 'Το όνομα χωραφιού είναι υποχρεωτικό',
    fieldNameTooLong: 'Το όνομα χωραφιού δεν μπορεί να υπερβεί τους 100 χαρακτήρες',
    areaInvalid: 'Η έκταση πρέπει να είναι αριθμός',
    areaMin: 'Η έκταση πρέπει να είναι μεγαλύτερη από 0',
    areaMax: 'Ένα χωράφι μπορεί να έχει έως 500 στρέμματα. Χωρίστε μεγαλύτερη έκταση σε περισσότερα χωράφια.',

    // Day names
    monday: 'Δευτέρα', tuesday: 'Τρίτη', wednesday: 'Τετάρτη',
    thursday: 'Πέμπτη', friday: 'Παρασκευή', saturday: 'Σάββατο', sunday: 'Κυριακή',
    mon: 'Δευ', tue: 'Τρι', wed: 'Τετ', thu: 'Πεμ', fri: 'Παρ', sat: 'Σαβ', sun: 'Κυρ',

    // Schedule form labels
    supportInbox: 'Εισερχόμενα',
    supportInboxSubtitle: 'Μηνύματα από παραγωγούς',
    noMessages: 'Δεν υπάρχουν μηνύματα ακόμα',
    markUnread: 'Σήμανση ως μη αναγνωσμένο',
    connectedOnly: 'Μόνο συνδεδεμένοι',
    noSearchResults: 'Δεν βρέθηκαν αποτελέσματα',
    searchMessages: 'Αναζήτηση μηνυμάτων...',
    subject: 'Θέμα',
    unread: 'Μη αναγνωσμένα',
    replied: 'Απαντήθηκε',
    selectMessageToRead: 'Επιλέξτε μήνυμα για ανάγνωση',
    allMessages: 'Όλα',
    typeReplyHere: 'Γράψτε την απάντησή σας…',
    sendReply: 'Αποστολή Απάντησης',
    replySent: 'Η απάντηση στάλθηκε',
    yourReply: 'Η απάντησή σας',
    failedToLoadMessages: 'Αποτυχία φόρτωσης μηνυμάτων',
    failedToSendReply: 'Αποτυχία αποστολής απάντησης',
    fieldAndZone: 'Χωράφι & Ζώνη',
    irrigationMode: 'Λειτουργία Άρδευσης',
    recurrence: 'Επανάληψη',
    timing: 'Χρονισμός',
    moreOptions: 'Περισσότερες Επιλογές',
    editDetails: 'Λεπτομέρειες',
    smartSkip: 'Έξυπνη Παράλειψη',
    smartSkipHelp: 'Ο Σύμβουλος μπορεί να παρακάμψει αυτό το πρόγραμμα αν η υγρασία εδάφους είναι επαρκής',
    unsavedChanges: 'Μη αποθηκευμένες αλλαγές',
    discardChanges: 'Έχετε μη αποθηκευμένες αλλαγές. Θέλετε να τις απορρίψετε;',
    keepEditing: 'Συνέχεια',
    discard: 'Απόρριψη',
    restoreDraft: 'Επαναφορά',
    draftFoundHint: 'Υπάρχει αποθηκευμένο προσχέδιο για αυτό το χωράφι.',
    scheduleUpdated: 'Το πρόγραμμα ενημερώθηκε',
    scheduleDeleted: 'Το πρόγραμμα διαγράφηκε',
    schedulesCreated: 'προγράμματα δημιουργήθηκαν',
    calendarHint: 'Κλικ σε μπλοκ για επεξεργασία · Σύρετε για μετακίνηση',
    paintCalendarHint: 'Ζωγραφίστε χρονοθυρίδες · Μετά δημιουργήστε πρόγραμμα',
    analyzingFields: 'Ανάλυση όλων των χωραφιών...',
    dssRecommendations: 'Τι να κάνεις σήμερα',
    dssRecommendationsInfo: 'Αυτές οι ζώνες χρειάζονται άρδευση. Επιλέξτε ποιες θα προγραμματιστούν για σήμερα.',
    dssRecentRecommendations: 'Προτάσεις Συμβούλου',
    viewInSchedule: 'Προβολή στο Πρόγραμμα',
    viewAnalytics: 'Προβολή Αναλυτικών',
    accept: 'Αποδοχή',
    reject: 'Παράλειψη',
    reasonWaiLow: 'Χαμηλή Υγρασία',
    reasonSoilAdequate: 'Υγρασία OK',
    reasonForecastHeat: 'Πρόβλεψη Καύσωνα',
    reasonDeficitGrowing: 'Αυξανόμενο Έλλειμμα',
    reasonKcPeak: 'Κορύφωση Ζήτησης',
    reasonStressPrevention: 'Πρόληψη Στρες',
    reasonProductionGoal: 'Στόχος Παραγωγής',
    reasonMlModel: 'Μοντέλο ML',
    viewFieldOnMapFromAlert: 'Προβολή Χωραφιού',
    scheduleSelected: 'Προγραμμάτισε',
    scheduling: 'Προγραμματισμός...',
    selected: 'επιλεγμένα',
    selectAll: 'Επιλογή Όλων',
    deselectAll: 'Αποεπιλογή Όλων',

    // Alert type labels
    alertTypeIrrigation: 'Άρδευση',
    alertTypeSensor: 'Αισθητήρας',
    alertTypeWeather: 'Καιρός',
    alertTypeSystem: 'Σύστημα',

    // Alert status labels
    alertStatus_active: 'Ενεργή',
    alertStatus_acknowledged: 'Αναγνωρισμένη',
    alertStatus_resolved: 'Επιλυμένη',

    // Provider labels
    providerManual: 'Χειροκίνητο',
    providerEdge: 'Ελεγκτής Edge',
    providerHunter: 'Hunter X2',
    providerHydrawise: 'Hydrawise',

    // User management errors
    failedToSaveUser: 'Αποτυχία αποθήκευσης χρήστη',
    failedToUpdateUserStatus: 'Αποτυχία ενημέρωσης κατάστασης χρήστη',
    cannotDeactivateSelf: 'Δεν μπορείτε να απενεργοποιήσετε τον δικό σας λογαριασμό',

    // Analytics chart labels
    leafHumidity: 'Υγρασία Φύλλου',
    leafTemperature: 'Θερμοκρασία Φύλλου',
    leafWetness: 'Υγρότητα Φύλλου',
    soilSalinity: 'Αλατότητα Εδάφους',
    solarRadiation: 'Ηλιακή Ακτινοβολία',
    et0Chart: 'Εξατμισοδιαπνοή αναφοράς ET₀',
    atmosphericConditions: 'Ατμοσφαιρικές Συνθήκες',
    atmosphericPressure: 'Ατμοσφαιρική Πίεση',
    uvIndex: 'Δείκτης UV',
    solarPanelVoltage: 'Μπαταρία Αισθητήρα',
    noAtmosphericData: 'Δεν υπάρχουν ατμοσφαιρικά δεδομένα για αυτή την περίοδο',
    category: 'Κατηγορία',
    allCategories: 'Όλες',
    lineChart: 'Γραμμή',
    areaChart: 'Περιοχή',
    barChart: 'Ράβδοι',
    selectMetrics: 'Επιλέξτε μία ή περισσότερες μετρήσεις για οπτικοποίηση',
    metricsSelected: 'μετρήσεις επιλεγμένες',
    clearSelection: 'Καθαρισμός',
    energy: 'Ενέργεια & Ακτινοβολία',
    temperatureHistory: 'Ιστορικό Θερμοκρασίας',
    maxTemp: 'Μέγ.',
    minTemp: 'Ελάχ.',
    avgTemp: 'Μέση',
    totalUsage: 'Σύνολο',
    manual: 'Χειροκίνητο',
    noWaterData: 'Δεν υπάρχουν δεδομένα νερού για αυτήν την περίοδο',
    noFieldData: 'Δεν υπάρχουν δεδομένα χωραφιών',
    noTrendData: 'Δεν υπάρχουν δεδομένα τάσεων',
    noBreakdownData: 'Δεν υπάρχουν δεδομένα άρδευσης',
    noLeafData: 'Δεν υπάρχουν δεδομένα αισθητήρα φύλλου για αυτήν την περίοδο',
    noWeatherData: 'Δεν υπάρχουν ιστορικά δεδομένα καιρού',
    dssVsManual: 'Συστάσεις έναντι χειροκίνητης άρδευσης',
    avgWaiAllZones: 'Μέσος WAI σε όλες τις ζώνες',
    fromWeatherData: 'Από δεδομένα καιρού',
    vsPreviousPeriod: 'vs προηγούμενη περίοδο',
    periodAverage: 'Μέσος περιόδου',
    periodTotal: 'Σύνολο περιόδου',
    soilTemp10: 'Έδαφος 10εκ.',
    soilTemp20: 'Έδαφος 20εκ.',
    soilTemp30: 'Έδαφος 30εκ.',
    salinity10: 'Αλατότητα 10εκ.',
    salinity20: 'Αλατότητα 20εκ.',
    salinity30: 'Αλατότητα 30εκ.',
    weeklyWaterUsage: 'Νερό · Έξυπνο vs Χειροκίνητο',
    fieldStatus: 'Κατάσταση Χωραφιού',
    customizeWidgets: 'Προσαρμογή',
    chooseWidgets: 'Επιλέξτε τι θα εμφανίζεται',
    resetDefaults: 'Επαναφορά αρχικών',
    insightsWidgets: 'Πληροφορίες',
    leafAndEnvironment: 'Φύλλο & Περιβάλλον',
    noWidgetsSelected: 'Δεν έχουν επιλεγεί widgets. Πατήστε "Προσαρμογή" για να επιλέξετε.',
    viewFieldOnMap: 'Προβολή στο Χάρτη',
    backToField: 'Πίσω στο Χωράφι',

    // ── Competitive Features (20 features) ──────────────────────
    morningPrescription: 'Πρωινή Συνταγή',
    prescriptionSummary: 'ζώνες χρειάζονται νερό σήμερα',
    skipZone: 'Παράλειψη',
    irrigateZone: 'Άρδευση',
    monitorZone: 'Παρακολούθηση',
    startRecommended: 'Εκκίνηση Προτεινόμενων',
    rainExpected: 'Αναμένεται βροχή',
    frostRisk: 'Κίνδυνος παγετού',
    operationalKpis: 'Λειτουργικοί Δείκτες',
    litersToday: 'Λίτρα Σήμερα',
    percentComplete: 'Ολοκλήρωση',
    nextScheduled: 'Επόμενο',
    timeline72h: 'Χρονοδιάγραμμα 72ω',
    past24h: 'Τελευταίες 24ω',
    next48h: 'Επόμενες 48ω',
    nowMarker: 'Τώρα',
    soilCrossSection: 'Τομή Εδάφους',
    deepSoil: 'Βαθύ έδαφος',
    surfaceSoil: 'Επιφάνεια',
    rootZone: 'Ζώνη ριζών',
    confidence: 'Αξιοπιστία',
    depthProfile: 'Προφίλ Βάθους',
    trendUp: 'Αυξάνεται',
    trendDown: 'Μειώνεται',
    trendStable: 'Σταθερό',
    sprayWindow: 'Παράθυρα Ψεκασμού',
    sprayWindowAdvisory: 'Σύμβουλος Ψεκασμού',
    excellent: 'Εξαιρετικό',
    fair: 'Μέτριο',
    poor: 'Κακό',
    noWindowAvailable: 'Δεν υπάρχει κατάλληλο παράθυρο ψεκασμού',
    diseaseRisk: 'Κίνδυνος Ασθενειών',
    psaRisk: 'Κίνδυνος PSA',
    lowRisk: 'Χαμηλός',
    mediumRisk: 'Μέτριος',
    highRisk: 'Υψηλός',
    criticalRisk: 'Κρίσιμος',
    copperSpray: 'Εφαρμόστε χαλκούχο σκεύασμα εντός 48ω',
    leafWetnessHours: 'Υγρασία φύλλου',
    // DSS Insights Widget
    dssInsights: 'Ανάλυση Αποφάσεων Συμβούλου',
    dssInsightsDesc: 'Λεπτομερής ανάλυση της συμπεριφοράς του Συμβούλου και των αποφάσεων άρδευσης',
    dssReasonDistribution: 'Κατανομή Αποφάσεων Συμβούλου',
    dssReasonDistributionDesc: 'Πώς ταξινόμησε ο Σύμβουλος κάθε απόφαση άρδευσης',
    rainSkipAnalysis: 'Ανάλυση Παράλειψης λόγω Βροχής',
    rainSkipAnalysisDesc: 'Ημέρες που ο Σύμβουλος εντόπισε βροχόπτωση και σύστησε παράλειψη άρδευσης',
    noRainSkipsFound: 'Δεν βρέθηκαν παραλείψεις λόγω βροχής στην εξεταζόμενη περίοδο',
    totalSaved: 'συνολική εξοικονόμηση',
    monthlyComparisonMatrix: 'Μηνιαία Σύγκριση',
    monthlyComparisonDesc: 'Ημέρες άρδευσης παραγωγού vs Σύμβουλος ανά μήνα με ποσοστό συμφωνίας',
    agreementDays: 'Συμφωνία',
    savedDays: 'Εξοικονόμηση',
    topReason: 'Κύρια αιτία',
    potentialSavings: 'Δυνητική εξοικονόμηση',
    depthTimeline: 'Προφίλ Υγρασίας Εδάφους σε Βάθος',
    depthTimelineDesc: 'Ογκομετρική περιεκτικότητα νερού σε 3 βάθη με επικάλυψη άρδευσης και βροχόπτωσης',
    irrigationEvent: 'Άρδευση (λεπτά)',
    decisions: 'Αποφάσεις',
    days: 'ημέρες',
    reason_WAI_LOW: 'Χαμηλός WAI',
    reason_FORECAST_HEAT: 'Πρόβλεψη Καύσωνα',
    reason_DEFICIT_GROWING: 'Αυξανόμενο Έλλειμμα',
    reason_KC_PEAK: 'Αιχμή Kc Καλλιέργειας',
    reason_STRESS_PREVENTION: 'Πρόληψη Καταπόνησης',
    reason_PRODUCTION_GOAL: 'Στόχος Παραγωγής',
    reason_ML_MODEL: 'Μοντέλο ML',
    reason_RAIN_SKIP: 'Παράλειψη λόγω Βροχής',
    reason_HIGH_ET0: 'Υψηλή Εξατμισοδιαπνοή',
    reason_SOIL_ADEQUATE: 'Επαρκής Εδαφική Υγρασία',
    reason_NO_STRESS: 'Χωρίς Καταπόνηση',

    waterBudget: 'Υδατικό Ισοζύγιο',
    historicalComparison: 'Παραγωγός vs Σύμβουλος',
    requestDss: 'Λήψη Προτάσεων AI',
    refreshRecommendations: 'Ανανέωση συστάσεων',
    scheduleHintPaint: 'Ζωγραφίστε χρονοθυρίδες στο ημερολόγιο για να προγραμματίσετε άρδευση ή εγκρίνετε μια σύσταση.',
    dssAccepted: 'Η σύσταση Συμβούλου έγινε αποδεκτή',
    dssRejected: 'Η σύσταση Συμβούλου απορρίφθηκε',
    dssModified: 'Η σύσταση Συμβούλου τροποποιήθηκε & αποδέχτηκε',
    noDssRecommendations: 'Σύμβουλος: Δεν χρειάζεται άρδευση αυτή την εβδομάδα',
    dssRecsCreated: '{count} συστάσεις έτοιμες για {field}',
    failedDssRecommend: 'Αποτυχία λήψης συστάσεων Συμβούλου',
    clickPocketToEdit: 'Κάντε κλικ στο μπλοκ για ρύθμιση',
    smartSkipEnabled: 'Έξυπνη Παράλειψη ενεργή',
    allZonesFilter: 'Όλες οι Ζώνες',
    allocated: 'Διατιθέμενο',
    used: 'Χρησιμοποιημένο',
    remaining: 'Υπόλοιπο',
    budgetUtilization: 'Χρήση Ισοζυγίου',
    farmDiary: 'Ημερολόγιο Αγρού',
    mapObservations: 'Παρατηρήσεις χάρτη',
    addEntry: 'Νέα Καταχώρηση',
    farmDiarySubtitle: 'Καταγράψτε δραστηριότητες αγρού, παρατηρήσεις και εργασίες',
    entriesThisMonth: 'καταχωρήσεις αυτό το μήνα',
    entry: 'καταχώρηση',
    entries: 'καταχωρήσεις',
    byDate: 'Ανά Ημερομηνία',
    byYear: 'Ανά Έτος',
    byCrop: 'Ανά Καλλιέργεια',
    byField: 'Ανά Χωράφι',
    highImpact: 'υψηλής σημασίας',
    pruning: 'Κλάδεμα',
    harvest: 'Συγκομιδή',
    spray: 'Ψεκασμός',
    scouting: 'Επιθεώρηση',
    frostProtection: 'Αντιπαγετική Προστασία',
    fertilization: 'Λίπανση',
    other: 'Άλλο',
    eventType: 'Τύπος Συμβάντος',
    addObservation: 'Καταγραφή Παρατήρησης',
    noFarmEvents: 'Δεν υπάρχουν καταχωρήσεις ημερολογίου',
    eventCreated: 'Καταχώρηση δημιουργήθηκε',
    eventDeleted: 'Καταχώρηση διαγράφηκε',
    photos: 'Φωτογραφίες',
    addPhoto: 'Προσθήκη',
    maxPhotos: 'Μέγιστο 6 φωτογραφίες ανά καταχώρηση',
    uploading: 'Μεταφόρτωση...',
    failedToRemovePhoto: 'Αποτυχία αφαίρεσης φωτογραφίας',
    photosFailedUpload: '{count} φωτογραφία(ες) απέτυχαν να ανεβούν: {files}',
    phenology: 'Φαινολογία',
    growthStage: 'Στάδιο Ανάπτυξης',
    gdd: 'GDD (Βαθμοημέρες)',
    phenologicalStage: 'Φαινολογικό Στάδιο',
    dormancy: 'Αδράνεια',
    budBreak: 'Εκβλάστηση',
    shootGrowth: 'Ανάπτυξη Βλαστών',
    flowering: 'Ανθοφορία',
    fruitSet: 'Καρπόδεση',
    fruitDevelopment: 'Ανάπτυξη Καρπού',
    fruitRipening: 'Ωρίμανση Καρπού',
    fruitGrowth: 'Ανάπτυξη Καρπού',
    harvestStage: 'Συγκομιδή',
    postHarvest: 'Μετασυλλεκτικά',
    senescence: 'Γήρανση',
    daysToNextStage: 'Ημέρες ως επόμενο στάδιο',
    hydraulicSchematic: 'Υδραυλικό Σχέδιο',
    pumpLimit: 'Όριο Αντλίας',
    mainPipe: 'Κεντρικός Αγωγός',
    valveStatus: 'Κατάσταση Βάνας',
    borehole: 'Γεώτρηση / Αντλία',
    idle: 'Αδρανής',
    executing: 'Εκτελείται',
    ecTarget: 'Στόχος EC (mS/cm)',
    phTarget: 'Στόχος pH',
    nutrientRecipe: 'Συνταγή Θρέψης',
    npkPreset: 'N-P-K Πρότυπο',
    customRecipe: 'Προσαρμοσμένο',
    fruitSizing: 'Μέγεθος Καρπού',
    currentWeight: 'Τρέχον Βάρος',
    harvestEstimate: 'Εκτίμηση Συγκομιδής',
    growthRate: 'Ρυθμός Ανάπτυξης',
    gradeA: 'Κατηγορία Α',
    gradeB: 'Κατηγορία Β',
    gradeC: 'Κατηγορία Γ',
    gPerDay: 'γρ/ημέρα',
    opekepeExport: 'Αναφορά ΟΠΕΚΕΠΕ',
    generateReport: 'Δημιουργία Αναφοράς',
    exportCsv: 'Εξαγωγή CSV',
    downloadCsv: 'Λήψη CSV',
    cooperativeView: 'Συνολική Επισκόπηση',
    allFarms: 'Όλα τα Αγροκτήματα',
    farmOwner: 'Ιδιοκτήτης',
    zonesNeedingWater: 'Ζώνες που Χρειάζονται Νερό',
    sparkline: 'Μικρογραφικό',
    vwcTrend: 'Τάση VWC',
    rationale: 'Αιτιολόγηση',
    refillThreshold: 'Κατώφλι Αναπλήρωσης',
    etForecast: 'Πρόβλεψη ET',

    // Missing validations & device confirmations
    confirmDeleteDevice: 'Διαγραφή Συσκευής',
    confirmDeleteDeviceMessage: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη συσκευή; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    fieldRequired: 'Το χωράφι είναι υποχρεωτικό',
    zoneRequired: 'Η ζώνη είναι υποχρεωτική',
    selectFieldFirst: 'Επιλέξτε πρώτα ένα χωράφι',
    selectFieldFirstPaint: 'Επιλέξτε χωράφι και ζώνη στην αριστερή στήλη για να ενεργοποιηθεί το "Προσθήκη όλων"',
    selectZoneFirstPaint: 'Επιλέξτε ζώνη στην αριστερή στήλη για να ενεργοποιηθεί το "Προσθήκη όλων"',
    discardNewField: 'Απόρριψη νέου χωραφιού;',
    discardNewFieldBody: 'Το χωράφι δημιουργήθηκε στο Βήμα 1 αλλά δεν έχει ακόμα ζώνες. Αν φύγετε τώρα θα διαγραφεί. Είστε σίγουροι;',
    discardAndDelete: 'Απόρριψη και διαγραφή',
    deleting: 'Διαγραφή…',
    durationRange: 'Η διάρκεια πρέπει να είναι 1-480 λεπτά',
    doseRange: 'Η δόση πρέπει να είναι 0,1-100 mm',
    deviceNameRequired: 'Το όνομα συσκευής είναι υποχρεωτικό',
    deviceIdentifierRequired: 'Το αναγνωριστικό συσκευής είναι υποχρεωτικό',

    // Schedule summary
    activeSchedules: 'Ενεργά',
    nextRun: 'Επόμενο',
    weeklyTotal: 'Εβδομαδιαίο Σύνολο',

    // History page KPIs
    totalPlans: 'Συνολικά Πλάνα',
    completedPlans: 'Ολοκληρωμένα',
    totalWater: 'Νερό',
    avgDuration: 'Μέση Διάρκεια',

    // Weather page
    forecastUnavailable: 'Πρόγνωση μη διαθέσιμη · εμφάνιση τελευταίων μετρήσεων',
    weatherNoDataTitle: 'Δεν υπάρχουν δεδομένα καιρού',
    weatherEmptyHint: 'Ρυθμίστε ένα κλειδί API καιρού (Meteoblue ή OpenWeatherMap) ή εκτελέστε την εντολή seed για δοκιμαστικά δεδομένα.',
    weatherApisTempUnavailable: 'Οι υπηρεσίες καιρού είναι προσωρινά μη διαθέσιμες',

    // Missing keys used in components
    failedToDeleteField: 'Αποτυχία διαγραφής χωραφιού',
    failedToDeleteZone: 'Αποτυχία διαγραφής ζώνης',
    failedToLoadField: 'Αποτυχία φόρτωσης στοιχείων χωραφιού',
    search: 'Αναζήτηση',
    settingsSaved: 'Οι ρυθμίσεις αποθηκεύτηκαν με επιτυχία',
    savedAt: 'Αποθηκεύτηκε στις',
    date: 'Ημερομηνία',
    wind: 'Άνεμος',
    environment: 'Περιβάλλον',
    selectField: 'Χωράφι',
    noFields: 'Δεν υπάρχουν χωράφια ακόμα',
    users: 'Χρήστες',
    total: 'Σύνολο',
    loadingMap: 'Φόρτωση χάρτη...',
    noDataAvailable: 'Δεν υπάρχουν διαθέσιμα δεδομένα',
    loading: 'Φόρτωση',
    failedToLoadDiary: 'Αποτυχία φόρτωσης ημερολογίου',
    failedToSaveEntry: 'Αποτυχία αποθήκευσης καταχώρησης',
    failedToDeleteEntry: 'Αποτυχία διαγραφής καταχώρησης',
    farmDiaryDescription: 'Καταγράψτε δραστηριότητες αγρού όπως λίπανση, κλάδεμα, επιθεώρηση και συγκομιδή για πλήρες αρχείο των εργασιών.',
    addFirstEntry: 'Καταγράψτε Πρώτη Δραστηριότητα',
    confirmDeleteEntry: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την καταχώρηση;',
    editEntry: 'Επεξεργασία Καταχώρησης',
    addEntryDescription: 'Καταγράψτε μια δραστηριότητα αγρού',
    notesPlaceholder: 'Τι παρατηρήσατε ή κάνατε;',
    none: 'Κανένα',
    addYourFields: 'Προσθέστε τα χωράφια σας',
    addFieldsHint: 'Σχεδιάστε τα όρια των χωραφιών σας στον χάρτη για να ξεκινήσετε.',
    addFields: 'Προσθήκη χωραφιών',
    fieldsAnalyzed: 'Αναλυμένα',
    fieldsNotAnalyzed: 'Χωράφια χωρίς ανάλυση',
    sortByName: 'Όνομα (Α→Ω)',
    sortByNameDesc: 'Όνομα (Ω→Α)',
    sortByArea: 'Έκταση (μεγαλύτερα πρώτα)',
    sortByAreaAsc: 'Έκταση (μικρότερα πρώτα)',
    sortByStatus: 'Κατάσταση (στρεσαρισμένα πρώτα)',
    sortByAttention: 'Χρειάζονται προσοχή πρώτα',
    sortByMoisture: 'Πιο ξηρά πρώτα',
    noFieldsMatchFilter: 'Κανένα χωράφι δεν ταιριάζει με το φίλτρο.',
    recommendationActionFailed: 'Η ενέργεια δεν ολοκληρώθηκε. Δεν προγραμματίστηκε άρδευση, δοκιμάστε ξανά.',
    hardwareTabCoverage: 'Κάλυψη',
    // Ελεγκτές βανών (Εξοπλισμός > Ελεγκτές).
    edgePageTitle: 'Ελεγκτές βανών',
    edgePageSubtitle: 'Οι πλακέτες που ανοίγουν και κλείνουν τις βάνες, η κατάστασή τους και ο χειροκίνητος έλεγχος',
    edgeStateOnline: 'Συνδεδεμένος',
    edgeStateOffline: 'Εκτός σύνδεσης',
    edgeStateNeverSeen: 'Δεν συνδέθηκε ποτέ',
    edgeHeartbeat: 'Τελευταίο σήμα',
    edgeNoHeartbeat: 'Κανένα σήμα ακόμη',
    edgeFirmware: 'Λογισμικό',
    edgeFirmwareUnknown: 'Άγνωστο λογισμικό',
    edgeUptime: 'λειτουργεί {m} λεπτά',
    edgeAgeSeconds: 'πριν {s} δευτ.',
    edgeAgeMinutes: 'πριν {m} λεπτά',
    edgeAgeHours: 'πριν {h} ώρες',
    edgeMinutesLeft: 'απομένουν {m} λεπτά',
    edgeMinutes: '{m} λεπτά',
    edgeNoFieldsServed: 'Καμία βάνα δεν είναι συνδεδεμένη σε χωράφι',
    edgeNoValvesWired: 'Καμία βάνα αυτού του ελεγκτή δεν είναι συνδεδεμένη σε ζώνη.',
    edgeStatusUnreachable: 'Δεν ήταν δυνατή η ανάγνωση της κατάστασης του ελεγκτή.',
    edgeListFailed: 'Δεν ήταν δυνατή η φόρτωση των ελεγκτών.',
    edgeColValve: 'Βάνα',
    edgeColLocation: 'Χωράφι και ζώνη',
    edgeColIrrigate: 'Άρδευση (το βλέπει ο παραγωγός)',
    edgeColTest: 'Δοκιμή',
    edgeValveNumber: 'Βάνα {n}',
    edgeValveUnwired: 'Χωρίς σύνδεση',
    edgeRelayTooltip: 'Ρελέ {n} στην πλακέτα',
    edgeZoneLabel: 'Ζώνη {n}',
    edgeIrrigatingNow: 'Σε άρδευση',
    edgeQueued: 'Σε αναμονή',
    edgeStart: 'Έναρξη',
    edgeStop: 'Διακοπή',
    edgeTest5s: 'Δοκιμή 5 δευτ.',
    edgeDeviceOffline: 'Ο ελεγκτής είναι εκτός σύνδεσης',
    edgeStartTooltip: 'Άρδευση για {m} λεπτά. Το βλέπει ο παραγωγός.',
    edgeTestTooltip: 'Ανοίγει τη βάνα για 5 δευτερόλεπτα, για έλεγχο της καλωδίωσης. Ο παραγωγός δεν ειδοποιείται.',
    edgeStartNote: 'ποτίζει τη ζώνη και εμφανίζεται στο πρόγραμμα και το ιστορικό του παραγωγού.',
    edgeTestNote: 'ανοίγει τη βάνα για 5 δευτερόλεπτα, για έλεγχο της καλωδίωσης. Μόνο για διαχειριστή.',
    edgeAddButton: 'Προσθήκη ελεγκτή',
    edgeAddTitle: 'Καταχώριση ελεγκτή βανών',
    edgeAddDeviceId: 'Κωδικός ελεγκτή',
    edgeAddField: 'Χωράφι',
    edgeAddToken: 'Κλειδί (αφήστε το κενό για αυτόματο)',
    edgeAddTokenPlaceholder: 'Επικολλήστε υπάρχον κλειδί ή αφήστε το κενό',
    edgeAddTokenOnce: 'Ο ελεγκτής καταχωρίθηκε. Αντιγράψτε τώρα αυτό το κλειδί στο λογισμικό της πλακέτας, εμφανίζεται μία μόνο φορά.',
    edgeAddMissingFields: 'Χρειάζονται και ο κωδικός του ελεγκτή και το χωράφι.',
    edgeAddFailed: 'Ο ελεγκτής δεν καταχωρίθηκε.',
    edgeAddSubmit: 'Καταχώριση',
    edgeAddCancel: 'Άκυρο',
    edgeAddDone: 'Τέλος',
    edgeNoDevices: 'Δεν έχει καταχωριθεί ακόμη κανένας ελεγκτής βανών.',
    coverageIntro: 'Τι μπορεί να κάνει η πλατφόρμα σε κάθε χωράφι σήμερα. Η παρακολούθηση χρειάζεται αισθητήρα που στέλνει μετρήσεις. Ο έλεγχος χρειάζεται ελεγκτή βάνας που απαντά. Ένα χωράφι μπορεί να έχει το ένα χωρίς το άλλο.',
    coverageMonitoring: 'Παρακολούθηση',
    coverageControl: 'Έλεγχος',
    coverageTotalFields: 'Χωράφια',
    coverageMonitored: 'Στέλνουν μετρήσεις',
    coverageControllable: 'Με έλεγχο άρδευσης',
    coverageBoth: 'Και τα δύο',
    coverageMon_live: 'Στέλνει μετρήσεις',
    coverageMon_stale: 'Παλιά τελευταία μέτρηση',
    coverageMon_silent: 'Καμία μέτρηση ακόμη',
    coverageMon_none: 'Χωρίς αισθητήρα',
    coverageCtl_ready: 'Βάνα έτοιμη',
    coverageCtl_offline: 'Ο ελεγκτής δεν απαντά',
    coverageCtl_none: 'Χωρίς βάνα',
    coverageLoadFailed: 'Δεν φορτώθηκε η εικόνα του εξοπλισμού. Δοκιμάστε ξανά.',
    coverageStaleNote: 'Μέτρηση παλαιότερη από {hours} ώρες θεωρείται παλιά.',
    gapNoSensor: 'Δεν υπάρχει αισθητήρας σε αυτό το χωράφι, οπότε ο σύμβουλος δεν μπορεί να πει πότε χρειάζεται άρδευση.',
    coverageAddSensor: 'Προσθήκη αισθητήρα',
    probeFromField: 'Από τον αισθητήρα του χωραφιού {field}',
    sensorIssueStuck: 'Ο αισθητήρας στα {cm} cm δείχνει την ίδια τιμή για ένα 24ωρο: δεν λαμβάνεται υπόψη στη σύσταση.',
    sensorIssueRange: 'Ο αισθητήρας στα {cm} cm δείχνει αδύνατη τιμή: δεν λαμβάνεται υπόψη στη σύσταση.',
    sensorIssueStuckEstimated: 'Ο αισθητήρας στα {cm} cm δείχνει την ίδια τιμή για ένα 24ωρο: η σύσταση τον εκτιμά από τον αισθητήρα στα {ref} cm.',
    sensorIssueRangeEstimated: 'Ο αισθητήρας στα {cm} cm δείχνει αδύνατη τιμή: η σύσταση τον εκτιμά από τον αισθητήρα στα {ref} cm.',
    sensorEstimatedValue: 'εκτίμηση',
    coverageUseProbeOf: 'Χρήση αισθητήρα άλλου χωραφιού',
    coverageProbeSourceHelp: 'Μόνο για χωράφι του ίδιου παραγωγού, με ίδιο έδαφος και καλλιέργεια, που ποτίζεται μαζί του. Δείχνει τη σύσταση εκείνου του χωραφιού, χωρίς δικά του λεπτά ή ειδοποιήσεις.',
    coverageProbeSourceNone: 'Δικοί του αισθητήρες',
    coverageProbeFrom: 'Διαβάζει τον αισθητήρα του χωραφιού {field}',
    coverageAddController: 'Προσθήκη ελεγκτή',
    coverageSetupFor: 'Εξοπλισμός: {name}',
    userEquipment: 'Εξοπλισμός',
    gapSensorStale: 'Ο αισθητήρας σταμάτησε να στέλνει. Ελέγξτε τον σταθμό ή την πύλη.',
    gapSensorSilent: 'Έχει οριστεί αισθητήρας αλλά δεν έχει στείλει ποτέ μέτρηση. Ελέγξτε την πύλη.',
    gapNoController: 'Δεν υπάρχει ελεγκτής βάνας εδώ, οπότε η Έναρξη καταγράφει την άρδευση χωρίς να ανοίξει κάτι.',
    gapControllerOffline: 'Ο ελεγκτής δεν έχει απαντήσει πρόσφατα. Η βάνα μπορεί να μην ανοίξει.',
    gapZonesWithoutValve: 'Ζώνες χωρίς βάνα',
    metric_moisture: 'υγρασία εδάφους',
    metric_tension: 'τάση εδάφους',
    metric_weather: 'καιρός',
    controllerOnline: 'απαντά',
    controllerOffline: 'δεν απαντά',
    relay: 'ρελέ',
    irrigateDurationNotDerived: 'Άρδευση τώρα',
    irrigateDurationNotDerivedWhy: 'Το χωράφι μετρά τάση εδάφους, όχι υγρασία, οπότε δεν υπάρχει έλλειμμα νερού για να υπολογιστεί διάρκεια. Ο σύμβουλος δείχνει ότι χρειάζεται νερό και αφήνει σε εσάς τη διάρκεια.',
    sensorNoneOnZone: 'Δεν έχει οριστεί αισθητήρας σε αυτή τη ζώνη, οπότε δεν υπάρχουν μετρήσεις εδάφους.',
    sensorSilent: 'Έχει οριστεί αισθητήρας σε αυτή τη ζώνη αλλά δεν έχει στείλει ακόμη καμία μέτρηση.',
    sensorStale: 'Η τελευταία μέτρηση είναι παλαιότερη της μίας ημέρας.',
    assignSensor: 'Ορισμός αισθητήρα',
    hoursShort: 'ώ',
    collapse: 'Σύμπτυξη',
    expand: 'Επέκταση',
    advisor: 'Σύμβουλος ΑΙ',
    profile: 'Προφίλ',
    agreementRate: 'Ποσοστό Συμφωνίας',
    waterSavings: 'Δυνητική Εξοικονόμηση Νερού',
    farmerDays: 'Ημέρες Άρδευσης Παραγωγού',
    dssDays: 'Ημέρες Σύστασης Συμβούλου',
    irrigationTimeline: 'Χρονοδιάγραμμα Άρδευσης',
    monthlyBreakdown: 'Μηνιαία Ανάλυση',
    confusionMatrix: 'Πίνακας Συμφωνίας Αποφάσεων',
    matrixDssIrrigate: 'Σύμβουλος: Άρδευση',
    matrixDssSkip: 'Σύμβουλος: Παράλειψη',
    matrixFarmerIrrigated: 'Παραγωγός: Αρδεύτηκε',
    matrixFarmerSkipped: 'Παραγωγός: Παραλείφθηκε',
    matrixBothAgree: 'Συμφωνία',
    matrixFarmerOnly: 'Μόνο Παραγωγός',
    matrixDssOnly: 'Μόνο Σύμβουλος',
    matrixBothSkip: 'Και οι Δύο Παράλειψαν',
    waterSavedM3: 'Εξοικονόμηση Νερού',
    waterSavedSubtext: 'αν χρησιμοποιούνταν ο Σύμβουλος αντί για χειροκίνητη άρδευση',
    efficiencyPerStremma: 'Απόδοση ανά Στρέμμα',
    farmerM3Str: 'Παραγωγός',
    dssM3Str: 'Σύμβουλος',
    reductionLabel: 'μείωση',
    weatherOverlay: 'Καιρικά Δεδομένα',
    whatWouldHaveChanged: 'Τι Θα Είχε Αλλάξει;',
    savedWater: 'Εξοικονόμηση Νερού',
    earlyDetection: 'Πρώιμη Ανίχνευση',
    showMore: 'Περισσότερα',
    showLess: 'Λιγότερα',
    noWhatIfData: 'Δεν βρέθηκαν σενάρια απόκλισης.',

    // Additional missing keys (second pass)
    failedToLoadRecommendations: 'Αποτυχία φόρτωσης συστάσεων Συμβούλου',
    failedToCreateSchedules: 'Αποτυχία δημιουργίας προγραμμάτων από συστάσεις',
    newSchedule: 'Νέο πρόγραμμα',
    d: 'η',
    addAllDays: 'Προσθήκη όλων των ημερών',
    addAllBlocks: 'Προσθήκη όλων',
    clickBlockForDay: 'Κάντε κλικ σε μπλοκ για ρύθμιση ή χρησιμοποιήστε "Προσθήκη" για μαζική',
    clickEachBlockToConfigure: 'Κάντε κλικ σε κάθε μπλοκ για μεμονωμένη ρύθμιση',
    unassigned: 'Μη ανατεθειμένο',
    sensorDeviceManagement: 'Συσκευές Αισθητήρων',
    manageSensorDevices: 'Διαχειριστείτε τις συσκευές αισθητήρων IoT',
    sensorHub: 'Κόμβος Αισθητήρων',
    noHub: 'Χωρίς Κόμβο',
    sensorFieldSection: 'Χωράφι που μετράει ο αισθητήρας',
    sensorFieldSectionHelp: 'Οι μετρήσεις του εμφανίζονται σε αυτό το χωράφι και χρησιμοποιούνται για τη σύσταση άρδευσης.',
    sensorFieldGatewayManaged: 'Πρόκειται για πύλη IoT. Ορίστε το χωράφι που εξυπηρετεί από την ίδια την πύλη, στον Εξοπλισμό.',
    sensorFieldLabel: 'Χωράφι',
    sensorFieldNone: 'Χωρίς σύνδεση σε χωράφι',
    sensorZoneLabel: 'Ζώνη',
    sensorZoneWholeField: 'Όλο το χωράφι (όλες οι ζώνες)',
    sensorDepthLabel: 'Βάθος τοποθέτησης',
    sensorDepthReported: 'Μετράει σε βάθος',
    tensionGaugeTooltip: 'Τάση εδάφους: όσο χαμηλότερη, τόσο πιο υγρό το έδαφος. Όσο υψηλότερη, τόσο δυσκολότερα αντλεί νερό το φυτό',
    vwTensionHistoryTitle: 'Τάση εδάφους, τελευταίες 14 ημέρες',
    vwTensionHistoryAxis: 'Centibar (cb). Η γραμμή ανεβαίνει καθώς το έδαφος στεγνώνει.',
    vwTensionHistoryTrigger: 'Χρειάζεται νερό πάνω από',
    vwTensionHistoryTooFew: 'Δεν υπάρχουν ακόμη αρκετές μετρήσεις για γράφημα. Θα εμφανιστεί μόλις ο σταθμός στείλει δεδομένα δύο ημερών.',
    vwTensionHistoryError: 'Δεν ήταν δυνατή η φόρτωση των μετρήσεων για το γράφημα.',
    vwTensionHistoryIrrigation: 'Άρδευση',
    vwTensionHistorySuspect: 'Μη αξιόπιστη μέτρηση αισθητήρα',
    vwMoistureHistoryTitle: 'Υγρασία εδάφους, τελευταίες 14 ημέρες',
    vwMoistureHistoryAxis: 'Ογκομετρική υγρασία (%). Η γραμμή κατεβαίνει καθώς το έδαφος στεγνώνει.',
    vwMoistureHistoryTrigger: 'Χρειάζεται νερό κάτω από',
    vwProbeVwc: 'Υγρασία εδάφους',
    vwProbeTension: 'Τάση εδάφους',
    vwProbeWeighted: 'Σταθμικός μέσος',
    vwProbeState_IRRIGATE: 'Άρδευση',
    vwProbeState_PREPARE: 'Προετοιμασία',
    vwProbeState_WAIT: 'Σε αναμονή',
    vwProbeState_NO_IRRIGATION: 'Χωρίς άρδευση',
    vwProbeNotChecked: 'εμφανίζεται, δεν συγκρίνεται με τα όρια',
    vwProbeProvisional: 'Προσωρινά όρια αισθητήρων, ορισμένα από τον γεωπόνο για δοκιμή σε αυτό το χωράφι.',
    vwProbeNoReading: 'Καμία μέτρηση από αυτόν τον αισθητήρα.',
    stationTitle: 'Μετεωρολογικός σταθμός',
    stationOnThisField: 'σε αυτό το χωράφι',
    stationOnField: 'στο {field}, σε απόσταση {km} km',
    stationTemp: 'Θερμοκρασία',
    stationHumidity: 'Υγρασία αέρα',
    stationRainToday: 'Βροχή σήμερα',
    stationRainRate: 'Βροχή τώρα',
    stationMinutesAgo: 'πριν {n} λεπτά',
    stationHoursAgo: 'πριν {n} ώρες',
    stationDaysAgo: 'πριν {n} ημέρες',
    stationNoReading: 'καμία μέτρηση ακόμη',
    stationStale: 'Ο σταθμός δεν έχει στείλει νέα μέτρηση για πάνω από μία ώρα. Οι τιμές είναι οι τελευταίες του.',
    station24h: 'Τελευταίο 24ωρο (χαμηλή / υψηλή)',
    stationRain24h: 'βροχή {mm}',
    stationFrost: 'Ο σταθμός μέτρησε 0 °C ή χαμηλότερα το τελευταίο 24ωρο.',
    frostTitleFrost: 'Πρόγνωση παγετού',
    frostTitleRisk: 'Κίνδυνος παγετού τις επόμενες νύχτες',
    frostMeasured: 'Ο σταθμός στο {field} μέτρησε {t} °C το τελευταίο 24ωρο.',
    frostNightOf: 'Νύχτα {day}',
    frostSource: 'Χαμηλότερη θερμοκρασία αέρα κάθε νύχτας (18:00 έως 09:00), από την πρόγνωση για την περιοχή. Τα χαμηλά σημεία του χωραφιού μπορεί να είναι ψυχρότερα.',
    hardwareTabStations: 'Μετεωρολογικοί σταθμοί',
    hardwareTabSentek: 'Sentek',
    sentekIntro: 'Οι αισθητήρες Sentek που διαβάζονται από το IrriMAX Live. Εδώ ορίζετε πού βρίσκεται ο καθένας και την κατάστασή του. Νέο αισθητήρα προσθέτετε από το κουμπί προσθήκης συσκευής.',
    sentekEmpty: 'Δεν υπάρχει ακόμη αισθητήρας Sentek.',
    sentekName: 'Όνομα στο IrriMAX Live',
    sentekNameLocked: 'Το όνομα δεν αλλάζει αφού έρθουν μετρήσεις, γιατί αποθηκεύονται με αυτό.',
    sentekZone: 'Ζώνη',
    sentekWholeField: 'Όλο το χωράφι',
    kaekCodesLabel: 'ΚΑΕΚ, ένας ή περισσότεροι',
    kaekCodesHelp: 'Χωρίστε τους με κόμμα αν το χωράφι έχει πολλά γεωτεμάχια.',
    kaekFind: 'Εύρεση στο Κτηματολόγιο',
    kaekFound: 'Γεωτεμάχια {n}, {area} στρέμματα',
    kaekOutline: 'Το όριο που βρέθηκε',
    kaekUse: 'Χρήση ως όριο χωραφιού',
    kaekUsed: 'Το όριο μπήκε. Αποθηκεύεται όταν αποθηκεύσετε το χωράφι.',
    kaekMissing: 'Δεν βρέθηκαν: {codes}. Η περιοχή μπορεί να μην έχει φορτωθεί ακόμη, οπότε εισαγάγετε το όριο από αρχείο KML.',
    kaekApart: 'Αυτά τα γεωτεμάχια δεν εφάπτονται, οπότε δεν γίνονται ένα χωράφι. Καταχωρίστε τα ως ξεχωριστά χωράφια.',
    kaekFailed: 'Η αναζήτηση δεν ολοκληρώθηκε.',
    kaekCredit: 'Όρια: Ελληνικό Κτηματολόγιο, data.gov.gr, CC-BY',
    stationsIntro: 'Οι σταθμοί καιρού των παραγωγών. Κάθε σταθμός διαβάζεται κάθε 10 λεπτά και εμφανίζεται στο χωράφι του και στα κοντινά χωράφια.',
    stationsAdd: 'Προσθήκη σταθμού',
    stationsEmpty: 'Δεν υπάρχει ακόμη μετεωρολογικός σταθμός.',
    stationsName: 'Όνομα',
    stationsProvider: 'Υπηρεσία',
    stationsExternalId: 'Σύνδεσμος ή αριθμός σταθμού',
    stationsExternalIdHelp: 'π.χ. app.weathercloud.net/d6334617235 (ο σταθμός πρέπει να είναι δημόσιος)',
    stationsField: 'Χωράφι όπου βρίσκεται',
    stationsRadius: 'Εμφάνιση σε χωράφια έως (km)',
    stationsLatest: 'Τελευταία μέτρηση',
    stationsError: 'Δεν διαβάστηκε',
    stationsReadNow: 'Ανάγνωση τώρα',
    stationsActive: 'Ενεργός',
    stationsSave: 'Αποθήκευση',
    stationsCancel: 'Ακύρωση',
    stationsDelete: 'Αφαίρεση',
    vwRangeTo: 'έως',
    vwNoValue: 'χωρίς τιμή',
    waterUnknownSub: 'Θα εμφανιστεί μόλις καταχωρηθούν οι σταλάκτες της ζώνης',
    sensorAssignmentFailed: 'Ο αισθητήρας αποθηκεύτηκε αλλά δεν συνδέθηκε με το χωράφι.',
    deviceIdentifierLocked: 'Το αναγνωριστικό δεν αλλάζει, οι μετρήσεις καταγράφονται ήδη με αυτό.',
    manageUsersSubtitle: 'Διαχείριση λογαριασμών χρηστών, ρόλων και ανάθεσης χωραφιών',
    noActiveAlerts: 'Δεν υπάρχουν ενεργές ειδοποιήσεις',
    alert: 'Ειδοποίηση',
    viewAllAlerts: 'Προβολή όλων των ειδοποιήσεων',

    // Analytics widget keys
    leafWetnessDuration: 'Διάρκεια Υγρασίας Φύλλου',
    leafWetnessSubtitle: 'Ώρες υγρασίας · Δείκτης κινδύνου ασθένειας PSA',
    calibrated: 'Βαθμονομημένο',
    watchZone: 'Παρακολούθηση',
    watch: 'Παρακολούθηση',
    low: 'Χαμηλή',
    noLeafWetnessData: 'Δεν υπάρχουν δεδομένα υγρασίας φύλλου',
    psaWarning: 'Ανιχνεύτηκε παρατεταμένη υγρασία φύλλου. Παρακολουθήστε για συμπτώματα PSA · έλκη, κηλίδες φύλλων, ξήρανση.',
    soilMoistureProfile: 'Προφίλ Υγρασίας Εδάφους',
    vwcThreeDepths: 'Ογκομετρική Περιεκτικότητα Νερού σε 10, 20, 30 εκ.',
    refillPoint: 'Σημείο Αναπλήρωσης',
    optimal: 'Βέλτιστη',
    dry: 'Ξηρό',
    noZoneData: 'Δεν υπάρχουν δεδομένα ζωνών',
    noZoneDataHint: 'Επιλέξτε χωράφι με ζώνες για προβολή κατάστασης υγείας',
    fieldMicroclimate: 'Μικροκλίμα Αγρού',
    microclimateSubtitle: 'Θερμοκρασία αέρα και σχετική υγρασία στον αγρό',
    relativeHumidity: 'ΣΥ',
    heatStress: 'Θερμική καταπόνηση',
    frost: 'Παγετός',
    heat: 'Καύσωνας',
    noMicroclimateData: 'Δεν υπάρχουν δεδομένα μικροκλίματος',
    leafCanopyClimate: 'Κλίμα Φύλλου & Κόμης',
    leafCanopySubtitle: 'Θερμοκρασία και υγρασία φύλλου · διαπνοή & ασθένειες',

    // Irrigation timeline widget keys
    irrigateToday: 'Συνιστάται άρδευση σήμερα',
    checkSoilMoisture: 'Ελέγξτε τους αισθητήρες υγρασίας εδάφους',
    irrigated: 'Αρδεύτηκε',
    forecastRain: 'Πρόβλεψη Βροχής',
    noIrrigationTimeline: 'Δεν υπάρχουν δεδομένα χρονοδιαγράμματος άρδευσης',
    noIrrigationTimelineHint: 'Προγραμματίστε αρδεύσεις για προβολή χρονοδιαγράμματος',

    // Demo Tour
    tourPresentation: 'Παρουσίαση',
    startTour: 'Ξεκινήστε Ξενάγηση',
    nextStep: 'Επόμενο',
    prevStep: 'Πίσω',
    skipTour: 'Κλείσιμο Ξενάγησης',
    finishTour: 'Τέλος',
    replayTour: 'Επανάληψη Ξενάγησης',
    hideTourFab: 'Απόκρυψη Οδηγού',
    tourActFeatures: 'Ξενάγηση Λειτουργιών',

    // === Feature Tour (12 steps) ===
    tourWelcomeTitle: 'Καλώς ήρθατε στο TerraMind',
    tourWelcomeDesc: 'Μια γρήγορη ξενάγηση σε όλα όσα προσφέρει το TerraMind. Θα δούμε χάρτη, ζώνες, δορυφορικές εικόνες, καιρό, προγραμματισμό, ειδοποιήσεις, ημερολόγιο, ιστορικό, αναλυτικά και ρυθμίσεις. Όλη η εικόνα σε λιγότερο από 3 λεπτά.',
    tourFieldsTitle: 'Τα Χωράφια σας με μια Ματιά',
    tourFieldsDesc: 'Όλα τα χωράφια εμφανίζονται στον χάρτη με χρωματικές ζώνες. Πράσινο σημαίνει καλή υγρασία, πορτοκαλί ότι πέφτει, κόκκινο ότι χρειάζεται νερό τώρα. Πατήστε σε οποιοδήποτε χωράφι για λεπτομέρειες.',
    tourZonesTitle: 'Ζώνες & Υγρασία Εδάφους',
    tourZonesDesc: 'Κάθε χωράφι χωρίζεται σε ζώνες άρδευσης. Κάθε ζώνη έχει αισθητήρες που μετρούν υγρασία σε 3 βάθη (10εκ, 20εκ, 30εκ), ώστε να ξέρετε ακριβώς πού χρειάζεται νερό.',
    tourWeatherTitle: 'Ζωντανός Καιρός & Προβλέψεις',
    tourWeatherDesc: 'Τα δεδομένα καιρού ενημερώνονται αυτόματα από τοπικούς σταθμούς. Το σύστημα ελέγχει την πρόγνωση πριν προτείνει άρδευση. Αν αναμένεται βροχή, προτείνει να μη γίνει άρδευση, για να εξοικονομηθεί νερό.',
    tourNdviTitle: 'Δορυφορικές Εικόνες (NDVI)',
    tourNdviDesc: 'Δείτε την υγεία της βλάστησης από τους δορυφόρους Copernicus Sentinel-2. Οι χάρτες NDVI δείχνουν τη ζωτικότητα ανά ζώνη. Οι πιο πράσινες περιοχές είναι πιο υγιείς, οι κίτρινες ή κόκκινες μπορεί να χρειάζονται προσοχή.',
    tourScheduleTitle: 'Προγραμματισμός Άρδευσης',
    tourScheduleDesc: 'Σχεδιάστε την άρδευση στο εβδομαδιαίο ημερολόγιο. Δημιουργήστε προγράμματα μόνοι σας ή ζητήστε πρόταση από τον Σύμβουλο, που προτείνει την καλύτερη ώρα και διάρκεια για κάθε ζώνη.',
    tourAlertsTitle: 'Ειδοποιήσεις & Συναγερμοί',
    tourAlertsDesc: 'Ειδοποιηθείτε όταν η υγρασία πέσει χαμηλά, ένας αισθητήρας βγει εκτός λειτουργίας, ή το σύστημα εντοπίσει πρόβλημα. Μπορείτε να προσαρμόσετε ποιες ειδοποιήσεις λαμβάνετε.',
    tourDiaryTitle: 'Ημερολόγιο Αγρού',
    tourDiaryDesc: 'Καταγράψτε ό,τι συμβαίνει στο χωράφι σας, όπως λίπανση, ψεκασμούς, κλάδεμα και σημειώσεις συγκομιδής. Κάθε εγγραφή συνδέεται με ένα χωράφι και μια ημερομηνία.',
    tourHistoryTitle: 'Ιστορικό Άρδευσης',
    tourHistoryDesc: 'Δείτε παλαιότερα σχέδια άρδευσης, ποιες ζώνες ποτίστηκαν και για πόση ώρα, και παρακολουθήστε πώς αλλάζει η κατανάλωση νερού σας στο χρόνο.',
    tourAnalyticsTitle: 'Αναλυτικά Απόδοσης',
    tourAnalyticsDesc: 'Παρακολουθήστε τη χρήση νερού, συγκρίνετε τις αποφάσεις σας με τις προτάσεις του συστήματος, και δείτε πώς αντιδρά κάθε ζώνη στο χρόνο. Όλα τα δεδομένα προέρχονται από τους αισθητήρες και τον καιρό σας.',
    tourSettingsTitle: 'Ρυθμίσεις & Προτιμήσεις',
    tourSettingsDesc: 'Διαμορφώστε τη συμπεριφορά DSS, ενεργοποιήστε αυτόματη αποδοχή προτάσεων, ρυθμίστε προτιμήσεις ημερολογίου, επιλέξτε γλώσσα και διαχειριστείτε τις ειδοποιήσεις σας.',
    tourSummaryTitle: 'Είστε Έτοιμοι',
    tourSummaryDesc: 'Αυτή ήταν η πλήρης ξενάγηση! Εξερευνήστε τα δεδομένα επίδειξης ελεύθερα, ή ανοίξτε την Ευφυΐα Άρδευσης για αναλυτική παρουσίαση του πώς λειτουργεί το σύστημα υποστήριξης αποφάσεων με πραγματικά δεδομένα.',
    tourSeeDetails: 'Δείτε πλήρη στοιχεία',
    tourOpenDssDemoLink: 'Άνοιγμα Ευφυΐας Άρδευσης',

    // === Section-based Tour (GuidedTourFab + TourOverlay) ===
    tourSelectorTitle: 'Ξενάγηση TerraMind',
    tourSelectorSubtitle: 'Επιλέξτε ενότητα ή ξεκινήστε την πλήρη ξενάγηση',
    tourPlayAll: 'Πλήρης Ξενάγηση',
    tourClose: 'Κλείσιμο',
    tourStep: 'βήμα',
    tourSteps: 'βήματα',
    tourExitSection: 'Ενότητες',
    tourBackToSections: 'Πίσω στις Ενότητες',
    tourNextSection: 'Επόμενη Ενότητα',
    // Section titles
    tourSectionMap: 'Χάρτης',
    tourSectionWeather: 'Καιρός',
    tourSectionSchedule: 'Πρόγραμμα',
    tourSectionAnalytics: 'Αναλυτικά',
    tourSectionAlerts: 'Ειδοποιήσεις',
    tourSectionDiary: 'Ημερολόγιο',
    tourSectionSettings: 'Ρυθμίσεις',
    tourSectionFieldDetail: 'Λεπτομέρειες Χωραφιού',
    tourSectionDss: 'Σύστημα Υποστήριξης Αποφάσεων',
    tourSectionFieldManagement: 'Διαχείριση Χωραφιών',
    tourAddFieldBtnTitle: 'Δημιουργία Νέου Χωραφιού',
    tourAddFieldBtnDesc: 'Κάντε κλικ στο "Προσθήκη Χωραφιού" για να ανοίξετε τον οδηγό δημιουργίας. Σχεδιάστε τα όρια στον χάρτη και προσθέστε αρδευτικές ζώνες στο βήμα 2.',
    tourAddZoneBtnTitle: 'Προσθήκη Ζώνης',
    tourAddZoneBtnDesc: 'Κάθε χωράφι χωρίζεται σε αρδευτικές ζώνες. Κάντε κλικ στο + για να σχεδιάσετε πολύγωνο νέας ζώνης στον χάρτη. Η έκταση υπολογίζεται αυτόματα.',
    tourZoneEditBtnTitle: 'Επεξεργασία Ζώνης',
    tourZoneEditBtnDesc: 'Κάντε κλικ στο Επεξεργασία για να ενημερώσετε τον αριθμό ψεκαστήρων, την παροχή, τη σύσταση εδάφους και το πολύγωνο της ζώνης.',
    // Step titles & descriptions (map)
    tourMapFieldsTitle: 'Τα Χωράφια σας',
    tourMapFieldsDesc: 'Πατήστε σε ένα χωράφι για να δείτε τις ζώνες του, την υγρασία εδάφους και την κατάσταση κάθε αισθητήρα.',
    tourKpiChipsTitle: 'Ζωντανά KPIs Αγροκτήματος',
    tourKpiChipsDesc: 'Νερό που χρησιμοποιήθηκε σήμερα, ενεργές ζώνες και επόμενο πρόγραμμα άρδευσης · ανανεώνεται κάθε 30 δευτερόλεπτα.',
    tourDssBannerTitle: 'Ειδοποίηση Ζωνών σε Στρες',
    tourFieldKebabTitle: 'Συντομεύσεις χωραφιού',
    tourFieldKebabDesc: 'Το μενού (⋮) σε κάθε γραμμή χωραφιού ανοίγει τις συντομεύσεις · προς το παρόν εκθέτει τη Διαγραφή. Η επεξεργασία και η μετονομασία θα προστεθούν εδώ ώστε να διαχειρίζεστε πολλά χωράφια χωρίς να μπαίνετε μέσα σε κάθε ένα.',
    tourDssBannerDesc: 'Όταν ζώνες χρειάζονται νερό, εμφανίζεται αυτό το banner. Δείχνει πόσες ζώνες βρίσκονται σε στρες ώστε να δράσετε άμεσα. Συμβουλή: πατήστε Esc οποτεδήποτε για έξοδο από την ξενάγηση.',
    tourMapLayerPillTitle: 'Επιλογέας Επιπέδου Χάρτη',
    tourMapLayerPillDesc: 'Εναλλαγή μεταξύ προβολής κατάστασης ζωνών (χρωματισμός stress), δορυφορικής εικόνας NDVI και επιπέδου τύπου καλλιέργειας.',
    tourMapContainerTitle: 'Διαδραστικός Χάρτης',
    tourMapContainerDesc: 'Πατήστε σε οποιοδήποτε πολύγωνο ζώνης για υγρασία και κατάσταση. Πατήστε σε όριο χωραφιού για να ανοίξει ο πίνακας λεπτομερειών.',
    tourSeasonSelectorTitle: 'Επιλογέας Καλλιεργητικής Περιόδου',
    tourSeasonSelectorDesc: 'Εναλλαγή μεταξύ καλλιεργητικών περιόδων για σύγκριση υγρασίας εδάφους, προγραμμάτων και αποφάσεων από προηγούμενα έτη.',
    tourRunDssBtnTitle: 'Εκτέλεση DSS για αυτό το Χωράφι',
    tourRunDssBtnDesc: 'Ενεργοποιεί τη μηχανή αποφάσεων αυτή τη στιγμή. Το TerraMind διαβάζει τις τρέχουσες τιμές WAI και ουρά αυτόματα άρδευση για ζώνες σε στρες.',
    // Step titles & descriptions (field detail)
    tourMapZonesTitle: 'Κατάσταση Ζωνών & Υγρασία',
    tourMapZonesDesc: 'Κάθε ζώνη δείχνει υγρασία εδάφους σε 3 βάθη και μια ένδειξη κατάστασης: OK (επαρκής υγρασία), Οριακή (παρακολούθηση), Στρεσαρισμένη (άρδευση τώρα) ή Κορεσμένη (διακοπή · υπερβολικό νερό). Η μπάρα γεμίζει από σημείο μαρασμού έως υδατοχωρητικότητα.',
    tourDssRecsTitle: 'Προτάσεις DSS',
    tourDssRecsDesc: 'Ο Σύμβουλος δείχνει αποφάσεις άρδευσης ανά ζώνη. Πατήστε "Εφαρμογή" για άμεσο προγραμματισμό, ή απορρίψτε για παράλειψη.',
    tourMapNdviTitle: 'Δορυφορικό Επίπεδο NDVI',
    tourMapNdviDesc: 'Ανοίξτε τη δορυφορική εικόνα για να δείτε πόσο πράσινη είναι κάθε ζώνη. Σκούρο πράσινο σημαίνει υγιές φύλλωμα. Κίτρινο σημαίνει ότι θέλει παρακολούθηση. Κόκκινο σημαίνει καταπόνηση ή γυμνό έδαφος. Νέα εικόνα έρχεται περίπου κάθε 5 ημέρες.',
    tourHistoryFiltersTitle: 'Φίλτρα Ιστορικού',
    tourHistoryFiltersDesc: 'Φιλτράρετε το ιστορικό άρδευσης κατά εύρος ημερομηνιών (7ημ, 30ημ, 90ημ) ή ανά ζώνη. Κάθε γραμμή δείχνει διάρκεια, νερό και ποιος το ενεργοποίησε.',
    tourSoilResponseTitle: 'Ανταπόκριση Εδάφους',
    tourSoilResponseDesc: 'Μετά από κάθε άρδευση, το TerraMind συγκρίνει την υγρασία του εδάφους στα 10 εκ. πριν και μετά. Πράσινη ένδειξη σημαίνει ότι το νερό έφτασε στη ρίζα. Αν δεν ανέβει, συνήθως φταίει ο αισθητήρας ή ο εξοπλισμός, και το ελέγχουμε εμείς.',
    tourIrrigationModeTitle: 'Λειτουργία Άρδευσης',
    tourCompareModelsTitle: 'Σύγκριση μοντέλων DSS',
    tourCompareModelsDesc: 'Κάθε κάρτα δείχνει τι προτείνει ένα διαφορετικό μοντέλο απόφασης για αυτή τη ζώνη τώρα: Φυσικής (WAI έναντι κατωφλίου), ML (υβριδικός ταξινομητής με αξιοπιστία), και Με πρόβλεψη (χρησιμοποιεί την πρόβλεψη 5 ημερών και σχεδιάζει και το ΕΠΟΜΕΝΟ συμβάν). Η απόκλιση μεταξύ καρτών είναι το ενδιαφέρον σήμα.',
    tourIrrigationModeDesc: 'Επιλέξτε Κανονική (τυπική άρδευση), Λίπανση (παρακάμπτει τα όρια παράλληλων ζωνών για χορήγηση λιπάσματος), ή Παγετός (έκτακτη λειτουργία · εκκινεί όλες τις ζώνες ταυτόχρονα).',
    tourPlanTabTitle: 'Πλάνο Ημέρας',
    tourPlanTabDesc: 'Η καρτέλα Πλάνο εμφανίζει KPIs (λίτρα, ποσοστό ολοκλήρωσης) και πρόταση ανά ζώνη · ΑΡΔΕΥΣΗ, ΠΑΡΑΚΟΛΟΥΘΗΣΗ ή ΠΑΡΑΛΕΙΨΗ · βάσει WAI και DSS. Ειδοποιήσεις παγετού και βροχής εμφανίζονται ως banner.',
    // Step titles & descriptions (weather)
    tourWeatherHeroTitle: 'Καιρός Τώρα',
    tourWeatherHeroDesc: 'Θερμοκρασία, υγρασία αέρα, άνεμος και πρόβλεψη 5 ημερών. Αν αναμένεται βροχή, το TerraMind προτείνει αναβολή ποτίσματος.',
    tourSprayWindowTitle: 'Παράθυρο Ψεκασμού',
    tourSprayWindowDesc: 'Δείτε αν οι συνθήκες επιτρέπουν ψεκασμό: άνεμος κάτω από 3 m/s, χωρίς βροχή τις επόμενες ώρες, κατάλληλη θερμοκρασία.',
    tourWeatherHistoryChartsTitle: 'Ιστορικό 30 Ημερών',
    tourWeatherHistoryChartsDesc: 'Γραφήματα θερμοκρασίας και βροχόπτωσης για τις τελευταίες 30 ημέρες. Συσχετίστε υγρές περιόδους με παραλείψεις ποτίσματος.',
    // Step titles & descriptions (schedule)
    tourDssButtonTitle: 'Πρόταση',
    tourDssButtonDesc: 'Πατήστε "Πρόταση" για να λάβετε αυτόματη πρόταση ποτίσματος βασισμένη σε υγρασία εδάφους, πρόβλεψη καιρού και ανάγκες του φυτού.',
    tourScheduleFieldFilterTitle: 'Φίλτρο Χωραφιού',
    tourScheduleFieldFilterDesc: 'Επιλέξτε χωράφι για φιλτράρισμα του ημερολογίου. Θα εμφανίζονται μόνο προγράμματα για το επιλεγμένο χωράφι και τις ζώνες του.',
    tourWeeklyCalendarTitle: 'Εβδομαδιαίο πρόγραμμα',
    tourWeeklyCalendarDesc: 'Κλικ και σύρσιμο για χρωματισμό χρονικών θέσεων. Αφήστε για να ανοίξει η φόρμα προγράμματος · ορίστε ζώνη, διάρκεια και επανάληψη.',
    tourSchedulePaintTitle: 'Λειτουργία Ζωγραφικής',
    tourSchedulePaintDesc: 'Ενεργοποιήστε τη λειτουργία ζωγραφικής για σχεδίαση θέσεων άρδευσης απευθείας στο ημερολόγιο. Ζωγραφίστε πολλές μέρες ταυτόχρονα ή ορίστε διαφορετικές ρυθμίσεις ανά μέρα.',
    tourScheduleFormPanelTitle: 'Φόρμα Προγράμματος',
    tourScheduleFormPanelDesc: 'Μετά τον χρωματισμό θέσης, ανοίγει αυτή η φόρμα. Επιλέξτε ζώνη, ορίστε διάρκεια και επιλέξτε επανάληψη. Αποθηκεύστε για δημιουργία εγγραφής άρδευσης.',
    tourScheduleTableTitle: 'Προβολή Πίνακα',
    tourScheduleTableDesc: 'Μεταβείτε σε προβολή πίνακα για εμφάνιση όλων των προγραμμάτων σε συμπαγή λίστα. Επεξεργαστείτε, εναλλάξτε ενεργό/ανενεργό ή διαγράψτε εγγραφές από εδώ.',
    // Step titles & descriptions (analytics)
    tourKpiStripTitle: 'Βασικοί Δείκτες (KPIs)',
    tourKpiStripDesc: 'Συνολικό νερό, αριθμός ποτισμάτων, μέση διάρκεια και κατάσταση ζωνών. Κάθε κάρτα αντλεί πραγματικά δεδομένα από τους αισθητήρες σας.',
    tourWidgetAreaTitle: 'Γραφήματα & Widgets',
    tourWidgetAreaDesc: 'Σύρετε, αλλάξτε μέγεθος ή αφαιρέστε widgets. Χρήση νερού ανά εβδομάδα, σύγκριση παραγωγού vs Σύμβουλο, τάση υγρασίας ανά ζώνη.',
    tourFarmerVsDssTitle: 'Παραγωγός vs Σύμβουλος Σύγκριση',
    tourFarmerVsDssDesc: 'Δείτε πού οι αποφάσεις σας συμφώνησαν ή διέφεραν από τον Σύμβουλο. Κατανοήστε πότε ο DSS πρότεινε άρδευση και δεν το κάνατε · και γιατί.',
    // Step titles & descriptions (DSS intelligence)
    tourDssZonesTitle: 'Ανάλυση Stress Ζωνών',
    tourDssZonesDesc: 'Ο DSS αξιολογεί WAI, συντελεστή καλλιέργειας και τύπο εδάφους για να κατατάξει κάθε ζώνη: OK, Οριακή, Stressed ή Κορεσμένη.',
    tourDssPlaygroundTitle: 'Παιδική Χαρά Σεναρίων DSS',
    tourDssPlaygroundDesc: 'Εισάγετε διαφορετικές τιμές υγρασίας και καιρού για να δείτε πώς ανταποκρίνεται ο αλγόριθμος. Χρήσιμο για κατανόηση της λογικής αποφάσεων.',
    // Step titles & descriptions (alerts)
    tourNotificationBellTitle: 'Ειδοποιήσεις',
    tourNotificationBellDesc: 'Πραγματικές ειδοποιήσεις για stressed ζώνες, ολοκληρωμένα ποτίσματα και προειδοποιήσεις αισθητήρων. Το καμπανάκι δείχνει τον αριθμό μη αναγνωσμένων.',
    tourAlertsPageTitle: 'Ειδοποιήσεις',
    tourAlertsPageDesc: 'Χαμηλή υγρασία, αισθητήρας εκτός λειτουργίας, ακυρωμένη άρδευση. Πατήστε σε κάθε ειδοποίηση για λεπτομέρειες και ενέργεια.',
    // Step titles & descriptions (diary)
    tourDiaryPageTitle: 'Ημερολόγιο Αγρού',
    tourDiaryPageDesc: 'Καταγράψτε λιπάνσεις, ψεκασμούς, κλαδέματα και παρατηρήσεις. Κάθε εγγραφή συνδέεται με χωράφι και ημερομηνία για πλήρες ιστορικό.',
    tourHistoryPageTitle: 'Ιστορικό Άρδευσης',
    tourHistoryPageDesc: 'Δείτε ποιες ζώνες ποτίστηκαν, πότε και για πόση ώρα. Συγκρίνετε πραγματική κατανάλωση νερού ανά εβδομάδα ή μήνα.',
    tourDiaryAddBtnTitle: 'Προσθήκη Εγγραφής Ημερολογίου',
    tourDiaryAddBtnDesc: 'Καταγράψτε οποιαδήποτε αγροτική δραστηριότητα: λίπανση, φυτοφάρμακο, κλάδεμα, επιθεώρηση. Επισυνάψτε φωτογραφίες και συνδέστε με χωράφι.',
    // Step titles & descriptions (settings)
    tourLanguageToggleTitle: 'Εναλλαγή Γλώσσας',
    tourLanguageToggleDesc: 'Εναλλαγή μεταξύ Αγγλικών και Ελληνικών. Όλες οι ετικέτες, προτροπές και κωδικοί λόγων DSS είναι πλήρως μεταφρασμένοι.',
    tourAutoAcceptTitle: 'Αυτόματη Αποδοχή DSS',
    tourAutoAcceptDesc: 'Ενεργοποιήστε αυτή τη ρύθμιση για να εφαρμόζονται αυτόματα οι προτάσεις ποτίσματος χωρίς χειροκίνητη έγκριση.',
    tourPrioritySliderTitle: 'Προτεραιότητα Εξοικονόμησης',
    tourPrioritySliderDesc: 'Ρυθμίστε αν προτιμάτε εξοικονόμηση νερού ή μέγιστη παραγωγή. Ο DSS προσαρμόζει τις προτάσεις του ανάλογα.',
    tourSeasonChipTitle: 'Φίλτρο σεζόν',
    tourSeasonChipDesc: 'Αυτό το chip συγχρονίζεται με τον επιλογέα σεζόν στο πλευρικό μενού του χάρτη. Κάντε κλικ για εναλλαγή μεταξύ της τρέχουσας σεζόν και όλων των ετών.',

    // === DSS Demo Page ===
    dssDemoNoData: 'Δεν υπάρχουν δεδομένα ανάλυσης',
    dssDemoNoDataDesc: 'Ενεργοποιήστε τη λειτουργία επίδειξης και βεβαιωθείτε ότι τα δεδομένα έχουν φορτωθεί.',
    dssDemoDecisions: 'Αποφάσεις που αναλύθηκαν',
    dssDemoAgreement: 'Συμφωνία παραγωγού-DSS',
    dssDemoSavingsPct: 'Δυνητική εξοικονόμηση νερού',
    dssDemoSavingsM3: 'Νερό που εξοικονομήθηκε',
    dssDemoFarmerDays: 'Ημέρες που ποτίσατε',
    dssDemoDssDays: 'Ημέρες που θα πρότεινε το DSS',
    dssDemoSection1Title: 'Τι Είναι το DSS;',
    dssDemoSection1Desc: 'Το Σύστημα Υποστήριξης Αποφάσεων (DSS) αναλύει υγρασία εδάφους, πρόγνωση καιρού και στάδιο ανάπτυξης για να προτείνει πότε και πόσο να ποτίσετε κάθε ζώνη. Μαθαίνει από το ιστορικό του χωραφιού σας για καλύτερες προτάσεις.',
    dssDemoIntroDetail: 'Το σύστημα χρησιμοποιεί την εξίσωση FAO-56 Penman-Monteith σε συνδυασμό με μετρήσεις υγρασίας σε 3 βάθη (10εκ, 20εκ, 30εκ) για τον υπολογισμό του Σταθμισμένου Δείκτη Διαθεσιμότητας (WAI) κάθε ζώνης. Όταν ο WAI πέσει κάτω από το όριο για το στάδιο ανάπτυξης, προτείνεται πότισμα.',
    dssDemoSection2Title: 'Οι Αποφάσεις σας vs. Σύστημα',
    dssDemoSection2Desc: 'Συγκρίναμε κάθε μέρα που κάνατε άρδευση με αυτό που θα πρότεινε το σύστημα. Κάποιες μέρες συμφωνήσατε. Σε άλλες, το σύστημα θα εξοικονομούσε νερό ή θα εντόπιζε ξηρασία που δεν είχατε δει.',
    dssDemoSection3Title: 'Τα Νούμερα',
    dssDemoSection3Desc: 'Η πλήρης εικόνα από 13 μήνες δεδομένων: πόσες αποφάσεις αναλύθηκαν, πόσο συχνά συμφωνήσατε και πόσο νερό θα μπορούσε να εξοικονομηθεί.',
    dssDemoSection4Title: 'Πραγματικά Σενάρια',
    dssDemoSection4Desc: 'Το DSS προσαρμόζεται στις καιρικές συνθήκες. Ορίστε τρία πραγματικά σενάρια από τα δεδομένα σας:',
    dssDemoRainTitle: 'Βροχή, χωρίς άρδευση',
    dssDemoRainDesc: 'Όταν η πρόγνωση δείχνει βροχή, το DSS προτείνει παράλειψη. Τον Μάιο 2024, αυτό εξοικονόμησε 3 κύκλους ποτίσματος.',
    dssDemoHeatTitle: 'Καύσωνας, μεγαλύτερη διάρκεια',
    dssDemoHeatDesc: 'Κατά τον καύσωνα Αυγούστου 2024 (40\u00b0C+), το DSS αύξησε τη διάρκεια ποτίσματος κατά 20% για προστασία της ριζικής ζώνης.',
    dssDemoOptimalTitle: 'Κανονικές συνθήκες, η σωστή διάρκεια',
    dssDemoOptimalDesc: 'Σε τυπικές ημέρες, το DSS ρυθμίζει ώρα έναρξης και διάρκεια ανά ζώνη βάσει τύπου εδάφους, υγρασίας και πρόβλεψης εξατμισοδιαπνοής.',
    dssDemoSection5Title: 'Έτοιμοι να το Δοκιμάσετε;',
    dssDemoSection5Desc: 'Το DSS σχεδιάστηκε να συνεργάζεται με την εμπειρία σας, όχι να την αντικαταστήσει. Πάντα εσείς αποφασίζετε.',
    dssDemoConclusionDetail: 'Ξεκινήστε τρέχοντας το DSS παράλληλα με το χειροκίνητο πρόγραμμά σας. Αξιολογήστε τις προτάσεις του και συγκρίνετε αποτελέσματα. Όταν νιώσετε σίγουροι, ενεργοποιήστε την αυτόματη λειτουργία στις Ρυθμίσεις.',
    dssDemoBackToMap: 'Πίσω στον Χάρτη',
    dssDemoGoAnalytics: 'Προβολή Αναλυτικών',
    // Section headers used directly in DSSDemo.js
    dssDemoAnalysisDays: 'Ημέρες ανάλυσης',
    dssDemoEstimatedSavings: 'Εκτιμώμενη εξοικονόμηση νερού:',
    dssDemoScenariosTitle: 'Πώς Αντιδρά σε Πραγματικές Συνθήκες',
    dssDemoScenariosSub: 'Τέσσερα σενάρια από τα πραγματικά δεδομένα · βροχή, καταπόνηση, καύσωνας και σωστή διαχείριση.',
    dssDemoSection1: 'Τι Μάθαμε',
    dssDemoSection1Sub: 'Βασικοί δείκτες από 13 μήνες σύγκρισης παραγωγού και συστήματος',
    dssDemoSection2: 'Εκπαίδευση & Αξιολόγηση',
    dssDemoSection2Sub: 'Αριστερά: δεδομένα εκπαίδευσης (2024 + Μάιος 2025). Δεξιά: αξιολόγηση σε αόρατα δεδομένα (Ιούνιος·Αύγουστος 2025). Η διακεκομμένη γραμμή χωρίζει τα δύο σύνολα.',
    dssDemoSection3: 'Πότε Διαφωνήσαμε',
    dssDemoSection3Sub: 'Ημέρες που παραγωγός και σύστημα είχαν διαφορετική γνώμη',
    dssDemoSection4: 'Ανά Ζώνη',
    dssDemoSection4Sub: 'Κάθε ζώνη έχει διαφορετικό έδαφος και διαφορετική συμπεριφορά',
    dssDemoSection5: 'Γιατί Αποφασίζει Έτσι',
    dssDemoSection5Sub: 'Οι πιο συχνοί λόγοι πίσω από κάθε σύσταση',
    dssDemoScenarioRain: 'Βροχόπτωση · Παράλειψη',
    dssDemoScenarioStress: 'Πτώση Υγρασίας · Συναγερμός',
    dssDemoScenarioHeat: 'Καύσωνας · Μέγιστη Ανάγκη',
    dssDemoScenarioOk: 'Καλή Διαχείριση · Επιβεβαίωση',
    dssDemoSection6: 'Κάθε Έδαφος, Διαφορετική Συμπεριφορά',
    dssDemoSection6Sub: 'Το ίδιο σύστημα, σε διαφορετικούς τύπους εδάφους. Η αμμώδης αποστραγγίζει γρήγορα (συχνότερα ποτίσματα), η αργιλώδης κρατάει το νερό (λιγότερα ποτίσματα).',

    snapshotViewing: 'Προβολή',

    // Demo Date Picker (time-travel)
    demoDateLiveMode: 'Ζωντανή Λειτουργία',
    demoDateHistoricalMode: 'Ιστορική Λειτουργία',
    demoDateLive: 'Ζωντανά',
    demoDateGoLive: 'Επιστροφή σε ζωντανά δεδομένα',
    demoDateSelectDate: 'Επιλογή ημερομηνίας...',
    demoDateScenarios: 'Εξερευνήστε σενάρια από πραγματικά δεδομένα:',
    demoDateViewingAsOf: 'Προβολή δεδομένων για',
    demoDatePreset_drought_jul24: 'Ξηρασία · Ιούλιος 2024',
    demoDatePresetDesc_drought_jul24: 'Η υγρασία πέφτει στο 18%, το DSS ενεργοποιεί επείγουσα άρδευση',
    demoDatePreset_rain_may24: 'Βροχοπτώσεις · Μάιος 2024',
    demoDatePresetDesc_rain_may24: 'Το DSS παραλείπει άρδευση, εξοικονομεί νερό από τη βροχή',
    demoDatePreset_heat_aug24: 'Καύσωνας · Αύγουστος 2024',
    demoDatePresetDesc_heat_aug24: 'Κορύφωση ET₀, το DSS αυξάνει τη διάρκεια άρδευσης',
    demoDatePreset_winter25: 'Χειμερινή Ηρεμία · Ιαν. 2025',
    demoDatePresetDesc_winter25: 'Χαμηλός Kc, ελάχιστες ανάγκες νερού, μειωμένη άρδευση',
    demoDateNoData: 'Δεν υπάρχουν δεδομένα για αυτή την ημερομηνία',
    demoDateZoneState: 'Κατάσταση ζώνης κατά',

    // Weather improvements
    showingLatestWeatherData: 'Εμφάνιση τελευταίων δεδομένων καιρού',
    showCharts: 'Εμφάνιση Γραφημάτων',
    hideCharts: 'Απόκρυψη Γραφημάτων',
    noWeatherHistory: 'Δεν υπάρχουν ιστορικά δεδομένα ακόμα',
    noWeatherHistoryHint: 'Τα καιρικά δεδομένα συλλέγονται αυτόματα κάθε 6 ώρες. Ελέγξτε ξανά μετά την πρώτη αυτόματη ενημέρωση.',
    weatherHistoryFewPoints: 'Λίγες μέρες δεδομένων · τα γραφήματα χρειάζονται τουλάχιστον 3 ημέρες για απόδοση.',
    hourly: 'Ωριαία',

    // Settings page
    settings: 'Ρυθμίσεις',
    settingsSubtitle: 'Διαμορφώστε τις προτιμήσεις σας για το σύστημα άρδευσης',
    profileSettings: 'Προφίλ',
    profileSettingsDesc: 'Στοιχεία λογαριασμού',
    saveProfile: 'Αποθήκευση Προφίλ',
    profileSaved: 'Το προφίλ αποθηκεύτηκε',
    changePassword: 'Αλλαγή Κωδικού',
    signedInDevices: 'Συνδεδεμένες συσκευές',
    signedInDevicesDesc: 'Κάθε κινητό, υπολογιστής ή οθόνη που είναι συνδεδεμένη στον λογαριασμό σας. Η σύνδεση από νέα συσκευή δεν αποσυνδέει τις υπόλοιπες.',
    thisDevice: 'Αυτή η συσκευή',
    signedInUnknownDevice: 'Άγνωστη συσκευή',
    deviceSignedInAt: 'Σύνδεση',
    deviceLastActive: 'Τελευταία χρήση',
    signOutDevice: 'Αποσύνδεση',
    showAllDevices: 'Όλες οι συσκευές ({n})',
    signOutOtherDevices: 'Αποσύνδεση από όλες τις άλλες συσκευές',
    signedInDevicesError: 'Δεν ήταν δυνατή η φόρτωση των συσκευών.',
    confirmPassword: 'Επαλήθευση Κωδικού',
    passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν',
    passwordTooShort: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
    passwordChanged: 'Ο κωδικός άλλαξε επιτυχώς',
    emailAddress: 'Διεύθυνση Email',
    dssPreferences: 'Προτιμήσεις DSS',
    dssPreferencesDesc: 'Ελέγξτε πώς ο Σύμβουλος Άρδευσης δημιουργεί και εφαρμόζει συστάσεις.',
    autoAcceptDss: 'Αυτόματα Με Σύμβουλο',
    autoAcceptDssDesc: 'Ο Σύμβουλος δημιουργεί αυτόματα αρδεύσεις, δεν χρειάζεται έγκρισή σου',
    defaultIrrigationMode: 'Προεπιλεγμένη λειτουργία άρδευσης',
    productionGoalPriority: 'Προτεραιότητα στόχου παραγωγής',
    productionGoalPriorityDesc: 'Ισορροπία μεταξύ εξοικονόμησης νερού και μέγιστης απόδοσης',
    conservative: 'Συντηρητικό',
    balanced: 'Ισορροπημένο',
    aggressive: 'Επιθετικό',
    calendarPreferences: 'Προτιμήσεις Ημερολογίου',
    calendarStartHour: 'Ώρα έναρξης',
    calendarEndHour: 'Ώρα λήξης',
    display: 'Εμφάνιση',
    defaultField: 'Προεπιλεγμένο χωράφι',
    defaultFieldDesc: 'Το χωράφι που εμφανίζεται κατά το άνοιγμα του πίνακα ελέγχου',
    notificationPreferences: 'Ειδοποιήσεις',
    notifyInApp: 'Στην εφαρμογή',
    notifyInAppDesc: 'Οι κλήσεις άρδευσης και τα σημαντικά μηνύματα εμφανίζονται στο καμπανάκι. Πάντα ενεργό.',
    notifyEmailIrrigation: 'Email όταν ένα χωράφι χρειάζεται άρδευση',
    notifyEmailIrrigationDesc: 'Ένα email όταν ένα χωράφι σας χρειάζεται άρδευση, με τα λεπτά.',
    guidedTour: 'Ξενάγηση',
    tutorialWalkthrough: 'Διαδραστική Εκμάθηση',
    demoFarmData: 'Δεδομένα Δοκιμαστικής Εκμετάλλευσης',
    tourRestartDesc: 'Ξεκινήστε ξανά την ξενάγηση για να δείτε όλες τις δυνατότητες της εφαρμογής.',
    restartTour: 'Έναρξη ξενάγησης',

    // Season management
    season: 'Εποχή',
    noSeason: 'Χωρίς εποχή',
    noSeasonsYet: 'Δεν υπάρχουν εποχές ακόμη',
    newSeason: 'Νέα εποχή',

    // Map / NDVI vegetation labels
    bare: 'Άγονο',
    sparse: 'Αραιή',
    dense: 'Πυκνή',

    // DSS decision matrix labels
    bothAgree: 'Συμφωνία',
    bothAgreedIrrigated: 'Αμφότεροι πότισαν',
    bothAgreedSkipped: 'Αμφότεροι παρέλειψαν',
    farmerOnly: 'Μόνο Παραγωγός',
    farmerOnlyDesc: 'Το ΣΥΑ θα παρέλειπε',
    dssOnly: 'Μόνο ΣΥΑ',
    dssOnlyDesc: 'Ο παραγωγός παρέλειψε',
    bothSkip: 'Καμία Άρδευση',

    // DSS timeline labels
    zoneStateOKDesc: 'Καλή υγρασία, δεν χρειάζεται άρδευση σήμερα',
    zoneStateMarginalDesc: 'Το έδαφος στεγνώνει, εξετάστε άρδευση σήμερα',
    zoneStateStressedDesc: 'Πολύ ξηρό, αρδεύστε το συντομότερο',
    zoneStateUnknownDesc: 'Δεν υπάρχει ακόμα μέτρηση για αυτή τη ζώνη',
    agreementBothIrrigated: 'Συμφωνία · Αμφότεροι πότισαν',
    agreementBothSkipped: 'Συμφωνία · Αμφότεροι παρέλειψαν',
    farmerIrrigatedDssSkip: 'Ο παραγωγός πότισε · Το ΣΥΑ θα παρέλειπε',
    dssWouldIrrigateFarmerSkipped: 'Το ΣΥΑ θα πότιζε · Ο παραγωγός παρέλειψε',
    farmerLabel: 'Παραγωγός',
    irrigatedLabel: 'Πότισε',
    waiThresholdHint: 'Επίπεδο νερού εδάφους · κάτω από 55% = χρειάζεται άρδευση',
    farmerVsSystemHint: 'Σύγκριση παραγωγού και συστήματος ανά ημέρα (κλικ για λεπτομέρειες)',

    // ProductionOverview
    gradeM: 'Μεικτή',

    // ScheduleFormPanel fertigation
    fertNPKBalanced: 'Ισορροπημένο Ν-Φ-Κ',
    fertHighNitrogen: 'Υψηλό Άζωτο',
    fertBloomBoost: 'Ενίσχυση Άνθησης',
    fertCustom: 'Προσαρμοσμένο',
    fertNone: 'Κανένα',
    fertilizerRecipe: 'Συνταγή Λιπάσματος',
    fertilizerRecipePlaceholder: 'π.χ. ΝΦΚ 20-20-20',
    fertilizerRecipeHelp: 'Όνομα ή φόρμουλα λιπάσματος για αυτή την υδρολίπανση',

    // Misc UI
    currentWeatherTooltip: 'Τρέχων καιρός · ενημέρωση κάθε 5 λεπτά',
    updatedAgo: 'Ενημερώθηκε',
    selectDate: 'Επιλογή ημερομηνίας',
    previousWeek: 'Προηγούμενη εβδομάδα',
    nextWeek: 'Επόμενη εβδομάδα',

    // Missing keys · FieldPanel / Schedule tab
    noScheduleTodayHint: 'Προσθέστε εβδομαδιαίο πρόγραμμα ή ξεκινήστε άρδευση χειροκίνητα.',
    goToSchedule: 'Πρόγραμμα Άρδευσης',
    minutes: 'λεπτ.',
    customDuration: 'Προσαρμοσμένο',
    kiwi: 'Ακτινίδιο',
    inQueue: 'Στην Ουρά',

    // Missing keys · FieldListSidebar / layout
    sort: 'Ταξινόμηση',
    year: 'Έτος',
    close: 'Κλείσιμο',
    ariaExpandSidebar: 'Ανάπτυξη πλαϊνής μπάρας',
    ariaCollapseSidebar: 'Σύμπτυξη πλαϊνής μπάρας',
    ariaCloseSidebar: 'Κλείσιμο πλαϊνής μπάρας',
    ariaSortFields: 'Ταξινόμηση χωραφιών',
    ariaFilterFields: 'Φιλτράρισμα χωραφιών',
    ariaEditZone: 'Επεξεργασία ρυθμίσεων ζώνης',
    ariaDeleteZone: 'Διαγραφή ζώνης',
    ariaCloseZonePanel: 'Κλείσιμο πίνακα ζώνης',
    ariaToggleNav: 'Εναλλαγή πλοήγησης',
    ariaDismissInstall: 'Απόρριψη μπάνερ εγκατάστασης',
    diary: 'Ημερολόγιο',

    // Missing keys · Analytics widgets
    addChart: 'Προσθήκη Γραφήματος',
    browseRecommended: 'Προτεινόμενα',
    chartTitle: 'Τίτλος Γραφήματος',
    chartType: 'Τύπος Γραφήματος',
    createCustom: 'Προσαρμοσμένο',
    cumulativeBalance: 'Αθροιστικό Ισοζύγιο',
    deficit: 'Έλλειμμα',
    demoData: 'Ιστορικά',
    demoDataDate: 'Εμφάνιση ιστορικών δεδομένων',
    dssRecommends: 'Σύσταση Συμβούλου',
    dss_recommendation: 'Σύσταση Συμβούλου',
    duration_min: 'Διάρκεια (λεπτ.)',
    editChart: 'Επεξεργασία Γραφήματος',
    elevated: 'Υψηλό',
    heavyRain: 'Έντονη Βροχόπτωση',
    high: 'Υψηλό',
    highDemand: 'Υψηλή Ζήτηση',
    loss: 'Απώλεια',
    modify: 'Τροποποίηση',
    month: 'Μήνας',
    ndviZoneColoring: 'Χρωματισμός Ζωνών NDVI',
    netBalance: 'Καθαρό Ισοζύγιο',
    newChart: 'Νέο Γράφημα',
    newScheduleEntry: 'Νέα Καταχώρηση Προγράμματος',
    noBacktestData: 'Δεν υπάρχουν δεδομένα ιστορικής ανάλυσης',
    noChartsDescription: 'Προσθέστε γραφήματα για παρακολούθηση των δεδομένων',
    noChartsYet: 'Δεν υπάρχουν γραφήματα ακόμα',
    noRainfallData: 'Δεν υπάρχουν δεδομένα βροχόπτωσης',
    noSalinityData: 'Δεν υπάρχουν δεδομένα αλατότητας',
    noSoilTempData: 'Δεν υπάρχουν δεδομένα θερμοκρασίας εδάφους',
    noSolarData: 'Δεν υπάρχουν δεδομένα ηλιακής ακτινοβολίας',
    noTimelineData: 'Δεν υπάρχουν δεδομένα χρονολογίου',
    noWaterBalanceData: 'Δεν υπάρχουν δεδομένα υδατικού ισοζυγίου',
    noWaterBalanceHint: 'Το υδατικό ισοζύγιο απαιτεί αναγνώσεις αισθητήρων και μετεωρολογικά δεδομένα.',
    noWeatherDataHint: 'Τα μετεωρολογικά δεδομένα θα εμφανιστούν μόλις ο σταθμός αρχίσει να αναφέρει.',
    panelVoltage: 'Τάση Πάνελ',
    rain: 'Βροχή',
    rainfallWindSubtitle: 'Βροχόπτωση & ταχύτητα ανέμου ανά χρόνο',
    realData: 'Πραγματικά Δεδομένα',
    removeChart: 'Αφαίρεση Γραφήματος',
    save_changes: 'Αποθήκευση Αλλαγών',
    saveFailed: 'Αποτυχία αποθήκευσης',
    saved: 'Αποθηκεύτηκε',
    deleted: 'Διαγράφηκε',
    deleteFailed: 'Αποτυχία διαγραφής',
    severeStress: 'Σοβαρό Στρες',
    slowUptake: 'Αργή Πρόσληψη',
    soilSalinitySubtitle: 'Ηλεκτρική αγωγιμότητα ανά βάθος',
    soilTempSubtitle: 'Θερμοκρασία εδάφους ανά βάθος',
    solarAndEnergy: 'Ηλιακή Ακτινοβολία & Ενέργεια',
    solarSubtitle: 'Φωτοσυνθετικά ενεργή ακτινοβολία',
    surplus: 'Πλεόνασμα',
    timingPerDay: 'Χρονισμός ανά Ημέρα',
    totalRain: 'Συνολική Βροχόπτωση',
    warm: 'Θερμό',
    cold: 'Ψυχρό',
    waterBalance: 'Υδατικό Ισοζύγιο',
    windDamage: 'Ζημιά Ανέμου',
    yieldLoss: 'Απώλεια Παραγωγής',

    // Common UI words (i18n audit fixes)
    done: 'Ολοκλήρωση',
    max: 'Μέγιστο',
    configuration: 'Ρυθμίσεις',

    // Irrigation history
    irrigationHistory: 'Ιστορικό Άρδευσης',
    noIrrigationHistory: 'Δεν υπάρχει ιστορικό άρδευσης',
    noIrrigationYet: 'Δεν έχει καταγραφεί άρδευση',

    // Sensor data
    noSensorReadings: 'Δεν υπάρχουν διαθέσιμες μετρήσεις αισθητήρα',
    sensorDataUnavailable: 'Τα δεδομένα αισθητήρα δεν είναι προσωρινά διαθέσιμα.',
    soilDataPending: 'Σε αναμονή δεδομένων αισθητήρα · το αποτέλεσμα θα εμφανιστεί όταν φτάσουν οι μετρήσεις',
    sensorsOffline: 'Αισθητήρες εδάφους εκτός σύνδεσης',
    sensorsOfflineHint: 'Χρησιμοποιούνται παλαιότερα δεδομένα καιρού και εκτιμήσεις εδάφους. Οι συστάσεις παραμένουν διαθέσιμες. Θα γίνουν πιο ακριβείς μόλις επανέλθουν οι αισθητήρες.',
    sensorsNotReporting: 'Δεν υπάρχουν ακόμα δεδομένα αισθητήρα εδάφους',
    sensorsNotReportingHint: 'Όταν οι αισθητήρες συνδεθούν και αρχίσουν να αναφέρουν, το χωράφι θα εμφανίζει ζωντανή υγρασία και οι συστάσεις θα βελτιστοποιηθούν.',
    daysShort: 'ημ',
    daysRemaining: 'ημέρες απομένουν',
    irrigating: 'Σε άρδευση',
    minRemaining: 'λεπτά απομένουν',
    vwcTrend30d: 'Τάση VWC (30 ημ.)',

    // Confirmation dialogs
    confirmStop: 'Διακοπή άρδευσης;',
    confirmStopZoneDesc: 'Αυτό θα διακόψει την τρέχουσα άρδευση για αυτή τη ζώνη.',

    // Error messages
    errorCreatingField: 'Σφάλμα δημιουργίας αγρού',
    errorCreatingZone: 'Σφάλμα δημιουργίας ζώνης',
    errorLoadingData: 'Αδυναμία φόρτωσης δεδομένων',
    errorSavingField: 'Σφάλμα αποθήκευσης αγρού',
    failedToSave: 'Αποτυχία αποθήκευσης',

    // Field wizard & polygon
    noFieldPolygon: 'Δεν υπάρχει διαθέσιμο πολύγωνο αγρού',

    // Schedule
    paintScheduleHint: 'Κάντε κλικ και σύρετε στο ημερολόγιο για να δημιουργήσετε πρόγραμμα άρδευσης. Χρησιμοποιήστε το + στη γραμμή εργαλείων.',

    // New season
    newSeasonDesc: 'Δημιουργία νέας καλλιεργητικής περιόδου για όλους τους αγρούς σας. Θα προστεθεί επίσης καταχώρηση στο Ημερολόγιο Αγρού.',

    // Tour / onboarding
    resetTourProgress: 'Επαναφορά προόδου',
    tourResetAllDesc: 'Σημειώστε όλες τις ενότητες ως μη αναγνωσμένες. Το κουμπί της ξενάγησης θα εμφανιστεί ξανά.',

    // Settings / password
    currentPassword: 'Τρέχων Κωδικός',
    passwordHint: 'Ελάχ. 12 χαρακτήρες, κεφαλαία, αριθμός & σύμβολο',
    passwordTooWeak: 'Ο κωδικός είναι πολύ αδύναμος. Χρησιμοποιήστε κεφαλαία, αριθμούς και σύμβολα.',

    // ── DSS Demo (DSSDemo.js + page tabs) ────────────────────────────
    dssDemoTitle: 'Ευφυΐα Άρδευσης · Μηχανισμός Απόφασης',
    dssDemoSubtitle: 'Ακτινίδιο · Βέροια',
    dssDemoPageDesc: 'Προβολή διαχειριστή: πώς ο αλγόριθμος λαμβάνει αποφάσεις άρδευσης, επικυρωμένος με 2 χρόνια πραγματικών δεδομένων. Χρησιμοποιήστε την καρτέλα Προσομοίωση για δοκιμή σεναρίων.',
    dssDemoLoading: 'Φόρτωση δεδομένων DSS...',
    dssDemoLoadError: 'Σφάλμα φόρτωσης',
    dssDemoRetry: 'Επαναφόρτωση',
    dssDemoBack: 'Πίσω',
    dssPage_architecture: '1. Αρχιτεκτονική',
    dssPage_datasources: '2. Πηγές Δεδομένων',
    dssPage_backtest: '3. Αξιολόγηση & KPIs',
    dssPage_timeline: '4. Χρονοσειρές',
    dssPage_water: '5. Σύγκριση Άρδευσης',
    dssPage_playground: '6. Προσομοίωση',

    // ── DSS Backtest section (BacktestPage in DSSDemo.js) ────────────
    dssBacktest_strategy_calendar_name: 'Κανόνας Ημερολογίου',
    dssBacktest_strategy_calendar_desc: 'Σταθερό πρόγραμμα κάθε 3 ημέρες · αγνοεί την υγρασία εδάφους',
    dssBacktest_strategy_physics_name: 'Φυσική Μόνο',
    dssBacktest_strategy_physics_desc: 'Ποτίζει όταν η υγρασία πέσει κάτω από κατώφλι · χωρίς πρόβλεψη καιρού ή ML',
    dssBacktest_strategy_dssml_name: 'DSS (ML + Φυσική)',
    dssBacktest_strategy_dssml_desc: 'Υγρασία εδάφους + πρόβλεψη καιρού + στάδιο καλλιέργειας + μηχανική μάθηση',
    dssBacktest_metric_daysRecommended: 'Ημέρες συστάσεων',
    dssBacktest_metric_recall: 'Ανάκληση',
    dssBacktest_metric_precision: 'Ακρίβεια',
    dssBacktest_evaluatedCaption: 'Αξιολογήθηκε σε δεδομένα σεζόν 2025 (κρατήθηκαν εκτός εκπαίδευσης 2024).',
    dssBacktest_dayBreakdown: 'Ανάλυση Ημερών',
    dssBacktest_seg_tp: 'Κοινή απόφαση · έδαφος σε στρες',
    dssBacktest_seg_tn: 'Κοινή παράλειψη · έδαφος επαρκές',
    dssBacktest_seg_fp: 'DSS μόνο · παραγωγός παρέλειψε καταπόνηση',
    dssBacktest_seg_fn: 'Παραγωγός μόνο · έδαφος ήταν επαρκές',
    dssBacktest_seg_waiAvg: 'μέσο WAI',
    dssBacktest_avgWaiByGroup: 'Μέση Υγρασία Εδάφους ανά Ομάδα',
    dssBacktest_avgWaiByGroupDesc: 'Μέσο WAI (%) τις ημέρες που κάθε ομάδα πήρε απόφαση πότισης',
    dssBacktest_avgWaiTooltip: 'Μέσο WAI',
    dssBacktest_waiGroup_tp: 'TP ημέρες · κοινή απόφαση',
    dssBacktest_waiGroup_fp: 'DSS-only · παραγωγός παρέλειψε',
    dssBacktest_waiGroup_tn: 'TN ημέρες · κοινή παράλειψη',
    dssBacktest_distinguishCaption: 'Τα τρία γκρουπ καλύπτουν εντελώς διαφορετικά εύρη υγρασίας, επιβεβαιώνοντας ότι το DSS κάνει πραγματικές διακρίσεις βάσει κατάστασης εδάφους.',
    dssBacktest_perMonthTitle: 'Απόδοση ανά Μήνα · Leave-One-Month-Out',
    dssBacktest_meanF1: 'Μέσο F1',
    dssBacktest_stdDev: 'τυπ. απόκλιση',
    dssBacktest_perMonthDesc: 'Κάθε μήνας αξιολογήθηκε ξεχωριστά · δείχνει πότε το μοντέλο δουλεύει καλύτερα και πότε δυσκολεύεται.',
    dssBacktest_best: 'Καλύτερος',
    dssBacktest_hardest: 'Δυσκολότερος',
    dssBacktest_fpCalloutFull: 'Οι {fp} ημέρες που το DSS πρότεινε αλλά ο παραγωγός δεν πότισε: μέσο WAI {wai}%, κάτω από κατώφλι σε {missed} από τις {fp} ημέρες. Δεν ήταν λάθος του συστήματος · το έδαφος ήταν πράγματι σε καταπόνηση.',
    dssBacktest_fpCalloutNoWai: 'Οι {fp} ημέρες που το DSS πρότεινε αλλά ο παραγωγός δεν πότισε: κάτω από κατώφλι σε {missed} από τις {fp} ημέρες. Δεν ήταν λάθος του συστήματος · το έδαφος ήταν πράγματι σε καταπόνηση.',
    dssBacktest_fpCalloutSimple: 'Οι {fp} ημέρες που το DSS πρότεινε αλλά ο παραγωγός δεν πότισε. Δεν ήταν λάθος του συστήματος · το έδαφος ήταν πράγματι σε καταπόνηση.',
    dssBacktest_farmerImperfectFootnote: '* Στις {fp} ημέρες που το DSS πρότεινε πότισμα και ο παραγωγός δεν πότισε, σε {missed} από αυτές ({pct}%) το έδαφος ήταν πράγματι σε καταπόνηση. Ο παραγωγός δεν αποτελεί τέλεια αναφορά · η ακρίβεια {precision} υπολογίστηκε βάσει της συμπεριφοράς του, όχι της φυσικής του εδάφους.',

    // ── DSS Timeline (DSSPageTimeline.js) ────────────────────────────
    dssTime_noData: 'Δεν υπάρχουν δεδομένα χρονοσειράς',
    dssTime_legend_moistureChart: 'Γράφημα υγρασίας',
    dssTime_legend_chartMarkers: 'Σημάδια στο γράφημα',
    dssTime_legend_show: 'Δες υπόμνημα',
    dssTime_legend_hide: 'Κλείσε υπόμνημα',
    dssTime_legend_vwc10_actual: 'Υγρασία στα 10cm (αισθητήρας)',
    dssTime_legend_dssScenario: 'Σενάριο DSS · αν ο παραγωγός ακολουθούσε τις συστάσεις (εκτίμηση)',
    dssTime_legend_vwc20: 'Υγρασία 20cm',
    dssTime_legend_vwc30: 'Υγρασία 30cm',
    dssTime_legend_wp: 'Σημείο μάρανσης 15% (κάτω: μη αναστρέψιμη βλάβη)',
    dssTime_legend_fc: 'Υδατοϊκανότητα 36% (πάνω: κορεσμός εδάφους)',
    dssTime_legend_farmerDot: 'Κουκκίδα = ο παραγωγός πότισε εκείνη τη μέρα',
    dssTime_legend_dssTriangle: 'Τρίγωνο = ο αλγόριθμος θα πρότεινε πότισμα',
    dssTime_inlineLegend_moisture10: 'Υγρασία 10cm',
    dssTime_inlineLegend_farmerIrr: 'Παραγωγός πότισε',
    dssTime_inlineLegend_dssRec: 'DSS πρότεινε',
    dssTime_daysCount: '{n} ημέρες',
    dssTime_panel1_title: 'Υγρασία εδάφους (%) · Πραγματική vs Σενάριο DSS',
    dssTime_panel1_actual10cm: 'Πραγματική (αισθητήρας 10cm)',
    dssTime_panel1_ifFollowed: 'Αν ακολουθούσε τις συστάσεις DSS',
    dssTime_chart_wp: 'Μάρανση 15%',
    dssTime_chart_fc: 'Πλήρες 36%',
    dssTime_chart_vwc10: 'Υγρασία 10cm',
    dssTime_chart_vwc20: 'Υγρασία 20cm',
    dssTime_chart_vwc30: 'Υγρασία 30cm',
    dssTime_chart_dssScenario: 'Σενάριο DSS',
    dssTime_chart_farmerIrrigated: 'Παραγωγός πότισε',
    dssTime_chart_dssRecommended: 'DSS πρότεινε',
    dssTime_panel2_title: 'WAI · Κάτω από {pct}% = χρειάζεται πότισμα',
    dssTime_panel2_limit: 'Όριο {pct}%',
    dssTime_panel2_dssDuration: 'Διάρκεια DSS',
    dssTime_panel3_title: 'Χρονικό Πλαίσιο · Έλλειμμα ΕΤ & Ώρες Στρες',
    dssTime_panel3_etDeficit7d: 'Έλλειμμα ET 7 ημ.',
    dssTime_panel3_stressHours: 'Ώρες στρες',
    dssTime_panel3_etDeficit: 'Έλλειμμα ET',
    dssTime_panel4_title: 'NDVI · Δείκτης βλάστησης (δορυφόρος)',
    dssTime_panel4_supplementary: 'Συμπληρωματικός δείκτης ~2% βαρύτητα',
    dssTime_panel4_caption: 'Το NDVI ελέγχει την υγεία της βλάστησης μέσω δορυφόρου Sentinel-2. Τιμές >0.6 = υγιής βλάστηση, <0.3 = γυμνό/ξηρό έδαφος. Ο δείκτης ενημερώνεται κάθε 5-10 ημέρες (εξαρτάται από νεφοκάλυψη).',
    dssTime_panel5_title: 'Συμφωνία παραγωγού και συστήματος ανά μέρα (πατήστε πάνω σε μια μέρα)',
    dssTime_strip_agreement: 'Συμφωνία',
    dssTime_strip_disagreement: 'Διαφωνία',
    dssTime_strip_legend_bothIrr: 'Και οι δύο πότισαν',
    dssTime_strip_legend_bothSkip: 'Και οι δύο παρέλειψαν',
    dssTime_strip_legend_dssOnly: 'DSS μόνο (παραγωγός παρέλειψε)',
    dssTime_strip_legend_farmerOnly: 'Παραγωγός μόνο (DSS παρέλειψε)',
    dssTime_detail_data: 'Δεδομένα',
    dssTime_detail_decisions: 'Αποφάσεις',
    dssTime_detail_soilWaterLevel: 'Επίπεδο νερού εδάφους',
    dssTime_detail_belowThreshold: 'Κάτω από κατώφλι 55%',
    dssTime_detail_waiTomorrow: 'WAI αύριο',
    dssTime_detail_daysToStress: 'Ημέρες μέχρι στρες',
    dssTime_detail_temperature: 'Θερμοκρασία',
    dssTime_detail_humidity: 'Υγρασία αέρα',
    dssTime_detail_rainfall: 'Βροχή',
    dssTime_detail_dailyWaterNeed: 'Ημερήσια ανάγκη νερού',
    dssTime_detail_farmer: 'Παραγωγός',
    dssTime_detail_irrigated: 'Πότισε',
    dssTime_detail_skipped: 'Παρέλειψε',
    dssTime_detail_recommended: 'Συνέστησε',
    dssTime_detail_skip: 'Παράλειψη',
    dssTime_detail_detected: 'Εντοπίστηκε',
    dssTime_detail_confidence_high: 'Υψηλή εμπιστοσύνη',
    dssTime_detail_confidence_medium: 'Μέτρια εμπιστοσύνη',
    dssTime_detail_confidence_low: 'Χαμηλή εμπιστοσύνη',
    dssTime_detail_rain: 'Βροχή',
    dssTime_detail_verdict_bothIrr: 'Συμφωνία · Αμφότεροι πότισαν',
    dssTime_detail_verdict_bothSkip: 'Συμφωνία · Αμφότεροι παρέλειψαν',
    dssTime_detail_verdict_farmerOnly: 'Παραγωγός πότισε · DSS θα παρέλειπε',
    dssTime_detail_verdict_dssOnly: 'DSS θα πότιζε · Παραγωγός παρέλειψε',
    dssTime_detail_hours: 'ώρες',
    dssTime_detail_minutes: 'λεπτά',
    dssZone_state_OK: 'Καλή υγρασία, δεν χρειάζεται άρδευση σήμερα',
    dssZone_state_MARGINAL: 'Το έδαφος στεγνώνει, εξετάστε άρδευση σήμερα',
    dssZone_state_STRESSED: 'Πολύ ξηρό, αρδεύστε το συντομότερο',
    dssZone_state_UNKNOWN: 'Χωρίς δεδομένα αισθητήρα',

    // ── DSS Zones (DSSPageZones.js) ──────────────────────────────────
    dssZones_noData: 'Δεν υπάρχουν δεδομένα ανά ζώνη',
    dssZones_intro: 'Το κτήμα δοκιμής έχει {n} ζώνες με διαφορετικό τύπο εδάφους (αργιλοπηλώδες, αμμοπηλώδες κλπ). Ο αλγόριθμος αποφασίζει ξεχωριστά για κάθε ζώνη γιατί κάθε ζώνη έχει τους δικούς της αισθητήρες και διαφορετική συμπεριφορά. Μέση συμφωνία παραγωγού-συστήματος: {pct}%.',
    dssZones_agreementPerZone: 'Συμφωνία ανά Ζώνη',
    dssZones_zone: 'Ζώνη',
    dssZones_th_zone: 'Ζώνη',
    dssZones_th_soil: 'Έδαφος',
    dssZones_th_farmer: 'Παραγωγός',
    dssZones_th_dss: 'DSS',
    dssZones_th_agreement: 'Συμφωνία',
    dssZones_th_topReason: 'Κύρια αιτία',
    dssZones_reasonDistribution: 'Κατανομή Λόγων Αποφάσεων',
    dssZones_bySoilType: 'Ανά Τύπο Εδάφους',
    dssZones_soil_farmer: 'Παραγωγός',
    dssZones_soil_agreement: 'Συμφωνία',

    // ── DSS Playground (DSSPagePlayground.js) ────────────────────────
    dssPlay_loading: 'Φόρτωση πραγματικών δεδομένων αγρού…',
    dssPlay_noSensorData: 'Δεν υπάρχουν δεδομένα αισθητήρων',
    dssPlay_liveBanner: 'Πραγματικά δεδομένα · {field} · {zone}',
    dssPlay_lastReading: 'Τελευταία ανάγνωση:',
    dssPlay_irrChip: 'Πότ.',
    dssPlay_month: 'Μήνας',
    dssPlay_soilType: 'Τύπος Εδάφους',
    dssPlay_bbchStage: 'BBCH',
    dssPlay_waiThreshold: 'Όριο WAI',
    dssPlay_slidersHint: 'Οι αρχικές τιμές είναι τα τελευταία δεδομένα αισθητήρων · ρυθμίστε για υποθετικά σενάρια',
    dssPlay_run: '▶ Εκτέλεση',
    dssPlay_realContextTitle: 'Πραγματικό Ιστορικό (από DB)',
    dssPlay_ctx_hoursSinceIrr: 'Ώρες από τελ. άρδευση',
    dssPlay_ctx_irr7d: 'Αρδεύσεις 7 ημερών',
    dssPlay_ctx_water7d: 'Νερό 7 ημερών',
    dssPlay_ctx_solarRadiation: 'Ηλιακή ακτινοβολία',
    dssPlay_decisionIrrigate: 'ΠΟΤΙΣΕ',
    dssPlay_decisionSkip: 'ΠΑΡΑΛΕΙΨΗ',
    dssPlay_unitHours: 'ώρες',
    dssPlay_unitMinutes: 'λεπτά',
    dssPlay_traceTitle: 'Ίχνος Απόφασης · 3 Επίπεδα',
    dssPlay_tier1Label: 'Φυσική (WAI)',
    dssPlay_tier2Label: 'ML XGBoost',
    dssPlay_tier2NotLoaded: 'Μη διαθέσιμο',
    dssPlay_tier3Label: 'Φρουρά Ασφαλείας',
    dssPlay_tier3_frost: 'Κίνδυνος παγετού · εκτροπή',
    dssPlay_tier3_recentRain: 'Πρόσφατη βροχή {n}mm',
    dssPlay_tier3_rainForecast: 'Πρόβλεψη βροχής {n}mm',
    dssPlay_tier3_clear: 'Χωρίς ενεργές φρουρές',
    dssPlay_forecastTitle: '5-Ήμερη Πρόβλεψη',
    dssPlay_forecastSrc_meteoblue: 'Meteoblue',
    dssPlay_forecastSrc_assumed: '0mm παραδοχή',
    dssPlay_forecastDesc: 'Εξέλιξη WAI εφαρμόζοντας τις συστάσεις DSS · κάθε άρδευση υπολογίζεται και εφαρμόζεται',
    dssPlay_dayIrrigate: 'Πότισε',
    dssPlay_dayRainSkip: 'Βροχή · παράλειψη',
    dssPlay_dayNoNeed: 'Δεν χρειάζεται',
    dssPlay_slider_vwc_10: 'Υγρασία 10cm',
    dssPlay_slider_vwc_20: 'Υγρασία 20cm',
    dssPlay_slider_vwc_30: 'Υγρασία 30cm',
    dssPlay_slider_temperature: 'Θερμοκρασία',
    dssPlay_slider_humidity: 'Υγρασία αέρα',
    dssPlay_slider_wind_speed: 'Άνεμος',
    dssPlay_slider_rainfall_24h: 'Βροχή 24ωρο',
    dssPlay_slider_rain_forecast_48h: 'Πρόβλεψη βροχής 48h',
    dssMonth_3: 'Μάρ',
    dssMonth_4: 'Απρ',
    dssMonth_5: 'Μάι',
    dssMonth_6: 'Ιούν',
    dssMonth_7: 'Ιούλ',
    dssMonth_8: 'Αύγ',
    dssMonth_9: 'Σεπ',
    dssMonth_10: 'Οκτ',
    dssBbch_10: 'Βλάστηση',
    dssBbch_30: 'Ανάπτυξη',
    dssBbch_50: 'Ανθοφορία',
    dssBbch_60: 'Καρπόδεση',
    dssBbch_71: 'Ανάπτυξη Καρπού',
    dssBbch_75: 'Ανάπτυξη Καρπού',
    dssBbch_80: 'Ωρίμανση',
    dssBbch_85: 'Ωρίμανση',
    dssBbch_89: 'Συγκομιδή',

    // ── DSS Shared (DSSShared.js · moisture tooltip + categories) ────
    dssShared_tooltip_moisture10: 'Υγρασία 10cm',
    dssShared_tooltip_moisture20: 'Υγρασία 20cm',
    dssShared_tooltip_moisture30: 'Υγρασία 30cm',
    dssShared_tooltip_dssProjected: 'Πρόβλεψη DSS',
    dssShared_tooltip_soilWaterLevel: 'Επίπεδο νερού εδάφους',
    dssShared_tooltip_rainfall: 'Βροχή',
    dssShared_tooltip_temperature: 'Θερμοκρασία',
    dssShared_tooltip_dailyWaterNeed: 'Ημερήσια ανάγκη νερού',
    dssShared_tooltip_farmer: 'Παραγωγός',
    dssShared_tooltip_farmerIrrigated: 'Πότισε',
    dssShared_tooltip_dssRecommended: 'Πρότεινε',
    dssShared_cat_soil_moisture: 'Υγρασία Εδάφους',
    dssShared_cat_wai: 'Δείκτης Υγρασίας (WAI)',
    dssShared_cat_weather: 'Καιρός',
    dssShared_cat_forecast: 'Πρόβλεψη Καιρού',
    dssShared_cat_et: 'Εξάτμιση Νερού',
    dssShared_cat_satellite: 'Δορυφόρος (NDVI)',
    dssShared_cat_crop: 'Στάδιο Καλλιέργειας',
    dssShared_cat_history: 'Ιστορικό Ποτισμάτων',
    dssShared_cat_soil_properties: 'Τύπος Εδάφους',
    dssShared_cat_trends: 'Τάσεις Υγρασίας',
    dssShared_cat_risk_flags: 'Ειδοποιήσεις',
    dssShared_cat_interactions: 'Συνδυαστικοί Δείκτες',
    dssShared_cat_projection: 'Εκτίμηση Επόμενων Ημερών',
    dssShared_cat_saturation: 'Κίνδυνος Κορεσμού',
    dssShared_cat_temporal: 'Εποχή / Ημερομηνία',
    dssShared_cat_zone_hydraulics: 'Δίκτυο Άρδευσης',
    dssShared_cat_other: 'Λοιπά',
    dssReason_RAIN_SKIP: 'Βροχή, δεν χρειάζεται άρδευση',
    dssReason_WAI_LOW: 'Χαμηλή υγρασία, χρειάζεται άρδευση',
    dssReason_SOIL_ADEQUATE: 'Το έδαφος έχει αρκετή υγρασία',
    dssReason_ET_HIGH: 'Υψηλή εξάτμιση · ξηραίνεται γρήγορα',
    dssReason_STRESS_RISK: 'Κίνδυνος στρες φυτού',
    dssReason_FC_REACHED: 'Το έδαφος γεμάτο νερό',
    dssReason_GROWTH_STAGE: 'Στάδιο ανάπτυξης φυτού',
    dssReason_TEMP_LOW: 'Χαμηλή θερμοκρασία',
    dssReason_TEMP_HIGH: 'Πολύ ζέστη · αυξημένες ανάγκες',
    dssReason_RECENT_IRRIGATION: 'Πότισε πρόσφατα',
    dssReason_DEFAULT: 'Κανονική απόφαση',
    dssReason_ROOTZONE_STRESSED: 'Ρίζες σε στρες · χρειάζεται νερό',
    dssReason_ML_DECISION: 'Αξιολόγηση αλγορίθμου',
    dssReason_WAI_THRESHOLD: 'Υγρασία κάτω από ασφαλές όριο',
    dssReason_HIGH_ET: 'Υψηλή εξάτμιση · ξηραίνεται γρήγορα',
    dssReason_FORECAST_RAIN: 'Αναμένεται βροχή',
    dssReason_SOIL_SATURATION: 'Κορεσμός εδάφους, χωρίς άρδευση',
    dssReason_STALE_SENSOR: 'Ο αισθητήρας δεν ενημερώθηκε',
    dssReason_FROST_RISK: 'Κίνδυνος παγετού',
    dssReason_SUFFICIENT_MOISTURE: 'Αρκετή υγρασία · δεν χρειάζεται',
    // Backend DSSRecommendation + Decision reason_code exact-match keys
    dssReasonCode_ROOTZONE_BELOW_MIN: 'Η υγρασία εδάφους είναι κάτω από το ελάχιστο όριο. Χρειάζεται άρδευση.',
    dssReasonCode_ROOTZONE_STRESSED: 'Το ριζόστρωμα σε καταπόνηση. Επείγουσα άρδευση.',
    dssReasonCode_SOIL_ADEQUATE: 'Η υγρασία εδάφους είναι ικανοποιητική. Δεν χρειάζεται άρδευση.',
    dssReasonCode_TENSION_ADEQUATE: 'Η υγρασία εδάφους είναι επαρκής. Δεν χρειάζεται άρδευση.',
    dssReasonCode_TENSION_IRRIGATE: 'Η τάση εδάφους είναι υψηλή. Συνιστάται άρδευση.',
    dssReasonCode_PROBE_IRRIGATE: 'Και οι δύο αισθητήρες δείχνουν ότι το έδαφος στεγνώνει. Συνιστάται άρδευση.',
    dssReasonCode_PROBE_PREPARE: 'Το έδαφος στεγνώνει. Προετοιμασία άρδευσης.',
    dssReasonCode_PROBE_ADEQUATE: 'Η υγρασία εδάφους είναι επαρκής. Δεν χρειάζεται άρδευση.',
    dssReasonCode_RAIN_EXPECTED: 'Αναμένεται βροχή. Η άρδευση αναβάλλεται.',
    dssReasonCode_ZONE_CAPACITY_UNCONFIGURED: 'Η διάταξη ποτίσματος αυτής της ζώνης δεν έχει ρυθμιστεί, οπότε δεν δίνεται διάρκεια.',
    dssReasonCode_DRYING_TREND: 'Το έδαφος στεγνώνει σταθερά. Πλησιάζει η άρδευση.',
    dssReasonCode_FROST_PROTECT: 'Προβλέπεται παγετός. Η άρδευση μπορεί να χρησιμοποιηθεί για προστασία.',
    dssReasonCode_OFF_SEASON: 'Εκτός περιόδου άρδευσης.',
    dssReasonCode_OFF_SEASON_DRY: 'Εκτός περιόδου άρδευσης, αλλά το έδαφος στέγνωσε. Ελέγξτε το χωράφι.',
    dssReasonCode_IRRIGATING: 'Η ζώνη ποτίζεται τώρα.',
    dssReasonCode_JUST_IRRIGATED: 'Η ζώνη μόλις ποτίστηκε. Η μέτρηση θα το δείξει σε λίγο.',
    dssReasonCode_MARGINAL_HIGH_ET: 'Η υγρασία είναι οριακή και η ζήτηση νερού υψηλή. Παρακολουθήστε τη ζώνη.',
    dssReasonCode_NO_SENSOR_DATA: 'Δεν υπάρχει πρόσφατη μέτρηση για αυτή τη ζώνη.',
    dssReasonCode_OK: 'Η υγρασία εδάφους είναι στο υγιές εύρος.',
    dssReasonCode_RECENTLY_IRRIGATED: 'Ποτίστηκε πρόσφατα. Δεν χρειάζεται ενέργεια.',
    dssReasonCode_RECENT_RAIN: 'Πρόσφατη βροχή αναπλήρωσε το έδαφος.',
    dssReasonCode_SATURATED: 'Το έδαφος είναι κορεσμένο. Η άρδευση αναστέλλεται.',
    dssReasonCode_FORECAST_HEAT: 'Αναμένονται υψηλές θερμοκρασίες · αυξημένη ανάγκη νερού.',
    dssReasonCode_DEFICIT_GROWING: 'Αυξανόμενο υδατικό έλλειμμα εδάφους · συνιστάται άρδευση.',
    dssReasonCode_KC_PEAK: 'Η καλλιέργεια στο στάδιο κορύφωσης υδατικής ζήτησης (άνθηση/καρπόδεση).',
    dssReasonCode_PRODUCTION_GOAL: 'Υψηλός στόχος παραγωγής απαιτεί επιπλέον άρδευση.',
    dssReasonCode_ML_MODEL: 'Προσαρμοστική σύσταση βάσει ιστορικών δεδομένων εδάφους και καιρού.',
    dssReasonCode_RAIN_FORECAST: 'Αναμένεται βροχή. Η άρδευση παραλείφθηκε.',

    // ── DSS How-It-Works (DSSPageHowItWorks.js) ─────────────────────
    dssHow_archTitle: 'Αρχιτεκτονική Τριών Επιπέδων',
    dssHow_archSubtitle: 'Κάθε απόφαση άρδευσης περνά από φυσική αξιολόγηση, μηχανική μάθηση και ελέγχους ασφαλείας · τρία ανεξάρτητα επίπεδα που αλληλοσυμπληρώνονται.',
    dssHow_finalOutput: 'Τελική Έξοδος',
    dssHow_executionExample: 'Παράδειγμα Εκτέλεσης',
    dssHow_realExampleCaption: 'Πραγματικό παράδειγμα · {date}, αγρός Σαφαρίκα',
    dssHow_step1_title: 'Δεδομένα',
    dssHow_step2_title: 'Φυσική',
    dssHow_step3_title: 'ML + Κανόνες',
    dssHow_status: 'Κατάσταση',
    dssHow_pIrrigate: 'P(πότισμα)',
    dssHow_reason: 'Κωδικός',
    dssHow_finalDecision: 'Τελική Απόφαση',
    dssHow_irrigateWithDur: '✓ Άρδευση {dur} min',
    dssHow_irrigate: '✓ Άρδευση',
    dssHow_tier1_title: 'Συλλογή Δεδομένων',
    dssHow_tier1_subtitle: '6 πηγές δεδομένων',
    dssHow_tier1_item1: 'Ποια είναι η υγρασία εδάφους τώρα; (10/20/30 cm)',
    dssHow_tier1_item2: 'Τι λέει η πρόγνωση καιρού για τις επόμενες 48 ώρες;',
    dssHow_tier1_item3: 'Σε ποιο στάδιο βρίσκεται η καλλιέργεια; (BBCH → Kc → ανάγκη νερού)',
    dssHow_tier1_item4: 'Τι ποτίστηκε τις τελευταίες 7 ημέρες;',
    dssHow_tier1_output: 'Στιγμιότυπο ζώνης · 85 χαρακτηριστικά ανά μέτρηση',
    dssHow_tier2_title: 'Φυσική Αξιολόγηση',
    dssHow_tier2_subtitle: 'FAO-56, ερμηνεύσιμη βάση',
    dssHow_tier2_item1: 'Είναι ο WAI κάτω από το κατώφλι για αυτό το στάδιο ανάπτυξης;',
    dssHow_tier2_item2: 'Πόσο νερό χρειάζεται η καλλιέργεια σήμερα; (ET₀ × Kc)',
    dssHow_tier2_item3: 'Σε πόσες ημέρες θα φτάσει η καταπόνηση;',
    dssHow_tier2_item4: 'Υπάρχει κίνδυνος κορεσμού ή παγετού;',
    dssHow_tier2_output: 'Δείκτης WAI + 74 σήματα για εκπαίδευση ML',
    dssHow_tier3_title: 'ML + Ασφαλιστικές Δικλείδες',
    dssHow_tier3_subtitle: 'Ταξινομητής XGBoost + σκληροί κανόνες',
    dssHow_tier3_item1: 'Συμφωνεί το μοντέλο XGBoost με το φυσικό σήμα;',
    dssHow_tier3_item2: 'Πόσα λεπτά άρδευσης χρειάζονται για να αποκατασταθεί η υδατοϊκανότητα;',
    dssHow_tier3_item3: 'Παρακάμπτει κάποιος κανόνας ασφαλείας το ML;',
    dssHow_tier3_item4: 'Ποιο είναι το επίπεδο εμπιστοσύνης και ο κωδικός αιτίας;',
    dssHow_tier3_output: 'Απόφαση + Διάρκεια + Βεβαιότητα + Εξήγηση',
    dssHow_out_decision_label: 'Απόφαση',
    dssHow_out_decision_desc: 'Πότισε ή αναβολή',
    dssHow_out_duration_label: 'Διάρκεια',
    dssHow_out_duration_desc: 'Λεπτά (από έλλειμμα εδάφους)',
    dssHow_out_priority_label: 'Σειρά',
    dssHow_out_priority_desc: 'Προτεραιότητα ζώνης',
    dssHow_out_explanation_label: 'Εξήγηση',
    dssHow_out_explanation_desc: 'Βασικοί παράγοντες',
    dssHow_out_bestHour_label: 'Ώρα',
    dssHow_out_bestHour_desc: 'Βέλτιστη ώρα',

    // ── DSS Decision Trace / Crop Science (DSSPageDecisionTrace.js) ──
    dssTrace_title: 'Επιστήμη Καλλιέργειας & Βαθμονόμηση',
    dssTrace_subtitle: 'Τα κατώφλια WAI και οι συντελεστές Kc αλλάζουν σε κάθε στάδιο ανάπτυξης. Το σύστημα βαθμονομήθηκε με εργαστηριακή ανάλυση εδάφους και 13 μήνες αισθητήρων από τον αγρό Σαφαρίκα.',
    dssTrace_waiThreshold: 'Κατώφλι WAI',
    dssTrace_soilLab_title: 'Ανάλυση Εδάφους (Εργαστήριο)',
    dssTrace_soilLab_caption: 'Αγρός Σαφαρίκα · Βέροια (Μάρτιος 2026)',
    dssTrace_soilLab_sand: 'Άμμος',
    dssTrace_soilLab_silt: 'Ιλύς',
    dssTrace_soilLab_clay: 'Άργιλος',
    dssTrace_soilLab_usda: 'Τύπος USDA',
    dssTrace_soilLab_clayValue: 'Αργιλώδες',
    dssTrace_soilLab_wp: 'Σημείο μάρανσης (ΣΜ)',
    dssTrace_soilLab_fc: 'Υδατοϊκανότητα (ΥΙ)',
    dssTrace_soilLab_method: 'Μέθοδος',
    dssTrace_soilLab_methodValue: 'Επιστημονικό μοντέλο εδάφους',
    dssTrace_soilLab_physicsNote: 'Κάτω από WP=26.6%: τα ριζικά τριχίδια δεν μπορούν να αντλήσουν νερό · μη αναστρέψιμη βλάβη. Πάνω από FC=39.6%: κορεσμός · έλλειψη οξυγόνου.',
    dssTrace_history_title: 'Ιστορικά Δεδομένα',
    dssTrace_history_period: 'Περίοδος',
    dssTrace_history_periodValue: 'Απρ 2024 · Αύγ 2025',
    dssTrace_history_duration: 'Διάρκεια',
    dssTrace_history_durationValue: '13 μήνες',
    dssTrace_history_hourly: 'Ωριαίες μετρήσεις',
    dssTrace_history_depths: 'Βάθη αισθητήρων',
    dssTrace_history_detected: 'Εντοπισμένες αρδεύσεις',
    dssTrace_history_detectedValue: '76 ημέρες',
    dssTrace_ml_title: 'Εκπαίδευση ML',
    dssTrace_ml_cvHeading: 'Διαφυγή-ενός-μήνα (leave-one-month-out)',
    dssTrace_ml_meanF1: 'Μέσο F1',
    dssTrace_ml_stdDev: 'Τυπ. απόκλιση',
    dssTrace_ml_bestMonth: 'Καλύτερος μήνας',
    dssTrace_ml_hardestMonth: 'Δυσκολότερος μήνας',
    dssTrace_ml_cvFooter: '{n} μήνες · κάθε μήνας αξιολογήθηκε ξεχωριστά',
    dssTrace_ml_timeSplit: 'Χρονική διάρθρωση',
    dssTrace_ml_train: 'Εκπαίδευση: Απρ·Οκτ 2024 (7μ)',
    dssTrace_ml_eval: 'Αξιολόγηση: Μαΐ·Αύγ 2025',
    dssTrace_ml_features: 'Χαρακτηριστικά',
    dssTrace_ml_algorithm: 'Αλγόριθμος',
    dssTrace_ml_threshold: 'Κατώφλι P(πότισμα)',
    dssTrace_temporal_title: 'Χρονικό Πλαίσιο (Rolling Features)',
    dssTrace_temporal_caption: 'Σωρευτικά χαρακτηριστικά που υπολογίστηκαν από τα ιστορικά δεδομένα αισθητήρων · παρέχουν στο ML χρονική μνήμη πέρα από τη στιγμιαία ένδειξη.',
    dssTrace_temporal_avg: 'Μέσο',
    dssTrace_temporal_peak: 'Μέγιστο',
    dssTrace_temporal_etTitle: 'Έλλειμμα ET (7 ημέρες)',
    dssTrace_temporal_etDesc: 'Άθροισμα (ETc − βροχή) 7 ημερών',
    dssTrace_temporal_stressTitle: 'Συνεχόμενες Ώρες Στρες',
    dssTrace_temporal_stressDesc: 'Ώρες με WAI κάτω από κατώφλι',
    dssTrace_temporal_droughtTitle: 'Ημέρες Ξηρασίας',
    dssTrace_temporal_droughtDesc: 'Ημέρες χωρίς βροχή >2mm',
    dssTrace_chart_title: 'Δυναμική Καλλιέργειας Ακτινιδίου · Kc & Κατώφλι WAI ανά Στάδιο BBCH',
    dssTrace_chart_caption: 'Ο συντελεστής Kc (ανάγκη σε νερό) και το κατώφλι WAI (πότε ποτίζουμε) αλλάζουν καθ\' όλη τη σεζόν · στην ανθοφορία (BBCH 60) το σύστημα γίνεται πιο προστατευτικό (WAI 70%) γιατί η καρπόδεση κινδυνεύει.',
    dssTrace_chart_xAxis: 'Στάδιο BBCH',
    dssTrace_chart_yAxis: 'Κατώφλι WAI',
    dssTrace_chart_legend_kc: 'Kc (ανάγκη νερού)',
    dssTrace_chart_legend_wai: 'WAI κατώφλι (πότε ποτίζουμε)',
    dssTrace_chart_legend_flowering: 'Ανθοφορία (BBCH 60·75)',
    dssTrace_chart_callout: 'BBCH 60·75: Ανθοφορία & Καρπόδεση · το σύστημα αυξάνει το κατώφλι σε 70% WAI. Ζημιά σε αυτό το στάδιο δεν αναστρέφεται.',
    dssTrace_stage_0: 'Αδράνεια',
    dssTrace_stage_10: 'Εκβλάστηση',
    dssTrace_stage_30: 'Βλαστοφορία',
    dssTrace_stage_50: 'Ταξιανθία',
    dssTrace_stage_60: 'Ανθοφορία',
    dssTrace_stage_70: 'Καρποφορία',
    dssTrace_stage_80: 'Ωρίμανση',
    dssTrace_stage_90: 'Μετασυλλεκτικά',

    // ── DSS Water Balance (DSSPageWaterBalance.js) ──────────────────
    dssWater_noData: 'Δεν υπάρχουν δεδομένα',
    dssWater_kpi_farmer: 'Παραγωγός',
    dssWater_kpi_dssDiff: 'Διαφορά DSS',
    dssWater_kpi_irrigations: 'αρδεύσεις',
    dssWater_kpi_extraDays: 'επιπλέον ημέρες',
    dssWater_kpi_unitMin: 'λ',
    dssWater_kpi_unitDay: 'ημ.',
    dssWater_kpi_water: 'νερού',
    dssWater_interpretation: 'Το DSS προτείνει συχνότερα αλλά μικρότερης διάρκειας ποτίσματα. Αντί για λίγα μεγάλα ποτίσματα, διατηρεί σταθερή υγρασία εδάφους κοντά στην υδατοϊκανότητα · αποτρέποντας καταπόνηση κατά την ανθοφορία.',
    dssWater_interpretationAvg: ' Μέση διάρκεια ανά άρδευση: {min} λεπτά.',
    dssWater_chart_title: 'Ώρες Άντλησης ανά Μήνα',
    dssWater_chart_caption: 'Εκτιμώμενες ώρες λειτουργίας αντλίας παραγωγού vs DSS ανά μήνα',
    dssWater_chart_yAxis: 'Ώρες',
    dssWater_chart_farmerHours: 'Παραγωγός (ώρες)',
    dssWater_chart_dssHours: 'DSS (ώρες)',
    dssWater_chart_agreementPct: 'Συμφωνία %',

    // Devices page, unified hardware list (GET /api/devices/)
    devicesPageTitle: 'Συσκευές',
    devicesPageSubtitle: 'Όλοι οι ελεγκτές και οι πύλες αισθητήρων, και τι χρειάζεται προσοχή.',
    devicesEmpty: 'Δεν υπάρχουν καταχωρημένες συσκευές ακόμα.',
    devicesNeedAttention: 'χρειάζονται προσοχή',
    devicesJobsStale: 'Οι αυτόματες εργασίες του συστήματος έχουν σταματήσει. Οι νέες μετρήσεις δεν επεξεργάζονται, οπότε μια συσκευή που φαίνεται συνδεδεμένη μπορεί να μην είναι.',
    deviceStateOnline: 'Συνδεδεμένη',
    deviceStateOffline: 'Εκτός σύνδεσης',
    deviceStateNeverSeen: 'Ποτέ δεν συνδέθηκε',
    deviceStateSpare: 'Χωρίς χωράφι',
    deviceStateLab: 'Πάγκος δοκιμών',
    deviceLabChoice: 'Πάγκος δοκιμών (χωρίς χωράφι, οι μετρήσεις δεν αποθηκεύονται)',
    deviceStateDegraded: 'Χρειάζεται προσοχή',
    deviceStateUnregistered: 'Μη καταχωρημένη',
    deviceHealthBattery: 'Μπαταρία',
    deviceHealthSignal: 'Σήμα',
    deviceHealthFirmware: 'Firmware',
    deviceHealthNextExpected: 'Επόμενη αναμενόμενη μέτρηση',
    deviceHealthNextExpectedOverdue: 'Καθυστερεί, αναμενόταν',
    deviceRegisterThis: 'Καταχώρηση',
    deviceTelemetryShow: 'Εμφάνιση τηλεμετρίας',
    deviceTelemetryLast: 'Τελευταία',
    deviceTelemetryNote: 'Η τάση (cb) είναι αντίστροφη της υγρασίας: χαμηλή = υγρό, υψηλή = ξηρό.',
    deviceTelemetryEmpty: 'Δεν υπάρχουν ακόμη δεδομένα καναλιού.',
    deviceTelemetryError: 'Αποτυχία φόρτωσης τηλεμετρίας.',
    deviceKindController: 'Ελεγκτής βανών',
    deviceKindGateway: 'Πύλη αισθητήρων',
    deviceKindProbe: 'Αισθητήρας σε πύλη IoT',
    deviceVia: 'Μεταδίδει μέσω',
    deviceKindStation: 'Σταθμός αισθητήρων',
    deviceLastSeen: 'Τελευταία επικοινωνία',
    deviceLastSeenNever: 'Ποτέ',
    deviceField: 'Χωράφι',
    deviceZone: 'Ζώνη',
    deviceUnassigned: 'Δεν έχει συνδεθεί με χωράφι',
    deviceMapping: 'Καλωδίωση',
    deviceMappingEmpty: 'Δεν έχει συνδεθεί κανένα κανάλι ακόμα.',
    deviceMappingRelay: 'Ρελέ',
    deviceMappingChannel: 'Κανάλι',
    deviceMappingDepth: 'εκ. βάθος',
    deviceTestButton: 'Δοκιμή',
    deviceTestSent: 'Ο παλμός δοκιμής στάλθηκε',
    deviceTestFailed: 'Αποτυχία αποστολής παλμού δοκιμής',
    deviceEditMapping: 'Επεξεργασία καλωδίωσης',
    deviceAssignButton: 'Ανάθεση σε χωράφι',
    devicePlainLanguageNote: 'Τι σημαίνει αυτό',
    deviceBindingDialogTitle: 'Σύνδεση καναλιού σε ζώνη',
    deviceBindingChannelLabel: 'Κανάλι',
    deviceBindingChannelHelp: "π.χ. 'relay:0' για βάνα, 's0.0' για αισθητήρα διεύθυνση 0 κανάλι 0",
    deviceBindingZoneLabel: 'Ζώνη',
    deviceBindingRoleLabel: 'Μετράει',
    deviceBindingDepthLabel: 'Βάθος (εκ.)',
    deviceBindingSave: 'Αποθήκευση καλωδίωσης',
    deviceBindingCancel: 'Ακύρωση',
    deviceBindingDelete: 'Αφαίρεση',
    deviceBindingAdd: 'Προσθήκη καναλιού',
    deviceBindingSaved: 'Η καλωδίωση αποθηκεύτηκε',
    deviceBindingSaveFailed: 'Αποτυχία αποθήκευσης, ελέγξτε τα παρακάτω πεδία',
    deviceBindingDeleteConfirm: 'Αφαίρεση αυτής της σύνδεσης καναλιού;',
    deviceBindingEdit: 'Επεξεργασία',
    deviceBindingEditDialogTitle: 'Επεξεργασία σύνδεσης καναλιού',
    deviceRoleValve: 'Βάνα (ανοίγει άρδευση)',
    deviceRoleVwc: 'Υγρασία εδάφους',
    deviceRoleSoilTemp: 'Θερμοκρασία εδάφους',
    deviceRoleSalinity: 'Αλατότητα',
    unboundZonesWarning: 'ζώνη(ες) έχουν ρυθμιστεί σε ελεγκτή αλλά δεν έχουν συνδεδεμένο κανάλι, η άρδευσή τους δεν θα κάνει τίποτα.',

    // Επεξεργασία / διαγραφή υπάρχουσας συσκευής
    deviceEditButton: 'Επεξεργασία συσκευής',
    deviceDeleteButton: 'Αφαίρεση συσκευής',
    deviceDeleteConfirm: 'Αφαίρεση αυτής της συσκευής; Δεν μπορεί να αναιρεθεί.',
    deviceEditDialogTitle: 'Επεξεργασία συσκευής',
    deviceDisplayNameLabel: 'Όνομα εμφάνισης',
    deviceDisplayNameHelp: 'Το όνομα που εμφανίζεται σε αυτή τη σελίδα. Αφήστε το κενό για να χρησιμοποιηθεί το τεχνικό αναγνωριστικό.',
    deviceEditNotesLabel: 'Σημειώσεις',
    deviceStatusLabel: 'Τι συμβαίνει με τη συσκευή',
    deviceStatusAssigned: 'Εγκατεστημένη και σε λειτουργία',
    deviceStatusSpare: 'Στην αποθήκη',
    deviceStatusMoving: 'Σε μετακίνηση',
    deviceStatusStopped: 'Εκτός λειτουργίας',
    deviceStatusRetired: 'Αποσύρθηκε',
    deviceStatusHelp: 'Αν δεν είναι εγκατεστημένη, δεν τροφοδοτεί κανένα κτήμα και δεν βγάζει ειδοποίηση. Το κτήμα της μένει καταγεγραμμένο.',
    deviceChangesTitle: 'Τελευταίες αλλαγές',
    deviceChangesAll: 'Όλο το ιστορικό και αναίρεση',
    deviceChangesCreated: 'Προστέθηκε',
    deviceChangesEdited: 'Άλλαξαν στοιχεία',
    deviceEditActiveLabel: 'Κατάσταση',
    deviceEditActiveYes: 'Ενεργή',
    deviceEditActiveNo: 'Ανενεργή',
    deviceEditRegenerateToken: 'Δημιουργία νέου token',
    deviceEditSave: 'Αποθήκευση',
    historyTabChanges: 'Αλλαγές',
    historyTabActivity: 'Ενέργειες',
    activityLogin: 'Σύνδεση',
    activityLoginFailed: 'Αποτυχημένη σύνδεση',
    activityLogout: 'Αποσύνδεση',
    activityRequest: 'Ενέργεια',
    activityValveTest: 'Δοκιμή βάνας',
    activityEmergencyStop: 'Έκτακτη διακοπή',
    activityStop: 'Διακοπή άρδευσης',
    activityStart: 'Έναρξη άρδευσης',
    activityBroadcast: 'Μήνυμα σε όλους',
    activityUndo: 'Αναίρεση αλλαγής',
    activityDownload: 'Λήψη αρχείου',
    activityNobody: 'Χωρίς σύνδεση',
    activityFilter: 'Είδος',
    activityNone: 'Δεν υπάρχουν ενέργειες ακόμη.',
    activityPerson: 'Πρόσωπο',
    deviceMoveNote: 'Αλλάξτε το κτήμα όταν η μονάδα σταθεί στη νέα της θέση. Το νέο κτήμα τη δείχνει από το επόμενο μήνυμά της και η αλλαγή καταγράφεται στο ιστορικό.',
    deviceEditSaveFailed: 'Αποτυχία αποθήκευσης, ελέγξτε τα παρακάτω πεδία',

    // Ταμπλό VWCw (εντός εφαρμογής, ίδιο με το PDF του πελάτη)
    vwPanelRecommendation: 'Προτεινόμενη άρδευση',
    vwPanelMoisture: 'Σταθμισμένη υγρασία ριζοστρώματος',
    vwPanelSensors: 'Αισθητήρες εδάφους',
    vwPanelForecast: 'Πρόβλεψη TerraMind',
    vwPanelForecastNoIrr: 'Πρόβλεψη χωρίς άρδευση',
    vwPanelForecastBoth: 'Πρόβλεψη με και χωρίς άρδευση',
    vwForecastWithRun: 'Με την προτεινόμενη άρδευση',
    vwForecastNoRun: 'Χωρίς άρδευση',
    vwPanelForecastAfterIrr: 'Πρόβλεψη μετά τη σημερινή άρδευση',
    vwPanelTrend: 'Τάση τελευταίων 48 ωρών',
    vwDecisionIrrigateNow: 'Άρδευση τώρα',
    vwDecisionIrrigate: 'Άρδευση σήμερα',
    vwDecisionMonitor: 'Παρακολούθηση',
    vwDecisionSkip: 'Καμία ενέργεια',
    vwDecisionSuspend: 'Αναστολή (πολύ υγρό)',
    vwDecisionNa: 'Μη διαθέσιμο',
    vwTensionBasis: 'Βάσει εδαφικής τάσης',
    vwTensionByDepth: 'Εδαφική τάση ανά βάθος',
    vwTensionTrigger: 'Άρδευση πάνω από',
    vwTensionHint: 'υψηλότερο cb = πιο ξηρό έδαφος',
    vwTimingNow: 'Τώρα',
    vwTimingToday: 'Σήμερα',
    vwTimingSuspend: 'Καμία άρδευση',
    vwTimingNot24h: 'Όχι εντός 24 ωρών',
    vwTimingLt6h: 'Σε λιγότερο από 6 ώρες',
    vwTiming612: 'Σε 6 έως 12 ώρες',
    vwTiming1224: 'Σε 12 έως 24 ώρες',
    vwZoneCritical: 'Κρίσιμη',
    vwZoneWarning: 'Προειδοποίηση',
    vwZoneTarget: 'Στόχος',
    vwZoneHigh: 'Υψηλή',
    vwZoneFilling: 'Πλήρωση',
    vwZoneExcess: 'Υπερβολική',
    vwDuration: 'Διάρκεια',
    vwMinutes: 'λεπτά',
    vwNetDose: 'Καθαρή δόση',
    vwTargetZone: 'Ζώνη στόχου',
    vwNow: 'Τώρα',
    vwHourShort: 'ω',
    vwNextEntry: 'Εκτιμώμενη είσοδος στη ζώνη άρδευσης',
    vwNoIrrigation24h: 'Δεν αναμένεται ανάγκη άρδευσης στο επόμενο 24ωρο',
    vwNoForecast: 'Η πρόβλεψη δεν είναι διαθέσιμη',
    vwLegendVwcw: 'Σταθμισμένη υγρασία',
    vwGaugeMoisture: 'Υγρασία',
    zoneOpenDetails: 'Άνοιγμα ζώνης',
    vwLegendIrrigation: 'Άρδευση',
    vwRain24h: 'Βροχή 24ω',
    vwHeroNoIrrigation: 'Δεν χρειάζεται άρδευση σήμερα',
    vwHeroIrrigate: 'Άρδευση',
    vwHeroSuspend: 'Χωρίς άρδευση: το έδαφος είναι πολύ υγρό',
    vwHeroNextDuration: 'Επόμενη άρδευση, όταν χρειαστεί',
    vwHeroUpdates: 'Ενημερώνεται με κάθε νέα μέτρηση',
    vwHeroUpdatesEstimate: 'Ενημερώνεται κάθε ώρα από τον καιρό',
    vwCtxLastReading: 'τελευταία μέτρηση',
    vwCtxEstimatedAt: 'εκτίμηση',
    vwCtxMaxTemp: 'Μέγιστη θερμοκρασία',
    vwCtxWaterDemand: 'Εξάτμιση νερού',
    vwCtxStage: 'Στάδιο ανάπτυξης',
    stageEdit: 'Διόρθωση σταδίου ανάπτυξης',
    stageDialogTitle: 'Στάδιο ανάπτυξης του χωραφιού',
    stageDialogHelp: 'Διαλέξτε το στάδιο που βλέπετε σήμερα στο χωράφι. Το ημερολόγιο συνεχίζει από εκεί και η σύσταση το ακολουθεί.',
    stageCorrectedNote: 'Έχετε διορθώσει το στάδιο αυτή τη σεζόν.',
    stageReset: 'Επαναφορά στο ημερολόγιο',
    stageOutOfReach: 'Το στάδιο αυτό απέχει πάνω από 60 ημέρες από το ημερολόγιο. Διαλέξτε ένα πιο κοντινό.',
    stageLocked: 'Το χωράφι είναι κλειδωμένο.',
    stageSaveError: 'Δεν αποθηκεύτηκε. Δοκιμάστε ξανά.',
    vwCtxSoil: 'Έδαφος',
    vwCtxSoilLimits: 'υδατοϊκανότητα / σημείο μάρανσης',
    vwRainDay: 'Βροχή',
    vwStale: 'Καθυστερημένα δεδομένα',
    liveRecReading: 'Μέτρηση',
    liveRecEstimate: 'Εκτίμηση',
    mobileNoReadings: 'Χωρίς μετρήσεις ακόμη',
    vwRetry: 'Επανάληψη',
    vwLoadError: 'Δεν ήταν δυνατή η φόρτωση του ταμπλό.',
    vwNoProfile: 'Ο τύπος εδάφους αυτού του χωραφιού δεν έχει ακόμη πίνακα ορίων VWCw. Ορίστε υποστηριζόμενη υφή εδάφους (αργιλώδες, ιλυοαργιλώδες, ιλυώδες, πηλώδες ή πηλοαμμώδες) για να ενεργοποιηθεί το ταμπλό.',
    vwNoData: 'Δεν φτάνουν ακόμη μετρήσεις αισθητήρων σε αυτό το χωράφι. Μόλις αναφέρουν οι αισθητήρες, το ταμπλό θα συμπληρωθεί.',
    vwProvisionalSoil: 'Προσωρινά όρια εδάφους, αυτές οι ζώνες είναι εκτιμήσεις FAO-56, δεν έχουν ακόμη επιβεβαιωθεί από τον γεωπόνο. Η σύσταση είναι ενδεικτική έως ότου εγκριθεί το προφίλ εδάφους του χωραφιού.',
    provisionalShort: 'εκτ.',
    vwcwTooltip: 'Σταθμισμένη υγρασία ριζοστρώματος (VWCw), η μετρική άρδευσης του πελάτη, συνδυάζει 10/20/30 cm κατά βάρος βάθους.',
    historyNav: 'Ιστορικό αλλαγών',
    historySubtitle: 'Κάθε αλλαγή και δημιουργία, ποιος την έκανε και πότε. Μπορείτε να αναιρέσετε οποιαδήποτε.',
    historyFilterModel: 'Εμφάνιση',
    historyAll: 'Όλα',
    historyNone: 'Δεν υπάρχουν αλλαγές ακόμη.',
    historyMore: 'Παλαιότερες',
    historySystem: 'Σύστημα',
    historyEmpty: 'κενό',
    historyYes: 'ναι',
    historyNo: 'όχι',
    historyUndo: 'Αναίρεση',
    historyRestore: 'Επαναφορά σε αυτό',
    historyCancel: 'Άκυρο',
    historyConfirmUndo: 'Να αναιρεθεί αυτή η αλλαγή; Θα μείνει στο ιστορικό ως νέα εγγραφή.',
    historyConfirmRestore: 'Να επανέλθει όπως ήταν τη στιγμή αυτή; Οι μεταγενέστερες αλλαγές αντικαθίστανται και μένουν στο ιστορικό.',
    historyDone: 'Έγινε. Το ιστορικό έχει νέα εγγραφή.',
    historyUndoFailed: 'Δεν ολοκληρώθηκε. Δεν άλλαξε τίποτα.',
    historyLoadFailed: 'Το ιστορικό δεν φορτώθηκε.',
    historyTypeCreated: 'Δημιουργία',
    historyTypeChanged: 'Αλλαγή',
    historyTypeDeleted: 'Διαγραφή',
    historyReasonBaseline: 'Η κατάσταση όταν ξεκίνησε το ιστορικό',
    historyReasonPassword: 'Αλλαγή κωδικού',
    historyReasonUndo: 'Αναίρεση',
    historyReasonRestore: 'Επαναφορά',
    historyReasonNames: 'Ενιαία μορφή ονομάτων',
    historyRefusedBaseline: 'Από εδώ ξεκινά το ιστορικό, δεν υπάρχει κάτι να αναιρεθεί.',
    historyRefusedValves: 'Ένα πρόγραμμα μπορεί να ανοίξει βάνα, γι\' αυτό αλλάζει από το πρόγραμμα άρδευσης.',
    historyRefusedPerson: 'Οι λογαριασμοί αλλάζουν μόνο από τον κύριο διαχειριστή.',
    historyRefusedSecret: 'Η συσκευή πρέπει να ρυθμιστεί ξανά, το κλειδί της δεν κρατιέται στο ιστορικό.',
    historyRefusedChanged: 'Η τιμή άλλαξε ξανά από τότε. Χρησιμοποιήστε την επαναφορά για να επιστρέψετε σε αυτή τη στιγμή.',
    historyRefusedNothingBefore: 'Δεν υπάρχει προηγούμενη κατάσταση.',
    historyRefusedInUse: 'Άλλα δεδομένα εξαρτώνται από αυτό, οπότε παραμένει.',
    historyRefusedGone: 'Δεν υπάρχει πια.',
    historyRefusedNothingToUndo: 'Έχει ήδη επανέλθει.',
    historyModelUser: 'Λογαριασμός',
    historyModelPreference: 'Ρυθμίσεις λογαριασμού',
    historyModelSubscription: 'Συνδρομή',
    historyModelField: 'Κτήμα',
    historyModelZone: 'Ζώνη',
    historyModelSoilProfile: 'Προφίλ εδάφους',
    historyModelSensorDevice: 'Αισθητήρας κτήματος',
    historyModelBinding: 'Σύνδεση συσκευής',
    historyModelTreeClass: 'Κατηγορία δέντρου',
    historyModelTree: 'Δέντρο',
    historyModelProduction: 'Παραγωγή',
    historyModelSeason: 'Καλλιεργητική περίοδος',
    historyModelEdgeDevice: 'Ελεγκτής',
    historyModelNote: 'Σημείωση κτήματος',
    historyModelApiKey: 'Κλειδί αισθητήρων',
    historyModelIoTDevice: 'Συσκευή',
    historyModelHub: 'Σταθμός αισθητήρων',
    historyModelDevice: 'Αισθητήρας',
    historyModelSentek: 'Καταγραφικό Sentek',
    historyModelSchedule: 'Άρδευση',
    historyModelWeekly: 'Επαναλαμβανόμενη άρδευση',
    historyModelEvent: 'Συμβάν κτήματος',
    historyModelStation: 'Μετεωρολογικός σταθμός',
    historyModelAlertRule: 'Κανόνας ειδοποίησης',
    historyModelMessage: 'Μήνυμα υποστήριξης',
    historyFieldName: 'Όνομα',
    historyFieldOwner: 'Ιδιοκτήτης',
    historyFieldField: 'Κτήμα',
    historyFieldZone: 'Ζώνη',
    historyFieldLabel: 'Ετικέτα',
    historyFieldStatus: 'Κατάσταση',
    historyFieldNotes: 'Σημειώσεις',
    historyFieldActive: 'Ενεργό',
    historyFieldCrop: 'Καλλιέργεια',
    historyFieldArea: 'Έκταση',
    historyFieldSoil: 'Έδαφος',
    historyFieldDeletedAt: 'Διαγράφηκε στις',
    historyFieldDeletedBy: 'Διαγράφηκε από',
    historyFieldUsername: 'Όνομα χρήστη',
    historyFieldEmail: 'Email',
    historyFieldFirstName: 'Όνομα',
    historyFieldLastName: 'Επώνυμο',
    historyFieldGroups: 'Ρόλος',
    historyFieldStaff: 'Προσωπικό',
    historyFieldSuperuser: 'Κύριος διαχειριστής',
    historyFieldDuration: 'Διάρκεια',
    historyFieldScheduled: 'Ώρα',
    historyFieldDescription: 'Περιγραφή',
    onbTitle: 'Νέος πελάτης',
    onbStepPerson: 'Το πρόσωπο',
    onbStepFields: 'Τα κτήματα',
    onbStepNext: 'Τι απομένει',
    onbExisting: 'Για ποιον',
    onbNewPerson: 'Νέο πρόσωπο',
    onbNoMail: 'Δεν αποστέλλεται email. Θα λάβετε σύνδεσμο για να τον δώσετε όταν έρθει η ώρα.',
    onbFieldsHelp: 'Επιλέξτε αρχείο KML, KMZ ή GeoJSON. Κάθε περίγραμμα γίνεται κτήμα. Συμπληρώστε ό,τι γνωρίζετε, τα υπόλοιπα μπορούν να περιμένουν.',
    onbCrop: 'Καλλιέργεια',
    onbVariety: 'Ποικιλία',
    onbKaek: 'ΚΑΕΚ',
    onbPlanted: 'Φύτευση',
    onbTrees: 'Δέντρα',
    onbCaco3: 'Ανθρακικό ασβέστιο %',
    onbOrganic: 'Οργανική ουσία %',
    onbEc: 'Αγωγιμότητα mS/cm',
    onbNext: 'Επόμενο',
    onbSkipFields: 'Αργότερα',
    onbDone: 'Ο λογαριασμός {name} έχει {n} νέα κτήματα.',
    onbGoZones: 'Προσθήκη ζωνών στα κτήματα',
    onbGoDevices: 'Σύνδεση αισθητήρων και βανών',
    onbLinkHelp: 'Ο σύνδεσμος για τον ορισμό κωδικού. Δεν στάλθηκε τίποτα, δώστε τον όταν έρθει η ώρα.',
    soilProfiles: 'Προφίλ εδάφους',
    spTitle: 'Προφίλ εδάφους',
    spSubtitle: 'Ελέγξτε και διορθώστε τα όρια υγρασίας για κάθε υφή εδάφους. Η επεξεργασία μιας υφής επηρεάζει όλα τα χωράφια αυτής της υφής.',
    spProvisional: 'Αυτές οι ζώνες είναι εκτιμήσεις FAO-56 που εκκρεμούν την έγκρισή σας. Απενεργοποιήστε το «Προσωρινό» μόλις τις επιβεβαιώσετε.',
    spProvisionalFlag: 'Προσωρινό',
    spFC: 'Υδατοϊκανότητα (%)',
    spWP: 'Σημείο μάρανσης (%)',
    spRootZone: 'Ριζόστρωμα (m)',
    spTensionTrigger: 'Όριο τάσης (cb)',
    spTensionTriggerHelp: 'Ισχύει όπου ο αισθητήρας μετράει τάση, όχι υγρασία',
    spMonth: 'Μήνας',
    spDerived: 'VWCw (αυτόματο)',
    spDerivedHint: 'Υπολογίζεται αυτόματα από τα βάρη και τις ζώνες ανά βάθος.',
    spWeightsSum: 'Τα βάρη βάθους κάθε μήνα πρέπει να αθροίζουν στο 1.0 (οι επισημασμένες γραμμές όχι).',
    spSave: 'Αποθήκευση',
    spResetBtn: 'Επαναφορά προεπιλογής',
    spSaved: 'Το προφίλ αποθηκεύτηκε. Είναι πλέον ενεργό.',
    spReset: 'Επαναφορά στις προεπιλεγμένες τιμές.',
    spSaveError: 'Η αποθήκευση απέτυχε.',
    spResetError: 'Η επαναφορά απέτυχε.',
    spLoadError: 'Δεν ήταν δυνατή η φόρτωση των προφίλ εδάφους.',
    vwRefresh: 'Ανανέωση',
    vwAsOf: 'Στιγμιότυπο',
    vwForecastDays: 'Επόμενες ημέρες',
    vwProvenance: 'Οι συστάσεις βγαίνουν από τους δικούς σας αισθητήρες και την πρόγνωση του καιρού.',
    vwProvenanceEstimate: 'Χωρίς αισθητήρα στο χωράφι: η υγρασία εκτιμάται από τον καιρό, την καλλιέργεια, το έδαφος και τις αρδεύσεις που έχουν καταγραφεί.',
    vwRecentReports: 'Πρόσφατες αναφορές',
    vwReportsNone: 'Δεν έχουν παραχθεί ακόμη αναφορές για αυτό το χωράφι.',
    vwReportsLoadError: 'Δεν ήταν δυνατή η φόρτωση των αναφορών.',
    vwReportsOpenError: 'Δεν ήταν δυνατό το άνοιγμα της αναφοράς.',
    vwReportView: 'Προβολή',
    vwReportDownload: 'Λήψη',
    // Η επίδειξη περιπτέρου (/showcase).
    // Λεζάντες της ξενάγησης. Γραμμένες για να διαβαστούν δυνατά.
    tourIntro: 'Ένα κτήμα με ακτινίδια στη Βέροια. Ένας σταθμός, τρία βάθη, κάθε ώρα.',
    tourDry: 'Πρώτη Οκτωβρίου. Το ριζόστρωμα είναι στο 25 τοις εκατό και πέφτει.',
    tourDepths: 'Τα βάθη διαφωνούν, και εκεί είναι η ουσία. Στα δέκα εκατοστά η υγρασία είναι 21 τοις εκατό, στα τριάντα ακόμη 31. Η επιφάνεια στεγνώνει πρώτη.',
    tourVerdict: 'Η πλατφόρμα ζητάει 50 λεπτά. Δεν είναι πρόγραμμα στην τύχη, είναι νούμερο που βγαίνει από το πόσο στεγνή είναι πραγματικά η ρίζα.',
    tourRainFell: 'Μέσα στη νύχτα πέφτουν 67 χιλιοστά.',
    tourSkip: 'Και η απάντηση αλλάζει μόνη της. Μην ποτίσεις. Δεν χρειάστηκε να ακυρώσει κανείς τίποτα.',
    tourDryDown: 'Ακολουθούν δεκαπέντε μέρες που το χώμα στεγνώνει, ώρα με την ώρα.',
    tourAgain: 'Δεκατρείς Οκτωβρίου. Πότισμα ξανά, 35 λεπτά.',
    tourLonger: 'Τρεις μέρες μετά το ίδιο χωράφι θέλει 50. Όσο στεγνώνει, τόσο περισσότερο ζητάει.',
    tourWhatIf: 'Κι αν η πρόγνωση έλεγε βροχή; Είκοσι χιλιοστά, και η σύσταση υποχωρεί.',
    tourUndo: 'Πίσω σε ό,τι έγινε στην πραγματικότητα.',
    tourSoil: 'Τώρα η ίδια μέτρηση σε αμμώδες έδαφος. Η απόφαση αλλάζει, γιατί αλλάζει ολόκληρη η κλίμακα. Το κρίσιμο όριο πέφτει από 29 τοις εκατό στο 12.',
    tourSoilBack: 'Πίσω στο πραγματικό έδαφος αυτού του χωραφιού, που είναι αργιλώδες.',
    tourShallowRain: 'Δεκαεπτά Οκτωβρίου. Έπεσαν δεκατέσσερα χιλιοστά. Στα δέκα εκατοστά η υγρασία πήδηξε από 21 σε 34, και στα είκοσι εκατοστά δεν κουνήθηκε καθόλου. Η βροχή έβρεξε την επιφάνεια και δεν έφτασε ποτέ στη ρίζα. Ένα βροχόμετρο θα το έλεγε βροχερή μέρα.',
    tourEnd: 'Δεκατέσσερις μέρες, μετρημένες. Κάθε σύσταση βγήκε από την ίδια μηχανή που τρέχει στην πλατφόρμα κάθε πρωί.',
    tourPrev: 'Προηγούμενο βήμα',
    tourNext: 'Επόμενο βήμα',
    tourTakeControl: 'Πάρε τον έλεγχο',
    tourRestart: 'Παίξε την ξενάγηση',
    // Η επισκόπηση του κτήματος και η αναφορά, μέσα στην ξενάγηση.
    farmTitle: 'Τα χωράφια μου',
    farmIntro: 'Έξι χωράφια, και η πλατφόρμα λέει καθαρά τι μπορεί να κάνει στο καθένα.',
    farmTotalFields: 'χωράφια',
    farmTotalMonitored: 'στέλνουν μετρήσεις',
    farmTotalControllable: 'ανοίγουν βάνα',
    farmZones: '{n} ζώνες',
    farmMonLive: 'Αισθητήρας ενεργός',
    farmMonStale: 'Αισθητήρας σιωπηλός',
    farmMonSilent: 'Αισθητήρας εκτός',
    farmMonNone: 'Χωρίς αισθητήρα',
    farmCtlReady: 'Βάνα έτοιμη',
    farmCtlOffline: 'Βάνα εκτός',
    farmCtlNone: 'Χωρίς βάνα',
    reportTitle: 'Η πρωινή αναφορά',
    reportIntro: 'Έρχεται με email και μένει μέσα στην πλατφόρμα, οπότε είναι εκεί από οποιαδήποτε συσκευή.',
    reportStamp: 'μετρήσεις από τον σταθμό 810',
    reportVerdictLabel: 'Σήμερα',
    reportWater: 'Πότισμα {n} λεπτά',
    reportNoWater: 'Δεν χρειάζεται άρδευση',
    reportRowMoisture: 'Υγρασία ριζοστρώματος',
    reportRowZone: 'Ζώνη',
    reportRowDepths: 'Στα 10 / 20 / 30 cm',
    reportRowRain: 'Βροχή της ημέρας',
    reportRowTemp: 'Μέγιστη θερμοκρασία',
    reportRowHours: 'Ώρες που ζητούσε νερό',
    reportHoursValue: '{n} από 24',
    tourFarm: 'Αυτό είναι το κτήμα όπως το βλέπει η πλατφόρμα. Έξι χωράφια, μία οθόνη, κάθε πρωί.',
    tourFarmMix: 'Και λέει καθαρά τι μπορεί να κάνει στο καθένα. Δύο χωράφια τα μετράει και τα ποτίζει. Δύο μόνο τα ποτίζει. Ένα έχει αισθητήρα και καμία βάνα. Κανείς δεν χρειάζεται να μαντέψει.',
    tourSubject: 'Σε αυτό εδώ είναι ο αισθητήρας που θα παρακολουθήσουμε, για δεκαπέντε μέρες.',
    tourReport: 'Και αυτή φτάνει κάθε πρωί. Τα ίδια νούμερα, σε μία σελίδα, μέσα στην πλατφόρμα και όχι μόνο σε ένα email.',
    controlTitle: 'Και το πότισμα, από εδώ',
    controlIntro: 'Τρεις ζώνες σε έναν ελεγκτή, τον {device}, και οι τρεις απαντούν.',
    controlZone: 'Ζώνη {n}',
    controlRelay: 'Βάνα {n}',
    controlOnline: 'Απαντά',
    controlOffline: 'Εκτός',
    controlStart: 'Έναρξη',
    controlRunning: 'Ποτίζει',
    controlSafety: 'Οι βάνες αυτές είναι ενεργές σε πραγματικό κτήμα, οπότε τίποτα σε αυτή την οθόνη δεν ανοίγει καμία.',
    tourControl: 'Το να ξέρεις είναι το μισό. Αυτό το χωράφι έχει τρεις βάνες σε έναν ελεγκτή, και οι τρεις απαντούν.',
    tourPress: 'Η σύσταση ήταν 50 λεπτά στη ζώνη δύο. Ένα πάτημα.',
    tourRunning: 'Ποτίζει. Δεν είναι μήνυμα σε κάποιον, ούτε σημείωση για αργότερα. Η βάνα είναι ανοιχτή.',
    tourLogged: 'Και γράφεται: ποια ζώνη, πόση ώρα, ποιος το ζήτησε. Από αυτό το ιστορικό σχεδιάζεται η επόμενη χρονιά.',
    seasonTitle: 'Η σεζόν {y}, όπως την κατέγραψε ο σταθμός',
    seasonIntro: 'Δεν είναι πρόβλεψη. Είναι όσα κατέγραψαν πραγματικά ο αισθητήρας και το βροχόμετρο, από τον Μάρτιο ως τον Οκτώβριο.',
    seasonHours: 'ώρες μετρήσεων',
    seasonRain: 'βροχή, μετρημένη',
    seasonWaterings: 'αρδεύσεις, καταγεγραμμένες',
    seasonHonest: 'Δεν υπάρχει σε αυτή την οθόνη νούμερο για νερό που εξοικονομήθηκε. Θα χρειαζόταν να ξέρουμε τι θα έκανε ο παραγωγός χωρίς την πλατφόρμα, και αυτό δεν το μέτρησε κανείς.',
    tourFarmGaps: 'Και όπου υπάρχει κενό, το λέει. Σε ένα χωράφι ο αισθητήρας έχει σταματήσει να μιλάει. Καλύτερα να το δεις εδώ παρά να το βρεις τον Αύγουστο.',
    tourShallowWhy: 'Ένα βροχόμετρο θα το έλεγε βροχερή μέρα και θα του έλεγε να μην ποτίσει. Ο αισθητήρας ήξερε καλύτερα.',
    tourSeason: 'Μέσα σε μια σεζόν αθροίζονται. Πέντε χιλιάδες οκτακόσιες ώρες μετρήσεων, τετρακόσια είκοσι χιλιοστά βροχής μετρημένα, εκατόν τριάντα οκτώ ποτίσματα καταγεγραμμένα.',
    tourHonest: 'Και κανένα φτιαχτό νούμερο για εξοικονόμηση, γιατί κανείς δεν μέτρησε τι θα έκανε χωρίς αυτήν. Το ιστορικό είναι το επιχείρημα.',
    showcaseSwitchLanguage: 'Αλλαγή στα Αγγλικά',
    showcaseLangShort: 'EN',
    manualDurationNoRec: 'Δεν υπάρχει σύσταση για αυτή τη ζώνη αυτή τη στιγμή. Όποια διάρκεια ορίσετε εδώ είναι δική σας επιλογή.',
    tourShowFieldsTitle: 'Όλο το κτήμα με μια ματιά',
    tourShowFieldsDesc: 'Ανοίγετε την εφαρμογή και κάθε χωράφι δείχνει πού βρίσκεται. Αυτό που χρειάζεται προσοχή είναι ήδη σημειωμένο.',
    tourShowZonesTitle: 'Το νερό εκεί που βρίσκονται οι ρίζες',
    tourShowZonesDesc: 'Υγρασία σε τρία βάθη, ζωντανά. Η επιφάνεια ξεγελά. Στο ριζόστρωμα κρίνεται η σοδειά.',
    tourTrendTitle: 'Υγρασία στον χρόνο',
    tourTrendDesc: 'Νερό εδάφους στα 10, 20 και 30 εκ. στην περίοδο, με σημειωμένες τις γραμμές αναπλήρωσης και πληρότητας.',
    tourShowTrendTitle: 'Τα δεδομένα πίσω από την απόφαση',
    tourShowTrendDesc: 'Οι αισθητήρες του χωραφιού μετρούν υγρασία στα 10, 20 και 30 εκ. Η πτώση προς το όριο αναπλήρωσης οδήγησε την απόφαση.',
    tourShowWeatherTitle: 'Έχει ήδη δει τον καιρό για εσάς',
    tourShowWeatherDesc: 'Ζέστη και βροχή για τις επόμενες μέρες, μέσα σε κάθε απόφαση. Καμία άρδευση πριν την καταιγίδα.',
    tourShowDssTitle: 'Η απόφαση και το γιατί',
    tourShowDssDesc: 'Άρδευση σε αυτή τη ζώνη, για συγκεκριμένο χρόνο: το ριζόστρωμα έπεσε κάτω από το ασφαλές όριο. Όλες οι μετρήσεις εδώ.',
    tourShowApproveTitle: 'Έγκριση με ένα άγγιγμα',
    tourShowApproveDesc: 'Συμφωνείτε με την πρόταση; Εγκρίνετέ την. Αλλάξτε πρώτα τα λεπτά ή την ώρα αν θέλετε. Εσείς αποφασίζετε.',
    tourShowNdviTitle: 'Απόδειξη από το διάστημα',
    tourShowNdviDesc: 'Δορυφορική εικόνα πάνω στις ζώνες σας. Μια αδύναμη γωνιά φαίνεται εδώ εβδομάδες πριν τη δείτε στο χωράφι.',
    tourShowMapTitle: 'Κάθε τμήμα, με μια ματιά',
    tourShowMapDesc: 'Ο οπωρώνας σας όπως είναι στο έδαφος, κάθε ζώνη χρωματισμένη με το τι χρειάζεται σήμερα.',
    tourShowScheduleTitle: 'Εγκρίθηκε, και μπήκε στο πρόγραμμα',
    tourShowScheduleDesc: 'Η άρδευση που εγκρίνατε είναι στο ημερολόγιο. Μετακινήστε την έναρξη ή αλλάξτε τη διάρκεια όπως σας βολεύει.',
    tourShowProgrammeTitle: 'Οι επόμενες συστάσεις, δική σας απόφαση',
    tourShowProgrammeDesc: 'Ο αλγόριθμος προτείνει συνεχώς τις επόμενες αρδεύσεις. Εγκρίνετε όσες θέλετε ή ορίστε τις δικές σας.',
    tourShowReportsTitle: 'Τα έγγραφά σας, ήδη γραμμένα',
    tourShowReportsDesc: 'Κάθε απόφαση αποθηκευμένη με τα νούμερα από πίσω. Όταν ρωτήσει ο ελεγκτής εξαγωγών, ανοίγετε μια σελίδα.',
    tourShowReportTitle: 'Όλη η μέρα σε μία σελίδα',
    tourShowReportDesc: 'Φτιαγμένη από αυτό το χωράφι. Υγρασία εδάφους σε τρία βάθη, θερμοκρασία εδάφους, καιρός και στάδιο ανάπτυξης, με το τι έτρεξε και γιατί.',
    tourShowReportGenerateTitle: 'Πλήρης αναφορά, όποτε τη θέλετε',
    tourShowReportGenerateDesc: 'Η πλατφόρμα φτιάχνει την αναφορά της ημέρας επιτόπου, έτοιμη να τη διαβάσετε όποια ώρα τη ζητήσετε.',
    tourShowFleetTitle: 'Κάθε συσκευή, με όνομα και κατάσταση',
    tourShowFleetDesc: 'Πύλες IoT, αισθητήρες και ελεγκτές, ο καθένας στη δική του καρτέλα, με το όνομα που δίνετε στο χωράφι και την κατάστασή του.',
    tourShowHardwareTitle: 'Κρατήστε τον εξοπλισμό που ήδη αγοράσατε',
    tourShowHardwareDesc: 'Λειτουργεί πάνω σε όποιους αισθητήρες και ελεγκτές έχετε στο χωράφι. Χωρίς αντικατάσταση, χωρίς νέο προμηθευτή.',
    tourShowAlertsTitle: 'Επισημαίνει πρώτα αυτό που χρειάζεται προσοχή',
    tourShowAlertsDesc: 'Κάθε ειδοποίηση σε ένα σημείο, ταξινομημένη κατά σημασία. Το ξηρό τεμάχιο σας ειδοποίησε πριν το δείξουν τα φύλλα.',
        showcaseChapterProblemKicker: 'Το πρόβλημα',
showcaseChapterProblemTitle: 'Το πότισμα «στο μάτι» είναι στοίχημα',
    showcaseChapterProblemDesc: 'Σε οπωρώνα υψηλής αξίας, η λάθος απόφαση κοστίζει καρπό, ποιότητα και νερό. Κάθε χρόνο, σε κάθε τμήμα.',
        showcaseChapterDiagnosisKicker: '01 Διάγνωση',
showcaseChapterDiagnosisTitle: 'Διαβάζει όλο το χωράφι',
    showcaseChapterDiagnosisDesc: 'Υγρασία ριζοστρώματος, τάση εδάφους, καιρός, στάδιο καλλιέργειας και ιστορικό, όλα μαζί.',
        showcaseChapterDecisionKicker: '02 Απόφαση',
showcaseChapterDecisionTitle: 'Παίρνει την απόφαση',
    showcaseChapterDecisionDesc: 'Κάθε βάθος εδάφους, τα όρια της ίδιας της καλλιέργειας και μια λογική που μπορείτε να ακολουθήσετε. Μία απάντηση για κάθε ζώνη.',
        showcaseChapterActionKicker: '03 Ενέργεια',
showcaseChapterActionTitle: 'Την εκτελεί',
    showcaseChapterActionDesc: 'Ώρα, διάρκεια, λόγος. Εσείς έχετε τον έλεγχο. Ο οπωρώνας δουλεύει μόνος του.',
    showcaseIntroKicker: 'AI Irrigation Decision Engine',
    showcaseIntroLine: 'Πότε, πόσο και γιατί να αρδεύσετε.',
    showcaseOutroTitle: 'Σταματήστε να μαντεύετε. Αρχίστε να αποφασίζετε.',
    showcaseOutroLine: 'Δοκιμασμένο σε εμπορικό οπωρώνα ακτινιδίου στη Βόρεια Ελλάδα. Κατατεθειμένη ευρεσιτεχνία.',
    showcaseOutroContact: 'www.terramind.gr',
    showcasePreparing: 'Προετοιμασία της επίδειξης…',
    showcasePlay: 'Αναπαραγωγή',
    showcasePause: 'Παύση',
    durationNotAvailable: 'δείτε ρυθμίσεις',
    tourPauseDemo: 'Παύση',
    tourResumeDemo: 'Αναπαραγωγή',
    tourExitDemo: 'Έξοδος',
    // Φωνή επίδειξης: τι σημαίνει η οθόνη. Η ξενάγηση κρατά τις δικές της
    // οδηγίες, για τον παραγωγό που μαθαίνει την εφαρμογή με το ποντίκι.
    showcaseNext: 'Επόμενο',
    showcasePrev: 'Προηγούμενο',
    showcaseSpeed: 'Ταχύτητα αναπαραγωγής',
    showcaseExit: 'Κλείσιμο',
    showcaseYouAreDriving: 'Έχετε τον έλεγχο',
    showcaseHistoricalNote: 'Πραγματικά δεδομένα του χωραφιού, από μια μέρα που χρειαζόταν άρδευση.',
    showcaseWrongAccountTitle: 'Ξεκινήστε την επίδειξη στον λογαριασμό showcase',
    showcaseWrongAccountBody: 'Η επίδειξη του περιπτέρου τρέχει στο προετοιμασμένο κτήμα showcase, όπου ένα τεμάχιο έχει ρυθμιστεί να χρειάζεται νερό ώστε η απόφαση να είναι καθαρή. Έχετε συνδεθεί με άλλον λογαριασμό, οπότε η επίδειξη θα έπαιζε με όποια δεδομένα έχει εκείνος. Αποσυνδεθείτε και συνδεθείτε ως λογαριασμός showcase, μετά ανοίξτε ξανά αυτή τη σελίδα.',
    showcaseWrongAccountCurrent: 'Συνδεδεμένος ως',
    showcaseWrongAccountProceed: 'Αναπαραγωγή έτσι κι αλλιώς',
    tourSectionHardware: 'Εξοπλισμός',
    tourSectionReports: 'Αναφορές',
    tourCoverageTitle: 'Τι μπορεί να κάνει το κάθε χωράφι',
    tourCoverageDesc: 'Κάθε χωράφι, και το αν η πλατφόρμα μπορεί να το μετρήσει, να το ποτίσει, ή και τα δύο. Ένα χωράφι με αισθητήρα και χωρίς βάνα το λέει, αντί να το ανακαλύψετε όταν ένα κουμπί δεν κάνει τίποτα.',
    tourHardwareTabsTitle: 'Ο εξοπλισμός από πίσω',
    tourHardwareTabsDesc: 'Σταθμοί, πύλες και ελεγκτές βανών, και ο καθένας δείχνει αν απαντά αυτή τη στιγμή. Η προσθήκη νέου ελεγκτή γίνεται από εδώ, όχι με επίσκεψη στο χωράφι.',
    tourReportsGenerateTitle: 'Δημιουργία αναφοράς τώρα',
    tourReportsGenerateDesc: 'Φτιάξε μια νέα αναφορά όποτε τη θελήσεις, χωρίς να περιμένεις το ημερήσιο email. Ανοίγει εδώ σε λίγα δευτερόλεπτα.',
    tourReportsListTitle: 'Όλες οι αναφορές που έχει βγάλει',
    tourReportsListDesc: 'Η αναφορά άρδευσης τρέχει τέσσερις φορές την ημέρα και η αναφορά αισθητήρων τρεις. Έρχονται με email και μένουν εδώ, οπότε τίποτα δεν χάνεται με ένα σβησμένο μήνυμα.',
    tourReportsViewerTitle: 'Η ίδια η αναφορά',
    tourReportsViewerDesc: 'Τα ίδια νούμερα που είδατε στις οθόνες, σε μία σελίδα, έτοιμα να κρατηθούν ή να δοθούν σε γεωπόνο.',
    reportsNavLabel: 'Αναφορές',
    reportsPageTitle: 'Αναφορές',
    reportsPageSubtitle: 'Όλες οι αναφορές άρδευσης και αισθητήρων που έχει βγάλει η πλατφόρμα, με τις πιο πρόσφατες πρώτες',
    reportsFilterAll: 'Όλες',
    reportsDownload: 'Λήψη',
    reportsNoneOfThisType: 'Δεν υπάρχει ακόμη αναφορά αυτού του είδους.',
    reportsEmptyTitle: 'Καμία αναφορά ακόμη',
    reportsEmptyBody: 'Οι αναφορές σας εμφανίζονται εδώ. Πατήστε «Δημιουργία αναφοράς τώρα» για την πρώτη.',
    reportsLoadFailed: 'Η λίστα των αναφορών δεν φορτώθηκε.',
    reportsGenerateNow: 'Δημιουργία αναφοράς τώρα',
    reportsGenerating: 'Δημιουργία...',
    reportsGenerateChoose: 'Επιλογή τύπου αναφοράς',
    reportsGenerateVwcw: 'Αναφορά άρδευσης',
    reportsGenerateIot: 'Αναφορά αισθητήρων',
    reportsGenerateField: 'Αναφορά χωραφιού',
    reportsWindow: 'Χρονικό διάστημα',
    reportsWindow2d: '48 ώρες',
    reportsWindow7d: '7 ημέρες',
    reportsWindow14d: '14 ημέρες',
    reportsSections: 'Περιεχόμενα',
    reportSection_sensors: 'Αισθητήρες εδάφους ανά βάθος',
    reportSection_soil: 'Θερμοκρασία και αλατότητα εδάφους',
    reportSection_forecast: 'Πρόβλεψη',
    reportSection_weather: 'Καιρός',
    reportsGenerateFailed: 'Η αναφορά δεν μπόρεσε να δημιουργηθεί. Δοκιμάστε ξανά.',
    reportsGenerateBusy: 'Μια αναφορά δημιουργείται ήδη. Δοκιμάστε ξανά σε λίγο.',
    reportsOpenFailed: 'Η αναφορά δεν άνοιξε. Δοκιμάστε λήψη.',
    reportTypeVwcwDaily: 'Άρδευση, ημερήσια',
    reportTypeVwcwSimple: 'Άρδευση, σύντομη',
    reportTypeFieldDaily: 'Αναφορά χωραφιού, ημερήσια',
    reportTypeFieldSimple: 'Αναφορά χωραφιού, σύντομη',
    reportTypeFarm: 'Όλα τα χωράφια',
    reasonShort_ROOTZONE_BELOW_MIN: 'Ριζόστρωμα κάτω από το ελάχιστο',
    reasonShort_ROOTZONE_STRESSED: 'Ριζόστρωμα σε καταπόνηση',
    reasonShort_SUBSOIL_DRY: 'Ξηρό βαθύ στρώμα',
    reasonShort_HEAT_STRESS: 'Καύσωνας',
    reasonShort_MARGINAL_HIGH_ET: 'Οριακή, υψηλή ζήτηση',
    reasonShort_DRYING_TREND: 'Το έδαφος στεγνώνει',
    reasonShort_FROST_PROTECT: 'Αντιπαγετική',
    reasonShort_RAIN_SKIP: 'Πρόγνωση βροχής',
    reasonShort_RAIN_FORECAST: 'Πρόγνωση βροχής',
    reasonShort_RECENT_RAIN: 'Πρόσφατη βροχή',
    reasonShort_RECENTLY_IRRIGATED: 'Πρόσφατη άρδευση',
    reasonShort_SOIL_ADEQUATE: 'Επαρκής υγρασία',
    reasonShort_OFF_SEASON: 'Εκτός περιόδου',
    reasonShort_OFF_SEASON_DRY: 'Εκτός περιόδου, ξηρό',
    reasonShort_IRRIGATING: 'Σε άρδευση',
    reasonShort_JUST_IRRIGATED: 'Μόλις ποτίστηκε',
    reasonShort_NO_DATA: 'Χωρίς δεδομένα',
    reasonShort_NO_SENSOR_DATA: 'Χωρίς μετρήσεις',
    reasonShort_STALE_DATA: 'Παλιές μετρήσεις',
    reasonShort_SATURATED: 'Κορεσμένο έδαφος',
    reasonShort_MANUAL_OVERRIDE: 'Αλλαγή από τον παραγωγό',
    reasonShort_WEEKLY_BASELINE: 'Εβδομαδιαίο πρόγραμμα',
    reportsGenerateFarm: 'Όλα τα χωράφια, το καθένα στη σελίδα του',
    reportsScope: 'Τι καλύπτει η αναφορά',
    reportsWholeField: 'Ολόκληρο το χωράφι',
    reportTypeIot4h2o: 'Αισθητήρες',
    reportTypeIot4h2oSnapshot: 'Στιγμιότυπο αισθητήρων',

    // Register-a-device dialog
    deviceRegisterButton: 'Προσθήκη συσκευής',
    deviceRegisterDialogTitle: 'Καταχώρηση συσκευής',
    deviceRegisterKindLabel: 'Τύπος συσκευής',
    deviceRegisterKindController: 'Ελεγκτής βανών (ESP8266 / ESP32)',
    deviceRegisterKindGateway: 'Πύλη αισθητήρων (τηλεμετρία)',
    deviceRegisterKindSentek: 'Αισθητήρας Sentek (IrriMAX Live)',
    deviceRegisterSentekNameLabel: 'Όνομα logger στο IrriMAX Live',
    deviceRegisterSentekNameHelp: 'Ακριβώς όπως το δείχνει το IrriMAX Live, π.χ. terramind001',
    deviceRegisterSentekTest: 'Δοκιμή',
    deviceRegisterFieldHelpSentek: 'Το χωράφι όπου είναι τοποθετημένος ο αισθητήρας.',
    deviceRegisterSentekTestOk: 'Συνδέθηκε. Τελευταία μέτρηση {time}: {values}',
    deviceRegisterIdLabel: 'Κωδικός συσκευής',
    deviceRegisterIdHelp: 'Πρέπει να ταιριάζει ακριβώς με ό,τι στέλνει η φυσική μονάδα.',
    deviceRegisterVendorLabel: 'Κατασκευαστής',
    deviceRegisterModelLabel: 'Μοντέλο',
    deviceRegisterFieldLabel: 'Χωράφι',
    deviceRegisterFieldHelpSpare: 'Αφήστε το κενό για να καταχωρηθεί ως αποθεματική, δεν είναι ακόμα εγκατεστημένη πουθενά.',
    deviceRegisterFieldHelpRequired: 'Ένας ελεγκτής πρέπει να ανατεθεί σε χωράφι.',
    deviceRegisterZoneLabel: 'Ζώνη (προαιρετικό)',
    deviceRegisterSubmit: 'Καταχώρηση',
    deviceRegisterCancel: 'Ακύρωση',
    recViewSubtitle: 'Τι συνέστησε το σύστημα και ποιες αρδεύσεις έγιναν, ανά χωράφι και ημέρα.',
    recViewAppRunsOnly: 'Μετρώνται οι αρδεύσεις που ξεκίνησαν από την εφαρμογή. Άρδευση εκτός εφαρμογής δεν εμφανίζεται ακόμη.',
    recViewIrrigateDays: 'Ημέρες με σύσταση άρδευσης',
    recViewRuns: 'Αρδεύσεις',
    recViewMinutesRun: 'Λεπτά άρδευσης',
    recViewWithoutCall: 'Αρδεύσεις χωρίς σύσταση',
    recViewNoResponseDays: 'Ημέρες χωρίς απόκριση εδάφους',
    recViewLegendRun: 'Λεπτά που έγιναν',
    recViewLegendCall: 'Λεπτά που συνέστησε',
    recViewLegendForecast: 'Πρόβλεψη ώρας άρδευσης',
    recViewLegendNoResponse: 'Χωρίς απόκριση εδάφους',
    recViewNoCall: 'Δεν καταγράφηκε σύσταση',
    recViewCallIrrigate: 'Σύσταση: άρδευση',
    recViewCallForecast: 'Σύσταση: άρδευση αργότερα, κατά την πρόβλεψη',
    recViewCallNone: 'Σύσταση: χωρίς άρδευση',
    recViewNoResponse: 'χωρίς απόκριση εδάφους',
    recViewNotRecorded: 'Δεν έχουν καταγραφεί ακόμη συστάσεις για αυτό το χωράφι.',
    recViewEmpty: 'Δεν υπάρχουν χωράφια για εμφάνιση.',
    recViewError: 'Δεν ήταν δυνατή η φόρτωση των στοιχείων.',
    recViewStripAria: 'Συστάσεις και αρδεύσεις ανά ημέρα',
    readingsDays: '{n} ημέρες',
    readingsMeasure_moisture: 'υγρασία εδάφους',
    readingsMeasure_tension: 'τάση εδάφους',
    readingsMeasure_soil_temp: 'θερμοκρασία εδάφους',
    readingsSensor: 'Αισθητήρας',
    readingsShort_moisture: 'υγρασία',
    readingsShort_tension: 'τάση',
    readingsShort_soil_temp: 'θερμοκρασία',
    readingsLimit: 'Όριο άρδευσης',
    readingsIrrigation: 'Άρδευση',
    readingsSuspect: 'Μη αξιόπιστη μέτρηση αισθητήρα',
    readingsEmpty: 'Δεν υπάρχουν μετρήσεις σε αυτό το διάστημα.',
    readingsError: 'Δεν ήταν δυνατή η φόρτωση των μετρήσεων.',
    readingsTitle: 'Μετρήσεις',
    deviceConnectButton: 'Σύνδεση με χωράφι',
    deviceConnectTitle: 'Σύνδεση της μονάδας με χωράφι',
    deviceConnectIntro: 'Επιλέξτε το χωράφι και τη ζώνη όπου είναι τοποθετημένοι οι αισθητήρες. Από τη στιγμή της σύνδεσης οι μετρήσεις αποθηκεύονται και χρησιμοποιούνται στις συστάσεις του χωραφιού.',
    deviceConnectNow: 'Τρέχουσες τιμές',
    deviceConnectNotInSoil: 'Η υγρασία δείχνει σχεδόν μηδέν, οπότε οι αισθητήρες μάλλον δεν είναι ακόμη μέσα στο έδαφος. Τιμές υγρασίας 1 % ή λιγότερο δεν αποθηκεύονται ποτέ.',
    deviceConnectField: 'Χωράφι',
    deviceConnectZone: 'Ζώνη (προαιρετικά)',
    deviceConnectWholeField: 'Όλο το χωράφι',
    deviceConnectSave: 'Σύνδεση',
    deviceConnectNoProbe: 'Δεν αναγνωρίστηκε αισθητήρας σε αυτή τη μονάδα. Ελέγξτε ότι οι αισθητήρες είναι συνδεδεμένοι στην πύλη.',
    deviceConnectFailed: 'Η σύνδεση δεν ολοκληρώθηκε. Δοκιμάστε ξανά.',
    deviceRegisterSaved: 'Η συσκευή καταχωρήθηκε',
    deviceRegisterSaveFailed: 'Αποτυχία καταχώρησης, ελέγξτε τα παρακάτω πεδία',
    deviceRegisterTokenLabel: 'Κλειδί (αφήστε το κενό για αυτόματο)',
    deviceRegisterTokenHelp: 'Αν η πλακέτα έχει ήδη προγραμματιστεί, επικολλήστε το κλειδί που έχει. Αλλιώς αφήστε το κενό και θα δοθεί καινούριο.',
    deviceRegisterTokenTitle: 'Αποθηκεύστε αυτό το token τώρα',
    deviceRegisterTokenBody: 'Εμφανίζεται μία φορά. Αντιγράψτε το στο firmware της συσκευής.',
    deviceRegisterTokenDone: 'Τέλος',
    deviceRegisterSpareBadge: 'Αποθεματική (μη εγκατεστημένη)',
  },
};

export default translations;

